import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Date: { input: any; output: any; }
  DateTime: { input: any; output: any; }
  JSON: { input: any; output: any; }
  JSONObject: { input: any; output: any; }
  UUID: { input: any; output: any; }
  Void: { input: any; output: any; }
};

/** AI feedback for the submission */
export type AiFeedback = {
  __typename?: 'AIFeedback';
  aiFeedback?: Maybe<Scalars['String']['output']>;
  aiFeedbackShort?: Maybe<Scalars['String']['output']>;
};

/** An identifier to a generated API Key. */
export type ApiKey = {
  __typename?: 'APIKey';
  /** The company associated with this API Key. */
  company: Company;
  /** The company associated with this API Key. */
  companyId: Scalars['UUID']['output'];
  /** The company profile who created this API Key. It will be null if the company profile is archived. */
  companyProfile?: Maybe<CompanyProfile>;
  /** The company profile id who created this API Key. */
  companyProfileId: Scalars['UUID']['output'];
  createdAt: Scalars['DateTime']['output'];
  /** Whether the API Key has been (soft) deleted. */
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['UUID']['output'];
  /** Last 4 digits of generated API Key */
  last4: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

/** A generated API Key. */
export type ApiKeyCreateResponse = {
  __typename?: 'APIKeyCreateResponse';
  accessToken: Scalars['String']['output'];
  /** The company associated with this API Key. */
  company: Company;
  /** The company associated with this API Key. */
  companyId: Scalars['UUID']['output'];
  /** The company profile who created this API Key. It will be null if the company profile is archived. */
  companyProfile?: Maybe<CompanyProfile>;
  /** The company profile id who created this API Key. */
  companyProfileId: Scalars['UUID']['output'];
  createdAt: Scalars['DateTime']['output'];
  /** Whether the API Key has been (soft) deleted. */
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['UUID']['output'];
  /** Last 4 digits of generated API Key */
  last4: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

/** Sort API keys by */
export enum ApiKeyListOrderBy {
  CreatedAtDesc = 'CREATED_AT_DESC'
}

/** An object that represents temporary credentials for accessing AWS resources */
export type AwsCredentials = {
  __typename?: 'AWSCredentials';
  /** AWS access key ID */
  accessKeyId: Scalars['String']['output'];
  /** Date when the credentials expire */
  expiresAt: Scalars['DateTime']['output'];
  /** AWS secret access key */
  secretAccessKey: Scalars['String']['output'];
  /** AWS session token */
  sessionToken: Scalars['String']['output'];
};

/** Amazon S3 parameters */
export type Awss3Params = {
  __typename?: 'AWSS3Params';
  /** AWS S3 bucket */
  bucket: Scalars['String']['output'];
  /** AWS S3 object key */
  key: Scalars['String']['output'];
  /** AWS region */
  region: Scalars['String']['output'];
};

export type Action = {
  __typename?: 'Action';
  actionId: Scalars['String']['output'];
  icon?: Maybe<Scalars['String']['output']>;
  label: Scalars['String']['output'];
};

/** self practice results of submission */
export type Articulation = {
  __typename?: 'Articulation';
  fillerWordScore?: Maybe<Scalars['Float']['output']>;
  fillerWords?: Maybe<Array<Scalars['String']['output']>>;
  fillerWordsCount?: Maybe<Scalars['Float']['output']>;
  keywordScore?: Maybe<Scalars['Float']['output']>;
  mediaLength?: Maybe<Scalars['Float']['output']>;
  overallScore?: Maybe<Scalars['Float']['output']>;
  wordsPerMinute?: Maybe<Scalars['Float']['output']>;
  wpmScore?: Maybe<Scalars['Float']['output']>;
};

export type Assignment = {
  __typename?: 'Assignment';
  assignmentLesson?: Maybe<AssignmentLesson>;
  assignmentLessonId?: Maybe<Scalars['UUID']['output']>;
  companyProfileId: Scalars['UUID']['output'];
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['UUID']['output'];
  isFailed: Scalars['Boolean']['output'];
  learningPlanId?: Maybe<Scalars['UUID']['output']>;
  skillId?: Maybe<Scalars['UUID']['output']>;
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type AssignmentLesson = {
  __typename?: 'AssignmentLesson';
  assignmentId: Scalars['UUID']['output'];
  companyProfileId: Scalars['UUID']['output'];
  id: Scalars['UUID']['output'];
  lesson: Lesson;
  lessonId: Scalars['UUID']['output'];
};

/** Authentication channel related metadata. Currently Local, SSO/IDP based authentication supported. */
export type AuthChannelResponse = {
  __typename?: 'AuthChannelResponse';
  /** Authentication channel for the company. If SSO is enabled, it takes priority */
  channelType?: Maybe<AuthenticationChannelType>;
  /** Company external identifier. */
  companyExtId?: Maybe<Scalars['String']['output']>;
  /** Company internal identifier. */
  companyId?: Maybe<Scalars['String']['output']>;
  /** Company profile identifier. */
  companyProfileId?: Maybe<Scalars['String']['output']>;
  /** Metadata for Local authentication channel */
  localChannel?: Maybe<LocalChannel>;
  /** Metadata for SSO type channel */
  ssoChannel?: Maybe<SsoChannel>;
};

/** A pair of JWT short-lived access token and a long-lived refresh tokens. Access token can be passed in subsequent requests via http header "Authentication: Bearer ACCESS_TOKEN". */
export type AuthSession = {
  __typename?: 'AuthSession';
  /** Bearer JWT token used to access the app via Authentication header. */
  accessToken: Scalars['String']['output'];
  /** Company External ID. */
  companyExternalId: Scalars['String']['output'];
  /** Company Profile ID. */
  companyProfileId: Scalars['String']['output'];
  /** If true, indicates that a second factor authentication step is required. */
  mfaRequired?: Maybe<Scalars['Boolean']['output']>;
  /** company profile external ID. */
  profileExternalId: Scalars['String']['output'];
  /** JWT token used to request a new pair of access and refresh tokens. */
  refreshToken: Scalars['String']['output'];
};

/** Available authentication channels */
export enum AuthenticationChannelType {
  Local = 'LOCAL',
  Sso = 'SSO'
}

/** Available auhthentication sources. */
export enum AuthenticationSource {
  Admin = 'ADMIN',
  App = 'APP'
}

/** Available auhthentication types. */
export enum AuthenticationType {
  Email = 'EMAIL',
  Phone = 'PHONE',
  Sso = 'SSO',
  Url = 'URL'
}

/** auto coach configuration */
export type AutoCoachConfig = {
  __typename?: 'AutoCoachConfig';
  approvalCutoff: Scalars['Float']['output'];
  rejectionCutoff: Scalars['Float']['output'];
};

/** auto coach configuration inputs */
export type AutoCoachConfigInput = {
  approvalCutoff: Scalars['Float']['input'];
  rejectionCutoff: Scalars['Float']['input'];
};

/** results of auto evaluation for submission */
export type AutoEvaluationCriteriaGraphql = {
  __typename?: 'AutoEvaluationCriteriaGraphql';
  keywordCheck?: Maybe<AutoEvaluationCriteriaKeywordCheck>;
  schemaVersion?: Maybe<Scalars['String']['output']>;
};

export type AutoEvaluationCriteriaGraphqlInput = {
  keywordCheck?: InputMaybe<AutoEvaluationKeywordCheckInput>;
  schemaVersion?: InputMaybe<Scalars['String']['input']>;
};

/** results of auto evaluation for submission */
export type AutoEvaluationCriteriaKeywordCheck = {
  __typename?: 'AutoEvaluationCriteriaKeywordCheck';
  allowedKeywords?: Maybe<Array<Scalars['String']['output']>>;
  incorrectKeywords?: Maybe<Array<Scalars['String']['output']>>;
};

/** results of auto evaluation for submission */
export type AutoEvaluationKeywordCheck = {
  __typename?: 'AutoEvaluationKeywordCheck';
  allowedKeywordsFuzzyMatched?: Maybe<Array<FuzzyMatch>>;
  allowedKeywordsMatched?: Maybe<Array<Scalars['String']['output']>>;
  allowedKeywordsMatchedV2?: Maybe<Array<KeywordsMatch>>;
  allowedKeywordsNotMatched?: Maybe<Array<Scalars['String']['output']>>;
  incorrectKeywordsFuzzyMatched?: Maybe<Array<FuzzyMatch>>;
  incorrectKeywordsMatched?: Maybe<Array<Scalars['String']['output']>>;
  incorrectKeywordsMatchedV2?: Maybe<Array<KeywordsMatch>>;
  incorrectKeywordsNotMatched?: Maybe<Array<Scalars['String']['output']>>;
};

export type AutoEvaluationKeywordCheckInput = {
  allowedKeywords?: InputMaybe<Array<Scalars['String']['input']>>;
  incorrectKeywords?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** results of auto evaluation for submission */
export type AutoEvaluationOutcome = {
  __typename?: 'AutoEvaluationOutcome';
  aiFeedback?: Maybe<AiFeedback>;
  articulation?: Maybe<Articulation>;
  contentScore?: Maybe<ContentScore>;
  conversationMetrics?: Maybe<ConversationMetrics>;
  isArticulationPass?: Maybe<Scalars['Boolean']['output']>;
  isKeywordPass?: Maybe<Scalars['Boolean']['output']>;
  keywordCheck?: Maybe<AutoEvaluationKeywordCheck>;
  keywordScore?: Maybe<Scalars['Float']['output']>;
  languageCode?: Maybe<Scalars['String']['output']>;
  overallScore?: Maybe<Scalars['Float']['output']>;
  schemaVersion?: Maybe<Scalars['String']['output']>;
  sentiment?: Maybe<Scalars['Float']['output']>;
  token?: Maybe<Token>;
};

export type AwsOutcome = {
  __typename?: 'AwsOutcome';
  accountId?: Maybe<Scalars['String']['output']>;
  jobName?: Maybe<Scalars['String']['output']>;
  results?: Maybe<Results>;
  status?: Maybe<Scalars['String']['output']>;
};

/** Basic parameters to handle pagination. */
export type BaseClassicPaginate = {
  /** Starting pointer where to  collect objects from, similar to offset. Passing null will return the first <limit> objects. */
  cursor?: InputMaybe<Scalars['String']['input']>;
  /** Maximum number of objects returned per page. */
  limit: Scalars['Int']['input'];
};

export enum BaseOperator {
  And = 'AND',
  Or = 'OR'
}

/** Campaigns date type options */
export enum CampaignsDateType {
  Dynamic = 'DYNAMIC',
  Static = 'STATIC'
}

/** Form prompt choice. */
export type Choice = {
  __typename?: 'Choice';
  id: Scalars['UUID']['output'];
  isCorrect?: Maybe<Scalars['Boolean']['output']>;
  localizations: ChoiceLocalizedConnection;
  /** Choice position within form prompt. */
  position: Scalars['Int']['output'];
  type: ChoiceType;
};

export type ChoiceConnection = {
  __typename?: 'ChoiceConnection';
  nodes: Array<Choice>;
};

export type ChoiceInput = {
  defaultLocalization: DefaultChoiceLocalizationInput;
  id?: InputMaybe<Scalars['String']['input']>;
  isCorrect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Choice position within form prompt. */
  position: Scalars['Int']['input'];
  type: ChoiceType;
};

/** Form prompt choice localization. */
export type ChoiceLocalized = {
  __typename?: 'ChoiceLocalized';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  language: Language;
  media?: Maybe<Media>;
  mediaId?: Maybe<Scalars['UUID']['output']>;
};

export type ChoiceLocalizedConnection = {
  __typename?: 'ChoiceLocalizedConnection';
  nodes: Array<ChoiceLocalized>;
};

/** Form prompt choice type. */
export enum ChoiceType {
  Image = 'IMAGE',
  Input = 'INPUT',
  Text = 'TEXT'
}

/** Company configuration. */
export type Company = {
  __typename?: 'Company';
  /** @deprecated Replaced in favour of Cloudinary. */
  brightcoveId?: Maybe<Scalars['String']['output']>;
  /** URL of the cerficiate template for the company. */
  certificateTemplate?: Maybe<Scalars['String']['output']>;
  /** Enabled authentication methods to both PWA and Admin. */
  companyAuthentications?: Maybe<Array<CompanyAuthentication>>;
  /** Enabled features. */
  companyFeatures?: Maybe<Array<CompanyFeature>>;
  /** Available languages. */
  companyLanguages?: Maybe<Array<CompanyLanguage>>;
  /** Default country code for the company. */
  countryCode?: Maybe<CountryCode>;
  createdAt: Scalars['DateTime']['output'];
  /** Default language for the company. */
  defaultLanguage?: Maybe<Language>;
  /** Company visible name that can be different from name. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Whether or not Contextual Assignment via URL is enabled. */
  enableLearnerInitiatedContextualAssignment?: Maybe<Scalars['Boolean']['output']>;
  /** Whether or not the Learning Plan Assignment via URL is enabled. */
  enableLearnerInitiatedLearningPlanAssignment?: Maybe<Scalars['Boolean']['output']>;
  /** A unique url-friendly identifier. i.e. my-company-name */
  externalId?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  /** Logo media object. */
  logoMedia?: Maybe<Media>;
  /** Media ID of Company Logo. */
  logoMediaId?: Maybe<Scalars['String']['output']>;
  /** Company name. */
  name?: Maybe<Scalars['String']['output']>;
  /** Whether or not the company notifications are enabled. */
  notificationsEnabled: Scalars['Boolean']['output'];
  /** Available tags for the company. */
  profileTags: Array<ProfileTag>;
  /** Company program name used in communications. */
  programName?: Maybe<Scalars['String']['output']>;
  /** Company Siblings. */
  siblings?: Maybe<Array<CompanySiblingDto>>;
  /** Whether or not the company SMS communication is enabled. */
  smsEnabled: Scalars['Boolean']['output'];
  /** Company contact name used in communications. */
  supportContact?: Maybe<Scalars['String']['output']>;
  /** Company contact email used in communications. */
  supportEmail?: Maybe<Scalars['String']['output']>;
  /** Default timezone for the company. */
  timezone?: Maybe<Timezone>;
  updatedAt: Scalars['DateTime']['output'];
  /** Whether or not the company whatsapp communication is enabled. */
  whatsappEnabled: Scalars['Boolean']['output'];
};

/** This object lists various SSO IDP related attributes. */
export type CompanyAuthAttributes = {
  __typename?: 'CompanyAuthAttributes';
  /** Company Authentication ID. */
  companyAuthId: Scalars['ID']['output'];
  /** Company ID. */
  companyId: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  /** Company Auth Attibute ID. */
  id: Scalars['ID']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

/** This object let enable different authentication methods for both PWA and Admin independently. */
export type CompanyAuthentication = {
  __typename?: 'CompanyAuthentication';
  /** The app: PWA or EDASH (Admin) */
  app: AuthenticationSource;
  /** Authentication type. It can be either email, phone, and URL. */
  authenticationType: AuthenticationType;
  /** Enabled authentication methods to both PWA and Admin. */
  companyAuthAttributes?: Maybe<Array<CompanyAuthAttributes>>;
  /** Company ID. */
  companyId: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type CompanyCreateInput = {
  /** URL of the cerficiate template for the company. */
  certificateTemplate?: InputMaybe<Scalars['String']['input']>;
  /** Default country code for the company. */
  countryCode?: InputMaybe<CountryCode>;
  /** Default language for the company. */
  defaultLanguage: Language;
  /** Company visible name that can be different from name. */
  displayName: Scalars['String']['input'];
  /** Whether or not Contextual Assignment via URL is enabled. */
  enableLearnerInitiatedContextualAssignment: Scalars['Boolean']['input'];
  /** Whether or not the Learning Plan Assignment via URL is enabled. */
  enableLearnerInitiatedLearningPlanAssignment: Scalars['Boolean']['input'];
  /** A unique url-friendly identifier. i.e. my-company-name. */
  externalId: Scalars['String']['input'];
  /** Enabled features. */
  features?: InputMaybe<Array<CompanyFeatureInput>>;
  /** Available languages. */
  languages: Array<CompanyLanguageInput>;
  /** Company internal name. */
  name: Scalars['String']['input'];
  /** Whether or not the company notifications are enabled. */
  notificationsEnabled: Scalars['Boolean']['input'];
  /** Company program name used in communications. */
  programName?: InputMaybe<Scalars['String']['input']>;
  /** Company Siblings list. */
  siblings?: InputMaybe<Array<CompanySiblingInput>>;
  /** Whether or not the company SMS communication is enabled. */
  smsEnabled: Scalars['Boolean']['input'];
  /** Company contact name used in communications. */
  supportContact?: InputMaybe<Scalars['String']['input']>;
  /** Company contact email used in communications. */
  supportEmail?: InputMaybe<Scalars['String']['input']>;
  /** Default timezone for the company. */
  timezone?: InputMaybe<Timezone>;
  /** External Photo URL and mime type of Company Logo. */
  uploadPhoto?: InputMaybe<UploadFileInput>;
  /** Whether or not the company whatsapp communication is enabled. */
  whatsappEnabled: Scalars['Boolean']['input'];
};

export type CompanyEditInput = {
  /** URL of the cerficiate template for the company. */
  certificateTemplate?: InputMaybe<Scalars['String']['input']>;
  /** Default country code for the company. */
  countryCode?: InputMaybe<CountryCode>;
  /** Default language. */
  defaultLanguage?: InputMaybe<Language>;
  /** Company visible name that can be different from name. */
  displayName?: InputMaybe<Scalars['String']['input']>;
  /** Whether or not Contextual Assignment via URL is enabled. */
  enableLearnerInitiatedContextualAssignment?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether or not the Learning Plan Assignment via URL is enabled. */
  enableLearnerInitiatedLearningPlanAssignment?: InputMaybe<Scalars['Boolean']['input']>;
  /** A unique url-friendly identifier. i.e. my-company-name. */
  externalId?: InputMaybe<Scalars['String']['input']>;
  /** Enabled features. */
  features?: InputMaybe<Array<CompanyFeatureInput>>;
  /** Available languages. */
  languages?: InputMaybe<Array<CompanyLanguageInput>>;
  /** Company internal name. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Whether or not the company notifications are enabled. */
  notificationsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Company program name used in communications. */
  programName?: InputMaybe<Scalars['String']['input']>;
  /** Company siblings input. */
  siblings?: InputMaybe<Array<CompanySiblingInput>>;
  /** Whether or not the company SMS communication is enabled. */
  smsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Company contact name used in communications. */
  supportContact?: InputMaybe<Scalars['String']['input']>;
  /** Company contact email used in communications. */
  supportEmail?: InputMaybe<Scalars['String']['input']>;
  /** Default timezone for the company. */
  timezone?: InputMaybe<Timezone>;
  /** External Photo URL and mime type of Company Logo. */
  uploadPhoto?: InputMaybe<UploadFileInput>;
  /** Whether or not the company whatsapp communication is enabled. */
  whatsappEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Features that can be toggled on Companies. */
export type CompanyFeature = {
  __typename?: 'CompanyFeature';
  /** The Company ID that this Feature is for. */
  companyId: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  /** The Feature that this Company has. */
  feature: Feature;
  /** The Feature ID that this Company has. */
  featureId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type CompanyFeatureInput = {
  /** The Feature ID. */
  featureId: Scalars['ID']['input'];
  /** The Company Feature ID. Leave null to create. */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Whether the Company has this Feature. */
  isEnabled: Scalars['Boolean']['input'];
};

/** Languages enabled on a given Company. */
export type CompanyLanguage = {
  __typename?: 'CompanyLanguage';
  /** Company ID. */
  companyId: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  /** Language code. */
  language: Language;
  updatedAt: Scalars['DateTime']['output'];
};

export type CompanyLanguageInput = {
  /** Company Language ID. Leave null to create. */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Language code. */
  language: Language;
};

/** One of our core objects. Attaches a Profile to a Company. While model-wise a Profile can be attached to multiple Companies, we currently assume a Profile has only one company. */
export type CompanyProfile = {
  __typename?: 'CompanyProfile';
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The Assignments this Profile has. */
  assignments?: Maybe<Array<Assignment>>;
  /** Whether or not the coach communications are enabled for the profile. Requires COACH permission. */
  coachCommsOptOut: Scalars['Boolean']['output'];
  /** The Company object. */
  company: Company;
  /** The Groups this Profile is a member of. */
  companyCohortMembers?: Maybe<Array<ProfileGroupMember>>;
  /** The Company ID this Profile is attached to. */
  companyId: Scalars['UUID']['output'];
  createdAt: Scalars['DateTime']['output'];
  /** creator id */
  createdBy: Scalars['Date']['output'];
  /** Email Address of the Profile. This is required as a Profile may have different email address accross its attached companies. */
  emailAddress?: Maybe<Scalars['String']['output']>;
  /** Whether or not the profile data such assignments and completions will be shown in analytics dashboard. */
  excludeFromAnalytics: Scalars['Boolean']['output'];
  /** An URL-friendly, memorable unique identified i.e. profile-full-name. This is required as a Profile may have different external IDs accross its attached companies. */
  externalId: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  /** Display language. */
  language?: Maybe<Language>;
  /** Whether or not the learner communications are enabled for the profile. */
  learnerCommsOptOut: Scalars['Boolean']['output'];
  /** Full international phone number with leading plus sign. e.g. +12125551234 */
  phoneNumber?: Maybe<Scalars['String']['output']>;
  /** Profile object. */
  profile: Profile;
  /**
   * An URL-friendly, memorable unique identified i.e. profile-full-name. This is required as a Profile may have different external IDs accross its attached companies.
   * @deprecated It has been replaced by "CompanyProfile.externalId".
   */
  profileExternalId: Scalars['String']['output'];
  /** The granted Roles for this Company Profile. */
  profileGrants?: Maybe<Array<ProfileGrant>>;
  /** The Profile ID. */
  profileId: Scalars['UUID']['output'];
  /** The Tags attached to this Profile. */
  profileTags?: Maybe<Array<ProfileTag>>;
  score: Scalars['Int']['output'];
  /** The date where the created profile will start using the application. */
  startDate: Scalars['Date']['output'];
  /** Default timezone for the profile. If defined it will override the company default timezone. */
  timezone?: Maybe<Timezone>;
  updatedAt: Scalars['DateTime']['output'];
  /** updator id */
  updatedBy: Scalars['Date']['output'];
};

/** One of our core objects. Attaches a Profile to a Company. While model-wise a Profile can be attached to multiple Companies, we currently assume a Profile has only one company. */
export type CompanyProfileDownload = {
  __typename?: 'CompanyProfileDownload';
  /** Url to download csv users */
  url: Scalars['String']['output'];
};

export type CompanyProfileListConditions = {
  /** Filter by creator id */
  filterByCreator?: InputMaybe<Scalars['String']['input']>;
  /** Filter by whether the Profile is active or not. */
  includeDisabled: Scalars['Boolean']['input'];
  /** Filter by profile roles. */
  roles?: InputMaybe<ProfileRoleCondition>;
  /** Search terms. Will look in display name, preferred name, email address, phone number and external ID. */
  searchTerms?: InputMaybe<StringCondition>;
};

/** Available options to sort CompanyProfile List. */
export enum CompanyProfileListOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  DisplayNameAsc = 'DISPLAY_NAME_ASC',
  DisplayNameDesc = 'DISPLAY_NAME_DESC',
  ExternalIdAsc = 'EXTERNAL_ID_ASC',
  ExternalIdDesc = 'EXTERNAL_ID_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

export type CompanyProfileListPageInfo = {
  __typename?: 'CompanyProfileListPageInfo';
  /** Pointer to the next page. When null, it means you are in the last page. */
  afterCursor?: Maybe<Scalars['String']['output']>;
  /** Pointer to the previous page. When null, it means you are in the first page. */
  beforeCursor?: Maybe<Scalars['String']['output']>;
};

export type CompanyProfileSearchConditions = {
  /** Filter profiles who belong to the given group ID(s) */
  companyCohortId?: InputMaybe<StringCondition>;
  /** Filter company profiles by ID. */
  id?: InputMaybe<StringCondition>;
  /** Filter profiles by coaching status. Set to true to fetch only coaches, false to fetch only non-coaches. */
  isCoached?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter profiles who belong to the given learning plan ID(s) */
  learningPlanId?: InputMaybe<StringCondition>;
  /** Filter profiles by granted roles */
  role?: InputMaybe<Array<Role>>;
  /** Search terms. Will look in display name, preferred name, email address, phone number and external ID. */
  searchTerms?: InputMaybe<StringCondition>;
};

export type CompanyProfileSearchPageInfo = {
  __typename?: 'CompanyProfileSearchPageInfo';
  /** Pointer to the next page. When null, it means you are in the last page. */
  afterCursor?: Maybe<Scalars['String']['output']>;
  /** Pointer to the previous page. When null, it means you are in the first page. */
  beforeCursor?: Maybe<Scalars['String']['output']>;
};

export type CompanyProfileSession = {
  __typename?: 'CompanyProfileSession';
  company: CompanySession;
  emailAddress?: Maybe<Scalars['String']['output']>;
  externalId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  language?: Maybe<Language>;
  permissions: Array<Permission>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  roles: Array<Role>;
  score: Scalars['Int']['output'];
};

export type CompanySsoInput = {
  /** IDP certificate */
  idpCertificate: Scalars['String']['input'];
  ssoAttributes: SsoAttributesInput;
};

export type CompanySearchConditions = {
  id?: InputMaybe<StringCondition>;
  /** Search terms. Will look in name or externalId. */
  searchTerms?: InputMaybe<StringCondition>;
};

export type CompanySession = {
  __typename?: 'CompanySession';
  externalId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

/** DTO for CompanySibling. Records company and its sibling information. */
export type CompanySiblingDto = {
  __typename?: 'CompanySiblingDto';
  /** The Company ID this mapping is attached to. */
  companyId: Scalars['UUID']['output'];
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['UUID']['output'];
  /** The Sibling Company this mapping is attached to. */
  siblingCompany?: Maybe<SiblingCompanyInfo>;
  /** The Sibling Company ID this mapping is attached to. */
  siblingCompanyId: Scalars['UUID']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type CompanySiblingInput = {
  /** The Company ID this mapping is attached to. Defaults to context company */
  companyId?: InputMaybe<Scalars['UUID']['input']>;
  /** The unique id for this mapping. */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** The Sibling Company ID this mapping is attached to. */
  siblingCompanyId: Scalars['UUID']['input'];
};

export type ContentMetadata = {
  __typename?: 'ContentMetadata';
  acl1?: Maybe<Array<Scalars['String']['output']>>;
  acl2?: Maybe<Array<Scalars['String']['output']>>;
  acl3?: Maybe<Array<Scalars['String']['output']>>;
  companyId?: Maybe<Scalars['String']['output']>;
  companyProfileId?: Maybe<Scalars['String']['output']>;
  masterMediaId?: Maybe<Scalars['String']['output']>;
  mediaId?: Maybe<Scalars['String']['output']>;
  path?: Maybe<Scalars['String']['output']>;
  s3Location?: Maybe<Scalars['String']['output']>;
  skillId?: Maybe<Scalars['String']['output']>;
  streamingUrl?: Maybe<Scalars['String']['output']>;
  submissionId?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

/** Scores for different aspects of the conversation content */
export type ContentScore = {
  __typename?: 'ContentScore';
  coherence: Scalars['Float']['output'];
  consistency: Scalars['Float']['output'];
  grammar: Scalars['Float']['output'];
  toneNstyle: Scalars['Float']['output'];
};

/** Metrics related to conversation analysis */
export type ConversationMetrics = {
  __typename?: 'ConversationMetrics';
  conversationType: Scalars['String']['output'];
  needsIdentificationScore: NeedsIdentificationScore;
  noOfSubmitterQuestions?: Maybe<Scalars['Int']['output']>;
  nonVerbalSkillScore: NonVerbalSkillScore;
  openEndedQuestions: Array<OpenEndedQuestion>;
  overallFeedback?: Maybe<Scalars['String']['output']>;
  qualitativeFeedback?: Maybe<QualitativeFeedback>;
  questionRate: Scalars['Float']['output'];
  speakerLabels?: Maybe<Array<SpeakerLabel>>;
  stackedQuestions: Array<StackedQuestion>;
  thresholds: ConversationMetricsThresholds;
};

export type ConversationMetricsThresholds = {
  __typename?: 'ConversationMetricsThresholds';
  noOfSubmitterQuestions: Scalars['Float']['output'];
  pauseDuration: Array<Scalars['Float']['output']>;
  questionRate: Scalars['Float']['output'];
  stackedQuestionsCount: Scalars['Int']['output'];
  talkRatio: Scalars['Float']['output'];
};

/** Conversation roles */
export type ConversationRoles = {
  __typename?: 'ConversationRoles';
  audience: Scalars['String']['output'];
  submitter: Scalars['String']['output'];
};

/** Conversation roles */
export type ConversationRolesInput = {
  audience: Scalars['String']['input'];
  submitter: Scalars['String']['input'];
};

/** ConversationType options */
export enum ConversationType {
  DiscoveryCall = 'DISCOVERY_CALL',
  Roleplay = 'ROLEPLAY'
}

/** Available country codes. */
export enum CountryCode {
  Afghanistan = 'AFGHANISTAN',
  AlandIslands = 'ALAND_ISLANDS',
  Albania = 'ALBANIA',
  Algeria = 'ALGERIA',
  AmericanSamoa = 'AMERICAN_SAMOA',
  Andorra = 'ANDORRA',
  Angola = 'ANGOLA',
  Anguilla = 'ANGUILLA',
  AntiguaAndBarbuda = 'ANTIGUA_AND_BARBUDA',
  Argentina = 'ARGENTINA',
  Armenia = 'ARMENIA',
  Aruba = 'ARUBA',
  AscensionIsland = 'ASCENSION_ISLAND',
  Australia = 'AUSTRALIA',
  Austria = 'AUSTRIA',
  Azerbaijan = 'AZERBAIJAN',
  Bahamas = 'BAHAMAS',
  Bahrain = 'BAHRAIN',
  Bangladesh = 'BANGLADESH',
  Barbados = 'BARBADOS',
  Belarus = 'BELARUS',
  Belgium = 'BELGIUM',
  Belize = 'BELIZE',
  Benin = 'BENIN',
  Bermuda = 'BERMUDA',
  Bhutan = 'BHUTAN',
  Bolivia = 'BOLIVIA',
  BosniaAndHerzegovina = 'BOSNIA_AND_HERZEGOVINA',
  Botswana = 'BOTSWANA',
  Brazil = 'BRAZIL',
  BritishIndianOceanTerritory = 'BRITISH_INDIAN_OCEAN_TERRITORY',
  BritishVirginIslands = 'BRITISH_VIRGIN_ISLANDS',
  Brunei = 'BRUNEI',
  Bulgaria = 'BULGARIA',
  BurkinaFaso = 'BURKINA_FASO',
  Burundi = 'BURUNDI',
  Cambodia = 'CAMBODIA',
  Cameroon = 'CAMEROON',
  Canada = 'CANADA',
  CapeVerde = 'CAPE_VERDE',
  CaribbeanNetherlands = 'CARIBBEAN_NETHERLANDS',
  CaymanIslands = 'CAYMAN_ISLANDS',
  CentralAfricanRepublic = 'CENTRAL_AFRICAN_REPUBLIC',
  Chad = 'CHAD',
  Chile = 'CHILE',
  China = 'CHINA',
  ChristmasIsland = 'CHRISTMAS_ISLAND',
  CocosKeelingIslands = 'COCOS_KEELING_ISLANDS',
  Colombia = 'COLOMBIA',
  Comoros = 'COMOROS',
  CookIslands = 'COOK_ISLANDS',
  CostaRica = 'COSTA_RICA',
  CoteDivoire = 'COTE_DIVOIRE',
  Croatia = 'CROATIA',
  Cuba = 'CUBA',
  Curacao = 'CURACAO',
  Cyprus = 'CYPRUS',
  CzechRepublic = 'CZECH_REPUBLIC',
  DemocraticRepublicCongo = 'DEMOCRATIC_REPUBLIC_CONGO',
  Denmark = 'DENMARK',
  Djibouti = 'DJIBOUTI',
  Dominica = 'DOMINICA',
  DominicanRepublic = 'DOMINICAN_REPUBLIC',
  EastTimor = 'EAST_TIMOR',
  Ecuador = 'ECUADOR',
  Egypt = 'EGYPT',
  ElSalvador = 'EL_SALVADOR',
  EquatorialGuinea = 'EQUATORIAL_GUINEA',
  Eritrea = 'ERITREA',
  Estonia = 'ESTONIA',
  Ethiopia = 'ETHIOPIA',
  FalklandIslandsIslasMalvinas = 'FALKLAND_ISLANDS_ISLAS_MALVINAS',
  FaroeIslands = 'FAROE_ISLANDS',
  Fiji = 'FIJI',
  Finland = 'FINLAND',
  France = 'FRANCE',
  FrenchGuiana = 'FRENCH_GUIANA',
  FrenchPolynesia = 'FRENCH_POLYNESIA',
  Gabon = 'GABON',
  Gambia = 'GAMBIA',
  Georgia = 'GEORGIA',
  Germany = 'GERMANY',
  Ghana = 'GHANA',
  Gibraltar = 'GIBRALTAR',
  Greece = 'GREECE',
  Greenland = 'GREENLAND',
  Grenada = 'GRENADA',
  Guadeloupe = 'GUADELOUPE',
  Guam = 'GUAM',
  Guatemala = 'GUATEMALA',
  Guernsey = 'GUERNSEY',
  GuineaBissau = 'GUINEA_BISSAU',
  GuineaConakry = 'GUINEA_CONAKRY',
  Guyana = 'GUYANA',
  Haiti = 'HAITI',
  HeardIslandAndMcdonaldIslands = 'HEARD_ISLAND_AND_MCDONALD_ISLANDS',
  Honduras = 'HONDURAS',
  HongKong = 'HONG_KONG',
  Hungary = 'HUNGARY',
  Iceland = 'ICELAND',
  India = 'INDIA',
  Indonesia = 'INDONESIA',
  Iran = 'IRAN',
  Iraq = 'IRAQ',
  Ireland = 'IRELAND',
  IsleOfMan = 'ISLE_OF_MAN',
  Israel = 'ISRAEL',
  Italy = 'ITALY',
  Jamaica = 'JAMAICA',
  Japan = 'JAPAN',
  Jersey = 'JERSEY',
  Jordan = 'JORDAN',
  Kazakhstan = 'KAZAKHSTAN',
  Kenya = 'KENYA',
  Kiribati = 'KIRIBATI',
  Kuwait = 'KUWAIT',
  Kyrgyzstan = 'KYRGYZSTAN',
  Laos = 'LAOS',
  Latvia = 'LATVIA',
  Lebanon = 'LEBANON',
  Lesotho = 'LESOTHO',
  Liberia = 'LIBERIA',
  Libya = 'LIBYA',
  Liechtenstein = 'LIECHTENSTEIN',
  Lithuania = 'LITHUANIA',
  Luxembourg = 'LUXEMBOURG',
  Macau = 'MACAU',
  Macedonia = 'MACEDONIA',
  Madagascar = 'MADAGASCAR',
  Malawi = 'MALAWI',
  Malaysia = 'MALAYSIA',
  Maldives = 'MALDIVES',
  Mali = 'MALI',
  Malta = 'MALTA',
  MarshallIslands = 'MARSHALL_ISLANDS',
  Martinique = 'MARTINIQUE',
  Mauritania = 'MAURITANIA',
  Mauritius = 'MAURITIUS',
  Mayotte = 'MAYOTTE',
  Mexico = 'MEXICO',
  Micronesia = 'MICRONESIA',
  Moldova = 'MOLDOVA',
  Monaco = 'MONACO',
  Mongolia = 'MONGOLIA',
  Montenegro = 'MONTENEGRO',
  Montserrat = 'MONTSERRAT',
  Morocco = 'MOROCCO',
  Mozambique = 'MOZAMBIQUE',
  MyanmarBurma = 'MYANMAR_BURMA',
  Namibia = 'NAMIBIA',
  Nauru = 'NAURU',
  Nepal = 'NEPAL',
  Netherlands = 'NETHERLANDS',
  NewCaledonia = 'NEW_CALEDONIA',
  NewZealand = 'NEW_ZEALAND',
  Nicaragua = 'NICARAGUA',
  Niger = 'NIGER',
  Nigeria = 'NIGERIA',
  Niue = 'NIUE',
  NorfolkIsland = 'NORFOLK_ISLAND',
  NorthernMarianaIslands = 'NORTHERN_MARIANA_ISLANDS',
  NorthKorea = 'NORTH_KOREA',
  Norway = 'NORWAY',
  Oman = 'OMAN',
  Pakistan = 'PAKISTAN',
  Palau = 'PALAU',
  PalestinianTerritories = 'PALESTINIAN_TERRITORIES',
  Panama = 'PANAMA',
  PapuaNewGuinea = 'PAPUA_NEW_GUINEA',
  Paraguay = 'PARAGUAY',
  Peru = 'PERU',
  Philippines = 'PHILIPPINES',
  Poland = 'POLAND',
  Portugal = 'PORTUGAL',
  PuertoRico = 'PUERTO_RICO',
  Qatar = 'QATAR',
  RepublicOfCongo = 'REPUBLIC_OF_CONGO',
  Reunion = 'REUNION',
  Romania = 'ROMANIA',
  Russia = 'RUSSIA',
  Rwanda = 'RWANDA',
  SaintBarthelemy = 'SAINT_BARTHELEMY',
  SaintHelena = 'SAINT_HELENA',
  SaintMartin = 'SAINT_MARTIN',
  SaintPierreAndMiquelon = 'SAINT_PIERRE_AND_MIQUELON',
  Samoa = 'SAMOA',
  SanMarino = 'SAN_MARINO',
  SaoTomeAndPrincipe = 'SAO_TOME_AND_PRINCIPE',
  SaudiArabia = 'SAUDI_ARABIA',
  Senegal = 'SENEGAL',
  Serbia = 'SERBIA',
  Seychelles = 'SEYCHELLES',
  SierraLeone = 'SIERRA_LEONE',
  Singapore = 'SINGAPORE',
  SintMaarten = 'SINT_MAARTEN',
  Slovakia = 'SLOVAKIA',
  Slovenia = 'SLOVENIA',
  SolomonIslands = 'SOLOMON_ISLANDS',
  Somalia = 'SOMALIA',
  SouthAfrica = 'SOUTH_AFRICA',
  SouthGeorgiaAndTheSouthSandwichIslands = 'SOUTH_GEORGIA_AND_THE_SOUTH_SANDWICH_ISLANDS',
  SouthKorea = 'SOUTH_KOREA',
  SouthSudan = 'SOUTH_SUDAN',
  Spain = 'SPAIN',
  SriLanka = 'SRI_LANKA',
  StKitts = 'ST_KITTS',
  StLucia = 'ST_LUCIA',
  StVincent = 'ST_VINCENT',
  Sudan = 'SUDAN',
  Suriname = 'SURINAME',
  SvalbardAndJanMayen = 'SVALBARD_AND_JAN_MAYEN',
  Swaziland = 'SWAZILAND',
  Sweden = 'SWEDEN',
  Switzerland = 'SWITZERLAND',
  Syria = 'SYRIA',
  Taiwan = 'TAIWAN',
  Tajikistan = 'TAJIKISTAN',
  Tanzania = 'TANZANIA',
  Thailand = 'THAILAND',
  Togo = 'TOGO',
  Tokelau = 'TOKELAU',
  Tonga = 'TONGA',
  TrinidadTobago = 'TRINIDAD_TOBAGO',
  Tunisia = 'TUNISIA',
  Turkey = 'TURKEY',
  Turkmenistan = 'TURKMENISTAN',
  TurksAndCaicosIslands = 'TURKS_AND_CAICOS_ISLANDS',
  Tuvalu = 'TUVALU',
  Uganda = 'UGANDA',
  Ukraine = 'UKRAINE',
  UnitedArabEmirates = 'UNITED_ARAB_EMIRATES',
  UnitedKingdom = 'UNITED_KINGDOM',
  UnitedStates = 'UNITED_STATES',
  Uruguay = 'URUGUAY',
  UsVirginIslands = 'US_VIRGIN_ISLANDS',
  Uzbekistan = 'UZBEKISTAN',
  Vanuatu = 'VANUATU',
  VaticanCity = 'VATICAN_CITY',
  Venezuela = 'VENEZUELA',
  Vietnam = 'VIETNAM',
  WallisAndFutuna = 'WALLIS_AND_FUTUNA',
  WesternSahara = 'WESTERN_SAHARA',
  Yemen = 'YEMEN',
  Zambia = 'ZAMBIA',
  Zimbabwe = 'ZIMBABWE'
}

export type CustomVocabulary = {
  __typename?: 'CustomVocabulary';
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  companyId: Scalars['UUID']['output'];
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  externalId: Scalars['String']['output'];
  id?: Maybe<Scalars['UUID']['output']>;
  language: DialectTypes;
  name: Scalars['String']['output'];
  status?: Maybe<CustomVocabularyStatuses>;
  updatedAt: Scalars['DateTime']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export type CustomVocabularyKeyword = {
  __typename?: 'CustomVocabularyKeyword';
  companyId: Scalars['UUID']['output'];
  displayAs?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  ipa?: Maybe<Scalars['String']['output']>;
  phrase: Scalars['String']['output'];
  soundsLike?: Maybe<Scalars['String']['output']>;
  vocabularyId: Scalars['UUID']['output'];
};

export type CustomVocabularyKeywordListConditions = {
  /** Search terms. Will look in name, externalId or description. */
  searchTerms?: InputMaybe<StringCondition>;
};

/** Sort Custom Vocabulary Keyword by */
export enum CustomVocabularyKeywordListOrderBy {
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC'
}

export type CustomVocabularyKeywordPageInfo = {
  __typename?: 'CustomVocabularyKeywordPageInfo';
  /** Pointer to the next page. When null, it means you are in the last page. */
  afterCursor?: Maybe<Scalars['String']['output']>;
  /** Pointer to the previous page. When null, it means you are in the first page. */
  beforeCursor?: Maybe<Scalars['String']['output']>;
};

export type CustomVocabularyListConditions = {
  /** Filter by whether the Profile is active or not. */
  includeDisabled: Scalars['Boolean']['input'];
  /** Search terms. Will look in name, externalId or description. */
  searchTerms?: InputMaybe<StringCondition>;
  /** Serch term to check by status of custom vocab */
  status?: InputMaybe<CustomVocabularyStatuses>;
};

/** Sort Custom Vocabulary by */
export enum CustomVocabularyListOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  ExternalIdAsc = 'EXTERNAL_ID_ASC',
  ExternalIdDesc = 'EXTERNAL_ID_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

export type CustomVocabularyPageInfo = {
  __typename?: 'CustomVocabularyPageInfo';
  /** Pointer to the next page. When null, it means you are in the last page. */
  afterCursor?: Maybe<Scalars['String']['output']>;
  /** Pointer to the previous page. When null, it means you are in the first page. */
  beforeCursor?: Maybe<Scalars['String']['output']>;
};

/** Statuses of the custom vocabulary processing */
export enum CustomVocabularyStatuses {
  Failed = 'FAILED',
  Pending = 'PENDING',
  Success = 'SUCCESS'
}

/** Start custom vocabulary sync */
export type CustomVocabularySync = {
  __typename?: 'CustomVocabularySync';
  success: Scalars['Boolean']['output'];
};

export type DateTimeCondition = {
  equals?: InputMaybe<Scalars['DateTime']['input']>;
  iLike?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['DateTime']['input']>;
  notEqualsTo?: InputMaybe<Scalars['DateTime']['input']>;
  notIn?: InputMaybe<Array<Scalars['DateTime']['input']>>;
};

export type DefaultChoiceLocalizationInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  mediaId?: InputMaybe<Scalars['String']['input']>;
};

export type DefaultFileLocalizationInput = {
  id?: InputMaybe<Scalars['UUID']['input']>;
  mediaId: Scalars['UUID']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type DefaultFlashCardLocalizationInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  photoUrl?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type DefaultFormLocalizationInput = {
  description: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
};

export type DefaultLinkoutLocalizationInput = {
  ctaTitle?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type DefaultPromptLocalizationInput = {
  description: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
};

export type DefaultVideoLocalizationInput = {
  id?: InputMaybe<Scalars['UUID']['input']>;
  masterMediaId: Scalars['UUID']['input'];
  textTrackMediaId?: InputMaybe<Scalars['UUID']['input']>;
  title: Scalars['String']['input'];
};

export type DepartmentInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

/** Available dialects for custom vocabularies */
export enum DialectTypes {
  AbGe = 'AbGE',
  AfZa = 'AfZA',
  ArAe = 'ArAE',
  ArSa = 'ArSA',
  AstEs = 'AstES',
  AzAz = 'AzAZ',
  BaRu = 'BaRU',
  BeBy = 'BeBY',
  BgBg = 'BgBG',
  BnIn = 'BnIN',
  BsBa = 'BsBA',
  CaEs = 'CaES',
  CkbIq = 'CkbIQ',
  CkbIr = 'CkbIR',
  CsCz = 'CsCZ',
  CyWl = 'CyWL',
  DaDk = 'DaDK',
  DeCh = 'DeCH',
  DeDe = 'DeDE',
  ElGr = 'ElGR',
  EnAb = 'EnAB',
  EnAu = 'EnAU',
  EnGb = 'EnGB',
  EnIe = 'EnIE',
  EnIn = 'EnIN',
  EnNz = 'EnNZ',
  EnUs = 'EnUS',
  EnWl = 'EnWL',
  EnZa = 'EnZA',
  EsEs = 'EsES',
  EsUs = 'EsUS',
  EtEt = 'EtET',
  EuEs = 'EuES',
  FaIr = 'FaIR',
  FiFi = 'FiFI',
  FrCa = 'FrCA',
  FrFr = 'FrFR',
  GlEs = 'GlES',
  GuIn = 'GuIN',
  HaNg = 'HaNG',
  HeIl = 'HeIL',
  HiIn = 'HiIN',
  HrHr = 'HrHR',
  HuHu = 'HuHU',
  HyAm = 'HyAM',
  IdId = 'IdID',
  IsIs = 'IsIS',
  ItIt = 'ItIT',
  JaJp = 'JaJP',
  KaGe = 'KaGE',
  KabDz = 'KabDZ',
  KkKz = 'KkKZ',
  KnIn = 'KnIN',
  KoKr = 'KoKR',
  KyKg = 'KyKG',
  LgIn = 'LgIN',
  LtLt = 'LtLT',
  LvLv = 'LvLV',
  MhrRu = 'MhrRU',
  MiNz = 'MiNZ',
  MkMk = 'MkMK',
  MlIn = 'MlIN',
  MnMn = 'MnMN',
  MrIn = 'MrIN',
  MsMy = 'MsMY',
  MtMt = 'MtMT',
  NlNl = 'NlNL',
  NoNo = 'NoNO',
  OrIn = 'OrIN',
  PaIn = 'PaIN',
  PlPl = 'PlPL',
  PsAf = 'PsAF',
  PtBr = 'PtBR',
  PtPt = 'PtPT',
  RoRo = 'RoRO',
  RuRu = 'RuRU',
  RwRw = 'RwRW',
  SiLk = 'SiLK',
  SkSk = 'SkSK',
  SlSi = 'SlSI',
  SoSo = 'SoSO',
  SrRs = 'SrRS',
  SuId = 'SuID',
  SvSe = 'SvSE',
  SwBi = 'SwBI',
  SwKe = 'SwKE',
  SwRw = 'SwRW',
  SwTz = 'SwTZ',
  SwUg = 'SwUG',
  TaIn = 'TaIN',
  TeIn = 'TeIN',
  ThTh = 'ThTH',
  TlPh = 'TlPH',
  TrTr = 'TrTR',
  TtRu = 'TtRU',
  UgCn = 'UgCN',
  UkUa = 'UkUA',
  UzUz = 'UzUZ',
  ViVn = 'ViVN',
  WoSn = 'WoSN',
  ZhCn = 'ZhCN',
  ZhTw = 'ZhTW',
  ZuZa = 'ZuZA'
}

/** Represents a domain of a topic and its parent domains */
export type Domain = {
  __typename?: 'Domain';
  /** name of the topic domain identified */
  domain: Scalars['String']['output'];
  parentDomains: Array<ParentDomain>;
};

export type EvidenceItem = {
  __typename?: 'EvidenceItem';
  content?: Maybe<Scalars['String']['output']>;
  label: Scalars['String']['output'];
  timestampEnd?: Maybe<Scalars['String']['output']>;
  timestampStart?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export type Feature = {
  __typename?: 'Feature';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  name: FeatureType;
  setting: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

/** Feature flags */
export enum FeatureType {
  AnonymousUsers = 'ANONYMOUS_USERS',
  DashboardSkillsWithReps = 'DASHBOARD_SKILLS_WITH_REPS',
  DisableSkillToSkillAutoplay = 'DISABLE_SKILL_TO_SKILL_AUTOPLAY',
  Forms = 'FORMS',
  KeywordAnalysisOnPractices = 'KEYWORD_ANALYSIS_ON_PRACTICES',
  MediaCaptureTestPage = 'MEDIA_CAPTURE_TEST_PAGE',
  RepSkill = 'REP_SKILL',
  SalesDemoCompany = 'SALES_DEMO_COMPANY',
  SkillSelfies = 'SKILL_SELFIES',
  SkillVideoS3Mux = 'SKILL_VIDEO_S3_MUX',
  TranscribeContent = 'TRANSCRIBE_CONTENT',
  VideoAutoPlay = 'VIDEO_AUTO_PLAY',
  WupAutoplay = 'WUP_AUTOPLAY'
}

/** Column / field to apply the date range filter */
export enum FilterOn {
  CompletionDate = 'COMPLETION_DATE',
  StartDate = 'START_DATE'
}

/** Feature flag. */
export type Flag = {
  __typename?: 'Flag';
  /** Flag name, always lowercase. */
  name: Scalars['String']['output'];
  /** Flag value type. Possible values: boolean, string, number, array, object. */
  type: Scalars['String']['output'];
  /** Flag value. Numbers, booleans, and JSON are coerced into strings. Disabled flags or false booleans are not returned. */
  value: Scalars['String']['output'];
};

/** Available input types for partOfFolder */
export enum FolderStatus {
  All = 'ALL',
  InFolder = 'IN_FOLDER',
  NotInFolder = 'NOT_IN_FOLDER'
}

/** Form. */
export type Form = {
  __typename?: 'Form';
  id: Scalars['UUID']['output'];
  localizations: FormLocalizedConnection;
  /** Maximum total number of form attempts. */
  maxTries?: Maybe<Scalars['Int']['output']>;
  /** Maximum number of form attempts per prompt. */
  maxTriesPerPrompt?: Maybe<MaxTriesPerPrompt>;
  name: Scalars['String']['output'];
  /** Number of prompts to show from the question bank. If not set, all prompts will be shown. */
  numPromptsShow?: Maybe<Scalars['Int']['output']>;
  /** Percentage of correctly-answered prompts required to pass the form (0-1). */
  passingThreshold?: Maybe<Scalars['Float']['output']>;
  prompts: PromptConnection;
  /** Whether to randomize prompts order for each attempt. */
  randomizePrompts: Scalars['Boolean']['output'];
  title?: Maybe<Scalars['String']['output']>;
  type: FormType;
};

export type FormInput = {
  defaultLocalization: DefaultFormLocalizationInput;
  id?: InputMaybe<Scalars['String']['input']>;
  /** Maximum total number of form attempts. */
  maxTries?: InputMaybe<Scalars['Int']['input']>;
  /** Maximum number of form attempts per prompt. */
  maxTriesPerPrompt?: InputMaybe<MaxTriesPerPrompt>;
  name: Scalars['String']['input'];
  /** Number of prompts to show from the question bank. If not set, all prompts will be shown. */
  numPromptsShow?: InputMaybe<Scalars['Int']['input']>;
  /** Percentage of correctly-answered prompts required to pass the form (0-1). */
  passingThreshold?: InputMaybe<Scalars['Float']['input']>;
  prompts: Array<PromptInput>;
  /** Whether to randomize prompts order for each attempt. */
  randomizePrompts?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type: FormType;
};

/** Form localization. */
export type FormLocalized = {
  __typename?: 'FormLocalized';
  description: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  language: Language;
};

export type FormLocalizedConnection = {
  __typename?: 'FormLocalizedConnection';
  nodes: Array<FormLocalized>;
};

/** Form type. */
export enum FormType {
  Quiz = 'QUIZ',
  Rubric = 'RUBRIC',
  Survey = 'SURVEY'
}

export type FunctionPageInfo = {
  __typename?: 'FunctionPageInfo';
  /** Pointer to the next page. When null, it means you are in the last page. */
  afterCursor?: Maybe<Scalars['String']['output']>;
  /** Pointer to the previous page. When null, it means you are in the first page. */
  beforeCursor?: Maybe<Scalars['String']['output']>;
};

/** probably matched keywords */
export type FuzzyMatch = {
  __typename?: 'FuzzyMatch';
  actualKeyword?: Maybe<Scalars['String']['output']>;
  expectedKeyword?: Maybe<Scalars['String']['output']>;
  fuzzyIndex?: Maybe<Scalars['Float']['output']>;
};

export type GetTranscriptionMediaObjectById = {
  __typename?: 'GetTranscriptionMediaObjectById';
  awsOutcome?: Maybe<AwsOutcome>;
  contentMetadata?: Maybe<ContentMetadata>;
  provider?: Maybe<Scalars['String']['output']>;
  schemaVersion?: Maybe<Scalars['String']['output']>;
};

export type GetWordCloudMediaObjectById = {
  __typename?: 'GetWordCloudMediaObjectById';
  schemaVersion: Scalars['String']['output'];
  words?: Maybe<Array<WordInfo>>;
};

/** Input Type used to sync Learning Plan with a Company Cohort */
export type GroupInput = {
  id: Scalars['String']['input'];
  membersActive?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GroupsDataIdsArg = {
  groupsIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  targetCompanyIds: Scalars['UUID']['input'];
};

/** Image Size options. */
export enum ImageSize {
  L = 'L',
  M = 'M',
  Original = 'ORIGINAL',
  S = 'S'
}

export type InsertCustomPersonaInput = {
  bio: Scalars['String']['input'];
  communicationStyle?: InputMaybe<Scalars['String']['input']>;
  cooperation?: InputMaybe<Scalars['String']['input']>;
  designation: Scalars['String']['input'];
  difficulty?: InputMaybe<Scalars['String']['input']>;
  goal: Scalars['String']['input'];
  industry: Scalars['String']['input'];
  name: Scalars['String']['input'];
  patience?: InputMaybe<Scalars['String']['input']>;
  scenario: Scalars['String']['input'];
  skepticism?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  traits?: InputMaybe<Scalars['String']['input']>;
  whatGoodLooksLike: Array<Scalars['String']['input']>;
};

/** probably matched description */
export type Interjection = {
  __typename?: 'Interjection';
  author?: Maybe<Scalars['String']['output']>;
  duration?: Maybe<Scalars['String']['output']>;
  index?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Array<InterjectionMessage>>;
  start?: Maybe<Scalars['String']['output']>;
};

export type InterjectionInput = {
  author?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<Scalars['String']['input']>;
  index?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Array<InterjectionMessageInput>>;
  start?: InputMaybe<Scalars['String']['input']>;
};

export type InterjectionMessage = {
  __typename?: 'InterjectionMessage';
  language: Language;
  translatedText?: Maybe<Scalars['String']['output']>;
};

export type InterjectionMessageInput = {
  language: Language;
  translatedText?: InputMaybe<Scalars['String']['input']>;
};

/** matched keywords */
export type KeywordsMatch = {
  __typename?: 'KeywordsMatch';
  actualKeyword?: Maybe<Scalars['String']['output']>;
  expectedKeyword?: Maybe<Scalars['String']['output']>;
};

export type LpSectionSkill = {
  __typename?: 'LPSectionSkill';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  points: Scalars['Int']['output'];
  position: Scalars['Int']['output'];
  skill: Skill;
  skillId: Scalars['String']['output'];
};

/** Input Type used to sync LP Section Skills with LP Section. */
export type LpSectionSkillInput = {
  id?: InputMaybe<Scalars['UUID']['input']>;
  /** Points given by completing this Skill. */
  points: Scalars['Float']['input'];
  /** The Skill to attach to the Learning Plan. */
  skillId: Scalars['UUID']['input'];
};

/** Language options */
export enum Language {
  Aa = 'aa',
  Ab = 'ab',
  Ae = 'ae',
  Af = 'af',
  Ak = 'ak',
  Am = 'am',
  An = 'an',
  Ar = 'ar',
  As = 'as',
  Av = 'av',
  Ay = 'ay',
  Az = 'az',
  Ba = 'ba',
  Be = 'be',
  Bg = 'bg',
  Bh = 'bh',
  Bi = 'bi',
  Bm = 'bm',
  Bn = 'bn',
  BnBd = 'bn_BD',
  Bo = 'bo',
  Br = 'br',
  Bs = 'bs',
  Ca = 'ca',
  Ce = 'ce',
  Ch = 'ch',
  Co = 'co',
  Cr = 'cr',
  Cs = 'cs',
  Cu = 'cu',
  Cv = 'cv',
  Cy = 'cy',
  Da = 'da',
  De = 'de',
  Dv = 'dv',
  Dz = 'dz',
  Ee = 'ee',
  El = 'el',
  En = 'en',
  Eo = 'eo',
  Es = 'es',
  Et = 'et',
  Eu = 'eu',
  Fa = 'fa',
  Ff = 'ff',
  Fi = 'fi',
  Fil = 'fil',
  Fj = 'fj',
  Fo = 'fo',
  Fr = 'fr',
  Fy = 'fy',
  Ga = 'ga',
  Gd = 'gd',
  Gl = 'gl',
  Gn = 'gn',
  Gu = 'gu',
  Gv = 'gv',
  Ha = 'ha',
  He = 'he',
  Hi = 'hi',
  Ho = 'ho',
  Hr = 'hr',
  Ht = 'ht',
  Hu = 'hu',
  Hy = 'hy',
  Hz = 'hz',
  Ia = 'ia',
  Id = 'id',
  Ie = 'ie',
  Ig = 'ig',
  Ii = 'ii',
  Ik = 'ik',
  Io = 'io',
  Is = 'is',
  It = 'it',
  Iu = 'iu',
  Ja = 'ja',
  Jv = 'jv',
  Ka = 'ka',
  Kg = 'kg',
  Ki = 'ki',
  Kj = 'kj',
  Kk = 'kk',
  Kl = 'kl',
  Km = 'km',
  Kn = 'kn',
  Ko = 'ko',
  Kr = 'kr',
  Ks = 'ks',
  Ku = 'ku',
  Kv = 'kv',
  Kw = 'kw',
  Ky = 'ky',
  La = 'la',
  Lb = 'lb',
  Lg = 'lg',
  Li = 'li',
  Ln = 'ln',
  Lo = 'lo',
  Lt = 'lt',
  Lu = 'lu',
  Lv = 'lv',
  Mg = 'mg',
  Mh = 'mh',
  Mi = 'mi',
  Mk = 'mk',
  Ml = 'ml',
  Mn = 'mn',
  Mr = 'mr',
  Ms = 'ms',
  Mt = 'mt',
  Na = 'na',
  Nb = 'nb',
  Nd = 'nd',
  Ne = 'ne',
  Ng = 'ng',
  Nl = 'nl',
  Nn = 'nn',
  No = 'no',
  Nr = 'nr',
  Nv = 'nv',
  Ny = 'ny',
  Oc = 'oc',
  Oj = 'oj',
  Om = 'om',
  Or = 'or',
  Os = 'os',
  Pa = 'pa',
  Pi = 'pi',
  Pl = 'pl',
  Ps = 'ps',
  Pt = 'pt',
  PtBr = 'pt_BR',
  Qu = 'qu',
  Rm = 'rm',
  Rn = 'rn',
  Ro = 'ro',
  Ru = 'ru',
  Rw = 'rw',
  Sa = 'sa',
  Sc = 'sc',
  Sd = 'sd',
  Se = 'se',
  Sg = 'sg',
  Si = 'si',
  Sk = 'sk',
  Sl = 'sl',
  Sm = 'sm',
  Sn = 'sn',
  So = 'so',
  Sq = 'sq',
  Sr = 'sr',
  Ss = 'ss',
  St = 'st',
  Su = 'su',
  Sv = 'sv',
  Sw = 'sw',
  Ta = 'ta',
  Te = 'te',
  Tg = 'tg',
  Th = 'th',
  Ti = 'ti',
  Tk = 'tk',
  Tn = 'tn',
  To = 'to',
  Tr = 'tr',
  Ts = 'ts',
  Tt = 'tt',
  Tw = 'tw',
  Ty = 'ty',
  Ug = 'ug',
  Uk = 'uk',
  Ur = 'ur',
  Uz = 'uz',
  Ve = 've',
  ViVn = 'vi_VN',
  Vo = 'vo',
  Wa = 'wa',
  Wo = 'wo',
  Xh = 'xh',
  Yi = 'yi',
  Yo = 'yo',
  Za = 'za',
  Zh = 'zh',
  ZhCn = 'zh_CN',
  ZhHk = 'zh_HK',
  ZhTw = 'zh_TW',
  Zu = 'zu'
}

/** Input Type used to attach or remove a Profile to a Learning Plan */
export type LearnerInput = {
  /** Whether to attach or remove the Profile from the Learning Plan. */
  active: Scalars['Boolean']['input'];
  /** Profile external ID. */
  profileExternalId: Scalars['String']['input'];
};

/** Skill learning card. */
export type LearningCard = LearningCardFile | LearningCardFlashCard | LearningCardForm | LearningCardLinkout | LearningCardVideo;

export type LearningCardConnection = {
  __typename?: 'LearningCardConnection';
  nodes: Array<LearningCard>;
};

/** Skill file */
export type LearningCardFile = {
  __typename?: 'LearningCardFile';
  experimentConfig?: Maybe<Scalars['JSONObject']['output']>;
  id: Scalars['UUID']['output'];
  localizations: LearningCardLocalizedFileConnection;
  position: Scalars['Int']['output'];
  resetLpIfFail: Scalars['Boolean']['output'];
  type: LearningCardType;
};

export type LearningCardFileInput = {
  defaultLocalization: DefaultFileLocalizationInput;
  experimentConfig?: InputMaybe<Scalars['JSONObject']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  position: Scalars['Int']['input'];
  /** If true the learning plan will be reset once the skill if marked as failed. */
  resetLpIfFail?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Skill flash card. */
export type LearningCardFlashCard = {
  __typename?: 'LearningCardFlashCard';
  experimentConfig?: Maybe<Scalars['JSONObject']['output']>;
  id: Scalars['UUID']['output'];
  localizations: LearningCardLocalizedFlashCardConnection;
  position: Scalars['Int']['output'];
  resetLpIfFail: Scalars['Boolean']['output'];
  type: LearningCardType;
};

export type LearningCardFlashCardInput = {
  defaultLocalization: DefaultFlashCardLocalizationInput;
  experimentConfig?: InputMaybe<Scalars['JSONObject']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  position: Scalars['Int']['input'];
  /** If true the learning plan will be reset once the skill if marked as failed. */
  resetLpIfFail?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Skill form. */
export type LearningCardForm = {
  __typename?: 'LearningCardForm';
  experimentConfig?: Maybe<Scalars['JSONObject']['output']>;
  form: Form;
  id: Scalars['UUID']['output'];
  position: Scalars['Int']['output'];
  resetLpIfFail: Scalars['Boolean']['output'];
  type: LearningCardType;
};

export type LearningCardFormInput = {
  experimentConfig?: InputMaybe<Scalars['JSONObject']['input']>;
  form: FormInput;
  id?: InputMaybe<Scalars['String']['input']>;
  position: Scalars['Int']['input'];
  /** If true the learning plan will be reset once the skill if marked as failed. */
  resetLpIfFail: Scalars['Boolean']['input'];
};

/** Skill linkout. */
export type LearningCardLinkout = {
  __typename?: 'LearningCardLinkout';
  experimentConfig?: Maybe<Scalars['JSONObject']['output']>;
  id: Scalars['UUID']['output'];
  localizations: LearningCardLocalizedLinkoutConnection;
  position: Scalars['Int']['output'];
  resetLpIfFail: Scalars['Boolean']['output'];
  type: LearningCardType;
};

export type LearningCardLinkoutInput = {
  defaultLocalization: DefaultLinkoutLocalizationInput;
  experimentConfig?: InputMaybe<Scalars['JSONObject']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  position: Scalars['Int']['input'];
  /** If true the learning plan will be reset once the skill if marked as failed. */
  resetLpIfFail?: InputMaybe<Scalars['Boolean']['input']>;
};

export type LearningCardLocalizedFile = {
  __typename?: 'LearningCardLocalizedFile';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  language: Language;
  media: Media;
  mediaId: Scalars['UUID']['output'];
  /** @deprecated moved to media table */
  mimetype: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type LearningCardLocalizedFileConnection = {
  __typename?: 'LearningCardLocalizedFileConnection';
  nodes: Array<LearningCardLocalizedFile>;
};

export type LearningCardLocalizedFlashCard = {
  __typename?: 'LearningCardLocalizedFlashCard';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  language: Language;
  media?: Maybe<Media>;
  mediaId?: Maybe<Scalars['UUID']['output']>;
  photoUrl?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type LearningCardLocalizedFlashCardConnection = {
  __typename?: 'LearningCardLocalizedFlashCardConnection';
  nodes: Array<LearningCardLocalizedFlashCard>;
};

export type LearningCardLocalizedLinkout = {
  __typename?: 'LearningCardLocalizedLinkout';
  ctaTitle?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  language: Language;
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type LearningCardLocalizedLinkoutConnection = {
  __typename?: 'LearningCardLocalizedLinkoutConnection';
  nodes: Array<LearningCardLocalizedLinkout>;
};

export type LearningCardLocalizedVideo = {
  __typename?: 'LearningCardLocalizedVideo';
  id: Scalars['UUID']['output'];
  language: Language;
  masterMedia?: Maybe<Media>;
  masterMediaId?: Maybe<Scalars['UUID']['output']>;
  /** @deprecated Use streamMedia instead */
  media?: Maybe<Media>;
  /** @deprecated Use streamMediaId instead */
  mediaId?: Maybe<Scalars['UUID']['output']>;
  posterMedia?: Maybe<Media>;
  posterMediaId?: Maybe<Scalars['UUID']['output']>;
  streamMedia?: Maybe<Media>;
  streamMediaId?: Maybe<Scalars['UUID']['output']>;
  textTrackMedia?: Maybe<Media>;
  textTrackMediaId?: Maybe<Scalars['UUID']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type LearningCardLocalizedVideoConnection = {
  __typename?: 'LearningCardLocalizedVideoConnection';
  nodes: Array<LearningCardLocalizedVideo>;
};

/** Learning Card types */
export enum LearningCardType {
  File = 'FILE',
  FlashCard = 'FLASH_CARD',
  Form = 'FORM',
  Linkout = 'LINKOUT',
  Quiz = 'QUIZ',
  Rep = 'REP',
  Video = 'VIDEO'
}

/** Skill video. */
export type LearningCardVideo = {
  __typename?: 'LearningCardVideo';
  experimentConfig?: Maybe<Scalars['JSONObject']['output']>;
  id: Scalars['UUID']['output'];
  localizations: LearningCardLocalizedVideoConnection;
  position: Scalars['Int']['output'];
  resetLpIfFail: Scalars['Boolean']['output'];
  type: LearningCardType;
};

export type LearningCardVideoInput = {
  defaultLocalization: DefaultVideoLocalizationInput;
  experimentConfig?: InputMaybe<Scalars['JSONObject']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  position: Scalars['Int']['input'];
  /** If true the learning plan will be reset once the skill if marked as failed. */
  resetLpIfFail?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Learning Plan */
export type LearningPlan = {
  __typename?: 'LearningPlan';
  /** Extra medatada of the learning plan/campaign. */
  additionalInfo?: Maybe<Scalars['String']['output']>;
  /** The archived_at column for archiving learning plan */
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  /** to send learner certificate on completion */
  certificateEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** The certificateName of the learning plan/campaign. */
  certificateName?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  /** The created_by column for storing creating user uuid */
  createdBy?: Maybe<Scalars['UUID']['output']>;
  /** The description of the learning plan. */
  description?: Maybe<Scalars['String']['output']>;
  /** Get the learning plan display name. */
  displayName: Scalars['String']['output'];
  /** The end date of the campaign in case endDateType is STATIC. */
  endDate?: Maybe<Scalars['String']['output']>;
  /** The end date type of the campaign. */
  endDateType?: Maybe<CampaignsDateType>;
  /** The number of days an assignment to this learning plan will end in case endDateType is DYNAMIC. */
  endDays?: Maybe<Scalars['Int']['output']>;
  /** A unique url-friendly identifier. i.e. my-learning-plan. */
  externalId: Scalars['String']['output'];
  /** The goal of the learning plan/campaign. */
  goal?: Maybe<Scalars['String']['output']>;
  groups: Array<ProfileGroup>;
  id: Scalars['UUID']['output'];
  /** SpringAI couldn't able to find best practice  */
  isNoDataForBestPractice?: Maybe<Scalars['Boolean']['output']>;
  /** Is learning plan allowed to be completed in any order */
  isOrderDisabled: Scalars['Boolean']['output'];
  learningPlanDependencies: Array<LearningPlanDependency>;
  /** Learning plan folder */
  learningPlanFolder?: Maybe<LearningPlanFolder>;
  /** If the learning plan is mandatory or not. */
  mandatory?: Maybe<Scalars['Boolean']['output']>;
  /** The internal name of the learning plan. */
  name: Scalars['String']['output'];
  prompt?: Maybe<Scalars['JSON']['output']>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  skills: SkillConnection;
  /** Get the number of skills. */
  skillsCount: Scalars['Float']['output'];
  /** The position of the learning plan in Dashboard. */
  sortRank: Scalars['Int']['output'];
  /** The start date of the campaign. */
  startDate?: Maybe<Scalars['String']['output']>;
  /** The start date type of the campaign. */
  startDateType?: Maybe<CampaignsDateType>;
  updatedAt: Scalars['DateTime']['output'];
  /** The updated_by column for storing last updated user uuid */
  updatedBy?: Maybe<Scalars['UUID']['output']>;
};

/** Learning Plan Completion Information by User */
export type LearningPlanActivityResponse = {
  __typename?: 'LearningPlanActivityResponse';
  companyProfileId: Scalars['UUID']['output'];
  /** The assignment completion date in UTC. */
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Profile email address */
  emailAddress?: Maybe<Scalars['String']['output']>;
  /** The external name of the learning plan. */
  learningPlanExternalId: Scalars['String']['output'];
  /** The internal name of the learning plan. */
  learningPlanName: Scalars['String']['output'];
  /** Profile phone number */
  phoneNumber?: Maybe<Scalars['String']['output']>;
  /** Display name for the user profile */
  profileDisplayName?: Maybe<Scalars['String']['output']>;
  /** Unique external identifier for the user profile */
  profileExternalId: Scalars['String']['output'];
  /** The assignment start date in UTC. */
  startedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type LearningPlanDependency = {
  __typename?: 'LearningPlanDependency';
  dependentLearningPlan: LearningPlan;
  dependentLearningPlanId: Scalars['UUID']['output'];
  id: Scalars['UUID']['output'];
  learningPlanId: Scalars['UUID']['output'];
};

export type LearningPlanDependencyInput = {
  dependentLearningPlanId: Scalars['UUID']['input'];
  id?: InputMaybe<Scalars['UUID']['input']>;
};

/** Learning Plan Folder */
export type LearningPlanFolder = {
  __typename?: 'LearningPlanFolder';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  /** Child learning plan ids. */
  learningPlans?: Maybe<Array<LearningPlan>>;
  /** name of the learning plan parent. */
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type LearningPlanFolderInput = {
  id?: InputMaybe<Scalars['UUID']['input']>;
  name: Scalars['String']['input'];
};

export type LearningPlanFolderListConditions = {
  /** Filter by learning plan folder ID */
  id?: InputMaybe<StringCondition>;
  /** Filter by whether the Profile is active or not. */
  includeDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Search terms. Will look in name and external ID. */
  searchTerms?: InputMaybe<StringCondition>;
};

/** LearningPlanFolderList collection - Order by fields */
export enum LearningPlanFolderListOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

export type LearningPlanFolderPageInfo = {
  __typename?: 'LearningPlanFolderPageInfo';
  /** Pointer to the next page. When null, it means you are in the last page. */
  afterCursor?: Maybe<Scalars['String']['output']>;
  /** Pointer to the previous page. When null, it means you are in the first page. */
  beforeCursor?: Maybe<Scalars['String']['output']>;
};

export type LearningPlanFolderSearchCondition = {
  /** Filter by learning plan parent ID */
  id?: InputMaybe<StringCondition>;
  /** Search terms. Will look in name. */
  searchTerms?: InputMaybe<StringCondition>;
};

/** A learner in a learning plan */
export type LearningPlanLearner = {
  __typename?: 'LearningPlanLearner';
  active: Scalars['Boolean']['output'];
  displayName?: Maybe<Scalars['String']['output']>;
  externalId: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
};

export type LearningPlanLearnerPageInfo = {
  __typename?: 'LearningPlanLearnerPageInfo';
  /** Pointer to the next page. When null, it means you are in the last page. */
  afterCursor?: Maybe<Scalars['String']['output']>;
  /** Pointer to the previous page. When null, it means you are in the first page. */
  beforeCursor?: Maybe<Scalars['String']['output']>;
};

export type LearningPlanLearnersConditions = {
  companyProfileId?: InputMaybe<StringCondition>;
  status?: InputMaybe<StringCondition>;
};

export type LearningPlanListConditions = {
  /** Filter by creator id */
  filterByCreator?: InputMaybe<Scalars['String']['input']>;
  /** Filter by learning plan ID */
  id?: InputMaybe<StringCondition>;
  /** Filter by whether the Profile is active or not. */
  includeDisabled: Scalars['Boolean']['input'];
  /** Filter by folder id */
  learningPlanFolderId?: InputMaybe<Scalars['String']['input']>;
  /** Filter to display learning plans what part of folder or not part of folder. */
  partOfFolder?: InputMaybe<FolderStatus>;
  /** Filter by learning plan state. It also accepts strict equals to a certain date */
  publishedAt?: InputMaybe<DateTimeCondition>;
  /** Search terms. Will look in name and external ID. */
  searchTerms?: InputMaybe<StringCondition>;
};

/** LearningPlanList collection - Order by fields */
export enum LearningPlanListOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  ExternalIdAsc = 'EXTERNAL_ID_ASC',
  ExternalIdDesc = 'EXTERNAL_ID_DESC',
  FolderAsc = 'FOLDER_ASC',
  FolderDesc = 'FOLDER_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  PositionAsc = 'POSITION_ASC',
  PositionDesc = 'POSITION_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

export type LearningPlanPageInfo = {
  __typename?: 'LearningPlanPageInfo';
  /** Pointer to the next page. When null, it means you are in the last page. */
  afterCursor?: Maybe<Scalars['String']['output']>;
  /** Pointer to the previous page. When null, it means you are in the first page. */
  beforeCursor?: Maybe<Scalars['String']['output']>;
};

export type LearningPlanSearchConditions = {
  /** Filter by learning plan ID */
  id?: InputMaybe<StringCondition>;
  /** Filter by learning plan published status */
  published?: InputMaybe<Scalars['Boolean']['input']>;
  /** Search terms. Will look in name and external ID. */
  searchTerms?: InputMaybe<StringCondition>;
};

export type LearningPlanSkillsSyncResponse = {
  __typename?: 'LearningPlanSkillsSyncResponse';
  /** Is learning plan allowed to be completed in any order */
  isOrderDisabled?: Maybe<Scalars['Boolean']['output']>;
  /** The LP Section Skills to sync with the given learning plan. */
  lpSectionSkills: Array<LpSectionSkill>;
};

export type Lesson = {
  __typename?: 'Lesson';
  companyId?: Maybe<Scalars['UUID']['output']>;
  gradingSchemeId?: Maybe<Scalars['UUID']['output']>;
  id: Scalars['UUID']['output'];
  isBlocking: Scalars['Boolean']['output'];
  isContextual: Scalars['Boolean']['output'];
  learningCardId?: Maybe<Scalars['UUID']['output']>;
  learningPlanId?: Maybe<Scalars['UUID']['output']>;
  level: Scalars['Int']['output'];
  points: Scalars['Int']['output'];
  position: Scalars['Int']['output'];
  skill: Skill;
  skillId: Scalars['UUID']['output'];
  track: Scalars['Int']['output'];
};

/** Metadata for Local authentication channel */
export type LocalChannel = {
  __typename?: 'LocalChannel';
  /** List of local authentication types supported e.g. EMAIL | PHONE | URL */
  supportedTypes?: Maybe<Array<Scalars['String']['output']>>;
};

/** A localization with the value and language that it represents. */
export type Localization = {
  __typename?: 'Localization';
  autoEvaluationCriteria?: Maybe<AutoEvaluationCriteriaGraphql>;
  disabled?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  language: Language;
  value?: Maybe<Scalars['String']['output']>;
};

/** An input type for a localization with the value and language that it represents. */
export type LocalizationInput = {
  autoEvaluationCriteria?: InputMaybe<AutoEvaluationCriteriaGraphqlInput>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  language: Language;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** A localized entity that usually is a table in the database. E.g: learning_card_localized_linkout. */
export type LocalizedEntity = {
  __typename?: 'LocalizedEntity';
  /** The type of the entity this localization represents. E.g: SKILL_LOCALIZED */
  entityType: LocalizedEntityType;
  /** The fields that are going to be expose in the localizations table. */
  inputs: Array<LocalizedInput>;
  /** The name of the localized entity. This will be expose in the localizations table as the input label or group of inputs in case it is multi row like Videos or Flash Cards. */
  label: Scalars['String']['output'];
  /** The id of the main entity related to this localization. E.g: Skill ID for skill_localized */
  relationshipEntityId: Scalars['UUID']['output'];
};

/** A localized entity that usually is a table in the database. E.g: learning_card_localized_linkout. */
export type LocalizedEntityInput = {
  /** The type of the entity this localization represents. E.g: SKILL_LOCALIZED */
  entityType: LocalizedEntityType;
  /** The fields that are going to be updated for the given entity type. */
  inputs: Array<LocalizedInputInput>;
  /** The id of the main entity related to this localization. E.g: Skill ID for skill_localized */
  relationshipEntityId: Scalars['UUID']['input'];
};

/** Available localized entities */
export enum LocalizedEntityType {
  LearningCardForm = 'LEARNING_CARD_FORM',
  LearningCardLocalizedFile = 'LEARNING_CARD_LOCALIZED_FILE',
  LearningCardLocalizedFlashcard = 'LEARNING_CARD_LOCALIZED_FLASHCARD',
  LearningCardLocalizedLinkout = 'LEARNING_CARD_LOCALIZED_LINKOUT',
  LearningCardLocalizedQuiz = 'LEARNING_CARD_LOCALIZED_QUIZ',
  LearningCardLocalizedVideo = 'LEARNING_CARD_LOCALIZED_VIDEO',
  LearningPlanFolderName = 'LEARNING_PLAN_FOLDER_NAME',
  LearningPlanLocalized = 'LEARNING_PLAN_LOCALIZED',
  PromptLocalized = 'PROMPT_LOCALIZED',
  RepPromptLocalized = 'REP_PROMPT_LOCALIZED',
  SkillLocalized = 'SKILL_LOCALIZED',
  TopicLocalized = 'TOPIC_LOCALIZED'
}

/** An input that will be expose in the localizations table. */
export type LocalizedInput = {
  __typename?: 'LocalizedInput';
  /** The name of the input that will be expose in the table first column in case it is a multi row entity like Videos or Flash Cards. */
  label?: Maybe<Scalars['String']['output']>;
  /** The list of localizations for this input. */
  localizations: Array<Localization>;
  /** The name of the input that will be sent back to the backend. */
  name: Scalars['String']['output'];
  /** The type of the input that will be expose in the localizations table. */
  type: LocalizedInputType;
};

/** A field in the localizations table. */
export type LocalizedInputInput = {
  /** The list of the updated localizations for this input. Localizations not sent will be removed. */
  localizations: Array<LocalizationInput>;
  /** The name of the field sent from the backend. */
  name: Scalars['String']['input'];
  /** The type of the field sent from the backend. */
  type: Scalars['String']['input'];
};

/** Available input types for localizations */
export enum LocalizedInputType {
  File = 'FILE',
  Hidden = 'HIDDEN',
  Image = 'IMAGE',
  Pdf = 'PDF',
  Text = 'TEXT',
  Textarea = 'TEXTAREA',
  Video = 'VIDEO'
}

export type LogoutInput = {
  /** Application from where the mutation is called. */
  source: AuthenticationSource;
};

/** The column to sort on for LP Activity Info */
export enum LpActivityInfoSortBy {
  CompletionDate = 'COMPLETION_DATE',
  ExternalProfileId = 'EXTERNAL_PROFILE_ID',
  StartDate = 'START_DATE'
}

/** Maximum number of tries per form prompt. */
export enum MaxTriesPerPrompt {
  One = 'ONE',
  Unlimited = 'UNLIMITED'
}

export type Me = {
  __typename?: 'Me';
  acceptedLegal?: Maybe<Scalars['String']['output']>;
  companyProfiles: Array<CompanyProfileSession>;
  createdAt: Scalars['DateTime']['output'];
  displayName?: Maybe<Scalars['String']['output']>;
  flags: Array<Flag>;
  id: Scalars['ID']['output'];
  isSuperAdmin: Scalars['Boolean']['output'];
  photoUrl?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};


export type MeFlagsArgs = {
  appName?: InputMaybe<Scalars['String']['input']>;
  appVersion?: InputMaybe<Scalars['String']['input']>;
  browserName?: InputMaybe<Scalars['String']['input']>;
  browserVersion?: InputMaybe<Scalars['String']['input']>;
  osName?: InputMaybe<Scalars['String']['input']>;
  osVersion?: InputMaybe<Scalars['String']['input']>;
  platform?: InputMaybe<Scalars['String']['input']>;
  platformModel?: InputMaybe<Scalars['String']['input']>;
  platformType?: InputMaybe<Scalars['String']['input']>;
  platformVendor?: InputMaybe<Scalars['String']['input']>;
};

/** An object that represents a media like photo, video, pdf or others. The client is responsible for uploading the asset to a supported source (i.e. Cloudinary, S3) and then use the mediaCreate mutation to register it in the system. */
export type Media = {
  __typename?: 'Media';
  createdAt: Scalars['DateTime']['output'];
  /** Media processing error. */
  error?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  /** The service where the media is stored. */
  location: MediaLocation;
  /** Simplified Media type to avoid using regex on mime type. */
  mediaType: MediaType;
  /**
   * Get media full url. Media can be requested with specific transformations, which are Cloudinary-compatible.
   * @deprecated Deprecated in favor of Media.mediaUrlV2.
   */
  mediaUrl?: Maybe<Scalars['String']['output']>;
  /** Get media full url. */
  mediaUrlV2?: Maybe<Scalars['String']['output']>;
  /** Full mime type */
  mimeType: Scalars['String']['output'];
  /** Path where the raw media is located. For Cloudinary media, this path could be private. */
  path: Scalars['String']['output'];
  /** Media processing status. */
  status: MediaStatus;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


/** An object that represents a media like photo, video, pdf or others. The client is responsible for uploading the asset to a supported source (i.e. Cloudinary, S3) and then use the mediaCreate mutation to register it in the system. */
export type MediaMediaUrlArgs = {
  field?: InputMaybe<Scalars['String']['input']>;
  isPreview?: InputMaybe<Scalars['Boolean']['input']>;
  transformations?: InputMaybe<Scalars['JSON']['input']>;
};


/** An object that represents a media like photo, video, pdf or others. The client is responsible for uploading the asset to a supported source (i.e. Cloudinary, S3) and then use the mediaCreate mutation to register it in the system. */
export type MediaMediaUrlV2Args = {
  imageSize?: InputMaybe<ImageSize>;
};

/** The service where the media is stored. */
export enum MediaLocation {
  Cloudinary = 'CLOUDINARY',
  Mux = 'MUX',
  S3 = 'S3'
}

/** Media status */
export enum MediaStatus {
  Aborted = 'ABORTED',
  Completed = 'COMPLETED',
  Error = 'ERROR',
  InProgress = 'IN_PROGRESS',
  New = 'NEW'
}

/** Simplified Media type to avoid using regex on mime type. */
export enum MediaType {
  Audio = 'AUDIO',
  Csv = 'CSV',
  Image = 'IMAGE',
  Other = 'OTHER',
  Pdf = 'PDF',
  Video = 'VIDEO',
  Vtt = 'VTT'
}

export type Mutation = {
  __typename?: 'Mutation';
  /** Create a Campaign using a prompt */
  aiCampaignDataCleanup: LearningPlan;
  apiKeyCreate: ApiKeyCreateResponse;
  apiKeyDelete: Scalars['Boolean']['output'];
  /** First step of 2FA. Requests an one time password to be received via email or sms. Returns an authentication id to be used by mutation authVerify */
  authInit: Scalars['String']['output'];
  /** Destroys current session. */
  authLogout: Scalars['Boolean']['output'];
  /** Uses received refresh token to extend the session. Returns a pair of JWT short-lived bearer token and a long-lived refresh tokens. */
  authRefresh: Scalars['Boolean']['output'];
  authVerify: AuthSession;
  /** Sync learners with the given learning plan list. */
  bulkLearningPlanLearnersSync: Array<Assignment>;
  cloneLearningPlan: LearningPlan;
  cloneProfile: Scalars['Boolean']['output'];
  cloneRep: SkillRep;
  cloneSkill: Skill;
  /** Create a company. */
  companyCreate: Company;
  /** Edit a company. */
  companyEdit: Company;
  /** Enable SSO auth for company. */
  companyEnableSSO: Company;
  /** Create a Campaign using a prompt */
  createCampaignFromPrompt: LearningPlan;
  /** Create a company sibling. */
  createSibling: CompanySiblingDto;
  /** Archive Custom Vocabularies */
  customVocabulariesArchive: Array<CustomVocabulary>;
  /** Add or update custom vocabulary. */
  customVocabularyUpsert: CustomVocabulary;
  deleteSkillProgress: Scalars['Boolean']['output'];
  exportLearningPlanBulk: Array<LearningPlan>;
  exportSkillRepsBulk: Array<SkillRep>;
  exportSkillsBulk: Array<Skill>;
  fileUploadGetSignedUrl: Upload;
  googleAuthVerify: Scalars['Boolean']['output'];
  /** Insert Custom Persona */
  insertCustomPersona: RolePlayConfig;
  /** Delete learning cards. */
  learningCardsDelete?: Maybe<Scalars['Void']['output']>;
  /** Create or update learning cards. */
  learningCardsUpsert: LearningCardConnection;
  /** Add groups to a learning plan. */
  learningPlanAddGroups: LearningPlan;
  /** archieve a learning plan. */
  learningPlanArchive: LearningPlan;
  /** Assign learning plan to folder. */
  learningPlanAssignToFolder: Array<LearningPlan>;
  /** Create a learning plan. */
  learningPlanCreate: LearningPlan;
  /** Delete groups from a learning plan. */
  learningPlanDeleteGroups: LearningPlan;
  /** Edit a Learning Plan. It can be used to update attached skill settings and to assign/remove learners from the Learning Plan. */
  learningPlanEdit: LearningPlan;
  /** Create a learning plan. */
  learningPlanFolderCreate: LearningPlanFolder;
  /** Sync learners with the given learning plan. */
  learningPlanLearnersSync: PaginatedLearningPlanLearners;
  /** Sync all the localizations for the given learning plan. */
  learningPlanLocalizationsSync: Array<LocalizedEntity>;
  /** Set the given learning plan as PUBLISHED. */
  learningPlanPublish: LearningPlan;
  /** Sync skills with the given learning plan. */
  learningPlanSkillsSync: LearningPlanSkillsSyncResponse;
  /** Registers a new Media object. */
  mediaCreate: Media;
  /** Updates an existing a Media object. */
  mediaEdit: Media;
  /** Create a profile. */
  profileCreate: CompanyProfile;
  /** Delete a profile. */
  profileDelete: CompanyProfile;
  /** Update a profile. */
  profileEdit: CompanyProfile;
  /** Archive a profile group. */
  profileGroupArchive: ProfileGroup;
  /** Create a profile group. */
  profileGroupCreate: ProfileGroup;
  /** Edit a profile group. */
  profileGroupEdit: ProfileGroup;
  /** Attach a Company Profile to this Group. */
  profileGroupMemberCreate: ProfileGroupMember;
  /** Remove a Company Profile from a Group */
  profileGroupMemberDelete: ProfileGroupMember;
  /** Modify settings of a Group Member. */
  profileGroupMemberEdit: ProfileGroupMember;
  /** Create a tag. */
  profileTagCreate: ProfileTag;
  /** Edit a tag. */
  profileTagEdit: ProfileTag;
  /** Deactivate a profile. */
  profileUpdateStatus: CompanyProfile;
  /** Attach a list of tags to a profile. Unexisting tags will be created. */
  profileUpdateTags: CompanyProfile;
  /** archieve a skill. */
  skillArchive: Skill;
  /** Sync all the localizations for the given skill. */
  skillLocalizationsSync: Array<LocalizedEntity>;
  /** Set the given Skill as PUBLISHED */
  skillPublish: Skill;
  /** Sync all the localizations for the given Skill Rep. */
  skillRepLocalizationsSync: Array<LocalizedEntity>;
  /** Set the given Skill Rep as PUBLISHED */
  skillRepPublish: SkillRep;
  /** Create or update a Skill of type CONTENT. */
  skillUpsert: Skill;
  /** Sync custom Vocabulary */
  synkCustomVocabulary: CustomVocabularySync;
  testCleanup: Scalars['Boolean']['output'];
  testInit: TestData;
  /** Create a Topic. */
  topicCreate: Topic;
  /** Delete a Topic. */
  topicDelete: Topic;
  /** Edit a Topic. */
  topicEdit: Topic;
  /** Sync all the localizations for the given topic. */
  topicLocalizationsSync: Array<LocalizedEntity>;
  /** Sync a Topic with Skills. */
  topicSkillsSync: Array<SkillTopic>;
  /** Deactivate a Topic. */
  topicUpdateStatus: Topic;
  /** Update Interjection value for repPrompt. */
  updateInterjections: Array<Interjection>;
  uploadProcess: Upload;
  uploadProvision: UploadProvision;
  /** Create or update a skill of type REP. */
  upsertSkillRep: SkillRep;
};


export type MutationAiCampaignDataCleanupArgs = {
  campaignId: Scalars['String']['input'];
};


export type MutationApiKeyDeleteArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationAuthInitArgs = {
  profileIdentifier: Scalars['String']['input'];
  workspaceId?: InputMaybe<Scalars['UUID']['input']>;
};


export type MutationAuthLogoutArgs = {
  logoutInput: LogoutInput;
};


export type MutationAuthRefreshArgs = {
  refreshToken?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<AuthenticationSource>;
};


export type MutationAuthVerifyArgs = {
  authInitId: Scalars['String']['input'];
  code: Scalars['String']['input'];
};


export type MutationBulkLearningPlanLearnersSyncArgs = {
  learners: Array<LearnerInput>;
  learningPlans: Array<Scalars['String']['input']>;
};


export type MutationCloneLearningPlanArgs = {
  learningPlanId: Scalars['UUID']['input'];
  newLearningPlanExternalId: Scalars['String']['input'];
};


export type MutationCloneProfileArgs = {
  newProfileExternalId: Scalars['String']['input'];
  profileExternalId: Scalars['String']['input'];
};


export type MutationCloneRepArgs = {
  newSkillRepExternalId: Scalars['String']['input'];
  skillRepId: Scalars['UUID']['input'];
};


export type MutationCloneSkillArgs = {
  newSkillExternalId: Scalars['String']['input'];
  skillId: Scalars['UUID']['input'];
};


export type MutationCompanyCreateArgs = {
  companyCreateInput: CompanyCreateInput;
};


export type MutationCompanyEditArgs = {
  companyEditInput: CompanyEditInput;
};


export type MutationCompanyEnableSsoArgs = {
  companySSOInput: CompanySsoInput;
};


export type MutationCreateCampaignFromPromptArgs = {
  company: Scalars['String']['input'];
  complexity: Scalars['String']['input'];
  includeExistRep?: InputMaybe<Scalars['Boolean']['input']>;
  includeQuiz: Scalars['Boolean']['input'];
  includeRep: Scalars['Boolean']['input'];
  objective: Scalars['String']['input'];
  prompt: Scalars['String']['input'];
};


export type MutationCreateSiblingArgs = {
  siblingCompanyId: Scalars['String']['input'];
};


export type MutationCustomVocabulariesArchiveArgs = {
  ids: Array<Scalars['String']['input']>;
};


export type MutationCustomVocabularyUpsertArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  language: DialectTypes;
  name: Scalars['String']['input'];
  status?: InputMaybe<CustomVocabularyStatuses>;
};


export type MutationDeleteSkillProgressArgs = {
  profileExternalId: Scalars['String']['input'];
  skillExternalId: Scalars['String']['input'];
};


export type MutationExportLearningPlanBulkArgs = {
  groupsDataIds?: InputMaybe<Array<GroupsDataIdsArg>>;
  learningPlanIds: Array<Scalars['UUID']['input']>;
  targetCompanyIds: Array<Scalars['UUID']['input']>;
};


export type MutationExportSkillRepsBulkArgs = {
  skillRepIds: Array<Scalars['UUID']['input']>;
  targetCompanyIds: Array<Scalars['UUID']['input']>;
};


export type MutationExportSkillsBulkArgs = {
  skillIds: Array<Scalars['UUID']['input']>;
  targetCompanyIds: Array<Scalars['UUID']['input']>;
};


export type MutationFileUploadGetSignedUrlArgs = {
  fileType: Scalars['String']['input'];
  options?: InputMaybe<UploadOptionsInput>;
  uploadSource: UploadSource;
};


export type MutationGoogleAuthVerifyArgs = {
  source?: InputMaybe<AuthenticationSource>;
  token: Scalars['String']['input'];
};


export type MutationInsertCustomPersonaArgs = {
  insertCustomPersonaInput: InsertCustomPersonaInput;
};


export type MutationLearningCardsDeleteArgs = {
  ids: Array<Scalars['String']['input']>;
  skillId: Scalars['String']['input'];
};


export type MutationLearningCardsUpsertArgs = {
  files?: InputMaybe<Array<LearningCardFileInput>>;
  flashCards?: InputMaybe<Array<LearningCardFlashCardInput>>;
  form?: InputMaybe<LearningCardFormInput>;
  linkouts?: InputMaybe<Array<LearningCardLinkoutInput>>;
  skillId?: InputMaybe<Scalars['String']['input']>;
  videos?: InputMaybe<Array<LearningCardVideoInput>>;
};


export type MutationLearningPlanAddGroupsArgs = {
  groups: Array<GroupInput>;
  learningPlanId: Scalars['UUID']['input'];
};


export type MutationLearningPlanArchiveArgs = {
  learningPlanId: Scalars['UUID']['input'];
};


export type MutationLearningPlanAssignToFolderArgs = {
  folderId?: InputMaybe<Scalars['UUID']['input']>;
  learningPlansIds: Array<Scalars['UUID']['input']>;
};


export type MutationLearningPlanCreateArgs = {
  additionalInfo?: InputMaybe<Scalars['String']['input']>;
  certificateEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  certificateName?: InputMaybe<Scalars['String']['input']>;
  createdBy?: InputMaybe<Scalars['UUID']['input']>;
  dependencies: Array<LearningPlanDependencyInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName: Scalars['String']['input'];
  endDate?: InputMaybe<Scalars['String']['input']>;
  endDateType?: InputMaybe<CampaignsDateType>;
  endDays?: InputMaybe<Scalars['Int']['input']>;
  externalId: Scalars['String']['input'];
  goal?: InputMaybe<Scalars['String']['input']>;
  learningPlanFolder?: InputMaybe<LearningPlanFolderInput>;
  mandatory?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  prompt?: InputMaybe<Scalars['JSON']['input']>;
  sortRank: Scalars['Int']['input'];
  startDate?: InputMaybe<Scalars['String']['input']>;
  startDateType?: InputMaybe<CampaignsDateType>;
};


export type MutationLearningPlanDeleteGroupsArgs = {
  groups: Array<GroupInput>;
  learningPlanId: Scalars['UUID']['input'];
};


export type MutationLearningPlanEditArgs = {
  additionalInfo?: InputMaybe<Scalars['String']['input']>;
  certificateEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  certificateName?: InputMaybe<Scalars['String']['input']>;
  createdBy?: InputMaybe<Scalars['UUID']['input']>;
  dependencies: Array<LearningPlanDependencyInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName: Scalars['String']['input'];
  endDate?: InputMaybe<Scalars['String']['input']>;
  endDateType?: InputMaybe<CampaignsDateType>;
  endDays?: InputMaybe<Scalars['Int']['input']>;
  externalId: Scalars['String']['input'];
  goal?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
  learningPlanFolder?: InputMaybe<LearningPlanFolderInput>;
  mandatory?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  prompt?: InputMaybe<Scalars['JSON']['input']>;
  sortRank: Scalars['Int']['input'];
  startDate?: InputMaybe<Scalars['String']['input']>;
  startDateType?: InputMaybe<CampaignsDateType>;
  updatedBy?: InputMaybe<Scalars['UUID']['input']>;
};


export type MutationLearningPlanFolderCreateArgs = {
  learningPlansIds: Array<Scalars['UUID']['input']>;
  name: Scalars['String']['input'];
};


export type MutationLearningPlanLearnersSyncArgs = {
  conditions?: InputMaybe<LearningPlanLearnersConditions>;
  learners: Array<LearnerInput>;
  learningPlanId: Scalars['UUID']['input'];
  paginate?: InputMaybe<BaseClassicPaginate>;
};


export type MutationLearningPlanLocalizationsSyncArgs = {
  entities: Array<LocalizedEntityInput>;
  id: Scalars['UUID']['input'];
};


export type MutationLearningPlanPublishArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationLearningPlanSkillsSyncArgs = {
  learningPlanId: Scalars['UUID']['input'];
  lpSectionSkills: Array<LpSectionSkillInput>;
  unlocked?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationMediaCreateArgs = {
  location?: InputMaybe<MediaLocation>;
  mediaType: MediaType;
  mimeType: Scalars['String']['input'];
  path: Scalars['String']['input'];
};


export type MutationMediaEditArgs = {
  id: Scalars['UUID']['input'];
  location?: InputMaybe<MediaLocation>;
  mediaType: MediaType;
  mimeType: Scalars['String']['input'];
  path: Scalars['String']['input'];
};


export type MutationProfileCreateArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  coachCommsOptOut?: InputMaybe<Scalars['Boolean']['input']>;
  departments?: InputMaybe<Array<DepartmentInput>>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  emailAddress?: InputMaybe<Scalars['String']['input']>;
  excludeFromAnalytics: Scalars['Boolean']['input'];
  externalId: Scalars['String']['input'];
  isDefaultLogin?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  learnerCommsOptOut: Scalars['Boolean']['input'];
  mergeAcceptance?: InputMaybe<Scalars['Boolean']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  photoUrl?: InputMaybe<Scalars['String']['input']>;
  preferredName?: InputMaybe<Scalars['String']['input']>;
  regions?: InputMaybe<Array<RegionInput>>;
  roles?: InputMaybe<Array<Role>>;
  startDate: Scalars['String']['input'];
  timezone?: InputMaybe<Timezone>;
};


export type MutationProfileDeleteArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationProfileEditArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  coachCommsOptOut?: InputMaybe<Scalars['Boolean']['input']>;
  departments?: InputMaybe<Array<DepartmentInput>>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  emailAddress?: InputMaybe<Scalars['String']['input']>;
  excludeFromAnalytics: Scalars['Boolean']['input'];
  externalId: Scalars['String']['input'];
  id: Scalars['UUID']['input'];
  language?: InputMaybe<Scalars['String']['input']>;
  learnerCommsOptOut: Scalars['Boolean']['input'];
  mergeAcceptance?: InputMaybe<Scalars['Boolean']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  photoUrl?: InputMaybe<Scalars['String']['input']>;
  preferredName?: InputMaybe<Scalars['String']['input']>;
  regions?: InputMaybe<Array<RegionInput>>;
  roles?: InputMaybe<Array<Role>>;
  startDate: Scalars['String']['input'];
  timezone?: InputMaybe<Timezone>;
};


export type MutationProfileGroupArchiveArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationProfileGroupCreateArgs = {
  description: Scalars['String']['input'];
  learningPlans?: InputMaybe<Array<Scalars['UUID']['input']>>;
  metadata?: InputMaybe<Scalars['JSONObject']['input']>;
  name: Scalars['String']['input'];
};


export type MutationProfileGroupEditArgs = {
  description: Scalars['String']['input'];
  id: Scalars['UUID']['input'];
  learningPlans?: InputMaybe<Array<Scalars['UUID']['input']>>;
  metadata?: InputMaybe<Scalars['JSONObject']['input']>;
  name: Scalars['String']['input'];
};


export type MutationProfileGroupMemberCreateArgs = {
  companyProfileId: Scalars['UUID']['input'];
  profileGroupId: Scalars['UUID']['input'];
  type: ProfileGroupMemberType;
};


export type MutationProfileGroupMemberDeleteArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationProfileGroupMemberEditArgs = {
  companyProfileId: Scalars['UUID']['input'];
  id: Scalars['UUID']['input'];
  profileGroupId?: InputMaybe<Scalars['UUID']['input']>;
  type: ProfileGroupMemberType;
};


export type MutationProfileTagCreateArgs = {
  companyProfileIds?: InputMaybe<Array<Scalars['String']['input']>>;
  metadata?: InputMaybe<Scalars['JSONObject']['input']>;
  name: Scalars['String']['input'];
};


export type MutationProfileTagEditArgs = {
  companyProfileIds?: InputMaybe<Array<Scalars['String']['input']>>;
  id: Scalars['UUID']['input'];
  metadata?: InputMaybe<Scalars['JSONObject']['input']>;
  name: Scalars['String']['input'];
};


export type MutationProfileUpdateStatusArgs = {
  active: Scalars['Boolean']['input'];
  id: Scalars['UUID']['input'];
};


export type MutationProfileUpdateTagsArgs = {
  id: Scalars['UUID']['input'];
  tags: Array<ProfileTagInput>;
};


export type MutationSkillArchiveArgs = {
  skillId: Scalars['UUID']['input'];
};


export type MutationSkillLocalizationsSyncArgs = {
  entities: Array<LocalizedEntityInput>;
  id: Scalars['UUID']['input'];
};


export type MutationSkillPublishArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationSkillRepLocalizationsSyncArgs = {
  entities: Array<LocalizedEntityInput>;
  id: Scalars['UUID']['input'];
};


export type MutationSkillRepPublishArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationSkillUpsertArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  displayName: Scalars['String']['input'];
  duration?: InputMaybe<Scalars['String']['input']>;
  externalId: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  photoUrl: Scalars['String']['input'];
};


export type MutationSynkCustomVocabularyArgs = {
  vocabularyId: Scalars['String']['input'];
};


export type MutationTestCleanupArgs = {
  additionalProfiles: Array<Scalars['String']['input']>;
  id: Scalars['String']['input'];
};


export type MutationTopicCreateArgs = {
  name: Scalars['String']['input'];
  photoUrl: Scalars['String']['input'];
};


export type MutationTopicDeleteArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationTopicEditArgs = {
  id: Scalars['UUID']['input'];
  name: Scalars['String']['input'];
  photoUrl: Scalars['String']['input'];
};


export type MutationTopicLocalizationsSyncArgs = {
  entities: Array<LocalizedEntityInput>;
  id: Scalars['UUID']['input'];
};


export type MutationTopicSkillsSyncArgs = {
  skillTopics: Array<SkillTopicInput>;
  topicId: Scalars['UUID']['input'];
};


export type MutationTopicUpdateStatusArgs = {
  active: Scalars['Boolean']['input'];
  id: Scalars['UUID']['input'];
};


export type MutationUpdateInterjectionsArgs = {
  interjections?: InputMaybe<Array<InterjectionInput>>;
  repPromptId: Scalars['UUID']['input'];
};


export type MutationUploadProcessArgs = {
  id: Scalars['String']['input'];
};


export type MutationUploadProvisionArgs = {
  mediaId?: InputMaybe<Scalars['String']['input']>;
  mediaType: MediaType;
  mimeType: Scalars['String']['input'];
};


export type MutationUpsertSkillRepArgs = {
  upsertSkillRepInput: UpsertSkillRepInput;
};

/** Scores related to need articulation */
export type NeedsIdentificationScore = {
  __typename?: 'NeedsIdentificationScore';
  identificationScore: Scalars['Float']['output'];
  needCaptured: Scalars['Boolean']['output'];
  needExpressed: Scalars['Boolean']['output'];
  problemClarity: Scalars['Float']['output'];
};

/** NonVerbalSkillScore for different aspects of the conversation content */
export type NonVerbalSkillScore = {
  __typename?: 'NonVerbalSkillScore';
  confidence: Scalars['Float']['output'];
  listening: Scalars['Float']['output'];
  patience: Scalars['Float']['output'];
  pauseDuration: Scalars['Float']['output'];
};

/** Details of an open-ended question in the conversation */
export type OpenEndedQuestion = {
  __typename?: 'OpenEndedQuestion';
  question: Scalars['String']['output'];
  speaker: Scalars['String']['output'];
  startTime: Scalars['Float']['output'];
};

/** Whether to sort collection ascending or descending. */
export enum OrderByDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

/** A paginated list of API Keys. */
export type PaginatedApiKeyResponse = {
  __typename?: 'PaginatedAPIKeyResponse';
  /** List of objects in current page. */
  nodes: Array<ApiKey>;
  /** Contains details to move forward and backwards from the collection. */
  pageInfo: FunctionPageInfo;
  /** Total number of objects in the collection. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A paginated list of CompanyProfiles. */
export type PaginatedCompanyProfileListResponse = {
  __typename?: 'PaginatedCompanyProfileListResponse';
  /** List of objects in current page. */
  nodes: Array<CompanyProfile>;
  /** Contains details to move forward and backwards from the collection. */
  pageInfo: CompanyProfileListPageInfo;
  /** Total number of objects in the collection. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A paginated list of Company Profiles. */
export type PaginatedCompanyProfileSearchResponse = {
  __typename?: 'PaginatedCompanyProfileSearchResponse';
  /** List of objects in current page. */
  nodes: Array<CompanyProfile>;
  /** Contains details to move forward and backwards from the collection. */
  pageInfo: CompanyProfileSearchPageInfo;
  /** Total number of objects in the collection. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** Company Paginated Response. */
export type PaginatedCompanyResponse = {
  __typename?: 'PaginatedCompanyResponse';
  /** Pointer to the next page. When null, it means you are in the last page. */
  afterCursor?: Maybe<Scalars['String']['output']>;
  /** Reference to the previous page. When null, it means you are in the first page. */
  beforeCursor?: Maybe<Scalars['String']['output']>;
  /** Total number of objects in the collection. */
  count?: Maybe<Scalars['Float']['output']>;
  /** List of objects in current page. */
  nodes: Array<Company>;
};

/** A paginated list of Custom Vocabulary. */
export type PaginatedCustomVocabularyKeywordResponse = {
  __typename?: 'PaginatedCustomVocabularyKeywordResponse';
  /** List of objects in current page. */
  nodes: Array<CustomVocabularyKeyword>;
  /** Contains details to move forward and backwards from the collection. */
  pageInfo: CustomVocabularyKeywordPageInfo;
  /** Total number of objects in the collection. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A paginated list of Custom Vocabulary. */
export type PaginatedCustomVocabularyResponse = {
  __typename?: 'PaginatedCustomVocabularyResponse';
  /** List of objects in current page. */
  nodes: Array<CustomVocabulary>;
  /** Contains details to move forward and backwards from the collection. */
  pageInfo: CustomVocabularyPageInfo;
  /** Total number of objects in the collection. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A paginated list of Learning Plans. */
export type PaginatedLearningPlanFolderResponse = {
  __typename?: 'PaginatedLearningPlanFolderResponse';
  /** List of objects in current page. */
  nodes: Array<LearningPlanFolder>;
  /** Contains details to move forward and backwards from the collection. */
  pageInfo: LearningPlanFolderPageInfo;
  /** Total number of objects in the collection. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type PaginatedLearningPlanLearners = {
  __typename?: 'PaginatedLearningPlanLearners';
  /** List of objects in current page. */
  nodes: Array<LearningPlanLearner>;
  /** Contains details to move forward and backwards from the collection. */
  pageInfo: LearningPlanLearnerPageInfo;
  /** Total number of objects in the collection. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A paginated list of Learning Plans. */
export type PaginatedLearningPlanResponse = {
  __typename?: 'PaginatedLearningPlanResponse';
  /** List of objects in current page. */
  nodes: Array<LearningPlan>;
  /** Contains details to move forward and backwards from the collection. */
  pageInfo: LearningPlanPageInfo;
  /** Total number of objects in the collection. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A paginated list of profile groups. */
export type PaginatedProfileGroupListResponse = {
  __typename?: 'PaginatedProfileGroupListResponse';
  /** List of objects in current page. */
  nodes: Array<ProfileGroup>;
  /** Contains details to move forward and backwards from the collection. */
  pageInfo: ProfileGroupListPageInfo;
  /** Total number of objects in the collection. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A paginated list of profile groups. */
export type PaginatedProfileGroupSearchResponse = {
  __typename?: 'PaginatedProfileGroupSearchResponse';
  /** List of objects in current page. */
  nodes: Array<ProfileGroup>;
  /** Contains details to move forward and backwards from the collection. */
  pageInfo: ProfileGroupSearchPageInfo;
  /** Total number of objects in the collection. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A paginated list of profile tags. */
export type PaginatedProfileTagResponse = {
  __typename?: 'PaginatedProfileTagResponse';
  /** List of objects in current page. */
  nodes: Array<ProfileTag>;
  /** Contains details to move forward and backwards from the collection. */
  pageInfo: ProfileTagPageInfo;
  /** Total number of objects in the collection. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A paginated list of Rep Prompts. */
export type PaginatedRepPromptLocalizedResponse = {
  __typename?: 'PaginatedRepPromptLocalizedResponse';
  /** List of objects in current page. */
  nodes: Array<RepPromptLocalized>;
  /** Contains details to move forward and backwards from the collection. */
  pageInfo: RepPromptLocalizedPageInfo;
  /** Total number of objects in the collection. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type PaginatedRepResponse = {
  __typename?: 'PaginatedRepResponse';
  /** Pointer to the next page. When null, it means you are in the last page. */
  afterCursor?: Maybe<Scalars['String']['output']>;
  /** Reference to the previous page. When null, it means you are in the first page. */
  beforeCursor?: Maybe<Scalars['String']['output']>;
  /** Total number of objects in the collection. */
  count?: Maybe<Scalars['Float']['output']>;
  /** List of objects in current page. */
  nodes: Array<RepResponse>;
};

/** A paginated list of Skills of type REP. */
export type PaginatedSkillRepResponse = {
  __typename?: 'PaginatedSkillRepResponse';
  /** List of objects in current page. */
  nodes: Array<SkillRep>;
  /** Contains details to move forward and backwards from the collection. */
  pageInfo: SkillRepPageInfo;
  /** Total number of objects in the collection. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A paginated list of Skills of type CONTENT. */
export type PaginatedSkillResponse = {
  __typename?: 'PaginatedSkillResponse';
  /** List of objects in current page. */
  nodes: Array<Skill>;
  /** Contains details to move forward and backwards from the collection. */
  pageInfo: SkillPageInfo;
  /** Total number of objects in the collection. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** Basic parameters to handle pagination. */
export type Paginator = {
  /** Starting pointer where to  collect objects from, similar to offset. Passing null will return the first <limit> objects. */
  cursor?: InputMaybe<Scalars['String']['input']>;
  /** Maximum number of objects returned per page. */
  limit?: InputMaybe<Scalars['Int']['input']>;
};

/** Represents a parent domain of a domain */
export type ParentDomain = {
  __typename?: 'ParentDomain';
  /** name of the parent domain for the extracted topic domain */
  parentDomain: Scalars['String']['output'];
};

/** Represents a parent topic of a specific topic */
export type ParentTopic = {
  __typename?: 'ParentTopic';
  /** Distance or hierarchy of the parent topic from the base topic, starting with 1 */
  level: Scalars['Int']['output'];
  /** The child topic name of the parentTopic */
  parentOf: Scalars['String']['output'];
  /** Name of the parent topic for an extracted topic */
  parentTopic: Scalars['String']['output'];
};

/** Permission options */
export enum Permission {
  Admins = 'ADMINS',
  ApiKeys = 'API_KEYS',
  CompanyAnalytics = 'COMPANY_ANALYTICS',
  LearningPlans = 'LEARNING_PLANS',
  Profiles = 'PROFILES',
  ProfileGroups = 'PROFILE_GROUPS',
  ProfileTags = 'PROFILE_TAGS',
  RepPrompts = 'REP_PROMPTS',
  RepResponses = 'REP_RESPONSES',
  Skills = 'SKILLS',
  Topics = 'TOPICS'
}

/** A Profile matches to a user in the system. Which can be a Learner, a Coach, or Administrator depending on the given roles. */
export type Profile = {
  __typename?: 'Profile';
  /** Whether Terms & Conditions have been accepted or not. */
  acceptedLegal: Scalars['Boolean']['output'];
  /** A Profile is connected to a Company through CompanyProfile, which may contain company-specific settings for this profile. */
  companyProfile?: Maybe<CompanyProfile>;
  createdAt: Scalars['DateTime']['output'];
  /** Profile display name, usually its full name. */
  displayName?: Maybe<Scalars['String']['output']>;
  /**
   * Email address. Plus addressing supported.
   * @deprecated It has been replaced by 'CompanyProfile.emailAddress'.
   */
  emailAddress?: Maybe<Scalars['String']['output']>;
  /** The date where the created profile accepted the terms & conditions. */
  enrolledAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * A URL-friendly, memorable, and unique identifier e.g. profile-full-name
   * @deprecated It has been replaced by 'CompanyProfile.externalId'.
   */
  externalId: Scalars['String']['output'];
  /** List of enabled feature flags. */
  flags: Array<Flag>;
  id: Scalars['ID']['output'];
  /**
   * Display language.
   * @deprecated It has been replaced by 'CompanyProfile.language'.
   */
  language?: Maybe<Language>;
  media?: Maybe<Media>;
  mediaId?: Maybe<Scalars['UUID']['output']>;
  /**
   * Full international phone number with leading plus sign. e.g. +12125551234
   * @deprecated It has been replaced by 'CompanyProfile.phoneNumber'.
   */
  phoneNumber?: Maybe<Scalars['String']['output']>;
  /** Absolute URL Profile Picture */
  photoUrl?: Maybe<Scalars['String']['output']>;
  /** Profile visible name that can be different from display name and will be used mostly for communications. */
  preferredName?: Maybe<Scalars['String']['output']>;
  /** List of granted Roles. */
  profileGrants?: Maybe<Array<ProfileGrant>>;
  updatedAt: Scalars['DateTime']['output'];
};

/** A Profile Grant is a connection between a Company Profile and a Role. A Company Profile could have different Roles attached between different Companies. */
export type ProfileGrant = {
  __typename?: 'ProfileGrant';
  /** The Company Profile related object. */
  companyProfile?: Maybe<CompanyProfile>;
  /** The Company Profile ID. */
  companyProfileId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  /**
   * The Profile ID
   * @deprecated Use companyProfileId for more specificity.
   */
  profileId: Scalars['String']['output'];
  /** The Role related object. */
  profileRole: ProfileRole;
  /** The Role ID. */
  profileRoleId?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

/** Profile Group (aka Cohorts) can be used to assign one or multiple coaches to a set of learners. */
export type ProfileGroup = {
  __typename?: 'ProfileGroup';
  /** The date the Group was archived. */
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The number of coaches in this Group. */
  coachCount: Scalars['Int']['output'];
  /** The Company this Group belongs to. */
  company: Company;
  /** Get the members attached to this profile group. */
  companyCohortMembers: ProfileGroupMemberConnection;
  /** The Company ID. */
  companyId: Scalars['UUID']['output'];
  createdAt: Scalars['DateTime']['output'];
  /** The CompanyProfile who created this Group. */
  creatorCompanyProfile?: Maybe<CompanyProfile>;
  /** CompanyProfile ID of the user who created this Group. */
  creatorCompanyProfileId?: Maybe<Scalars['UUID']['output']>;
  /** Get creator profile objects. */
  creatorProfile: Profile;
  /** Profile ID of the user who created this Group. */
  creatorProfileId: Scalars['UUID']['output'];
  /** The date the Group was (soft) deleted. */
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  /** A longer description for the Group. */
  description: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  /** The number of learners in this Group. */
  learnerCount: Scalars['Int']['output'];
  learningPlans: Array<LearningPlan>;
  /** A free-use key-value record to store related data. */
  metadata: Scalars['JSONObject']['output'];
  /** A name for the Group. */
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};


/** Profile Group (aka Cohorts) can be used to assign one or multiple coaches to a set of learners. */
export type ProfileGroupCompanyCohortMembersArgs = {
  paginate?: InputMaybe<BaseClassicPaginate>;
};

export type ProfileGroupListConditions = {
  /** Filter by members present in the group */
  companyProfileId?: InputMaybe<StringCondition>;
  /** Filter by creator id */
  filterByCreator?: InputMaybe<Scalars['String']['input']>;
  /** Whether to include archived records. */
  includeDisabled: Scalars['Boolean']['input'];
  /** Search terms. Will look in name. */
  searchTerms?: InputMaybe<StringCondition>;
};

/** Available order by options for the ProfileGroup list */
export enum ProfileGroupListOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

export type ProfileGroupListPageInfo = {
  __typename?: 'ProfileGroupListPageInfo';
  /** Pointer to the next page. When null, it means you are in the last page. */
  afterCursor?: Maybe<Scalars['String']['output']>;
  /** Pointer to the previous page. When null, it means you are in the first page. */
  beforeCursor?: Maybe<Scalars['String']['output']>;
};

/** Profile Group Member */
export type ProfileGroupMember = {
  __typename?: 'ProfileGroupMember';
  /** Profile Group */
  companyCohort: ProfileGroup;
  /** Profile Group ID */
  companyCohortId: Scalars['UUID']['output'];
  /** Company Profile object. */
  companyProfile: CompanyProfile;
  /** Company Profile ID of the Member */
  companyProfileId: Scalars['UUID']['output'];
  createdAt: Scalars['DateTime']['output'];
  /** Company Profile who assigned this Profile to this Group. */
  createdByCompanyProfile?: Maybe<CompanyProfile>;
  /** Company Profile ID who assigned this Profile to this Group. */
  createdByCompanyProfileId?: Maybe<Scalars['UUID']['output']>;
  /** Profile who assigned this Profile to this Group. */
  createdByProfile: CompanyProfile;
  /** Profile ID who assigned this Profile to this Group. */
  createdByProfileId: Scalars['UUID']['output'];
  id: Scalars['UUID']['output'];
  /** Type of Member. It can be either coach, learner or peer. */
  type: ProfileGroupMemberType;
  updatedAt: Scalars['DateTime']['output'];
};

export type ProfileGroupMemberConnection = {
  __typename?: 'ProfileGroupMemberConnection';
  /** List of objects in current page. */
  nodes: Array<ProfileGroupMember>;
  /** Contains details to move forward and backwards from the collection. */
  pageInfo: ProfileGroupMemberPageInfo;
  /** Total number of objects in the collection. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type ProfileGroupMemberPageInfo = {
  __typename?: 'ProfileGroupMemberPageInfo';
  /** Pointer to the next page. When null, it means you are in the last page. */
  afterCursor?: Maybe<Scalars['String']['output']>;
  /** Pointer to the previous page. When null, it means you are in the first page. */
  beforeCursor?: Maybe<Scalars['String']['output']>;
};

/** Available Profile Group Member Types */
export enum ProfileGroupMemberType {
  Coach = 'COACH',
  Peer = 'PEER',
  User = 'USER'
}

export type ProfileGroupSearchConditions = {
  /** Filter by group id */
  id?: InputMaybe<StringCondition>;
  /** Search terms. Will look in name. */
  searchTerms?: InputMaybe<StringCondition>;
};

export type ProfileGroupSearchPageInfo = {
  __typename?: 'ProfileGroupSearchPageInfo';
  /** Pointer to the next page. When null, it means you are in the last page. */
  afterCursor?: Maybe<Scalars['String']['output']>;
  /** Pointer to the previous page. When null, it means you are in the first page. */
  beforeCursor?: Maybe<Scalars['String']['output']>;
};

/** A Permission is the definition of a specific action that a Role has attached to it. */
export type ProfilePermission = {
  __typename?: 'ProfilePermission';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  /** The name of the permission. */
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

/** A Role, which can be attached to a Company Profile, is a list of Permissions. */
export type ProfileRole = {
  __typename?: 'ProfileRole';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  /** Name of the Role */
  name?: Maybe<Role>;
  /** List of Permissions attached to this Role. */
  profileRoleProfilePermissions: Array<ProfileRoleProfilePermission>;
  updatedAt: Scalars['DateTime']['output'];
};

export type ProfileRoleCondition = {
  equals?: InputMaybe<Role>;
  iLike?: InputMaybe<Role>;
  in?: InputMaybe<Array<Role>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Role>;
  notEqualsTo?: InputMaybe<Role>;
  notIn?: InputMaybe<Array<Role>>;
};

/** Connection between a Role and a Permission. */
export type ProfileRoleProfilePermission = {
  __typename?: 'ProfileRoleProfilePermission';
  id: Scalars['ID']['output'];
  /** The Permission. */
  profilePermission: ProfilePermission;
  /** The Role. */
  profileRole: ProfileRole;
};

export type ProfileTag = {
  __typename?: 'ProfileTag';
  /** The Company ID. */
  companyId: Scalars['UUID']['output'];
  /** The Company Profiles attached to this Tag. */
  companyProfiles?: Maybe<Array<CompanyProfile>>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  /** A free-use key-value record to store related data. */
  metadata?: Maybe<Scalars['JSONObject']['output']>;
  /** The name of the Tag. */
  name: Scalars['String']['output'];
  /** The number of Profiles attached to this Tag. */
  profileCount?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type ProfileTagInput = {
  id?: InputMaybe<Scalars['UUID']['input']>;
  metadata?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type ProfileTagListConditions = {
  /** Filter by tag id */
  id?: InputMaybe<StringCondition>;
  /** Filter by tag types */
  metadata?: InputMaybe<ProfileTagMetadataCondition>;
  /** Search terms. Will look in name. */
  searchTerms?: InputMaybe<StringCondition>;
};

/** Properties by which profile tags can be ordered. */
export enum ProfileTagListOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

export type ProfileTagMetadataCondition = {
  equals?: InputMaybe<Scalars['JSONObject']['input']>;
  iLike?: InputMaybe<Scalars['JSONObject']['input']>;
  in?: InputMaybe<Array<Scalars['JSONObject']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['JSONObject']['input']>;
  notEqualsTo?: InputMaybe<Scalars['JSONObject']['input']>;
  notIn?: InputMaybe<Array<Scalars['JSONObject']['input']>>;
};

export type ProfileTagPageInfo = {
  __typename?: 'ProfileTagPageInfo';
  /** Pointer to the next page. When null, it means you are in the last page. */
  afterCursor?: Maybe<Scalars['String']['output']>;
  /** Pointer to the previous page. When null, it means you are in the first page. */
  beforeCursor?: Maybe<Scalars['String']['output']>;
};

export type ProfileTagSearchConditions = {
  /** Filter by tag types */
  metadata?: InputMaybe<ProfileTagMetadataCondition>;
  /** Search terms. Will look in name. */
  searchTerms?: InputMaybe<StringCondition>;
};

/** Form prompt. */
export type Prompt = {
  __typename?: 'Prompt';
  choices: ChoiceConnection;
  id: Scalars['UUID']['output'];
  /** It means this prompt will have a priority if Bank of questions is used. */
  isMandatory?: Maybe<Scalars['Boolean']['output']>;
  /** It means this prompt will be marked as a list of checkboxes instead of radio buttons. */
  isMultiple?: Maybe<Scalars['Boolean']['output']>;
  /** It means this prompt will be marked as a rubric prompt. */
  isRubric?: Maybe<Scalars['Boolean']['output']>;
  localizations: PromptLocalizedConnection;
  /** Prompt position within form. */
  position: Scalars['Int']['output'];
};

export type PromptConnection = {
  __typename?: 'PromptConnection';
  nodes: Array<Prompt>;
};

export type PromptInput = {
  choices: Array<ChoiceInput>;
  defaultLocalization: DefaultPromptLocalizationInput;
  id?: InputMaybe<Scalars['String']['input']>;
  /** It means this prompt will have a priority if Bank of questions is used. */
  isMandatory?: InputMaybe<Scalars['Boolean']['input']>;
  /** It means this prompt will be marked as a list of checkboxes instead of radio buttons. */
  isMultiple?: InputMaybe<Scalars['Boolean']['input']>;
  /** It means this prompt will be marked as a rubric prompt. */
  isRubric?: InputMaybe<Scalars['Boolean']['input']>;
  /** Prompt position within form. */
  position: Scalars['Int']['input'];
};

/** Form prompt localization. */
export type PromptLocalized = {
  __typename?: 'PromptLocalized';
  description: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  language: Language;
};

export type PromptLocalizedConnection = {
  __typename?: 'PromptLocalizedConnection';
  nodes: Array<PromptLocalized>;
};

export type QualitativeFeedback = {
  __typename?: 'QualitativeFeedback';
  meta?: Maybe<QualitativeFeedbackMeta>;
  overview?: Maybe<QualitativeFeedbackOverview>;
  sections?: Maybe<Array<QualitativeSection>>;
};

export type QualitativeFeedbackMeta = {
  __typename?: 'QualitativeFeedbackMeta';
  generatedAt: Scalars['String']['output'];
  reportId: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

export type QualitativeFeedbackOverview = {
  __typename?: 'QualitativeFeedbackOverview';
  actions?: Maybe<Array<Action>>;
  content: Scalars['String']['output'];
  overallScore: Scalars['String']['output'];
};

export type QualitativeSection = {
  __typename?: 'QualitativeSection';
  id: Scalars['String']['output'];
  items: Array<QualitativeSectionItem>;
  style: QualitativeSectionStyle;
  title: Scalars['String']['output'];
};

export type QualitativeSectionItem = {
  __typename?: 'QualitativeSectionItem';
  content: Scalars['String']['output'];
  evidence: Array<EvidenceItem>;
  id: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
  visualIndicator?: Maybe<VisualIndicator>;
};

export type QualitativeSectionStyle = {
  __typename?: 'QualitativeSectionStyle';
  backgroundColorHex: Scalars['String']['output'];
  icon: Scalars['String']['output'];
  titleTextColorHex: Scalars['String']['output'];
};

export type Query = {
  __typename?: 'Query';
  apiKeyList: PaginatedApiKeyResponse;
  authChannel: AuthChannelResponse;
  /** Get a paginated list of all the companies for super admins or profile companies otherwise */
  companies: PaginatedCompanyResponse;
  /** Get a company. */
  company: Company;
  /** Get a paginated list of companies. */
  companySearch: PaginatedCompanyResponse;
  /** Get Custom Vocabulary. */
  customVocabulary: CustomVocabulary;
  /** Get Custom Vocabulary list. */
  customVocabularyList: PaginatedCustomVocabularyResponse;
  /** Get Custom Vocabulary list. */
  customVocabularylKeywordList: PaginatedCustomVocabularyKeywordResponse;
  /** Return a list of all available Features. */
  featureList: Array<Feature>;
  /** Get a paginated list of profiles filtered by the current company. */
  getCompanySiblings: Array<CompanySiblingDto>;
  /** returns all creators of the groups */
  getCreatorGroupList: Array<CompanyProfile>;
  /** returns all creators of the learning plans */
  getCreatorLPList: Array<CompanyProfile>;
  /** returns all creators of the profiles */
  getCreatorList: Array<CompanyProfile>;
  /** returns all creators of the reps */
  getCreatorRepList: Array<CompanyProfile>;
  /** returns all creators of the skills */
  getCreatorSkillList: Array<CompanyProfile>;
  /** returns all creators of the groups */
  getCreatorTopicList: Array<CompanyProfile>;
  /** Get the user activity info on the learning plans. */
  getLearningPlanActivityInfo: Array<LearningPlanActivityResponse>;
  /** Get RolePlay Configs */
  getRolePlayConfigs: Array<RolePlayConfig>;
  /** Get the user activity info on skills. */
  getSkillActivityInfo: Array<SkillActivityResponse>;
  getTranscriptionMediaObjectById: GetTranscriptionMediaObjectById;
  /** returns all users of company as CSV file */
  getUsersCsv: CompanyProfileDownload;
  getWordCloudMediaObjectById: GetWordCloudMediaObjectById;
  /** Return a new auth feature for email. */
  isNewAuth: Scalars['Boolean']['output'];
  /** Get a learning plan by id. */
  learningPlan: LearningPlan;
  /** Search learning plan parents. */
  learningPlanFolderSearch: PaginatedLearningPlanFolderResponse;
  /** Get a paginated list of learning plans filtered by current company. */
  learningPlanFoldersList: PaginatedLearningPlanFolderResponse;
  /** Get the learners for a learning plan. */
  learningPlanLearners: PaginatedLearningPlanLearners;
  /** Get all the learning plan localizations. */
  learningPlanLocalizations: Array<LocalizedEntity>;
  /** Get a paginated list of learning plans for autocomplete input resutls. */
  learningPlanSearch: PaginatedLearningPlanResponse;
  /** Returns a list of skills for a learning plan. */
  learningPlanSkills: Array<LpSectionSkill>;
  /** Get a paginated list of learning plans filtered by current company. */
  learningPlans: PaginatedLearningPlanResponse;
  /** get all learning plans which is archieved */
  learningPlansAssociatedWithSkill: Array<LearningPlan>;
  /** Returns profile information from current session. */
  me?: Maybe<Me>;
  /** Returns a Media object by ID */
  media: Media;
  /** Get a profile by ID. */
  profile: CompanyProfile;
  /** Get a profile group. */
  profileGroup: ProfileGroup;
  /** Get a paginated list of profile groups filtered by current company. */
  profileGroupList: PaginatedProfileGroupListResponse;
  /** Remove a Company Profile from a Group */
  profileGroupListofProfile: Array<ProfileGroupMember>;
  /** Get a paginated list of profile groups for autocomplete input results. */
  profileGroupSearch: PaginatedProfileGroupSearchResponse;
  /** Get a paginated list of profiles filtered by the current company. */
  profileList: PaginatedCompanyProfileListResponse;
  /** Get a paginated list of profiles for autocomplete input results */
  profileSearch: PaginatedCompanyProfileSearchResponse;
  /** Return a tag by id. */
  profileTag: ProfileTag;
  /** Get a paginated list of tags filtered by current company. */
  profileTagList: PaginatedProfileTagResponse;
  /** Get tag list for autocomplete input results. */
  profileTagSearch: PaginatedProfileTagResponse;
  /** Get skill list for autocomplete input results. */
  repPromptSearch: PaginatedRepPromptLocalizedResponse;
  repResponse: RepResponse;
  repResponseList: PaginatedRepResponse;
  /** Get a skill. */
  skill: Skill;
  /** Get skill list of type CONTENT. */
  skillList: PaginatedSkillResponse;
  /** Get all the skill localizations. */
  skillLocalizations: Array<LocalizedEntity>;
  /** Get a skill of type REP. */
  skillRep: SkillRep;
  /** Get skill list of type REP. */
  skillRepList: PaginatedSkillRepResponse;
  /** Get all the Skill Rep localizations. */
  skillRepLocalizations: Array<LocalizedEntity>;
  /** Get skill list for autocomplete input results. */
  skillSearch: PaginatedSkillResponse;
  /** Returns a topic by ID. */
  topic: Topic;
  /** Returns a list of paginated topics filtered by the current company. */
  topicList: TopicList;
  /** Get all the topic localizations. */
  topicLocalizations: Array<LocalizedEntity>;
};


export type QueryApiKeyListArgs = {
  paginate?: InputMaybe<BaseClassicPaginate>;
  sorts?: InputMaybe<Array<ApiKeyListOrderBy>>;
};


export type QueryAuthChannelArgs = {
  profileIdentifier: Scalars['String']['input'];
};


export type QueryCompaniesArgs = {
  conditions?: InputMaybe<CompanySearchConditions>;
  paginate?: InputMaybe<BaseClassicPaginate>;
};


export type QueryCompanySearchArgs = {
  conditions?: InputMaybe<CompanySearchConditions>;
  paginate?: InputMaybe<BaseClassicPaginate>;
};


export type QueryCustomVocabularyArgs = {
  id: Scalars['String']['input'];
};


export type QueryCustomVocabularyListArgs = {
  conditions?: InputMaybe<CustomVocabularyListConditions>;
  paginate?: InputMaybe<BaseClassicPaginate>;
  sorts?: InputMaybe<Array<CustomVocabularyListOrderBy>>;
};


export type QueryCustomVocabularylKeywordListArgs = {
  conditions?: InputMaybe<CustomVocabularyKeywordListConditions>;
  paginate?: InputMaybe<BaseClassicPaginate>;
  sorts?: InputMaybe<Array<CustomVocabularyKeywordListOrderBy>>;
  vocabularyId: Scalars['String']['input'];
};


export type QueryGetCompanySiblingsArgs = {
  ActiveOnly: Scalars['Boolean']['input'];
};


export type QueryGetLearningPlanActivityInfoArgs = {
  endDate: Scalars['DateTime']['input'];
  filterOn?: InputMaybe<FilterOn>;
  learningPlanExtIds?: InputMaybe<Array<Scalars['String']['input']>>;
  sortOn?: InputMaybe<LpActivityInfoSortBy>;
  startDate: Scalars['DateTime']['input'];
};


export type QueryGetSkillActivityInfoArgs = {
  endDate: Scalars['DateTime']['input'];
  filterOn?: InputMaybe<FilterOn>;
  skillExtIds?: InputMaybe<Array<Scalars['String']['input']>>;
  sortOn?: InputMaybe<SkillActivityInfoSortBy>;
  startDate: Scalars['DateTime']['input'];
};


export type QueryGetTranscriptionMediaObjectByIdArgs = {
  mediaId: Scalars['String']['input'];
};


export type QueryGetWordCloudMediaObjectByIdArgs = {
  repPromptId: Scalars['String']['input'];
};


export type QueryIsNewAuthArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
};


export type QueryLearningPlanArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryLearningPlanFolderSearchArgs = {
  conditions?: InputMaybe<LearningPlanFolderSearchCondition>;
  paginate?: InputMaybe<BaseClassicPaginate>;
};


export type QueryLearningPlanFoldersListArgs = {
  conditions?: InputMaybe<LearningPlanFolderListConditions>;
  paginate?: InputMaybe<BaseClassicPaginate>;
  sorts?: InputMaybe<Array<LearningPlanFolderListOrderBy>>;
};


export type QueryLearningPlanLearnersArgs = {
  conditions?: InputMaybe<LearningPlanLearnersConditions>;
  learningPlanId: Scalars['UUID']['input'];
  paginate?: InputMaybe<BaseClassicPaginate>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryLearningPlanLocalizationsArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryLearningPlanSearchArgs = {
  conditions?: InputMaybe<LearningPlanSearchConditions>;
  paginate?: InputMaybe<BaseClassicPaginate>;
};


export type QueryLearningPlanSkillsArgs = {
  learningPlanId: Scalars['UUID']['input'];
};


export type QueryLearningPlansArgs = {
  conditions?: InputMaybe<LearningPlanListConditions>;
  paginate?: InputMaybe<BaseClassicPaginate>;
  sorts?: InputMaybe<Array<LearningPlanListOrderBy>>;
};


export type QueryLearningPlansAssociatedWithSkillArgs = {
  skillId: Scalars['UUID']['input'];
};


export type QueryMediaArgs = {
  id: Scalars['String']['input'];
};


export type QueryProfileArgs = {
  id: Scalars['String']['input'];
};


export type QueryProfileGroupArgs = {
  id: Scalars['String']['input'];
};


export type QueryProfileGroupListArgs = {
  conditions?: InputMaybe<ProfileGroupListConditions>;
  paginate?: InputMaybe<BaseClassicPaginate>;
  sorts?: InputMaybe<Array<ProfileGroupListOrderBy>>;
};


export type QueryProfileGroupListofProfileArgs = {
  companyProfileId: Scalars['String']['input'];
};


export type QueryProfileGroupSearchArgs = {
  companyId?: InputMaybe<Scalars['UUID']['input']>;
  conditions?: InputMaybe<ProfileGroupSearchConditions>;
  paginate?: InputMaybe<BaseClassicPaginate>;
};


export type QueryProfileListArgs = {
  conditions?: InputMaybe<CompanyProfileListConditions>;
  paginate?: InputMaybe<BaseClassicPaginate>;
  sorts?: InputMaybe<Array<CompanyProfileListOrderBy>>;
};


export type QueryProfileSearchArgs = {
  conditions?: InputMaybe<CompanyProfileSearchConditions>;
  paginate?: InputMaybe<BaseClassicPaginate>;
};


export type QueryProfileTagArgs = {
  id: Scalars['String']['input'];
};


export type QueryProfileTagListArgs = {
  conditions?: InputMaybe<ProfileTagListConditions>;
  paginate?: InputMaybe<BaseClassicPaginate>;
  sorts?: InputMaybe<Array<ProfileTagListOrderBy>>;
};


export type QueryProfileTagSearchArgs = {
  conditions?: InputMaybe<ProfileTagSearchConditions>;
  paginate?: InputMaybe<BaseClassicPaginate>;
};


export type QueryRepPromptSearchArgs = {
  conditions?: InputMaybe<RepPromptLocalizedSearchConditions>;
  paginate?: InputMaybe<BaseClassicPaginate>;
};


export type QueryRepResponseArgs = {
  id: Scalars['String']['input'];
};


export type QueryRepResponseListArgs = {
  excludeIds?: InputMaybe<Array<Scalars['String']['input']>>;
  filters: RepResponseFilter;
  orderBy?: InputMaybe<RepResponseListOrderBy>;
  orderDirection?: InputMaybe<OrderByDirection>;
  paginator?: InputMaybe<Paginator>;
};


export type QuerySkillArgs = {
  id: Scalars['UUID']['input'];
};


export type QuerySkillListArgs = {
  conditions?: InputMaybe<SkillListConditions>;
  paginate?: InputMaybe<BaseClassicPaginate>;
  sorts?: InputMaybe<Array<SkillListOrderBy>>;
};


export type QuerySkillLocalizationsArgs = {
  id: Scalars['UUID']['input'];
};


export type QuerySkillRepArgs = {
  id: Scalars['UUID']['input'];
};


export type QuerySkillRepListArgs = {
  conditions?: InputMaybe<SkillRepListConditions>;
  paginate?: InputMaybe<BaseClassicPaginate>;
  sorts?: InputMaybe<Array<SkillRepListOrderBy>>;
};


export type QuerySkillRepLocalizationsArgs = {
  id: Scalars['UUID']['input'];
};


export type QuerySkillSearchArgs = {
  conditions?: InputMaybe<SkillSearchConditions>;
  paginate?: InputMaybe<BaseClassicPaginate>;
};


export type QueryTopicArgs = {
  id: Scalars['String']['input'];
};


export type QueryTopicListArgs = {
  conditions?: InputMaybe<TopicListConditions>;
  paginate?: InputMaybe<BaseClassicPaginate>;
  sorts?: InputMaybe<Array<TopicListOrderBy>>;
};


export type QueryTopicLocalizationsArgs = {
  id: Scalars['UUID']['input'];
};

export type RegionInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

/** Represents a related topic with its relationship type */
export type RelatedTopic = {
  __typename?: 'RelatedTopic';
  /** The language code of the text corpus and the topic extracted e.g. en , fr , hi */
  language: Scalars['String']['output'];
  /** A number between 0 and 1 denoting the relevance of the related topic to the base topic in comparison to other related topics extracted */
  proximity: Scalars['Float']['output'];
  /** Name of the related topic for an extracted topic */
  relatedTopic: Scalars['String']['output'];
  /** relationship type between related topic and the base topic as per the instructions given */
  relationshipType: Scalars['String']['output'];
  /** The english translation of the topic if text corpus is not in english , after analyzing the semantic significance of the topic. If the topic is an unknown keyword then transliterate to english */
  topicInEnglish: Scalars['String']['output'];
};

export type RepAssignment = {
  __typename?: 'RepAssignment';
  assignorCompanyProfile?: Maybe<CompanyProfile>;
  companyProfile: CompanyProfile;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  repAssignmentStatus: RepAssignmentStatus;
  repPrompt: RepPrompt;
  skill: SkillRep;
  updatedAt: Scalars['DateTime']['output'];
};

/** RepAssignmentStatus options */
export enum RepAssignmentStatus {
  Approved = 'APPROVED',
  Done = 'DONE',
  Locked = 'LOCKED',
  New = 'NEW',
  Practiced = 'PRACTICED',
  Reviewed = 'REVIEWED',
  Submitted = 'SUBMITTED'
}

/** RepFeedbackType options */
export enum RepFeedbackType {
  Approval = 'APPROVAL',
  Comment = 'COMMENT',
  Feedback = 'FEEDBACK'
}

export type RepPrompt = {
  __typename?: 'RepPrompt';
  allResponseTypeEnabled: Scalars['Boolean']['output'];
  allowedKeywords?: Maybe<Array<Scalars['String']['output']>>;
  autoCoachConfig?: Maybe<AutoCoachConfig>;
  conversationRoles?: Maybe<ConversationRoles>;
  conversationType?: Maybe<ConversationType>;
  createdAt: Scalars['DateTime']['output'];
  form?: Maybe<Form>;
  formId?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  incorrectKeywords?: Maybe<Array<Scalars['String']['output']>>;
  interjections?: Maybe<Array<Interjection>>;
  isAiEnabled: Scalars['Boolean']['output'];
  isAutoCoachEnabled: Scalars['Boolean']['output'];
  isCoached: Scalars['Boolean']['output'];
  isKeywords: Scalars['Boolean']['output'];
  isRepeatable?: Maybe<Scalars['Boolean']['output']>;
  points?: Maybe<Scalars['Int']['output']>;
  rejectionPoints?: Maybe<Scalars['Int']['output']>;
  repPromptLocalizeds: Array<RepPromptLocalized>;
  repPromptResponseTypes: Array<RepPromptResponseType>;
  repType: RepType;
  rolePlayConfigId?: Maybe<Scalars['UUID']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type RepPromptLocalized = {
  __typename?: 'RepPromptLocalized';
  autoEvaluationCriteria?: Maybe<AutoEvaluationCriteriaGraphql>;
  caption?: Maybe<Scalars['String']['output']>;
  content: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  language: Language;
  promptType: RepResponseKind;
  repPromptId: Scalars['UUID']['output'];
  skillId?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type RepPromptLocalizedPageInfo = {
  __typename?: 'RepPromptLocalizedPageInfo';
  /** Pointer to the next page. When null, it means you are in the last page. */
  afterCursor?: Maybe<Scalars['String']['output']>;
  /** Pointer to the previous page. When null, it means you are in the first page. */
  beforeCursor?: Maybe<Scalars['String']['output']>;
};

export type RepPromptLocalizedSearchConditions = {
  companyId?: InputMaybe<StringCondition>;
  /** Search terms. Will look in name, externalId or description. */
  searchTerms?: InputMaybe<StringCondition>;
};

export type RepPromptResponseType = {
  __typename?: 'RepPromptResponseType';
  id: Scalars['UUID']['output'];
  responseType: RepResponseKind;
};

export type RepPromptResponseTypeInput = {
  id?: InputMaybe<Scalars['UUID']['input']>;
  responseType: RepResponseKind;
};

export type RepResponse = {
  __typename?: 'RepResponse';
  autoEvaluationOutcome?: Maybe<AutoEvaluationOutcome>;
  caption?: Maybe<Scalars['String']['output']>;
  content?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  /** It returns only video submissions */
  masterMedia?: Maybe<Media>;
  media: Scalars['String']['output'];
  posterMedia?: Maybe<Media>;
  repAssignment: RepAssignment;
  repSubmissionFeedback?: Maybe<Array<RepSubmissionFeedback>>;
  responseType: RepResponseKind;
  /** It returns only video submissions */
  streamMedia?: Maybe<Media>;
  title?: Maybe<Scalars['String']['output']>;
  topicMetadata?: Maybe<TopicMetadata>;
  topicProcessingStatus: TopicProcessingStatus;
  transcriptionMedia?: Maybe<Media>;
};

export type RepResponseCondition = {
  assignment_status_eq?: InputMaybe<Scalars['String']['input']>;
  feedback_type_eq?: InputMaybe<Scalars['String']['input']>;
  feedback_type_in?: InputMaybe<Array<Scalars['String']['input']>>;
  learner_eq?: InputMaybe<Scalars['String']['input']>;
  learner_group_eq?: InputMaybe<Scalars['String']['input']>;
  learner_group_in?: InputMaybe<Array<Scalars['String']['input']>>;
  learner_in?: InputMaybe<Array<Scalars['String']['input']>>;
  learning_plan_in?: InputMaybe<Array<Scalars['String']['input']>>;
  operator?: InputMaybe<BaseOperator>;
  prompt_type_eq?: InputMaybe<Scalars['String']['input']>;
  response_type_eq?: InputMaybe<Scalars['String']['input']>;
  response_type_in?: InputMaybe<Array<Scalars['String']['input']>>;
  reviewer_eq?: InputMaybe<Scalars['String']['input']>;
  reviewer_in?: InputMaybe<Array<Scalars['String']['input']>>;
  skill_eq?: InputMaybe<Scalars['String']['input']>;
  skill_in?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type RepResponseFilter = {
  assignment_status_eq?: InputMaybe<Scalars['String']['input']>;
  conditions?: InputMaybe<Array<RepResponseCondition>>;
  feedback_type_eq?: InputMaybe<Scalars['String']['input']>;
  feedback_type_in?: InputMaybe<Array<Scalars['String']['input']>>;
  learner_eq?: InputMaybe<Scalars['String']['input']>;
  learner_group_eq?: InputMaybe<Scalars['String']['input']>;
  learner_group_in?: InputMaybe<Array<Scalars['String']['input']>>;
  learner_in?: InputMaybe<Array<Scalars['String']['input']>>;
  learning_plan_in?: InputMaybe<Array<Scalars['String']['input']>>;
  operator?: InputMaybe<BaseOperator>;
  prompt_type_eq?: InputMaybe<Scalars['String']['input']>;
  response_type_eq?: InputMaybe<Scalars['String']['input']>;
  response_type_in?: InputMaybe<Array<Scalars['String']['input']>>;
  reviewer_eq?: InputMaybe<Scalars['String']['input']>;
  reviewer_in?: InputMaybe<Array<Scalars['String']['input']>>;
  skill_eq?: InputMaybe<Scalars['String']['input']>;
  skill_in?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** RepResponseKind options */
export enum RepResponseKind {
  Audio = 'AUDIO',
  Conversation = 'CONVERSATION',
  Image = 'IMAGE',
  Pdf = 'PDF',
  Text = 'TEXT',
  Video = 'VIDEO'
}

/** RepResponseList collection - Order by fields */
export enum RepResponseListOrderBy {
  CreatedAt = 'CREATED_AT',
  ReviewedAt = 'REVIEWED_AT'
}

export type RepResponseTypeCondition = {
  equals?: InputMaybe<RepResponseKind>;
  iLike?: InputMaybe<RepResponseKind>;
  in?: InputMaybe<Array<RepResponseKind>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<RepResponseKind>;
  notEqualsTo?: InputMaybe<RepResponseKind>;
  notIn?: InputMaybe<Array<RepResponseKind>>;
};

export type RepSubmissionFeedback = {
  __typename?: 'RepSubmissionFeedback';
  autoEvaluationOutcome?: Maybe<AutoEvaluationOutcome>;
  caption?: Maybe<Scalars['String']['output']>;
  companyProfile?: Maybe<CompanyProfile>;
  content?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  feedbackType: RepFeedbackType;
  id: Scalars['UUID']['output'];
  responseType: RepResponseKind;
  reviewerRole: ReviewerRoleType;
  rubric?: Maybe<Rubric>;
  transcriptionMedia?: Maybe<Media>;
  updatedAt: Scalars['DateTime']['output'];
};

/** RepType options */
export enum RepType {
  Coached = 'COACHED',
  Roleplay = 'ROLEPLAY',
  Selfcoached = 'SELFCOACHED',
  Social = 'SOCIAL'
}

export type Results = {
  __typename?: 'Results';
  timeline?: Maybe<Array<Timeline>>;
  transcripts?: Maybe<Array<Transcript>>;
};

/** ReviewerRoleType options */
export enum ReviewerRoleType {
  AiCoach = 'AI_COACH',
  Coach = 'COACH',
  Peer = 'PEER',
  Self = 'SELF'
}

/** Available roles for profiles. */
export enum Role {
  Coach = 'COACH',
  CompanyAdministrator = 'COMPANY_ADMINISTRATOR',
  CompanyAnalytics = 'COMPANY_ANALYTICS',
  ContentCreator = 'CONTENT_CREATOR',
  DraftViewer = 'DRAFT_VIEWER',
  SuperAdmin = 'SUPER_ADMIN'
}

/** RolePlay Config entity */
export type RolePlayConfig = {
  __typename?: 'RolePlayConfig';
  cardDescription: Scalars['String']['output'];
  cardTitle: Scalars['String']['output'];
  config: RolePlayConfigSettings;
  createdAt: Scalars['DateTime']['output'];
  designation: Scalars['String']['output'];
  details: RolePlayDetails;
  id: Scalars['ID']['output'];
  personaName: Scalars['String']['output'];
  status: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

/** Configuration settings for a role-play scenario */
export type RolePlayConfigSettings = {
  __typename?: 'RolePlayConfigSettings';
  avatarUrl?: Maybe<Scalars['String']['output']>;
  difficulty: Scalars['String']['output'];
  gender: Scalars['String']['output'];
  language: Scalars['String']['output'];
  voiceName?: Maybe<Scalars['String']['output']>;
  voiceService?: Maybe<Scalars['String']['output']>;
};

/** Details about the persona in a role-play scenario */
export type RolePlayDetails = {
  __typename?: 'RolePlayDetails';
  bio: Scalars['String']['output'];
  communicationStyle: Scalars['String']['output'];
  cooperationLevel: Scalars['String']['output'];
  detailedBio: Scalars['String']['output'];
  detailedGoal: Scalars['String']['output'];
  difficulty: Scalars['String']['output'];
  goal: Scalars['String']['output'];
  industry: Scalars['String']['output'];
  knowledgeText: Scalars['String']['output'];
  mainTrait: Scalars['String']['output'];
  patienceLevel: Scalars['String']['output'];
  skepticismLevel: Scalars['String']['output'];
  traits: Array<Scalars['String']['output']>;
};

/** Form rubrick feedback data */
export type Rubric = {
  __typename?: 'Rubric';
  formId?: Maybe<Scalars['String']['output']>;
  prompts?: Maybe<Array<RubricPrompt>>;
  version?: Maybe<Scalars['Float']['output']>;
};

export type RubricAnswer = {
  __typename?: 'RubricAnswer';
  answer?: Maybe<Scalars['String']['output']>;
  choiceId?: Maybe<Scalars['String']['output']>;
};

export type RubricPrompt = {
  __typename?: 'RubricPrompt';
  answers?: Maybe<Array<RubricAnswer>>;
  promptId?: Maybe<Scalars['String']['output']>;
};

/** DTO for CompanySibling. Records company and its sibling information. */
export type SiblingCompanyInfo = {
  __typename?: 'SiblingCompanyInfo';
  /** Company visible name that can be different from name. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** A unique url-friendly identifier. i.e. my-company-name */
  externalId?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  /** Company name. */
  name?: Maybe<Scalars['String']['output']>;
};

/** Skill of type CONTENT. */
export type Skill = {
  __typename?: 'Skill';
  /** The archived_at column for archiving learning plan */
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  companyId: Scalars['UUID']['output'];
  createdAt: Scalars['DateTime']['output'];
  /** The created_by column for storing creating user uuid */
  createdBy?: Maybe<Scalars['UUID']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  /** Get skill display name. */
  displayName: Scalars['String']['output'];
  duration?: Maybe<Scalars['String']['output']>;
  externalId: Scalars['String']['output'];
  flow: SkillFlow;
  id: Scalars['UUID']['output'];
  learningCards: LearningCardConnection;
  media?: Maybe<Media>;
  mediaId?: Maybe<Scalars['UUID']['output']>;
  name: Scalars['String']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  sourceCompanyId?: Maybe<Scalars['UUID']['output']>;
  sourceSkillId?: Maybe<Scalars['UUID']['output']>;
  type: SkillType;
  updatedAt: Scalars['DateTime']['output'];
  /** The updated_by column for storing last updated user uuid */
  updatedBy?: Maybe<Scalars['UUID']['output']>;
};

/** The column to sort on for Skill Activity Info */
export enum SkillActivityInfoSortBy {
  CompletionDate = 'COMPLETION_DATE',
  ExternalProfileId = 'EXTERNAL_PROFILE_ID',
  StartDate = 'START_DATE'
}

/** Skill Completion Information by User */
export type SkillActivityResponse = {
  __typename?: 'SkillActivityResponse';
  companyProfileId: Scalars['UUID']['output'];
  /** The assignment completion date in UTC. */
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Profile email address */
  emailAddress?: Maybe<Scalars['String']['output']>;
  /** Total number of approved attempts made by user for the learning card form. */
  numApprovedFormAttempts?: Maybe<Scalars['Int']['output']>;
  /** Total number of failed attempts made by user for the learning card form. */
  numFailedFormAttempts?: Maybe<Scalars['Int']['output']>;
  /** Total number of attempts made to pass the learning card form. */
  numTotalAttempts?: Maybe<Scalars['Int']['output']>;
  /** Passed or Failed */
  outcome?: Maybe<Scalars['String']['output']>;
  /** Profile phone number */
  phoneNumber?: Maybe<Scalars['String']['output']>;
  /** Display name for the user profile */
  profileDisplayName?: Maybe<Scalars['String']['output']>;
  /** Unique external identifier for the user profile */
  profileExternalId: Scalars['String']['output'];
  /** The external name of the skill. */
  skillExternalId: Scalars['String']['output'];
  /** The internal name of the skill. */
  skillName: Scalars['String']['output'];
  /** The assignment start date in UTC. */
  startedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type SkillConnection = {
  __typename?: 'SkillConnection';
  nodes: Array<Skill>;
};

/** Skill flow configuration. */
export enum SkillFlow {
  Rep = 'REP',
  Stack = 'STACK',
  Wup = 'WUP'
}

export type SkillListConditions = {
  /** Filter by creator id */
  filterByCreator?: InputMaybe<Scalars['String']['input']>;
  /** Filter by whether the Profile is active or not. */
  includeDisabled: Scalars['Boolean']['input'];
  /** Filter by skill state. It also accepts strict equals to a certain date */
  publishedAt?: InputMaybe<DateTimeCondition>;
  /** Search terms. Will look in name, externalId or description. */
  searchTerms?: InputMaybe<StringCondition>;
};

/** Sort skills by */
export enum SkillListOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  ExternalIdAsc = 'EXTERNAL_ID_ASC',
  ExternalIdDesc = 'EXTERNAL_ID_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

export type SkillPageInfo = {
  __typename?: 'SkillPageInfo';
  /** Pointer to the next page. When null, it means you are in the last page. */
  afterCursor?: Maybe<Scalars['String']['output']>;
  /** Pointer to the previous page. When null, it means you are in the first page. */
  beforeCursor?: Maybe<Scalars['String']['output']>;
};

/** Skill of type REP. */
export type SkillRep = {
  __typename?: 'SkillRep';
  createdAt: Scalars['DateTime']['output'];
  /** The created_by column for storing creating user uuid */
  createdBy?: Maybe<Scalars['UUID']['output']>;
  displayName: Scalars['String']['output'];
  externalId: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  media?: Maybe<Media>;
  mediaId?: Maybe<Scalars['UUID']['output']>;
  name: Scalars['String']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Get skill RepPrompt relationship. */
  repPrompt?: Maybe<RepPrompt>;
  type: SkillType;
  updatedAt: Scalars['DateTime']['output'];
  /** The updated_by column for storing last updated user uuid */
  updatedBy?: Maybe<Scalars['UUID']['output']>;
};

export type SkillRepListConditions = {
  /** Filter by creator id */
  filterByCreator?: InputMaybe<Scalars['String']['input']>;
  /** Filter by whether the REP is active or not. */
  includeDisabled: Scalars['Boolean']['input'];
  /** Filter by Rep state. It also accepts strict equals to a certain date */
  publishedAt?: InputMaybe<DateTimeCondition>;
  /** Filter by Rep prompt response types */
  responseType?: InputMaybe<RepResponseTypeCondition>;
  /** Search terms. Will look in name, externalId or description. */
  searchTerms?: InputMaybe<StringCondition>;
};

/** Sort skills by */
export enum SkillRepListOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  ExternalIdAsc = 'EXTERNAL_ID_ASC',
  ExternalIdDesc = 'EXTERNAL_ID_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

export type SkillRepPageInfo = {
  __typename?: 'SkillRepPageInfo';
  /** Pointer to the next page. When null, it means you are in the last page. */
  afterCursor?: Maybe<Scalars['String']['output']>;
  /** Pointer to the previous page. When null, it means you are in the first page. */
  beforeCursor?: Maybe<Scalars['String']['output']>;
};

export type SkillSearchConditions = {
  companyId?: InputMaybe<StringCondition>;
  id?: InputMaybe<StringCondition>;
  /** Search terms. Will look in name, externalId or description. */
  searchTerms?: InputMaybe<StringCondition>;
  /** Filter by skill type REP or CONTENT. */
  type?: InputMaybe<SkillTypeCondition>;
};

export type SkillTopic = {
  __typename?: 'SkillTopic';
  id?: Maybe<Scalars['UUID']['output']>;
  /** Skill type. */
  skill: Skill;
  /** The Skill Id. */
  skillId: Scalars['UUID']['output'];
  /** The Topic Id. */
  topicId: Scalars['UUID']['output'];
};

export type SkillTopicConnection = {
  __typename?: 'SkillTopicConnection';
  nodes: Array<SkillTopic>;
};

export type SkillTopicInput = {
  id?: InputMaybe<Scalars['UUID']['input']>;
  /** The Skill Id. */
  skillId: Scalars['UUID']['input'];
};

/** Available types for a Skill. */
export enum SkillType {
  Content = 'CONTENT',
  Rep = 'REP'
}

export type SkillTypeCondition = {
  equals?: InputMaybe<SkillType>;
  iLike?: InputMaybe<SkillType>;
  in?: InputMaybe<Array<SkillType>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<SkillType>;
  notEqualsTo?: InputMaybe<SkillType>;
  notIn?: InputMaybe<Array<SkillType>>;
};

export type SpeakerLabel = {
  __typename?: 'SpeakerLabel';
  isPresenter?: Maybe<Scalars['Boolean']['output']>;
  speakerId?: Maybe<Scalars['String']['output']>;
  speakerLabel?: Maybe<Scalars['String']['output']>;
  speakerName?: Maybe<Scalars['String']['output']>;
  speakerRole?: Maybe<Scalars['String']['output']>;
  speakerRoleDisplayed?: Maybe<Scalars['String']['output']>;
  talkRatio?: Maybe<Scalars['Float']['output']>;
};

export type SsoAttributesInput = {
  idpEndPoint: Scalars['String']['input'];
  ssoMethod: Scalars['String']['input'];
  tagTypesMap?: InputMaybe<Scalars['JSONObject']['input']>;
};

/** Metadata for SSO type authentication channel */
export type SsoChannel = {
  __typename?: 'SsoChannel';
  /** The IDP X509 certificate path */
  certPath?: Maybe<Scalars['String']['output']>;
  /** The base URL for the endpoint where request has to be forwarded for external authentication. Usually the backend URL */
  idpProxyBaseUrl?: Maybe<Scalars['String']['output']>;
  /** The path fragment for the endpoint where request has to be forwarded for external authentication */
  idpProxyPath?: Maybe<Scalars['String']['output']>;
};

/** Details of stacked questions in the conversation */
export type StackedQuestion = {
  __typename?: 'StackedQuestion';
  questions: Array<Scalars['String']['output']>;
  speaker: Scalars['String']['output'];
  startTime: Scalars['Float']['output'];
};

export type StringCondition = {
  equals?: InputMaybe<Scalars['String']['input']>;
  iLike?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  notEqualsTo?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type TestData = {
  __typename?: 'TestData';
  companyId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  phoneArea: Scalars['String']['output'];
  phoneCountry: Scalars['String']['output'];
  phoneNumber: Scalars['String']['output'];
  token: Scalars['String']['output'];
  verificationCode: Scalars['String']['output'];
};

export type Timeline = {
  __typename?: 'Timeline';
  end_time?: Maybe<Scalars['String']['output']>;
  sentence?: Maybe<Scalars['String']['output']>;
  speaker?: Maybe<Scalars['String']['output']>;
  start_time?: Maybe<Scalars['String']['output']>;
};

/** Available timezones. */
export enum Timezone {
  AfricaLagos = 'AFRICA_LAGOS',
  AmericaNewYork = 'AMERICA_NEW_YORK',
  AsiaKolkata = 'ASIA_KOLKATA',
  AsiaSingapore = 'ASIA_SINGAPORE',
  EuropeBerlin = 'EUROPE_BERLIN',
  EuropeMadrid = 'EUROPE_MADRID',
  EuropeParis = 'EUROPE_PARIS',
  UsAlaska = 'US_ALASKA',
  UsCentral = 'US_CENTRAL',
  UsEastern = 'US_EASTERN',
  UsHawaii = 'US_HAWAII',
  UsMountain = 'US_MOUNTAIN',
  UsPacific = 'US_PACIFIC'
}

/** Token usage for the auto evaluation */
export type Token = {
  __typename?: 'Token';
  completion_tokens: Scalars['Float']['output'];
  prompt_tokens: Scalars['Float']['output'];
  total_tokens: Scalars['Float']['output'];
};

export type Topic = {
  __typename?: 'Topic';
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  companyId?: Maybe<Scalars['UUID']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<Scalars['UUID']['output']>;
  id: Scalars['UUID']['output'];
  media?: Maybe<Media>;
  name: Scalars['String']['output'];
  skillCount: Scalars['Int']['output'];
  skillTopics: SkillTopicConnection;
  skills: SkillConnection;
  updatedAt: Scalars['DateTime']['output'];
  updatedBy?: Maybe<Scalars['UUID']['output']>;
};

export type TopicList = {
  __typename?: 'TopicList';
  /** List of objects in current page. */
  nodes: Array<Topic>;
  /** Contains details to move forward and backwards from the collection. */
  pageInfo: TopicPageInfo;
  /** Total number of objects in the collection. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type TopicListConditions = {
  /** Filter by creator id */
  filterByCreator?: InputMaybe<Scalars['String']['input']>;
  /** Filter by whether the Topic is active or not. */
  includeDisabled: Scalars['Boolean']['input'];
  /** Search terms. Will look in name, externalId or description. */
  searchTerms?: InputMaybe<StringCondition>;
};

/** Sort topics by */
export enum TopicListOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

/** Represents a topic and its related details */
export type TopicMetadata = {
  __typename?: 'TopicMetadata';
  /** List of topic domains  for the extracted topic */
  domains: Array<Domain>;
  /** The language code of the text corpus and the topic extracted e.g. en , fr , hi */
  language: Scalars['String']['output'];
  /** List of parent topics for the extracted topic */
  parentTopics: Array<ParentTopic>;
  /** List of related topics for the extracted topic */
  relatedTopics: Array<RelatedTopic>;
  /** Relevance of the topic in the current text corpus i.e. how much importance is given on this topic in a scale of 0 to 1 and in comparison to other topics */
  relevance: Scalars['Float']['output'];
  /** Name of the topic extracted from the given text corpus */
  topic: Scalars['String']['output'];
  /** The base language translation of the topic if text corpus is not in base language for the company or user. If the topic is an unknown keyword then transliterate to base language */
  topicInBaseLang: Scalars['String']['output'];
  /** The english translation of the topic if text corpus is not in english , after analyzing the semantic significance of the topic. If the topic is an unknown keyword then transliterate to english */
  topicInEnglish: Scalars['String']['output'];
};

export type TopicPageInfo = {
  __typename?: 'TopicPageInfo';
  /** Pointer to the next page. When null, it means you are in the last page. */
  afterCursor?: Maybe<Scalars['String']['output']>;
  /** Pointer to the previous page. When null, it means you are in the first page. */
  beforeCursor?: Maybe<Scalars['String']['output']>;
};

/** TopicProcessingStatus options */
export enum TopicProcessingStatus {
  Complete = 'COMPLETE',
  Error = 'ERROR',
  NotStarted = 'NOT_STARTED',
  Processing = 'PROCESSING',
  Skipped = 'SKIPPED'
}

export type Transcript = {
  __typename?: 'Transcript';
  language?: Maybe<Scalars['String']['output']>;
  transcript?: Maybe<Scalars['String']['output']>;
};

export type Upload = {
  __typename?: 'Upload';
  affectedRowCount?: Maybe<Scalars['Int']['output']>;
  bucket: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  error?: Maybe<Scalars['JSONObject']['output']>;
  errorDetails?: Maybe<Array<Scalars['JSONObject']['output']>>;
  errorRowCount?: Maybe<Scalars['Int']['output']>;
  filePath: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  source: UploadSource;
  status: UploadStatus;
  updatedAt: Scalars['DateTime']['output'];
  url: Scalars['String']['output'];
};

export type UploadFileInput = {
  mimeType: Scalars['String']['input'];
  url: Scalars['String']['input'];
};

/** additional upload options */
export type UploadOptionsInput = {
  vocabularyId?: InputMaybe<Scalars['String']['input']>;
};

/** An object that represents temporary credentials and upload details for storage */
export type UploadProvision = {
  __typename?: 'UploadProvision';
  /** Temporary credentials for AWS S3 */
  credentials?: Maybe<AwsCredentials>;
  media: Media;
  s3: Awss3Params;
  /** Signed URL for direct upload (used with GCS) */
  signedUrl?: Maybe<Scalars['String']['output']>;
};

/** UploadSource options */
export enum UploadSource {
  AdHocAssignProfileTags = 'AD_HOC_ASSIGN_PROFILE_TAGS',
  AdHocCreateCompany = 'AD_HOC_CREATE_COMPANY',
  AdHocCreateLearnerGroups = 'AD_HOC_CREATE_LEARNER_GROUPS',
  AdHocCreateLearningPlan = 'AD_HOC_CREATE_LEARNING_PLAN',
  AdHocDeleteCompanyProfile = 'AD_HOC_DELETE_COMPANY_PROFILE',
  AdHocDeleteProfile = 'AD_HOC_DELETE_PROFILE',
  AdHocDuplicateCompetency = 'AD_HOC_DUPLICATE_COMPETENCY',
  AdHocDuplicateSkill = 'AD_HOC_DUPLICATE_SKILL',
  AdHocMigrateAdminToProfile = 'AD_HOC_MIGRATE_ADMIN_TO_PROFILE',
  AssignProfileGroups = 'ASSIGN_PROFILE_GROUPS',
  AssignProfileTags = 'ASSIGN_PROFILE_TAGS',
  ContextualAssignment = 'CONTEXTUAL_ASSIGNMENT',
  CustomCertificates = 'CUSTOM_CERTIFICATES',
  CustomVocabularyKeywords = 'CUSTOM_VOCABULARY_KEYWORDS',
  LearningPlanAssignment = 'LEARNING_PLAN_ASSIGNMENT',
  LearningPlanCreation = 'LEARNING_PLAN_CREATION',
  ProfileActivation = 'PROFILE_ACTIVATION',
  ProfileCreation = 'PROFILE_CREATION',
  ProfileDeactivation = 'PROFILE_DEACTIVATION'
}

/** UploadStatus options */
export enum UploadStatus {
  Error = 'ERROR',
  Pending = 'PENDING',
  Processed = 'PROCESSED'
}

export type UpsertSkillRepInput = {
  allowedKeywords?: InputMaybe<Array<Scalars['String']['input']>>;
  autoCoachConfig?: InputMaybe<AutoCoachConfigInput>;
  conversationRoles?: InputMaybe<ConversationRolesInput>;
  conversationType?: InputMaybe<ConversationType>;
  displayName: Scalars['String']['input'];
  externalId: Scalars['String']['input'];
  form?: InputMaybe<FormInput>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  incorrectKeywords?: InputMaybe<Array<Scalars['String']['input']>>;
  interjections?: InputMaybe<Array<InterjectionInput>>;
  isAiEnabled: Scalars['Boolean']['input'];
  isAutoCoachEnabled: Scalars['Boolean']['input'];
  isCoached: Scalars['Boolean']['input'];
  isKeywords: Scalars['Boolean']['input'];
  isRepeatable: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  photoUrl?: InputMaybe<Scalars['String']['input']>;
  prompt: Scalars['String']['input'];
  repType: RepType;
  responseTypes: Array<RepPromptResponseTypeInput>;
  rolePlayConfigId?: InputMaybe<Scalars['UUID']['input']>;
};

export type VisualIndicator = {
  __typename?: 'VisualIndicator';
  colorHex?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type WordInfo = {
  __typename?: 'WordInfo';
  count: Scalars['Int']['output'];
  percentage: Scalars['Float']['output'];
  word: Scalars['String']['output'];
};

export type ApiKeyCreateMutationVariables = Exact<{ [key: string]: never; }>;


export type ApiKeyCreateMutation = { __typename?: 'Mutation', apiKeyCreate: { __typename?: 'APIKeyCreateResponse', id: any, accessToken: string } };

export type ApiKeyDeleteMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type ApiKeyDeleteMutation = { __typename?: 'Mutation', apiKeyDelete: boolean };

export type ApiKeyListQueryVariables = Exact<{
  paginate?: InputMaybe<BaseClassicPaginate>;
  sorts?: InputMaybe<Array<ApiKeyListOrderBy> | ApiKeyListOrderBy>;
}>;


export type ApiKeyListQuery = { __typename?: 'Query', apiKeyList: { __typename?: 'PaginatedAPIKeyResponse', totalCount?: number | null, nodes: Array<{ __typename?: 'APIKey', id: any, last4: string, createdAt: any, deletedAt?: any | null, companyProfileId: any, companyProfile?: { __typename?: 'CompanyProfile', id: any, profile: { __typename?: 'Profile', id: string, displayName?: string | null } } | null }>, pageInfo: { __typename?: 'FunctionPageInfo', beforeCursor?: string | null, afterCursor?: string | null } } };

export type AuthChannelQueryVariables = Exact<{
  profileIdentifier: Scalars['String']['input'];
}>;


export type AuthChannelQuery = { __typename?: 'Query', authChannel: { __typename?: 'AuthChannelResponse', channelType?: AuthenticationChannelType | null, companyId?: string | null, companyProfileId?: string | null, ssoChannel?: { __typename?: 'SsoChannel', idpProxyBaseUrl?: string | null, idpProxyPath?: string | null } | null, localChannel?: { __typename?: 'LocalChannel', supportedTypes?: Array<string> | null } | null } };

export type AuthInitMutationVariables = Exact<{
  profileIdentifier: Scalars['String']['input'];
}>;


export type AuthInitMutation = { __typename?: 'Mutation', authInit: string };

export type AuthLogoutMutationVariables = Exact<{
  logoutInput: LogoutInput;
}>;


export type AuthLogoutMutation = { __typename?: 'Mutation', authLogout: boolean };

export type AuthRefreshMutationVariables = Exact<{
  refreshToken?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<AuthenticationSource>;
}>;


export type AuthRefreshMutation = { __typename?: 'Mutation', authRefresh: boolean };

export type AuthVerifyMutationVariables = Exact<{
  authInitId: Scalars['String']['input'];
  code: Scalars['String']['input'];
}>;


export type AuthVerifyMutation = { __typename?: 'Mutation', authVerify: { __typename?: 'AuthSession', mfaRequired?: boolean | null } };

export type CloneLearningPlanMutationVariables = Exact<{
  learningPlanId: Scalars['UUID']['input'];
  newLearningPlanExternalId: Scalars['String']['input'];
}>;


export type CloneLearningPlanMutation = { __typename?: 'Mutation', cloneLearningPlan: { __typename?: 'LearningPlan', id: any, name: string, displayName: string, externalId: string, description?: string | null, sortRank: number, updatedAt: any, createdAt: any, publishedAt?: any | null, isOrderDisabled: boolean, additionalInfo?: string | null, goal?: string | null, mandatory?: boolean | null, startDateType?: CampaignsDateType | null, startDate?: string | null, endDateType?: CampaignsDateType | null, endDate?: string | null, endDays?: number | null, createdBy?: any | null, updatedBy?: any | null, certificateEnabled?: boolean | null, certificateName?: string | null, isNoDataForBestPractice?: boolean | null, learningPlanDependencies: Array<{ __typename?: 'LearningPlanDependency', id: any, dependentLearningPlan: { __typename?: 'LearningPlan', id: any, name: string, externalId: string } }>, groups: Array<{ __typename?: 'ProfileGroup', id: any, name: string, learnerCount: number, coachCount: number }>, learningPlanFolder?: { __typename?: 'LearningPlanFolder', id: any, name: string } | null } };

export type CloneProfileMutationVariables = Exact<{
  profileExternalId: Scalars['String']['input'];
  newProfileExternalId: Scalars['String']['input'];
}>;


export type CloneProfileMutation = { __typename?: 'Mutation', cloneProfile: boolean };

export type CloneRepMutationVariables = Exact<{
  skillRepId: Scalars['UUID']['input'];
  newSkillRepExternalId: Scalars['String']['input'];
}>;


export type CloneRepMutation = { __typename?: 'Mutation', cloneRep: { __typename?: 'SkillRep', id: any, name: string, externalId: string, displayName: string, publishedAt?: any | null, media?: { __typename?: 'Media', id: any, mediaUrl?: string | null } | null, repPrompt?: { __typename?: 'RepPrompt', id: any, isRepeatable?: boolean | null, isCoached: boolean, isKeywords: boolean, repType: RepType, allowedKeywords?: Array<string> | null, incorrectKeywords?: Array<string> | null, conversationType?: ConversationType | null, rolePlayConfigId?: any | null, isAiEnabled: boolean, isAutoCoachEnabled: boolean, autoCoachConfig?: { __typename?: 'AutoCoachConfig', approvalCutoff: number, rejectionCutoff: number } | null, conversationRoles?: { __typename?: 'ConversationRoles', submitter: string, audience: string } | null, interjections?: Array<{ __typename?: 'Interjection', index?: string | null, duration?: string | null, start?: string | null, message?: Array<{ __typename?: 'InterjectionMessage', translatedText?: string | null, language: Language }> | null }> | null, repPromptLocalizeds: Array<{ __typename?: 'RepPromptLocalized', id: any, language: Language, content: string, autoEvaluationCriteria?: { __typename?: 'AutoEvaluationCriteriaGraphql', keywordCheck?: { __typename?: 'AutoEvaluationCriteriaKeywordCheck', allowedKeywords?: Array<string> | null, incorrectKeywords?: Array<string> | null } | null } | null }>, repPromptResponseTypes: Array<{ __typename?: 'RepPromptResponseType', id: any, responseType: RepResponseKind }>, form?: { __typename?: 'Form', id: any, localizations: { __typename?: 'FormLocalizedConnection', nodes: Array<{ __typename?: 'FormLocalized', id: any, language: Language, description: string }> }, prompts: { __typename?: 'PromptConnection', nodes: Array<{ __typename?: 'Prompt', id: any, isMultiple?: boolean | null, localizations: { __typename?: 'PromptLocalizedConnection', nodes: Array<{ __typename?: 'PromptLocalized', id: any, language: Language, description: string }> }, choices: { __typename?: 'ChoiceConnection', nodes: Array<{ __typename?: 'Choice', id: any, type: ChoiceType, isCorrect?: boolean | null, localizations: { __typename?: 'ChoiceLocalizedConnection', nodes: Array<{ __typename?: 'ChoiceLocalized', id: any, language: Language, description?: string | null }> } }> } }> } } | null } | null } };

export type CloneSkillMutationVariables = Exact<{
  skillId: Scalars['UUID']['input'];
  newSkillExternalId: Scalars['String']['input'];
}>;


export type CloneSkillMutation = { __typename?: 'Mutation', cloneSkill: { __typename?: 'Skill', id: any, type: SkillType, externalId: string, name: string, displayName: string, description?: string | null, duration?: string | null, createdAt: any, updatedAt: any, publishedAt?: any | null, companyId: any, sourceCompanyId?: any | null, sourceSkillId?: any | null, createdBy?: any | null, updatedBy?: any | null, media?: { __typename?: 'Media', id: any, mediaUrl?: string | null } | null } };

export type CollectionsQueryVariables = Exact<{ [key: string]: never; }>;


export type CollectionsQuery = { __typename?: 'Query', companies: { __typename?: 'PaginatedCompanyResponse', nodes: Array<{ __typename?: 'Company', id: any, name?: string | null, externalId?: string | null, countryCode?: CountryCode | null, timezone?: Timezone | null, defaultLanguage?: Language | null, companyFeatures?: Array<{ __typename?: 'CompanyFeature', id: string, feature: { __typename?: 'Feature', id: string, name: FeatureType } }> | null, companyLanguages?: Array<{ __typename?: 'CompanyLanguage', id: string, language: Language }> | null }> } };

export type CompanyEditQueryVariables = Exact<{ [key: string]: never; }>;


export type CompanyEditQuery = { __typename?: 'Query', company: { __typename?: 'Company', id: any, name?: string | null, displayName?: string | null, externalId?: string | null, enableLearnerInitiatedContextualAssignment?: boolean | null, enableLearnerInitiatedLearningPlanAssignment?: boolean | null, defaultLanguage?: Language | null, countryCode?: CountryCode | null, supportEmail?: string | null, supportContact?: string | null, programName?: string | null, certificateTemplate?: string | null, timezone?: Timezone | null, notificationsEnabled: boolean, whatsappEnabled: boolean, smsEnabled: boolean, updatedAt: any, companyAuthentications?: Array<{ __typename?: 'CompanyAuthentication', id: string, authenticationType: AuthenticationType, app: AuthenticationSource }> | null, logoMedia?: { __typename?: 'Media', id: any, path: string, mediaUrl?: string | null } | null, companyFeatures?: Array<{ __typename?: 'CompanyFeature', id: string, feature: { __typename?: 'Feature', id: string, name: FeatureType } }> | null, companyLanguages?: Array<{ __typename?: 'CompanyLanguage', id: string, language: Language }> | null, siblings?: Array<{ __typename?: 'CompanySiblingDto', id: any, companyId: any, siblingCompanyId: any, deletedAt?: any | null, siblingCompany?: { __typename?: 'SiblingCompanyInfo', id: any, name?: string | null, externalId?: string | null, displayName?: string | null } | null }> | null } };

export type CompanyEditSubmitMutationVariables = Exact<{
  companyEditInput: CompanyEditInput;
}>;


export type CompanyEditSubmitMutation = { __typename?: 'Mutation', companyEdit: { __typename?: 'Company', id: any, name?: string | null, displayName?: string | null, externalId?: string | null, enableLearnerInitiatedContextualAssignment?: boolean | null, enableLearnerInitiatedLearningPlanAssignment?: boolean | null, defaultLanguage?: Language | null, countryCode?: CountryCode | null, supportEmail?: string | null, supportContact?: string | null, programName?: string | null, certificateTemplate?: string | null, timezone?: Timezone | null, notificationsEnabled: boolean, whatsappEnabled: boolean, smsEnabled: boolean, updatedAt: any, companyAuthentications?: Array<{ __typename?: 'CompanyAuthentication', id: string, authenticationType: AuthenticationType, app: AuthenticationSource }> | null, logoMedia?: { __typename?: 'Media', id: any, path: string, mediaUrl?: string | null } | null, companyFeatures?: Array<{ __typename?: 'CompanyFeature', id: string, feature: { __typename?: 'Feature', id: string, name: FeatureType } }> | null, companyLanguages?: Array<{ __typename?: 'CompanyLanguage', id: string, language: Language }> | null, siblings?: Array<{ __typename?: 'CompanySiblingDto', id: any, companyId: any, siblingCompanyId: any, deletedAt?: any | null, siblingCompany?: { __typename?: 'SiblingCompanyInfo', id: any, name?: string | null, externalId?: string | null, displayName?: string | null } | null }> | null } };

export type CompanyLanguageListQueryVariables = Exact<{ [key: string]: never; }>;


export type CompanyLanguageListQuery = { __typename?: 'Query', company: { __typename?: 'Company', id: any, defaultLanguage?: Language | null, companyLanguages?: Array<{ __typename?: 'CompanyLanguage', id: string, language: Language }> | null } };

export type CompanyNewQueryVariables = Exact<{ [key: string]: never; }>;


export type CompanyNewQuery = { __typename?: 'Query', featureList: Array<{ __typename?: 'Feature', id: string, name: FeatureType }> };

export type CompanyNewSubmitMutationVariables = Exact<{
  companyCreateInput: CompanyCreateInput;
}>;


export type CompanyNewSubmitMutation = { __typename?: 'Mutation', companyCreate: { __typename?: 'Company', id: any, name?: string | null, displayName?: string | null, externalId?: string | null, enableLearnerInitiatedContextualAssignment?: boolean | null, enableLearnerInitiatedLearningPlanAssignment?: boolean | null, defaultLanguage?: Language | null, countryCode?: CountryCode | null, supportEmail?: string | null, supportContact?: string | null, programName?: string | null, certificateTemplate?: string | null, timezone?: Timezone | null, notificationsEnabled: boolean, whatsappEnabled: boolean, smsEnabled: boolean, updatedAt: any, companyAuthentications?: Array<{ __typename?: 'CompanyAuthentication', id: string, authenticationType: AuthenticationType, app: AuthenticationSource }> | null, logoMedia?: { __typename?: 'Media', id: any, path: string, mediaUrl?: string | null } | null, companyFeatures?: Array<{ __typename?: 'CompanyFeature', id: string, feature: { __typename?: 'Feature', id: string, name: FeatureType } }> | null, companyLanguages?: Array<{ __typename?: 'CompanyLanguage', id: string, language: Language }> | null, siblings?: Array<{ __typename?: 'CompanySiblingDto', id: any, companyId: any, siblingCompanyId: any, deletedAt?: any | null, siblingCompany?: { __typename?: 'SiblingCompanyInfo', id: any, name?: string | null, externalId?: string | null, displayName?: string | null } | null }> | null } };

export type CompanySearchQueryVariables = Exact<{
  paginate?: InputMaybe<BaseClassicPaginate>;
  conditions?: InputMaybe<CompanySearchConditions>;
}>;


export type CompanySearchQuery = { __typename?: 'Query', companySearch: { __typename?: 'PaginatedCompanyResponse', nodes: Array<{ __typename?: 'Company', id: any, name?: string | null, externalId?: string | null }> } };

export type GetCompanySiblingsQueryVariables = Exact<{
  activeOnly: Scalars['Boolean']['input'];
}>;


export type GetCompanySiblingsQuery = { __typename?: 'Query', getCompanySiblings: Array<{ __typename?: 'CompanySiblingDto', id: any, companyId: any, siblingCompanyId: any, deletedAt?: any | null, siblingCompany?: { __typename?: 'SiblingCompanyInfo', id: any, name?: string | null, externalId?: string | null, displayName?: string | null } | null }> };

export type GetCreatorGroupListQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCreatorGroupListQuery = { __typename?: 'Query', getCreatorGroupList: Array<{ __typename?: 'CompanyProfile', id: any, profile: { __typename?: 'Profile', displayName?: string | null } }> };

export type GetCreatorLpListQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCreatorLpListQuery = { __typename?: 'Query', getCreatorLPList: Array<{ __typename?: 'CompanyProfile', id: any, profile: { __typename?: 'Profile', displayName?: string | null } }> };

export type GetCreatorListQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCreatorListQuery = { __typename?: 'Query', getCreatorList: Array<{ __typename?: 'CompanyProfile', id: any, profile: { __typename?: 'Profile', displayName?: string | null } }> };

export type GetCreatorRepListQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCreatorRepListQuery = { __typename?: 'Query', getCreatorRepList: Array<{ __typename?: 'CompanyProfile', id: any, profile: { __typename?: 'Profile', displayName?: string | null } }> };

export type GetCreatorSkillListQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCreatorSkillListQuery = { __typename?: 'Query', getCreatorSkillList: Array<{ __typename?: 'CompanyProfile', id: any, profile: { __typename?: 'Profile', displayName?: string | null } }> };

export type GetCreatorTopicListQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCreatorTopicListQuery = { __typename?: 'Query', getCreatorTopicList: Array<{ __typename?: 'CompanyProfile', id: any, profile: { __typename?: 'Profile', displayName?: string | null } }> };

export type InsertCustomPersonaMutationVariables = Exact<{
  input: InsertCustomPersonaInput;
}>;


export type InsertCustomPersonaMutation = { __typename?: 'Mutation', insertCustomPersona: { __typename?: 'RolePlayConfig', id: string, cardTitle: string, cardDescription: string, status: string, personaName: string, designation: string, details: { __typename?: 'RolePlayDetails', bio: string, goal: string, traits: Array<string> }, config: { __typename?: 'RolePlayConfigSettings', difficulty: string, voiceName?: string | null, gender: string, voiceService?: string | null, avatarUrl?: string | null } } };

export type CustomVocabularyQueryVariables = Exact<{
  customVocabularyId: Scalars['String']['input'];
}>;


export type CustomVocabularyQuery = { __typename?: 'Query', customVocabulary: { __typename?: 'CustomVocabulary', url?: string | null, id?: any | null, companyId: any, name: string, description?: string | null, language: DialectTypes, status?: CustomVocabularyStatuses | null, error?: string | null, createdAt: any, updatedAt: any, archivedAt?: any | null } };

export type CustomVocabulariesArchiveMutationVariables = Exact<{
  ids: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type CustomVocabulariesArchiveMutation = { __typename?: 'Mutation', customVocabulariesArchive: Array<{ __typename?: 'CustomVocabulary', id?: any | null, companyId: any, name: string, description?: string | null, language: DialectTypes, status?: CustomVocabularyStatuses | null, error?: string | null, createdAt: any, updatedAt: any, archivedAt?: any | null }> };

export type CustomVocabularyKeywordListQueryVariables = Exact<{
  vocabularyId: Scalars['String']['input'];
  paginate?: InputMaybe<BaseClassicPaginate>;
  sorts?: InputMaybe<Array<CustomVocabularyKeywordListOrderBy> | CustomVocabularyKeywordListOrderBy>;
  conditions?: InputMaybe<CustomVocabularyKeywordListConditions>;
}>;


export type CustomVocabularyKeywordListQuery = { __typename?: 'Query', customVocabularylKeywordList: { __typename?: 'PaginatedCustomVocabularyKeywordResponse', totalCount?: number | null, pageInfo: { __typename?: 'CustomVocabularyKeywordPageInfo', beforeCursor?: string | null, afterCursor?: string | null }, nodes: Array<{ __typename?: 'CustomVocabularyKeyword', id?: any | null, companyId: any, vocabularyId: any, phrase: string, soundsLike?: string | null, ipa?: string | null, displayAs?: string | null }> } };

export type CustomVocabularyListQueryVariables = Exact<{
  paginate?: InputMaybe<BaseClassicPaginate>;
  sorts?: InputMaybe<Array<CustomVocabularyListOrderBy> | CustomVocabularyListOrderBy>;
  conditions?: InputMaybe<CustomVocabularyListConditions>;
}>;


export type CustomVocabularyListQuery = { __typename?: 'Query', customVocabularyList: { __typename?: 'PaginatedCustomVocabularyResponse', totalCount?: number | null, pageInfo: { __typename?: 'CustomVocabularyPageInfo', beforeCursor?: string | null, afterCursor?: string | null }, nodes: Array<{ __typename?: 'CustomVocabulary', id?: any | null, companyId: any, name: string, description?: string | null, language: DialectTypes, status?: CustomVocabularyStatuses | null, error?: string | null, createdAt: any, updatedAt: any, archivedAt?: any | null }> } };

export type CustomVocabularyUpsertMutationVariables = Exact<{
  language: DialectTypes;
  status?: InputMaybe<CustomVocabularyStatuses>;
  name: Scalars['String']['input'];
  customVocabularyUpsertId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
}>;


export type CustomVocabularyUpsertMutation = { __typename?: 'Mutation', customVocabularyUpsert: { __typename?: 'CustomVocabulary', id?: any | null, companyId: any, name: string, description?: string | null, language: DialectTypes, status?: CustomVocabularyStatuses | null, error?: string | null, createdAt: any, updatedAt: any, archivedAt?: any | null } };

export type DeleteSkillProgressMutationVariables = Exact<{
  profileExternalId: Scalars['String']['input'];
  skillExternalId: Scalars['String']['input'];
}>;


export type DeleteSkillProgressMutation = { __typename?: 'Mutation', deleteSkillProgress: boolean };

export type ExportLearningPlanBulkMutationVariables = Exact<{
  targetCompanyIds: Array<Scalars['UUID']['input']> | Scalars['UUID']['input'];
  learningPlanIds: Array<Scalars['UUID']['input']> | Scalars['UUID']['input'];
  groupsDataIds?: InputMaybe<Array<GroupsDataIdsArg> | GroupsDataIdsArg>;
}>;


export type ExportLearningPlanBulkMutation = { __typename?: 'Mutation', exportLearningPlanBulk: Array<{ __typename?: 'LearningPlan', id: any, name: string, displayName: string, externalId: string, description?: string | null, sortRank: number, updatedAt: any, createdAt: any, publishedAt?: any | null, isOrderDisabled: boolean, additionalInfo?: string | null, goal?: string | null, mandatory?: boolean | null, startDateType?: CampaignsDateType | null, startDate?: string | null, endDateType?: CampaignsDateType | null, endDate?: string | null, endDays?: number | null, createdBy?: any | null, updatedBy?: any | null, certificateEnabled?: boolean | null, certificateName?: string | null, isNoDataForBestPractice?: boolean | null, learningPlanDependencies: Array<{ __typename?: 'LearningPlanDependency', id: any, dependentLearningPlan: { __typename?: 'LearningPlan', id: any, name: string, externalId: string } }>, groups: Array<{ __typename?: 'ProfileGroup', id: any, name: string, learnerCount: number, coachCount: number }>, learningPlanFolder?: { __typename?: 'LearningPlanFolder', id: any, name: string } | null }> };

export type ExportSkillRepsBulkMutationVariables = Exact<{
  targetCompanyIds: Array<Scalars['UUID']['input']> | Scalars['UUID']['input'];
  skillRepIds: Array<Scalars['UUID']['input']> | Scalars['UUID']['input'];
}>;


export type ExportSkillRepsBulkMutation = { __typename?: 'Mutation', exportSkillRepsBulk: Array<{ __typename?: 'SkillRep', id: any, name: string, externalId: string, displayName: string, publishedAt?: any | null, media?: { __typename?: 'Media', id: any, mediaUrl?: string | null } | null, repPrompt?: { __typename?: 'RepPrompt', id: any, isRepeatable?: boolean | null, isCoached: boolean, isKeywords: boolean, repType: RepType, allowedKeywords?: Array<string> | null, incorrectKeywords?: Array<string> | null, conversationType?: ConversationType | null, rolePlayConfigId?: any | null, isAiEnabled: boolean, isAutoCoachEnabled: boolean, autoCoachConfig?: { __typename?: 'AutoCoachConfig', approvalCutoff: number, rejectionCutoff: number } | null, conversationRoles?: { __typename?: 'ConversationRoles', submitter: string, audience: string } | null, interjections?: Array<{ __typename?: 'Interjection', index?: string | null, duration?: string | null, start?: string | null, message?: Array<{ __typename?: 'InterjectionMessage', translatedText?: string | null, language: Language }> | null }> | null, repPromptLocalizeds: Array<{ __typename?: 'RepPromptLocalized', id: any, language: Language, content: string, autoEvaluationCriteria?: { __typename?: 'AutoEvaluationCriteriaGraphql', keywordCheck?: { __typename?: 'AutoEvaluationCriteriaKeywordCheck', allowedKeywords?: Array<string> | null, incorrectKeywords?: Array<string> | null } | null } | null }>, repPromptResponseTypes: Array<{ __typename?: 'RepPromptResponseType', id: any, responseType: RepResponseKind }>, form?: { __typename?: 'Form', id: any, localizations: { __typename?: 'FormLocalizedConnection', nodes: Array<{ __typename?: 'FormLocalized', id: any, language: Language, description: string }> }, prompts: { __typename?: 'PromptConnection', nodes: Array<{ __typename?: 'Prompt', id: any, isMultiple?: boolean | null, localizations: { __typename?: 'PromptLocalizedConnection', nodes: Array<{ __typename?: 'PromptLocalized', id: any, language: Language, description: string }> }, choices: { __typename?: 'ChoiceConnection', nodes: Array<{ __typename?: 'Choice', id: any, type: ChoiceType, isCorrect?: boolean | null, localizations: { __typename?: 'ChoiceLocalizedConnection', nodes: Array<{ __typename?: 'ChoiceLocalized', id: any, language: Language, description?: string | null }> } }> } }> } } | null } | null }> };

export type ExportSkillsBulkMutationVariables = Exact<{
  targetCompanyIds: Array<Scalars['UUID']['input']> | Scalars['UUID']['input'];
  skillIds: Array<Scalars['UUID']['input']> | Scalars['UUID']['input'];
}>;


export type ExportSkillsBulkMutation = { __typename?: 'Mutation', exportSkillsBulk: Array<{ __typename?: 'Skill', id: any, type: SkillType, externalId: string, name: string, displayName: string, description?: string | null, duration?: string | null, createdAt: any, updatedAt: any, publishedAt?: any | null, companyId: any, sourceCompanyId?: any | null, sourceSkillId?: any | null, createdBy?: any | null, updatedBy?: any | null, media?: { __typename?: 'Media', id: any, mediaUrl?: string | null } | null }> };

export type FeatureListQueryVariables = Exact<{ [key: string]: never; }>;


export type FeatureListQuery = { __typename?: 'Query', featureList: Array<{ __typename?: 'Feature', id: string, name: FeatureType }> };

export type FileUploaderGetSignedUrlMutationVariables = Exact<{
  fileType: Scalars['String']['input'];
  uploadSource: UploadSource;
  options?: InputMaybe<UploadOptionsInput>;
}>;


export type FileUploaderGetSignedUrlMutation = { __typename?: 'Mutation', fileUploadGetSignedUrl: { __typename?: 'Upload', id: string, status: UploadStatus, url: string, source: UploadSource, bucket: string, filePath: string, affectedRowCount?: number | null, errorRowCount?: number | null, error?: any | null, createdAt: any, updatedAt: any } };

export type GetTranscriptionMediaObjectByIdQueryVariables = Exact<{
  mediaId: Scalars['String']['input'];
}>;


export type GetTranscriptionMediaObjectByIdQuery = { __typename?: 'Query', getTranscriptionMediaObjectById: { __typename?: 'GetTranscriptionMediaObjectById', awsOutcome?: { __typename?: 'AwsOutcome', jobName?: string | null, accountId?: string | null, status?: string | null, results?: { __typename?: 'Results', transcripts?: Array<{ __typename?: 'Transcript', transcript?: string | null, language?: string | null }> | null, timeline?: Array<{ __typename?: 'Timeline', sentence?: string | null, speaker?: string | null, start_time?: string | null, end_time?: string | null }> | null } | null } | null } };

export type GetWordCloudMediaObjectByIdQueryVariables = Exact<{
  repPromptId: Scalars['String']['input'];
}>;


export type GetWordCloudMediaObjectByIdQuery = { __typename?: 'Query', getWordCloudMediaObjectById: { __typename?: 'GetWordCloudMediaObjectById', schemaVersion: string, words?: Array<{ __typename?: 'WordInfo', word: string, count: number, percentage: number }> | null } };

export type GoogleAuthVerifyMutationVariables = Exact<{
  idToken: Scalars['String']['input'];
  source?: InputMaybe<AuthenticationSource>;
}>;


export type GoogleAuthVerifyMutation = { __typename?: 'Mutation', googleAuthVerify: boolean };

export type IsNewAuthQueryVariables = Exact<{
  email?: InputMaybe<Scalars['String']['input']>;
}>;


export type IsNewAuthQuery = { __typename?: 'Query', isNewAuth: boolean };

export type LearningCardsDeleteSubmitMutationVariables = Exact<{
  skillId: Scalars['String']['input'];
  ids: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type LearningCardsDeleteSubmitMutation = { __typename?: 'Mutation', learningCardsDelete?: any | null };

export type LearningCardsUpsertSubmitMutationVariables = Exact<{
  skillId?: InputMaybe<Scalars['String']['input']>;
  linkouts?: InputMaybe<Array<LearningCardLinkoutInput> | LearningCardLinkoutInput>;
  videos?: InputMaybe<Array<LearningCardVideoInput> | LearningCardVideoInput>;
  flashCards?: InputMaybe<Array<LearningCardFlashCardInput> | LearningCardFlashCardInput>;
  files?: InputMaybe<Array<LearningCardFileInput> | LearningCardFileInput>;
  form?: InputMaybe<LearningCardFormInput>;
}>;


export type LearningCardsUpsertSubmitMutation = { __typename?: 'Mutation', learningCardsUpsert: { __typename?: 'LearningCardConnection', nodes: Array<{ __typename?: 'LearningCardFile', id: any, type: LearningCardType, position: number, experimentConfig?: any | null, localizations: { __typename?: 'LearningCardLocalizedFileConnection', nodes: Array<{ __typename?: 'LearningCardLocalizedFile', id: any, language: Language, url?: string | null, media: { __typename?: 'Media', id: any, mediaUrl?: string | null } }> } } | { __typename?: 'LearningCardFlashCard', id: any, type: LearningCardType, position: number, experimentConfig?: any | null, localizations: { __typename?: 'LearningCardLocalizedFlashCardConnection', nodes: Array<{ __typename?: 'LearningCardLocalizedFlashCard', id: any, language: Language, title?: string | null, description?: string | null, fcMedia?: { __typename?: 'Media', id: any, mediaUrl?: string | null } | null }> } } | { __typename?: 'LearningCardForm', id: any, type: LearningCardType, position: number, experimentConfig?: any | null, resetLpIfFail: boolean, form: { __typename?: 'Form', id: any, name: string, type: FormType, title?: string | null, passingThreshold?: number | null, maxTries?: number | null, maxTriesPerPrompt?: MaxTriesPerPrompt | null, randomizePrompts: boolean, numPromptsShow?: number | null, localizations: { __typename?: 'FormLocalizedConnection', nodes: Array<{ __typename?: 'FormLocalized', id: any, language: Language, description: string }> }, prompts: { __typename?: 'PromptConnection', nodes: Array<{ __typename?: 'Prompt', id: any, position: number, isMultiple?: boolean | null, isMandatory?: boolean | null, localizations: { __typename?: 'PromptLocalizedConnection', nodes: Array<{ __typename?: 'PromptLocalized', id: any, language: Language, description: string }> }, choices: { __typename?: 'ChoiceConnection', nodes: Array<{ __typename?: 'Choice', id: any, type: ChoiceType, position: number, isCorrect?: boolean | null, localizations: { __typename?: 'ChoiceLocalizedConnection', nodes: Array<{ __typename?: 'ChoiceLocalized', id: any, language: Language, description?: string | null, media?: { __typename?: 'Media', id: any, mediaUrl?: string | null } | null }> } }> } }> } } } | { __typename?: 'LearningCardLinkout', id: any, type: LearningCardType, position: number, experimentConfig?: any | null, localizations: { __typename?: 'LearningCardLocalizedLinkoutConnection', nodes: Array<{ __typename?: 'LearningCardLocalizedLinkout', id: any, language: Language, title?: string | null, url?: string | null, description?: string | null, ctaTitle?: string | null }> } } | { __typename?: 'LearningCardVideo', id: any, type: LearningCardType, position: number, experimentConfig?: any | null, localizations: { __typename?: 'LearningCardLocalizedVideoConnection', nodes: Array<{ __typename?: 'LearningCardLocalizedVideo', id: any, language: Language, title?: string | null, streamMedia?: { __typename?: 'Media', id: any, mimeType: string, location: MediaLocation, mediaUrl?: string | null } | null, masterMedia?: { __typename?: 'Media', id: any, mediaUrl?: string | null } | null, posterMedia?: { __typename?: 'Media', id: any, mediaUrl?: string | null } | null, textTrackMedia?: { __typename?: 'Media', id: any, mediaUrl?: string | null } | null }> } }> } };

export type LearningPlanAddGroupsMutationVariables = Exact<{
  learningPlanId: Scalars['UUID']['input'];
  groups: Array<GroupInput> | GroupInput;
}>;


export type LearningPlanAddGroupsMutation = { __typename?: 'Mutation', learningPlanAddGroups: { __typename?: 'LearningPlan', id: any, name: string, displayName: string, externalId: string, description?: string | null, sortRank: number, updatedAt: any, createdAt: any, publishedAt?: any | null, isOrderDisabled: boolean, additionalInfo?: string | null, goal?: string | null, mandatory?: boolean | null, startDateType?: CampaignsDateType | null, startDate?: string | null, endDateType?: CampaignsDateType | null, endDate?: string | null, endDays?: number | null, createdBy?: any | null, updatedBy?: any | null, certificateEnabled?: boolean | null, certificateName?: string | null, isNoDataForBestPractice?: boolean | null, learningPlanDependencies: Array<{ __typename?: 'LearningPlanDependency', id: any, dependentLearningPlan: { __typename?: 'LearningPlan', id: any, name: string, externalId: string } }>, groups: Array<{ __typename?: 'ProfileGroup', id: any, name: string, learnerCount: number, coachCount: number }>, learningPlanFolder?: { __typename?: 'LearningPlanFolder', id: any, name: string } | null } };

export type LearningPlanArchiveMutationVariables = Exact<{
  learningPlanId: Scalars['UUID']['input'];
}>;


export type LearningPlanArchiveMutation = { __typename?: 'Mutation', learningPlanArchive: { __typename?: 'LearningPlan', id: any, name: string, displayName: string, externalId: string, description?: string | null, sortRank: number, updatedAt: any, createdAt: any, publishedAt?: any | null, isOrderDisabled: boolean, additionalInfo?: string | null, goal?: string | null, mandatory?: boolean | null, startDateType?: CampaignsDateType | null, startDate?: string | null, endDateType?: CampaignsDateType | null, endDate?: string | null, endDays?: number | null, createdBy?: any | null, updatedBy?: any | null, certificateEnabled?: boolean | null, certificateName?: string | null, isNoDataForBestPractice?: boolean | null, learningPlanDependencies: Array<{ __typename?: 'LearningPlanDependency', id: any, dependentLearningPlan: { __typename?: 'LearningPlan', id: any, name: string, externalId: string } }>, groups: Array<{ __typename?: 'ProfileGroup', id: any, name: string, learnerCount: number, coachCount: number }>, learningPlanFolder?: { __typename?: 'LearningPlanFolder', id: any, name: string } | null } };

export type LearningPlanAssignToFolderMutationVariables = Exact<{
  learningPlansIds: Array<Scalars['UUID']['input']> | Scalars['UUID']['input'];
  folderId?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type LearningPlanAssignToFolderMutation = { __typename?: 'Mutation', learningPlanAssignToFolder: Array<{ __typename?: 'LearningPlan', id: any, externalId: string, name: string, sortRank: number, skillsCount: number, createdAt: any, updatedAt: any, publishedAt?: any | null, archivedAt?: any | null, learningPlanFolder?: { __typename?: 'LearningPlanFolder', id: any, name: string } | null }> };

export type LearningPlanDeleteGroupsMutationVariables = Exact<{
  learningPlanId: Scalars['UUID']['input'];
  groups: Array<GroupInput> | GroupInput;
}>;


export type LearningPlanDeleteGroupsMutation = { __typename?: 'Mutation', learningPlanDeleteGroups: { __typename?: 'LearningPlan', id: any, name: string, displayName: string, externalId: string, description?: string | null, sortRank: number, updatedAt: any, createdAt: any, publishedAt?: any | null, isOrderDisabled: boolean, additionalInfo?: string | null, goal?: string | null, mandatory?: boolean | null, startDateType?: CampaignsDateType | null, startDate?: string | null, endDateType?: CampaignsDateType | null, endDate?: string | null, endDays?: number | null, createdBy?: any | null, updatedBy?: any | null, certificateEnabled?: boolean | null, certificateName?: string | null, isNoDataForBestPractice?: boolean | null, learningPlanDependencies: Array<{ __typename?: 'LearningPlanDependency', id: any, dependentLearningPlan: { __typename?: 'LearningPlan', id: any, name: string, externalId: string } }>, groups: Array<{ __typename?: 'ProfileGroup', id: any, name: string, learnerCount: number, coachCount: number }>, learningPlanFolder?: { __typename?: 'LearningPlanFolder', id: any, name: string } | null } };

export type LearningPlanEditQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type LearningPlanEditQuery = { __typename?: 'Query', learningPlan: { __typename?: 'LearningPlan', id: any, name: string, displayName: string, externalId: string, description?: string | null, sortRank: number, updatedAt: any, createdAt: any, publishedAt?: any | null, isOrderDisabled: boolean, additionalInfo?: string | null, goal?: string | null, mandatory?: boolean | null, startDateType?: CampaignsDateType | null, startDate?: string | null, endDateType?: CampaignsDateType | null, endDate?: string | null, endDays?: number | null, createdBy?: any | null, updatedBy?: any | null, certificateEnabled?: boolean | null, certificateName?: string | null, isNoDataForBestPractice?: boolean | null, learningPlanDependencies: Array<{ __typename?: 'LearningPlanDependency', id: any, dependentLearningPlan: { __typename?: 'LearningPlan', id: any, name: string, externalId: string } }>, groups: Array<{ __typename?: 'ProfileGroup', id: any, name: string, learnerCount: number, coachCount: number }>, learningPlanFolder?: { __typename?: 'LearningPlanFolder', id: any, name: string } | null } };

export type LearningPlanEditSubmitMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  externalId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  displayName: Scalars['String']['input'];
  sortRank: Scalars['Int']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  dependencies: Array<LearningPlanDependencyInput> | LearningPlanDependencyInput;
  additionalInfo?: InputMaybe<Scalars['String']['input']>;
  goal?: InputMaybe<Scalars['String']['input']>;
  mandatory?: InputMaybe<Scalars['Boolean']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  endDateType?: InputMaybe<CampaignsDateType>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  endDays?: InputMaybe<Scalars['Int']['input']>;
  updatedBy?: InputMaybe<Scalars['UUID']['input']>;
  learningPlanFolder?: InputMaybe<LearningPlanFolderInput>;
  certificateEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  certificateName?: InputMaybe<Scalars['String']['input']>;
}>;


export type LearningPlanEditSubmitMutation = { __typename?: 'Mutation', learningPlanEdit: { __typename?: 'LearningPlan', id: any, name: string, displayName: string, externalId: string, description?: string | null, sortRank: number, updatedAt: any, createdAt: any, publishedAt?: any | null, isOrderDisabled: boolean, additionalInfo?: string | null, goal?: string | null, mandatory?: boolean | null, startDateType?: CampaignsDateType | null, startDate?: string | null, endDateType?: CampaignsDateType | null, endDate?: string | null, endDays?: number | null, createdBy?: any | null, updatedBy?: any | null, certificateEnabled?: boolean | null, certificateName?: string | null, isNoDataForBestPractice?: boolean | null, learningPlanDependencies: Array<{ __typename?: 'LearningPlanDependency', id: any, dependentLearningPlan: { __typename?: 'LearningPlan', id: any, name: string, externalId: string } }>, groups: Array<{ __typename?: 'ProfileGroup', id: any, name: string, learnerCount: number, coachCount: number }>, learningPlanFolder?: { __typename?: 'LearningPlanFolder', id: any, name: string } | null } };

export type LearningPlanFolderCreateMutationVariables = Exact<{
  name: Scalars['String']['input'];
  learningPlansIds: Array<Scalars['UUID']['input']> | Scalars['UUID']['input'];
}>;


export type LearningPlanFolderCreateMutation = { __typename?: 'Mutation', learningPlanFolderCreate: { __typename?: 'LearningPlanFolder', id: any, name: string } };

export type LearningPlanFoldersListQueryVariables = Exact<{
  paginate?: InputMaybe<BaseClassicPaginate>;
  sorts?: InputMaybe<Array<LearningPlanFolderListOrderBy> | LearningPlanFolderListOrderBy>;
  conditions?: InputMaybe<LearningPlanFolderListConditions>;
}>;


export type LearningPlanFoldersListQuery = { __typename?: 'Query', learningPlanFoldersList: { __typename?: 'PaginatedLearningPlanFolderResponse', totalCount?: number | null, nodes: Array<{ __typename?: 'LearningPlanFolder', id: any, name: string, createdAt: any, updatedAt: any }>, pageInfo: { __typename?: 'LearningPlanFolderPageInfo', beforeCursor?: string | null, afterCursor?: string | null } } };

export type LearningPlanFolderSearchQueryVariables = Exact<{
  paginate?: InputMaybe<BaseClassicPaginate>;
  conditions?: InputMaybe<LearningPlanFolderSearchCondition>;
}>;


export type LearningPlanFolderSearchQuery = { __typename?: 'Query', learningPlanFolderSearch: { __typename?: 'PaginatedLearningPlanFolderResponse', nodes: Array<{ __typename?: 'LearningPlanFolder', id: any, name: string }> } };

export type LearningPlanFromPromptMutationVariables = Exact<{
  includeRep: Scalars['Boolean']['input'];
  includeExistRep: Scalars['Boolean']['input'];
  includeQuiz: Scalars['Boolean']['input'];
  complexity: Scalars['String']['input'];
  objective: Scalars['String']['input'];
  prompt: Scalars['String']['input'];
  company: Scalars['String']['input'];
}>;


export type LearningPlanFromPromptMutation = { __typename?: 'Mutation', createCampaignFromPrompt: { __typename?: 'LearningPlan', id: any, name: string, displayName: string, externalId: string, description?: string | null, sortRank: number, updatedAt: any, createdAt: any, publishedAt?: any | null, isOrderDisabled: boolean, additionalInfo?: string | null, goal?: string | null, mandatory?: boolean | null, startDateType?: CampaignsDateType | null, startDate?: string | null, endDateType?: CampaignsDateType | null, endDate?: string | null, endDays?: number | null, createdBy?: any | null, updatedBy?: any | null, certificateEnabled?: boolean | null, certificateName?: string | null, isNoDataForBestPractice?: boolean | null, learningPlanDependencies: Array<{ __typename?: 'LearningPlanDependency', id: any, dependentLearningPlan: { __typename?: 'LearningPlan', id: any, name: string, externalId: string } }>, groups: Array<{ __typename?: 'ProfileGroup', id: any, name: string, learnerCount: number, coachCount: number }>, learningPlanFolder?: { __typename?: 'LearningPlanFolder', id: any, name: string } | null } };

export type LearningPlanFromPromptCleanupMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type LearningPlanFromPromptCleanupMutation = { __typename?: 'Mutation', aiCampaignDataCleanup: { __typename?: 'LearningPlan', id: any, name: string, displayName: string, externalId: string, description?: string | null, sortRank: number, updatedAt: any, createdAt: any, publishedAt?: any | null, isOrderDisabled: boolean, additionalInfo?: string | null, goal?: string | null, mandatory?: boolean | null, startDateType?: CampaignsDateType | null, startDate?: string | null, endDateType?: CampaignsDateType | null, endDate?: string | null, endDays?: number | null, createdBy?: any | null, updatedBy?: any | null, certificateEnabled?: boolean | null, certificateName?: string | null, isNoDataForBestPractice?: boolean | null, learningPlanDependencies: Array<{ __typename?: 'LearningPlanDependency', id: any, dependentLearningPlan: { __typename?: 'LearningPlan', id: any, name: string, externalId: string } }>, groups: Array<{ __typename?: 'ProfileGroup', id: any, name: string, learnerCount: number, coachCount: number }>, learningPlanFolder?: { __typename?: 'LearningPlanFolder', id: any, name: string } | null } };

export type LearningPlanLearnersQueryVariables = Exact<{
  learningPlanId: Scalars['UUID']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  paginate?: InputMaybe<BaseClassicPaginate>;
  conditions?: InputMaybe<LearningPlanLearnersConditions>;
}>;


export type LearningPlanLearnersQuery = { __typename?: 'Query', learningPlanLearners: { __typename?: 'PaginatedLearningPlanLearners', totalCount?: number | null, nodes: Array<{ __typename?: 'LearningPlanLearner', id: any, externalId: string, displayName?: string | null, active: boolean }>, pageInfo: { __typename?: 'LearningPlanLearnerPageInfo', beforeCursor?: string | null, afterCursor?: string | null } } };

export type LearningPlanLearnersSyncMutationVariables = Exact<{
  learningPlanId: Scalars['UUID']['input'];
  learners: Array<LearnerInput> | LearnerInput;
  paginate?: InputMaybe<BaseClassicPaginate>;
  conditions?: InputMaybe<LearningPlanLearnersConditions>;
}>;


export type LearningPlanLearnersSyncMutation = { __typename?: 'Mutation', learningPlanLearnersSync: { __typename?: 'PaginatedLearningPlanLearners', totalCount?: number | null, nodes: Array<{ __typename?: 'LearningPlanLearner', id: any, externalId: string, displayName?: string | null, active: boolean }>, pageInfo: { __typename?: 'LearningPlanLearnerPageInfo', beforeCursor?: string | null, afterCursor?: string | null } } };

export type LearningPlanListQueryVariables = Exact<{
  paginate?: InputMaybe<BaseClassicPaginate>;
  sorts?: InputMaybe<Array<LearningPlanListOrderBy> | LearningPlanListOrderBy>;
  conditions?: InputMaybe<LearningPlanListConditions>;
}>;


export type LearningPlanListQuery = { __typename?: 'Query', learningPlans: { __typename?: 'PaginatedLearningPlanResponse', totalCount?: number | null, pageInfo: { __typename?: 'LearningPlanPageInfo', beforeCursor?: string | null, afterCursor?: string | null }, nodes: Array<{ __typename?: 'LearningPlan', id: any, externalId: string, name: string, sortRank: number, skillsCount: number, createdAt: any, updatedAt: any, publishedAt?: any | null, archivedAt?: any | null, learningPlanFolder?: { __typename?: 'LearningPlanFolder', id: any, name: string } | null }> } };

export type LearningPlanLocalizationsQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type LearningPlanLocalizationsQuery = { __typename?: 'Query', learningPlanLocalizations: Array<{ __typename?: 'LocalizedEntity', label: string, entityType: LocalizedEntityType, relationshipEntityId: any, inputs: Array<{ __typename?: 'LocalizedInput', label?: string | null, name: string, type: LocalizedInputType, localizations: Array<{ __typename?: 'Localization', id?: any | null, language: Language, value?: string | null, disabled?: boolean | null, autoEvaluationCriteria?: { __typename?: 'AutoEvaluationCriteriaGraphql', schemaVersion?: string | null, keywordCheck?: { __typename?: 'AutoEvaluationCriteriaKeywordCheck', allowedKeywords?: Array<string> | null, incorrectKeywords?: Array<string> | null } | null } | null }> }> }> };

export type LearningPlanLocalizationsSyncMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  entities: Array<LocalizedEntityInput> | LocalizedEntityInput;
}>;


export type LearningPlanLocalizationsSyncMutation = { __typename?: 'Mutation', learningPlanLocalizationsSync: Array<{ __typename?: 'LocalizedEntity', label: string, entityType: LocalizedEntityType, relationshipEntityId: any, inputs: Array<{ __typename?: 'LocalizedInput', label?: string | null, name: string, type: LocalizedInputType, localizations: Array<{ __typename?: 'Localization', id?: any | null, language: Language, value?: string | null, disabled?: boolean | null, autoEvaluationCriteria?: { __typename?: 'AutoEvaluationCriteriaGraphql', schemaVersion?: string | null, keywordCheck?: { __typename?: 'AutoEvaluationCriteriaKeywordCheck', allowedKeywords?: Array<string> | null, incorrectKeywords?: Array<string> | null } | null } | null }> }> }> };

export type LearningPlanNewSubmitMutationVariables = Exact<{
  externalId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  displayName: Scalars['String']['input'];
  sortRank: Scalars['Int']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  dependencies: Array<LearningPlanDependencyInput> | LearningPlanDependencyInput;
  additionalInfo?: InputMaybe<Scalars['String']['input']>;
  goal?: InputMaybe<Scalars['String']['input']>;
  mandatory?: InputMaybe<Scalars['Boolean']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  endDateType?: InputMaybe<CampaignsDateType>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  endDays?: InputMaybe<Scalars['Int']['input']>;
  createdBy?: InputMaybe<Scalars['UUID']['input']>;
  certificateEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  certificateName?: InputMaybe<Scalars['String']['input']>;
  learningPlanFolder?: InputMaybe<LearningPlanFolderInput>;
}>;


export type LearningPlanNewSubmitMutation = { __typename?: 'Mutation', learningPlanCreate: { __typename?: 'LearningPlan', id: any, name: string, displayName: string, externalId: string, description?: string | null, sortRank: number, updatedAt: any, createdAt: any, publishedAt?: any | null, isOrderDisabled: boolean, additionalInfo?: string | null, goal?: string | null, mandatory?: boolean | null, startDateType?: CampaignsDateType | null, startDate?: string | null, endDateType?: CampaignsDateType | null, endDate?: string | null, endDays?: number | null, createdBy?: any | null, updatedBy?: any | null, certificateEnabled?: boolean | null, certificateName?: string | null, isNoDataForBestPractice?: boolean | null, learningPlanDependencies: Array<{ __typename?: 'LearningPlanDependency', id: any, dependentLearningPlan: { __typename?: 'LearningPlan', id: any, name: string, externalId: string } }>, groups: Array<{ __typename?: 'ProfileGroup', id: any, name: string, learnerCount: number, coachCount: number }>, learningPlanFolder?: { __typename?: 'LearningPlanFolder', id: any, name: string } | null } };

export type LearningPlanPublishMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type LearningPlanPublishMutation = { __typename?: 'Mutation', learningPlanPublish: { __typename?: 'LearningPlan', id: any, name: string, displayName: string, externalId: string, description?: string | null, sortRank: number, updatedAt: any, createdAt: any, publishedAt?: any | null, isOrderDisabled: boolean, additionalInfo?: string | null, goal?: string | null, mandatory?: boolean | null, startDateType?: CampaignsDateType | null, startDate?: string | null, endDateType?: CampaignsDateType | null, endDate?: string | null, endDays?: number | null, createdBy?: any | null, updatedBy?: any | null, certificateEnabled?: boolean | null, certificateName?: string | null, isNoDataForBestPractice?: boolean | null, learningPlanDependencies: Array<{ __typename?: 'LearningPlanDependency', id: any, dependentLearningPlan: { __typename?: 'LearningPlan', id: any, name: string, externalId: string } }>, groups: Array<{ __typename?: 'ProfileGroup', id: any, name: string, learnerCount: number, coachCount: number }>, learningPlanFolder?: { __typename?: 'LearningPlanFolder', id: any, name: string } | null } };

export type LearningPlanSearchQueryVariables = Exact<{
  paginate?: InputMaybe<BaseClassicPaginate>;
  conditions?: InputMaybe<LearningPlanSearchConditions>;
}>;


export type LearningPlanSearchQuery = { __typename?: 'Query', learningPlanSearch: { __typename?: 'PaginatedLearningPlanResponse', totalCount?: number | null, pageInfo: { __typename?: 'LearningPlanPageInfo', beforeCursor?: string | null, afterCursor?: string | null }, nodes: Array<{ __typename?: 'LearningPlan', id: any, name: string, externalId: string }> } };

export type LearningPlanSkillsQueryVariables = Exact<{
  learningPlanId: Scalars['UUID']['input'];
}>;


export type LearningPlanSkillsQuery = { __typename?: 'Query', learningPlanSkills: Array<{ __typename?: 'LPSectionSkill', id: any, points: number, position: number, skill: { __typename?: 'Skill', id: any, type: SkillType, name: string, externalId: string, publishedAt?: any | null } }> };

export type LearningPlanSkillsSyncMutationVariables = Exact<{
  learningPlanId: Scalars['UUID']['input'];
  lpSectionSkills: Array<LpSectionSkillInput> | LpSectionSkillInput;
  unlocked: Scalars['Boolean']['input'];
}>;


export type LearningPlanSkillsSyncMutation = { __typename?: 'Mutation', learningPlanSkillsSync: { __typename?: 'LearningPlanSkillsSyncResponse', isOrderDisabled?: boolean | null, lpSectionSkills: Array<{ __typename?: 'LPSectionSkill', id: any, points: number, position: number, skill: { __typename?: 'Skill', id: any, type: SkillType, name: string, externalId: string, publishedAt?: any | null } }> } };

export type LearningPlansAssociatedWithSkillQueryVariables = Exact<{
  skillId: Scalars['UUID']['input'];
}>;


export type LearningPlansAssociatedWithSkillQuery = { __typename?: 'Query', learningPlansAssociatedWithSkill: Array<{ __typename?: 'LearningPlan', id: any, name: string }> };

export type MeQueryVariables = Exact<{
  appName?: InputMaybe<Scalars['String']['input']>;
  appVersion?: InputMaybe<Scalars['String']['input']>;
  browserName?: InputMaybe<Scalars['String']['input']>;
  browserVersion?: InputMaybe<Scalars['String']['input']>;
  osName?: InputMaybe<Scalars['String']['input']>;
  osVersion?: InputMaybe<Scalars['String']['input']>;
  platform?: InputMaybe<Scalars['String']['input']>;
  platformType?: InputMaybe<Scalars['String']['input']>;
  platformVendor?: InputMaybe<Scalars['String']['input']>;
  platformModel?: InputMaybe<Scalars['String']['input']>;
}>;


export type MeQuery = { __typename?: 'Query', me?: { __typename?: 'Me', id: string, displayName?: string | null, photoUrl?: string | null, isSuperAdmin: boolean, createdAt: any, updatedAt: any, companyProfiles: Array<{ __typename?: 'CompanyProfileSession', id: string, externalId: string, emailAddress?: string | null, phoneNumber?: string | null, language?: Language | null, score: number, roles: Array<Role>, permissions: Array<Permission>, company: { __typename?: 'CompanySession', id: string, name: string, externalId: string } }>, flags: Array<{ __typename?: 'Flag', name: string, value: string }> } | null };

export type MediaNewSubmitMutationVariables = Exact<{
  path: Scalars['String']['input'];
  mimeType: Scalars['String']['input'];
  mediaType: MediaType;
}>;


export type MediaNewSubmitMutation = { __typename?: 'Mutation', mediaCreate: { __typename?: 'Media', id: any, path: string, mimeType: string, mediaType: MediaType, mediaUrl?: string | null, createdAt: any } };

export type ProfileEditQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type ProfileEditQuery = { __typename?: 'Query', profile: { __typename?: 'CompanyProfile', id: any, profileId: any, language?: Language | null, phoneNumber?: string | null, emailAddress?: string | null, startDate: any, timezone?: Timezone | null, learnerCommsOptOut: boolean, coachCommsOptOut: boolean, excludeFromAnalytics: boolean, externalId: string, archivedAt?: any | null, profileTags?: Array<{ __typename?: 'ProfileTag', id: any, name: string, metadata?: any | null }> | null, profileGrants?: Array<{ __typename?: 'ProfileGrant', id: string, profileRole: { __typename?: 'ProfileRole', id: string, name?: Role | null } }> | null, companyCohortMembers?: Array<{ __typename?: 'ProfileGroupMember', id: any, type: ProfileGroupMemberType, companyCohort: { __typename?: 'ProfileGroup', id: any, name: string, deletedAt?: any | null } }> | null, profile: { __typename?: 'Profile', id: string, displayName?: string | null, preferredName?: string | null, media?: { __typename?: 'Media', id: any, mediaUrl?: string | null } | null, flags: Array<{ __typename?: 'Flag', name: string, value: string }> } } };

export type ProfileEditSubmitMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  displayName?: InputMaybe<Scalars['String']['input']>;
  photoUrl?: InputMaybe<Scalars['String']['input']>;
  externalId: Scalars['String']['input'];
  language?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  emailAddress?: InputMaybe<Scalars['String']['input']>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  roles: Array<Role> | Role;
  preferredName?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Timezone>;
  startDate: Scalars['String']['input'];
  learnerCommsOptOut: Scalars['Boolean']['input'];
  coachCommsOptOut?: InputMaybe<Scalars['Boolean']['input']>;
  excludeFromAnalytics: Scalars['Boolean']['input'];
  regions?: InputMaybe<Array<RegionInput> | RegionInput>;
  departments?: InputMaybe<Array<DepartmentInput> | DepartmentInput>;
  mergeAcceptance?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ProfileEditSubmitMutation = { __typename?: 'Mutation', profileEdit: { __typename?: 'CompanyProfile', id: any, profileId: any, language?: Language | null, phoneNumber?: string | null, emailAddress?: string | null, startDate: any, timezone?: Timezone | null, learnerCommsOptOut: boolean, coachCommsOptOut: boolean, excludeFromAnalytics: boolean, externalId: string, archivedAt?: any | null, profileTags?: Array<{ __typename?: 'ProfileTag', id: any, name: string, metadata?: any | null }> | null, profileGrants?: Array<{ __typename?: 'ProfileGrant', id: string, profileRole: { __typename?: 'ProfileRole', id: string, name?: Role | null } }> | null, companyCohortMembers?: Array<{ __typename?: 'ProfileGroupMember', id: any, type: ProfileGroupMemberType, companyCohort: { __typename?: 'ProfileGroup', id: any, name: string, deletedAt?: any | null } }> | null, profile: { __typename?: 'Profile', id: string, displayName?: string | null, preferredName?: string | null, media?: { __typename?: 'Media', id: any, mediaUrl?: string | null } | null, flags: Array<{ __typename?: 'Flag', name: string, value: string }> } } };

export type ProfileGroupArchiveMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type ProfileGroupArchiveMutation = { __typename?: 'Mutation', profileGroupArchive: { __typename?: 'ProfileGroup', id: any, name: string, description: string, learningPlans: Array<{ __typename?: 'LearningPlan', id: any, name: string, externalId: string }> } };

export type ProfileGroupCohortMembersQueryVariables = Exact<{
  id: Scalars['String']['input'];
  paginate?: InputMaybe<BaseClassicPaginate>;
}>;


export type ProfileGroupCohortMembersQuery = { __typename?: 'Query', profileGroup: { __typename?: 'ProfileGroup', companyCohortMembers: { __typename?: 'ProfileGroupMemberConnection', totalCount?: number | null, nodes: Array<{ __typename?: 'ProfileGroupMember', id: any, type: ProfileGroupMemberType, companyProfile: { __typename?: 'CompanyProfile', id: any, externalId: string, profile: { __typename?: 'Profile', id: string, displayName?: string | null } } }>, pageInfo: { __typename?: 'ProfileGroupMemberPageInfo', afterCursor?: string | null, beforeCursor?: string | null } } } };

export type ProfileGroupEditQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type ProfileGroupEditQuery = { __typename?: 'Query', profileGroup: { __typename?: 'ProfileGroup', id: any, name: string, description: string, learningPlans: Array<{ __typename?: 'LearningPlan', id: any, name: string, externalId: string }> } };

export type ProfileGroupEditSubmitMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  name: Scalars['String']['input'];
  description: Scalars['String']['input'];
  learningPlans?: InputMaybe<Array<Scalars['UUID']['input']> | Scalars['UUID']['input']>;
}>;


export type ProfileGroupEditSubmitMutation = { __typename?: 'Mutation', profileGroupEdit: { __typename?: 'ProfileGroup', id: any, name: string, description: string, learningPlans: Array<{ __typename?: 'LearningPlan', id: any, name: string, externalId: string }> } };

export type ProfileGroupListQueryVariables = Exact<{
  paginate?: InputMaybe<BaseClassicPaginate>;
  sorts?: InputMaybe<Array<ProfileGroupListOrderBy> | ProfileGroupListOrderBy>;
  conditions?: InputMaybe<ProfileGroupListConditions>;
}>;


export type ProfileGroupListQuery = { __typename?: 'Query', profileGroupList: { __typename?: 'PaginatedProfileGroupListResponse', totalCount?: number | null, pageInfo: { __typename?: 'ProfileGroupListPageInfo', beforeCursor?: string | null, afterCursor?: string | null }, nodes: Array<{ __typename?: 'ProfileGroup', id: any, name: string, description: string, coachCount: number, learnerCount: number, createdAt: any, updatedAt: any, deletedAt?: any | null, creatorProfile: { __typename?: 'Profile', id: string, displayName?: string | null } }> } };

export type ProfileGroupListofProfileQueryVariables = Exact<{
  companyProfileId: Scalars['String']['input'];
}>;


export type ProfileGroupListofProfileQuery = { __typename?: 'Query', profileGroupListofProfile: Array<{ __typename?: 'ProfileGroupMember', id: any, type: ProfileGroupMemberType, companyCohort: { __typename?: 'ProfileGroup', name: string, id: any } }> };

export type ProfileGroupMemberDeleteMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type ProfileGroupMemberDeleteMutation = { __typename?: 'Mutation', profileGroupMemberDelete: { __typename?: 'ProfileGroupMember', id: any, type: ProfileGroupMemberType, companyProfile: { __typename?: 'CompanyProfile', id: any, externalId: string, profile: { __typename?: 'Profile', id: string, displayName?: string | null } } } };

export type ProfileGroupMemberEditSubmitMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  type: ProfileGroupMemberType;
  companyProfileId: Scalars['UUID']['input'];
  profileGroupId?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type ProfileGroupMemberEditSubmitMutation = { __typename?: 'Mutation', profileGroupMemberEdit: { __typename?: 'ProfileGroupMember', id: any, type: ProfileGroupMemberType, companyProfile: { __typename?: 'CompanyProfile', id: any, externalId: string, profile: { __typename?: 'Profile', id: string, displayName?: string | null } } } };

export type ProfileGroupMemberNewSubmitMutationVariables = Exact<{
  type: ProfileGroupMemberType;
  companyProfileId: Scalars['UUID']['input'];
  profileGroupId: Scalars['UUID']['input'];
}>;


export type ProfileGroupMemberNewSubmitMutation = { __typename?: 'Mutation', profileGroupMemberCreate: { __typename?: 'ProfileGroupMember', id: any, type: ProfileGroupMemberType, companyProfile: { __typename?: 'CompanyProfile', id: any, externalId: string, profile: { __typename?: 'Profile', id: string, displayName?: string | null } } } };

export type ProfileGroupNewSubmitMutationVariables = Exact<{
  name: Scalars['String']['input'];
  description: Scalars['String']['input'];
  learningPlans?: InputMaybe<Array<Scalars['UUID']['input']> | Scalars['UUID']['input']>;
}>;


export type ProfileGroupNewSubmitMutation = { __typename?: 'Mutation', profileGroupCreate: { __typename?: 'ProfileGroup', id: any, name: string, description: string, learningPlans: Array<{ __typename?: 'LearningPlan', id: any, name: string, externalId: string }> } };

export type ProfileGroupSearchQueryVariables = Exact<{
  paginate?: InputMaybe<BaseClassicPaginate>;
  conditions?: InputMaybe<ProfileGroupSearchConditions>;
  companyId?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type ProfileGroupSearchQuery = { __typename?: 'Query', profileGroupSearch: { __typename?: 'PaginatedProfileGroupSearchResponse', totalCount?: number | null, pageInfo: { __typename?: 'ProfileGroupSearchPageInfo', beforeCursor?: string | null, afterCursor?: string | null }, nodes: Array<{ __typename?: 'ProfileGroup', id: any, name: string, description: string, learnerCount: number, coachCount: number, companyCohortMembers: { __typename?: 'ProfileGroupMemberConnection', nodes: Array<{ __typename?: 'ProfileGroupMember', id: any, type: ProfileGroupMemberType, companyProfile: { __typename?: 'CompanyProfile', id: any, externalId: string, profile: { __typename?: 'Profile', id: string, displayName?: string | null } } }> }, creatorProfile: { __typename?: 'Profile', id: string, displayName?: string | null } }> } };

export type ProfileListQueryVariables = Exact<{
  paginate?: InputMaybe<BaseClassicPaginate>;
  sorts?: InputMaybe<Array<CompanyProfileListOrderBy> | CompanyProfileListOrderBy>;
  conditions?: InputMaybe<CompanyProfileListConditions>;
}>;


export type ProfileListQuery = { __typename?: 'Query', profileList: { __typename?: 'PaginatedCompanyProfileListResponse', totalCount?: number | null, pageInfo: { __typename?: 'CompanyProfileListPageInfo', beforeCursor?: string | null, afterCursor?: string | null }, nodes: Array<{ __typename?: 'CompanyProfile', id: any, externalId: string, createdAt: any, updatedAt: any, phoneNumber?: string | null, archivedAt?: any | null, profileGrants?: Array<{ __typename?: 'ProfileGrant', id: string, profileRole: { __typename?: 'ProfileRole', id: string, name?: Role | null } }> | null, profile: { __typename?: 'Profile', id: string, displayName?: string | null } }> } };

export type ProfileNewSubmitMutationVariables = Exact<{
  displayName?: InputMaybe<Scalars['String']['input']>;
  photoUrl?: InputMaybe<Scalars['String']['input']>;
  externalId: Scalars['String']['input'];
  language?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  emailAddress?: InputMaybe<Scalars['String']['input']>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  roles: Array<Role> | Role;
  preferredName?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Timezone>;
  startDate: Scalars['String']['input'];
  learnerCommsOptOut: Scalars['Boolean']['input'];
  coachCommsOptOut?: InputMaybe<Scalars['Boolean']['input']>;
  excludeFromAnalytics: Scalars['Boolean']['input'];
  regions?: InputMaybe<Array<RegionInput> | RegionInput>;
  departments?: InputMaybe<Array<DepartmentInput> | DepartmentInput>;
  mergeAcceptance?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ProfileNewSubmitMutation = { __typename?: 'Mutation', profileCreate: { __typename?: 'CompanyProfile', id: any, profileId: any, language?: Language | null, phoneNumber?: string | null, emailAddress?: string | null, startDate: any, timezone?: Timezone | null, learnerCommsOptOut: boolean, coachCommsOptOut: boolean, excludeFromAnalytics: boolean, externalId: string, archivedAt?: any | null, profileTags?: Array<{ __typename?: 'ProfileTag', id: any, name: string, metadata?: any | null }> | null, profileGrants?: Array<{ __typename?: 'ProfileGrant', id: string, profileRole: { __typename?: 'ProfileRole', id: string, name?: Role | null } }> | null, companyCohortMembers?: Array<{ __typename?: 'ProfileGroupMember', id: any, type: ProfileGroupMemberType, companyCohort: { __typename?: 'ProfileGroup', id: any, name: string, deletedAt?: any | null } }> | null, profile: { __typename?: 'Profile', id: string, displayName?: string | null, preferredName?: string | null, media?: { __typename?: 'Media', id: any, mediaUrl?: string | null } | null, flags: Array<{ __typename?: 'Flag', name: string, value: string }> } } };

export type ProfileSearchQueryVariables = Exact<{
  paginate?: InputMaybe<BaseClassicPaginate>;
  conditions?: InputMaybe<CompanyProfileSearchConditions>;
}>;


export type ProfileSearchQuery = { __typename?: 'Query', profileSearch: { __typename?: 'PaginatedCompanyProfileSearchResponse', totalCount?: number | null, pageInfo: { __typename?: 'CompanyProfileSearchPageInfo', beforeCursor?: string | null, afterCursor?: string | null }, nodes: Array<{ __typename?: 'CompanyProfile', id: any, externalId: string, profile: { __typename?: 'Profile', id: string, displayName?: string | null, emailAddress?: string | null } }> } };

export type ProfileTagEditQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type ProfileTagEditQuery = { __typename?: 'Query', profileTag: { __typename?: 'ProfileTag', id: any, name: string, companyProfiles?: Array<{ __typename?: 'CompanyProfile', id: any, externalId: string, profile: { __typename?: 'Profile', id: string, displayName?: string | null } }> | null } };

export type ProfileTagEditSubmitMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  name: Scalars['String']['input'];
  companyProfileIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type ProfileTagEditSubmitMutation = { __typename?: 'Mutation', profileTagEdit: { __typename?: 'ProfileTag', id: any, name: string, companyProfiles?: Array<{ __typename?: 'CompanyProfile', id: any, externalId: string, profile: { __typename?: 'Profile', id: string, displayName?: string | null } }> | null } };

export type ProfileTagListQueryVariables = Exact<{
  paginate?: InputMaybe<BaseClassicPaginate>;
  sorts?: InputMaybe<Array<ProfileTagListOrderBy> | ProfileTagListOrderBy>;
  conditions?: InputMaybe<ProfileTagListConditions>;
}>;


export type ProfileTagListQuery = { __typename?: 'Query', profileTagList: { __typename?: 'PaginatedProfileTagResponse', totalCount?: number | null, pageInfo: { __typename?: 'ProfileTagPageInfo', beforeCursor?: string | null, afterCursor?: string | null }, nodes: Array<{ __typename?: 'ProfileTag', id: any, name: string, metadata?: any | null, profileCount?: number | null, createdAt: any, updatedAt: any }> } };

export type ProfileTagNewSubmitMutationVariables = Exact<{
  name: Scalars['String']['input'];
  companyProfileIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type ProfileTagNewSubmitMutation = { __typename?: 'Mutation', profileTagCreate: { __typename?: 'ProfileTag', id: any, name: string, companyProfiles?: Array<{ __typename?: 'CompanyProfile', id: any, externalId: string, profile: { __typename?: 'Profile', id: string, displayName?: string | null } }> | null } };

export type ProfileTagSearchQueryVariables = Exact<{
  paginate?: InputMaybe<BaseClassicPaginate>;
  conditions?: InputMaybe<ProfileTagSearchConditions>;
}>;


export type ProfileTagSearchQuery = { __typename?: 'Query', profileTagSearch: { __typename?: 'PaginatedProfileTagResponse', totalCount?: number | null, pageInfo: { __typename?: 'ProfileTagPageInfo', beforeCursor?: string | null, afterCursor?: string | null }, nodes: Array<{ __typename?: 'ProfileTag', id: any, name: string }> } };

export type ProfileUpdateStatusMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  active: Scalars['Boolean']['input'];
}>;


export type ProfileUpdateStatusMutation = { __typename?: 'Mutation', profileUpdateStatus: { __typename?: 'CompanyProfile', id: any, profileId: any, language?: Language | null, phoneNumber?: string | null, emailAddress?: string | null, startDate: any, timezone?: Timezone | null, learnerCommsOptOut: boolean, coachCommsOptOut: boolean, excludeFromAnalytics: boolean, externalId: string, archivedAt?: any | null, profileTags?: Array<{ __typename?: 'ProfileTag', id: any, name: string, metadata?: any | null }> | null, profileGrants?: Array<{ __typename?: 'ProfileGrant', id: string, profileRole: { __typename?: 'ProfileRole', id: string, name?: Role | null } }> | null, companyCohortMembers?: Array<{ __typename?: 'ProfileGroupMember', id: any, type: ProfileGroupMemberType, companyCohort: { __typename?: 'ProfileGroup', id: any, name: string, deletedAt?: any | null } }> | null, profile: { __typename?: 'Profile', id: string, displayName?: string | null, preferredName?: string | null, media?: { __typename?: 'Media', id: any, mediaUrl?: string | null } | null, flags: Array<{ __typename?: 'Flag', name: string, value: string }> } } };

export type ProfileUpdateTagsMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  tags: Array<ProfileTagInput> | ProfileTagInput;
}>;


export type ProfileUpdateTagsMutation = { __typename?: 'Mutation', profileUpdateTags: { __typename?: 'CompanyProfile', id: any, profileId: any, language?: Language | null, phoneNumber?: string | null, emailAddress?: string | null, startDate: any, timezone?: Timezone | null, learnerCommsOptOut: boolean, coachCommsOptOut: boolean, excludeFromAnalytics: boolean, externalId: string, archivedAt?: any | null, profileTags?: Array<{ __typename?: 'ProfileTag', id: any, name: string, metadata?: any | null }> | null, profileGrants?: Array<{ __typename?: 'ProfileGrant', id: string, profileRole: { __typename?: 'ProfileRole', id: string, name?: Role | null } }> | null, companyCohortMembers?: Array<{ __typename?: 'ProfileGroupMember', id: any, type: ProfileGroupMemberType, companyCohort: { __typename?: 'ProfileGroup', id: any, name: string, deletedAt?: any | null } }> | null, profile: { __typename?: 'Profile', id: string, displayName?: string | null, preferredName?: string | null, media?: { __typename?: 'Media', id: any, mediaUrl?: string | null } | null, flags: Array<{ __typename?: 'Flag', name: string, value: string }> } } };

export type RepPromptSearchQueryVariables = Exact<{
  paginate?: InputMaybe<BaseClassicPaginate>;
  conditions?: InputMaybe<RepPromptLocalizedSearchConditions>;
}>;


export type RepPromptSearchQuery = { __typename?: 'Query', repPromptSearch: { __typename?: 'PaginatedRepPromptLocalizedResponse', totalCount?: number | null, pageInfo: { __typename?: 'RepPromptLocalizedPageInfo', beforeCursor?: string | null, afterCursor?: string | null }, nodes: Array<{ __typename?: 'RepPromptLocalized', repPromptId: any, content: string, skillId?: string | null }> } };

export type RepResponseQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type RepResponseQuery = { __typename?: 'Query', repResponse: { __typename?: 'RepResponse', id: any, content?: string | null, responseType: RepResponseKind, createdAt: any, masterMedia?: { __typename?: 'Media', id: any, mediaUrl?: string | null } | null, streamMedia?: { __typename?: 'Media', id: any, mediaUrl?: string | null } | null, posterMedia?: { __typename?: 'Media', mediaUrl?: string | null } | null, assignment: { __typename?: 'RepAssignment', id: any, repAssignmentStatus: RepAssignmentStatus, createdAt: any, prompt: { __typename?: 'RepPrompt', id: any, isCoached: boolean, repType: RepType, assignedAt: any, localizations: Array<{ __typename?: 'RepPromptLocalized', content: string, language: Language }>, form?: { __typename?: 'Form', id: any, localizations: { __typename?: 'FormLocalizedConnection', nodes: Array<{ __typename?: 'FormLocalized', id: any, language: Language, description: string }> }, prompts: { __typename?: 'PromptConnection', nodes: Array<{ __typename?: 'Prompt', id: any, isMultiple?: boolean | null, localizations: { __typename?: 'PromptLocalizedConnection', nodes: Array<{ __typename?: 'PromptLocalized', id: any, language: Language, description: string }> }, choices: { __typename?: 'ChoiceConnection', nodes: Array<{ __typename?: 'Choice', id: any, type: ChoiceType, isCorrect?: boolean | null, localizations: { __typename?: 'ChoiceLocalizedConnection', nodes: Array<{ __typename?: 'ChoiceLocalized', id: any, language: Language, description?: string | null }> } }> } }> } } | null }, skill: { __typename?: 'SkillRep', id: any, displayName: string, externalId: string, repPrompt?: { __typename?: 'RepPrompt', repPromptLocalizeds: Array<{ __typename?: 'RepPromptLocalized', id: any, language: Language, autoEvaluationCriteria?: { __typename?: 'AutoEvaluationCriteriaGraphql', schemaVersion?: string | null, keywordCheck?: { __typename?: 'AutoEvaluationCriteriaKeywordCheck', allowedKeywords?: Array<string> | null, incorrectKeywords?: Array<string> | null } | null } | null }> } | null }, companyProfile: { __typename?: 'CompanyProfile', id: any, externalId: string, emailAddress?: string | null, profile: { __typename?: 'Profile', id: string, displayName?: string | null, media?: { __typename?: 'Media', mediaUrlV2?: string | null } | null } } }, feedback?: Array<{ __typename?: 'RepSubmissionFeedback', id: any, reviewerRole: ReviewerRoleType, responseType: RepResponseKind, feedbackType: RepFeedbackType, content?: string | null, createdAt: any, reviewerCompanyProfile?: { __typename?: 'CompanyProfile', id: any, externalId: string, emailAddress?: string | null, profile: { __typename?: 'Profile', id: string, displayName?: string | null } } | null, rubric?: { __typename?: 'Rubric', formId?: string | null, version?: number | null, prompts?: Array<{ __typename?: 'RubricPrompt', promptId?: string | null, answers?: Array<{ __typename?: 'RubricAnswer', answer?: string | null, choiceId?: string | null }> | null }> | null } | null }> | null, transcriptionMedia?: { __typename?: 'Media', id: any, status: MediaStatus, error?: string | null, mediaUrlV2?: string | null } | null, autoEvaluationOutcome?: { __typename?: 'AutoEvaluationOutcome', isArticulationPass?: boolean | null, isKeywordPass?: boolean | null, schemaVersion?: string | null, languageCode?: string | null, sentiment?: number | null, keywordCheck?: { __typename?: 'AutoEvaluationKeywordCheck', allowedKeywordsMatched?: Array<string> | null, allowedKeywordsNotMatched?: Array<string> | null, incorrectKeywordsMatched?: Array<string> | null, incorrectKeywordsNotMatched?: Array<string> | null, allowedKeywordsMatchedV2?: Array<{ __typename?: 'KeywordsMatch', expectedKeyword?: string | null, actualKeyword?: string | null }> | null, allowedKeywordsFuzzyMatched?: Array<{ __typename?: 'FuzzyMatch', expectedKeyword?: string | null, actualKeyword?: string | null, fuzzyIndex?: number | null }> | null, incorrectKeywordsMatchedV2?: Array<{ __typename?: 'KeywordsMatch', expectedKeyword?: string | null, actualKeyword?: string | null }> | null, incorrectKeywordsFuzzyMatched?: Array<{ __typename?: 'FuzzyMatch', expectedKeyword?: string | null, actualKeyword?: string | null, fuzzyIndex?: number | null }> | null } | null, articulation?: { __typename?: 'Articulation', overallScore?: number | null, mediaLength?: number | null, wordsPerMinute?: number | null, fillerWordsCount?: number | null, keywordScore?: number | null, fillerWords?: Array<string> | null, wpmScore?: number | null, fillerWordScore?: number | null } | null, contentScore?: { __typename?: 'ContentScore', consistency: number, coherence: number, grammar: number, toneNstyle: number } | null, conversationMetrics?: { __typename?: 'ConversationMetrics', conversationType: string, questionRate: number, overallFeedback?: string | null, noOfSubmitterQuestions?: number | null, needsIdentificationScore: { __typename?: 'NeedsIdentificationScore', identificationScore: number, problemClarity: number, needExpressed: boolean, needCaptured: boolean }, nonVerbalSkillScore: { __typename?: 'NonVerbalSkillScore', listening: number, confidence: number, patience: number, pauseDuration: number }, openEndedQuestions: Array<{ __typename?: 'OpenEndedQuestion', question: string, speaker: string, startTime: number }>, stackedQuestions: Array<{ __typename?: 'StackedQuestion', questions: Array<string>, speaker: string, startTime: number }>, speakerLabels?: Array<{ __typename?: 'SpeakerLabel', speakerId?: string | null, speakerLabel?: string | null, speakerRole?: string | null, speakerRoleDisplayed?: string | null, speakerName?: string | null, talkRatio?: number | null, isPresenter?: boolean | null }> | null, thresholds: { __typename?: 'ConversationMetricsThresholds', stackedQuestionsCount: number, talkRatio: number, questionRate: number, pauseDuration: Array<number>, noOfSubmitterQuestions: number } } | null } | null } };

export type RepResponseListQueryVariables = Exact<{
  filters: RepResponseFilter;
  limit?: InputMaybe<Scalars['Int']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<RepResponseListOrderBy>;
  orderDirection?: InputMaybe<OrderByDirection>;
}>;


export type RepResponseListQuery = { __typename?: 'Query', repResponseList: { __typename?: 'PaginatedRepResponse', count?: number | null, beforeCursor?: string | null, afterCursor?: string | null, nodes: Array<{ __typename?: 'RepResponse', id: any, content?: string | null, responseType: RepResponseKind, createdAt: any, masterMedia?: { __typename?: 'Media', id: any, mediaUrl?: string | null } | null, streamMedia?: { __typename?: 'Media', id: any, mediaUrl?: string | null } | null, posterMedia?: { __typename?: 'Media', mediaUrl?: string | null } | null, assignment: { __typename?: 'RepAssignment', id: any, repAssignmentStatus: RepAssignmentStatus, createdAt: any, prompt: { __typename?: 'RepPrompt', id: any, isCoached: boolean, repType: RepType, assignedAt: any, localizations: Array<{ __typename?: 'RepPromptLocalized', content: string, language: Language }>, form?: { __typename?: 'Form', id: any, localizations: { __typename?: 'FormLocalizedConnection', nodes: Array<{ __typename?: 'FormLocalized', id: any, language: Language, description: string }> }, prompts: { __typename?: 'PromptConnection', nodes: Array<{ __typename?: 'Prompt', id: any, isMultiple?: boolean | null, localizations: { __typename?: 'PromptLocalizedConnection', nodes: Array<{ __typename?: 'PromptLocalized', id: any, language: Language, description: string }> }, choices: { __typename?: 'ChoiceConnection', nodes: Array<{ __typename?: 'Choice', id: any, type: ChoiceType, isCorrect?: boolean | null, localizations: { __typename?: 'ChoiceLocalizedConnection', nodes: Array<{ __typename?: 'ChoiceLocalized', id: any, language: Language, description?: string | null }> } }> } }> } } | null }, skill: { __typename?: 'SkillRep', id: any, displayName: string, externalId: string, repPrompt?: { __typename?: 'RepPrompt', repPromptLocalizeds: Array<{ __typename?: 'RepPromptLocalized', id: any, language: Language, autoEvaluationCriteria?: { __typename?: 'AutoEvaluationCriteriaGraphql', schemaVersion?: string | null, keywordCheck?: { __typename?: 'AutoEvaluationCriteriaKeywordCheck', allowedKeywords?: Array<string> | null, incorrectKeywords?: Array<string> | null } | null } | null }> } | null }, companyProfile: { __typename?: 'CompanyProfile', id: any, externalId: string, emailAddress?: string | null, profile: { __typename?: 'Profile', id: string, displayName?: string | null, media?: { __typename?: 'Media', mediaUrlV2?: string | null } | null } } }, feedback?: Array<{ __typename?: 'RepSubmissionFeedback', id: any, reviewerRole: ReviewerRoleType, responseType: RepResponseKind, feedbackType: RepFeedbackType, content?: string | null, createdAt: any, reviewerCompanyProfile?: { __typename?: 'CompanyProfile', id: any, externalId: string, emailAddress?: string | null, profile: { __typename?: 'Profile', id: string, displayName?: string | null } } | null, rubric?: { __typename?: 'Rubric', formId?: string | null, version?: number | null, prompts?: Array<{ __typename?: 'RubricPrompt', promptId?: string | null, answers?: Array<{ __typename?: 'RubricAnswer', answer?: string | null, choiceId?: string | null }> | null }> | null } | null }> | null, transcriptionMedia?: { __typename?: 'Media', id: any, status: MediaStatus, error?: string | null, mediaUrlV2?: string | null } | null, autoEvaluationOutcome?: { __typename?: 'AutoEvaluationOutcome', isArticulationPass?: boolean | null, isKeywordPass?: boolean | null, schemaVersion?: string | null, languageCode?: string | null, sentiment?: number | null, keywordCheck?: { __typename?: 'AutoEvaluationKeywordCheck', allowedKeywordsMatched?: Array<string> | null, allowedKeywordsNotMatched?: Array<string> | null, incorrectKeywordsMatched?: Array<string> | null, incorrectKeywordsNotMatched?: Array<string> | null, allowedKeywordsMatchedV2?: Array<{ __typename?: 'KeywordsMatch', expectedKeyword?: string | null, actualKeyword?: string | null }> | null, allowedKeywordsFuzzyMatched?: Array<{ __typename?: 'FuzzyMatch', expectedKeyword?: string | null, actualKeyword?: string | null, fuzzyIndex?: number | null }> | null, incorrectKeywordsMatchedV2?: Array<{ __typename?: 'KeywordsMatch', expectedKeyword?: string | null, actualKeyword?: string | null }> | null, incorrectKeywordsFuzzyMatched?: Array<{ __typename?: 'FuzzyMatch', expectedKeyword?: string | null, actualKeyword?: string | null, fuzzyIndex?: number | null }> | null } | null, articulation?: { __typename?: 'Articulation', overallScore?: number | null, mediaLength?: number | null, wordsPerMinute?: number | null, fillerWordsCount?: number | null, keywordScore?: number | null, fillerWords?: Array<string> | null, wpmScore?: number | null, fillerWordScore?: number | null } | null, contentScore?: { __typename?: 'ContentScore', consistency: number, coherence: number, grammar: number, toneNstyle: number } | null, conversationMetrics?: { __typename?: 'ConversationMetrics', conversationType: string, questionRate: number, overallFeedback?: string | null, noOfSubmitterQuestions?: number | null, needsIdentificationScore: { __typename?: 'NeedsIdentificationScore', identificationScore: number, problemClarity: number, needExpressed: boolean, needCaptured: boolean }, nonVerbalSkillScore: { __typename?: 'NonVerbalSkillScore', listening: number, confidence: number, patience: number, pauseDuration: number }, openEndedQuestions: Array<{ __typename?: 'OpenEndedQuestion', question: string, speaker: string, startTime: number }>, stackedQuestions: Array<{ __typename?: 'StackedQuestion', questions: Array<string>, speaker: string, startTime: number }>, speakerLabels?: Array<{ __typename?: 'SpeakerLabel', speakerId?: string | null, speakerLabel?: string | null, speakerRole?: string | null, speakerRoleDisplayed?: string | null, speakerName?: string | null, talkRatio?: number | null, isPresenter?: boolean | null }> | null, thresholds: { __typename?: 'ConversationMetricsThresholds', stackedQuestionsCount: number, talkRatio: number, questionRate: number, pauseDuration: Array<number>, noOfSubmitterQuestions: number } } | null } | null }> } };

export type RolePlayConfigListQueryVariables = Exact<{ [key: string]: never; }>;


export type RolePlayConfigListQuery = { __typename?: 'Query', getRolePlayConfigs: Array<{ __typename?: 'RolePlayConfig', id: string, cardTitle: string, cardDescription: string, status: string, personaName: string, designation: string, details: { __typename?: 'RolePlayDetails', bio: string, goal: string, traits: Array<string> }, config: { __typename?: 'RolePlayConfigSettings', difficulty: string, voiceName?: string | null, gender: string, voiceService?: string | null, avatarUrl?: string | null } }> };

export type SkillArchiveMutationVariables = Exact<{
  skillId: Scalars['UUID']['input'];
}>;


export type SkillArchiveMutation = { __typename?: 'Mutation', skillArchive: { __typename?: 'Skill', id: any, type: SkillType, externalId: string, name: string, displayName: string, description?: string | null, duration?: string | null, createdAt: any, updatedAt: any, publishedAt?: any | null, companyId: any, sourceCompanyId?: any | null, sourceSkillId?: any | null, createdBy?: any | null, updatedBy?: any | null, media?: { __typename?: 'Media', id: any, mediaUrl?: string | null } | null } };

export type SkillEditQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type SkillEditQuery = { __typename?: 'Query', skill: { __typename?: 'Skill', id: any, type: SkillType, externalId: string, name: string, displayName: string, description?: string | null, duration?: string | null, createdAt: any, updatedAt: any, publishedAt?: any | null, companyId: any, sourceCompanyId?: any | null, sourceSkillId?: any | null, createdBy?: any | null, updatedBy?: any | null, learningCards: { __typename?: 'LearningCardConnection', nodes: Array<{ __typename?: 'LearningCardFile', id: any, type: LearningCardType, position: number, experimentConfig?: any | null, localizations: { __typename?: 'LearningCardLocalizedFileConnection', nodes: Array<{ __typename?: 'LearningCardLocalizedFile', id: any, language: Language, url?: string | null, media: { __typename?: 'Media', id: any, mediaUrl?: string | null } }> } } | { __typename?: 'LearningCardFlashCard', id: any, type: LearningCardType, position: number, experimentConfig?: any | null, localizations: { __typename?: 'LearningCardLocalizedFlashCardConnection', nodes: Array<{ __typename?: 'LearningCardLocalizedFlashCard', id: any, language: Language, title?: string | null, description?: string | null, fcMedia?: { __typename?: 'Media', id: any, mediaUrl?: string | null } | null }> } } | { __typename?: 'LearningCardForm', id: any, type: LearningCardType, position: number, experimentConfig?: any | null, resetLpIfFail: boolean, form: { __typename?: 'Form', id: any, name: string, type: FormType, title?: string | null, passingThreshold?: number | null, maxTries?: number | null, maxTriesPerPrompt?: MaxTriesPerPrompt | null, randomizePrompts: boolean, numPromptsShow?: number | null, localizations: { __typename?: 'FormLocalizedConnection', nodes: Array<{ __typename?: 'FormLocalized', id: any, language: Language, description: string }> }, prompts: { __typename?: 'PromptConnection', nodes: Array<{ __typename?: 'Prompt', id: any, position: number, isMultiple?: boolean | null, isMandatory?: boolean | null, localizations: { __typename?: 'PromptLocalizedConnection', nodes: Array<{ __typename?: 'PromptLocalized', id: any, language: Language, description: string }> }, choices: { __typename?: 'ChoiceConnection', nodes: Array<{ __typename?: 'Choice', id: any, type: ChoiceType, position: number, isCorrect?: boolean | null, localizations: { __typename?: 'ChoiceLocalizedConnection', nodes: Array<{ __typename?: 'ChoiceLocalized', id: any, language: Language, description?: string | null, media?: { __typename?: 'Media', id: any, mediaUrl?: string | null } | null }> } }> } }> } } } | { __typename?: 'LearningCardLinkout', id: any, type: LearningCardType, position: number, experimentConfig?: any | null, localizations: { __typename?: 'LearningCardLocalizedLinkoutConnection', nodes: Array<{ __typename?: 'LearningCardLocalizedLinkout', id: any, language: Language, title?: string | null, url?: string | null, description?: string | null, ctaTitle?: string | null }> } } | { __typename?: 'LearningCardVideo', id: any, type: LearningCardType, position: number, experimentConfig?: any | null, localizations: { __typename?: 'LearningCardLocalizedVideoConnection', nodes: Array<{ __typename?: 'LearningCardLocalizedVideo', id: any, language: Language, title?: string | null, streamMedia?: { __typename?: 'Media', id: any, mimeType: string, location: MediaLocation, mediaUrl?: string | null } | null, masterMedia?: { __typename?: 'Media', id: any, mediaUrl?: string | null } | null, posterMedia?: { __typename?: 'Media', id: any, mediaUrl?: string | null } | null, textTrackMedia?: { __typename?: 'Media', id: any, mediaUrl?: string | null } | null }> } }> }, media?: { __typename?: 'Media', id: any, mediaUrl?: string | null } | null } };

export type SkillListQueryVariables = Exact<{
  paginate?: InputMaybe<BaseClassicPaginate>;
  sorts?: InputMaybe<Array<SkillListOrderBy> | SkillListOrderBy>;
  conditions?: InputMaybe<SkillListConditions>;
}>;


export type SkillListQuery = { __typename?: 'Query', skillList: { __typename?: 'PaginatedSkillResponse', totalCount?: number | null, pageInfo: { __typename?: 'SkillPageInfo', beforeCursor?: string | null, afterCursor?: string | null }, nodes: Array<{ __typename?: 'Skill', id: any, externalId: string, name: string, duration?: string | null, createdAt: any, publishedAt?: any | null, media?: { __typename?: 'Media', id: any, mediaUrl?: string | null } | null }> } };

export type SkillLocalizationsQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type SkillLocalizationsQuery = { __typename?: 'Query', skillLocalizations: Array<{ __typename?: 'LocalizedEntity', label: string, entityType: LocalizedEntityType, relationshipEntityId: any, inputs: Array<{ __typename?: 'LocalizedInput', label?: string | null, name: string, type: LocalizedInputType, localizations: Array<{ __typename?: 'Localization', id?: any | null, language: Language, value?: string | null, disabled?: boolean | null, autoEvaluationCriteria?: { __typename?: 'AutoEvaluationCriteriaGraphql', schemaVersion?: string | null, keywordCheck?: { __typename?: 'AutoEvaluationCriteriaKeywordCheck', allowedKeywords?: Array<string> | null, incorrectKeywords?: Array<string> | null } | null } | null }> }> }> };

export type SkillLocalizationsSyncMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  entities: Array<LocalizedEntityInput> | LocalizedEntityInput;
}>;


export type SkillLocalizationsSyncMutation = { __typename?: 'Mutation', skillLocalizationsSync: Array<{ __typename?: 'LocalizedEntity', label: string, entityType: LocalizedEntityType, relationshipEntityId: any, inputs: Array<{ __typename?: 'LocalizedInput', label?: string | null, name: string, type: LocalizedInputType, localizations: Array<{ __typename?: 'Localization', id?: any | null, language: Language, value?: string | null, disabled?: boolean | null, autoEvaluationCriteria?: { __typename?: 'AutoEvaluationCriteriaGraphql', schemaVersion?: string | null, keywordCheck?: { __typename?: 'AutoEvaluationCriteriaKeywordCheck', allowedKeywords?: Array<string> | null, incorrectKeywords?: Array<string> | null } | null } | null }> }> }> };

export type SkillPublishMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type SkillPublishMutation = { __typename?: 'Mutation', skillPublish: { __typename?: 'Skill', id: any, type: SkillType, externalId: string, name: string, displayName: string, description?: string | null, duration?: string | null, createdAt: any, updatedAt: any, publishedAt?: any | null, companyId: any, sourceCompanyId?: any | null, sourceSkillId?: any | null, createdBy?: any | null, updatedBy?: any | null, media?: { __typename?: 'Media', id: any, mediaUrl?: string | null } | null } };

export type SkillRepEditQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type SkillRepEditQuery = { __typename?: 'Query', skillRep: { __typename?: 'SkillRep', id: any, name: string, externalId: string, displayName: string, publishedAt?: any | null, media?: { __typename?: 'Media', id: any, mediaUrl?: string | null } | null, repPrompt?: { __typename?: 'RepPrompt', id: any, isRepeatable?: boolean | null, isCoached: boolean, isKeywords: boolean, repType: RepType, allowedKeywords?: Array<string> | null, incorrectKeywords?: Array<string> | null, conversationType?: ConversationType | null, rolePlayConfigId?: any | null, isAiEnabled: boolean, isAutoCoachEnabled: boolean, autoCoachConfig?: { __typename?: 'AutoCoachConfig', approvalCutoff: number, rejectionCutoff: number } | null, conversationRoles?: { __typename?: 'ConversationRoles', submitter: string, audience: string } | null, interjections?: Array<{ __typename?: 'Interjection', index?: string | null, duration?: string | null, start?: string | null, message?: Array<{ __typename?: 'InterjectionMessage', translatedText?: string | null, language: Language }> | null }> | null, repPromptLocalizeds: Array<{ __typename?: 'RepPromptLocalized', id: any, language: Language, content: string, autoEvaluationCriteria?: { __typename?: 'AutoEvaluationCriteriaGraphql', keywordCheck?: { __typename?: 'AutoEvaluationCriteriaKeywordCheck', allowedKeywords?: Array<string> | null, incorrectKeywords?: Array<string> | null } | null } | null }>, repPromptResponseTypes: Array<{ __typename?: 'RepPromptResponseType', id: any, responseType: RepResponseKind }>, form?: { __typename?: 'Form', id: any, localizations: { __typename?: 'FormLocalizedConnection', nodes: Array<{ __typename?: 'FormLocalized', id: any, language: Language, description: string }> }, prompts: { __typename?: 'PromptConnection', nodes: Array<{ __typename?: 'Prompt', id: any, isMultiple?: boolean | null, localizations: { __typename?: 'PromptLocalizedConnection', nodes: Array<{ __typename?: 'PromptLocalized', id: any, language: Language, description: string }> }, choices: { __typename?: 'ChoiceConnection', nodes: Array<{ __typename?: 'Choice', id: any, type: ChoiceType, isCorrect?: boolean | null, localizations: { __typename?: 'ChoiceLocalizedConnection', nodes: Array<{ __typename?: 'ChoiceLocalized', id: any, language: Language, description?: string | null }> } }> } }> } } | null } | null } };

export type SkillRepListQueryVariables = Exact<{
  paginate?: InputMaybe<BaseClassicPaginate>;
  sorts?: InputMaybe<Array<SkillRepListOrderBy> | SkillRepListOrderBy>;
  conditions?: InputMaybe<SkillRepListConditions>;
}>;


export type SkillRepListQuery = { __typename?: 'Query', skillRepList: { __typename?: 'PaginatedSkillRepResponse', totalCount?: number | null, pageInfo: { __typename?: 'SkillRepPageInfo', beforeCursor?: string | null, afterCursor?: string | null }, nodes: Array<{ __typename?: 'SkillRep', id: any, name: string, externalId: string, createdAt: any, updatedAt: any, publishedAt?: any | null, repPrompt?: { __typename?: 'RepPrompt', id: any, allResponseTypeEnabled: boolean, isCoached: boolean, repType: RepType, repPromptResponseTypes: Array<{ __typename?: 'RepPromptResponseType', id: any, responseType: RepResponseKind }> } | null }> } };

export type SkillRepLocalizationsQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type SkillRepLocalizationsQuery = { __typename?: 'Query', skillRepLocalizations: Array<{ __typename?: 'LocalizedEntity', label: string, entityType: LocalizedEntityType, relationshipEntityId: any, inputs: Array<{ __typename?: 'LocalizedInput', label?: string | null, name: string, type: LocalizedInputType, localizations: Array<{ __typename?: 'Localization', id?: any | null, language: Language, value?: string | null, disabled?: boolean | null, autoEvaluationCriteria?: { __typename?: 'AutoEvaluationCriteriaGraphql', schemaVersion?: string | null, keywordCheck?: { __typename?: 'AutoEvaluationCriteriaKeywordCheck', allowedKeywords?: Array<string> | null, incorrectKeywords?: Array<string> | null } | null } | null }> }> }> };

export type SkillRepLocalizationsSyncMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  entities: Array<LocalizedEntityInput> | LocalizedEntityInput;
}>;


export type SkillRepLocalizationsSyncMutation = { __typename?: 'Mutation', skillRepLocalizationsSync: Array<{ __typename?: 'LocalizedEntity', label: string, entityType: LocalizedEntityType, relationshipEntityId: any, inputs: Array<{ __typename?: 'LocalizedInput', label?: string | null, name: string, type: LocalizedInputType, localizations: Array<{ __typename?: 'Localization', id?: any | null, language: Language, value?: string | null, disabled?: boolean | null, autoEvaluationCriteria?: { __typename?: 'AutoEvaluationCriteriaGraphql', schemaVersion?: string | null, keywordCheck?: { __typename?: 'AutoEvaluationCriteriaKeywordCheck', allowedKeywords?: Array<string> | null, incorrectKeywords?: Array<string> | null } | null } | null }> }> }> };

export type SkillRepPublishMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type SkillRepPublishMutation = { __typename?: 'Mutation', skillRepPublish: { __typename?: 'SkillRep', id: any, name: string, externalId: string, displayName: string, publishedAt?: any | null, media?: { __typename?: 'Media', id: any, mediaUrl?: string | null } | null, repPrompt?: { __typename?: 'RepPrompt', id: any, isRepeatable?: boolean | null, isCoached: boolean, isKeywords: boolean, repType: RepType, allowedKeywords?: Array<string> | null, incorrectKeywords?: Array<string> | null, conversationType?: ConversationType | null, rolePlayConfigId?: any | null, isAiEnabled: boolean, isAutoCoachEnabled: boolean, autoCoachConfig?: { __typename?: 'AutoCoachConfig', approvalCutoff: number, rejectionCutoff: number } | null, conversationRoles?: { __typename?: 'ConversationRoles', submitter: string, audience: string } | null, interjections?: Array<{ __typename?: 'Interjection', index?: string | null, duration?: string | null, start?: string | null, message?: Array<{ __typename?: 'InterjectionMessage', translatedText?: string | null, language: Language }> | null }> | null, repPromptLocalizeds: Array<{ __typename?: 'RepPromptLocalized', id: any, language: Language, content: string, autoEvaluationCriteria?: { __typename?: 'AutoEvaluationCriteriaGraphql', keywordCheck?: { __typename?: 'AutoEvaluationCriteriaKeywordCheck', allowedKeywords?: Array<string> | null, incorrectKeywords?: Array<string> | null } | null } | null }>, repPromptResponseTypes: Array<{ __typename?: 'RepPromptResponseType', id: any, responseType: RepResponseKind }>, form?: { __typename?: 'Form', id: any, localizations: { __typename?: 'FormLocalizedConnection', nodes: Array<{ __typename?: 'FormLocalized', id: any, language: Language, description: string }> }, prompts: { __typename?: 'PromptConnection', nodes: Array<{ __typename?: 'Prompt', id: any, isMultiple?: boolean | null, localizations: { __typename?: 'PromptLocalizedConnection', nodes: Array<{ __typename?: 'PromptLocalized', id: any, language: Language, description: string }> }, choices: { __typename?: 'ChoiceConnection', nodes: Array<{ __typename?: 'Choice', id: any, type: ChoiceType, isCorrect?: boolean | null, localizations: { __typename?: 'ChoiceLocalizedConnection', nodes: Array<{ __typename?: 'ChoiceLocalized', id: any, language: Language, description?: string | null }> } }> } }> } } | null } | null } };

export type SkillRepUpsertMutationVariables = Exact<{
  upsertSkillRepInput: UpsertSkillRepInput;
}>;


export type SkillRepUpsertMutation = { __typename?: 'Mutation', upsertSkillRep: { __typename?: 'SkillRep', id: any, name: string, externalId: string, displayName: string, publishedAt?: any | null, media?: { __typename?: 'Media', id: any, mediaUrl?: string | null } | null, repPrompt?: { __typename?: 'RepPrompt', id: any, isRepeatable?: boolean | null, isCoached: boolean, isKeywords: boolean, repType: RepType, allowedKeywords?: Array<string> | null, incorrectKeywords?: Array<string> | null, conversationType?: ConversationType | null, rolePlayConfigId?: any | null, isAiEnabled: boolean, isAutoCoachEnabled: boolean, autoCoachConfig?: { __typename?: 'AutoCoachConfig', approvalCutoff: number, rejectionCutoff: number } | null, conversationRoles?: { __typename?: 'ConversationRoles', submitter: string, audience: string } | null, interjections?: Array<{ __typename?: 'Interjection', index?: string | null, duration?: string | null, start?: string | null, message?: Array<{ __typename?: 'InterjectionMessage', translatedText?: string | null, language: Language }> | null }> | null, repPromptLocalizeds: Array<{ __typename?: 'RepPromptLocalized', id: any, language: Language, content: string, autoEvaluationCriteria?: { __typename?: 'AutoEvaluationCriteriaGraphql', keywordCheck?: { __typename?: 'AutoEvaluationCriteriaKeywordCheck', allowedKeywords?: Array<string> | null, incorrectKeywords?: Array<string> | null } | null } | null }>, repPromptResponseTypes: Array<{ __typename?: 'RepPromptResponseType', id: any, responseType: RepResponseKind }>, form?: { __typename?: 'Form', id: any, localizations: { __typename?: 'FormLocalizedConnection', nodes: Array<{ __typename?: 'FormLocalized', id: any, language: Language, description: string }> }, prompts: { __typename?: 'PromptConnection', nodes: Array<{ __typename?: 'Prompt', id: any, isMultiple?: boolean | null, localizations: { __typename?: 'PromptLocalizedConnection', nodes: Array<{ __typename?: 'PromptLocalized', id: any, language: Language, description: string }> }, choices: { __typename?: 'ChoiceConnection', nodes: Array<{ __typename?: 'Choice', id: any, type: ChoiceType, isCorrect?: boolean | null, localizations: { __typename?: 'ChoiceLocalizedConnection', nodes: Array<{ __typename?: 'ChoiceLocalized', id: any, language: Language, description?: string | null }> } }> } }> } } | null } | null } };

export type SkillSearchQueryVariables = Exact<{
  paginate?: InputMaybe<BaseClassicPaginate>;
  conditions?: InputMaybe<SkillSearchConditions>;
}>;


export type SkillSearchQuery = { __typename?: 'Query', skillSearch: { __typename?: 'PaginatedSkillResponse', totalCount?: number | null, pageInfo: { __typename?: 'SkillPageInfo', beforeCursor?: string | null, afterCursor?: string | null }, nodes: Array<{ __typename?: 'Skill', id: any, type: SkillType, externalId: string, name: string, publishedAt?: any | null }> } };

export type SkillUpsertSubmitMutationVariables = Exact<{
  id?: InputMaybe<Scalars['String']['input']>;
  externalId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  displayName: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  photoUrl: Scalars['String']['input'];
  duration?: InputMaybe<Scalars['String']['input']>;
}>;


export type SkillUpsertSubmitMutation = { __typename?: 'Mutation', skillUpsert: { __typename?: 'Skill', id: any, type: SkillType, externalId: string, name: string, displayName: string, description?: string | null, duration?: string | null, createdAt: any, updatedAt: any, publishedAt?: any | null, companyId: any, sourceCompanyId?: any | null, sourceSkillId?: any | null, createdBy?: any | null, updatedBy?: any | null, media?: { __typename?: 'Media', id: any, mediaUrl?: string | null } | null } };

export type SynkCustomVocabularyMutationVariables = Exact<{
  vocabularyId: Scalars['String']['input'];
}>;


export type SynkCustomVocabularyMutation = { __typename?: 'Mutation', synkCustomVocabulary: { __typename?: 'CustomVocabularySync', success: boolean } };

export type TopicEditQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type TopicEditQuery = { __typename?: 'Query', topic: { __typename?: 'Topic', id: any, name: string, companyId?: any | null, skillCount: number, createdAt: any, updatedAt: any, archivedAt?: any | null, media?: { __typename?: 'Media', id: any, mediaUrl?: string | null } | null, skillTopics: { __typename?: 'SkillTopicConnection', nodes: Array<{ __typename?: 'SkillTopic', id?: any | null, topicId: any, skillId: any, skill: { __typename?: 'Skill', id: any, type: SkillType, name: string, externalId: string, publishedAt?: any | null } }> } } };

export type TopicEditSubmitMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  name: Scalars['String']['input'];
  photoUrl: Scalars['String']['input'];
}>;


export type TopicEditSubmitMutation = { __typename?: 'Mutation', topicEdit: { __typename?: 'Topic', id: any, name: string, companyId?: any | null, skillCount: number, createdAt: any, updatedAt: any, archivedAt?: any | null, media?: { __typename?: 'Media', id: any, mediaUrl?: string | null } | null, skillTopics: { __typename?: 'SkillTopicConnection', nodes: Array<{ __typename?: 'SkillTopic', id?: any | null, topicId: any, skillId: any, skill: { __typename?: 'Skill', id: any, type: SkillType, name: string, externalId: string, publishedAt?: any | null } }> } } };

export type TopicListQueryVariables = Exact<{
  paginate?: InputMaybe<BaseClassicPaginate>;
  sorts?: InputMaybe<Array<TopicListOrderBy> | TopicListOrderBy>;
  conditions?: InputMaybe<TopicListConditions>;
}>;


export type TopicListQuery = { __typename?: 'Query', topicList: { __typename?: 'TopicList', totalCount?: number | null, pageInfo: { __typename?: 'TopicPageInfo', beforeCursor?: string | null, afterCursor?: string | null }, nodes: Array<{ __typename?: 'Topic', id: any, name: string, companyId?: any | null, skillCount: number, createdAt: any, updatedAt: any, archivedAt?: any | null, media?: { __typename?: 'Media', id: any, mediaUrl?: string | null } | null }> } };

export type TopicLocalizationsQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type TopicLocalizationsQuery = { __typename?: 'Query', topicLocalizations: Array<{ __typename?: 'LocalizedEntity', label: string, entityType: LocalizedEntityType, relationshipEntityId: any, inputs: Array<{ __typename?: 'LocalizedInput', label?: string | null, name: string, type: LocalizedInputType, localizations: Array<{ __typename?: 'Localization', id?: any | null, language: Language, value?: string | null, disabled?: boolean | null, autoEvaluationCriteria?: { __typename?: 'AutoEvaluationCriteriaGraphql', schemaVersion?: string | null, keywordCheck?: { __typename?: 'AutoEvaluationCriteriaKeywordCheck', allowedKeywords?: Array<string> | null, incorrectKeywords?: Array<string> | null } | null } | null }> }> }> };

export type TopicLocalizationsSyncMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  entities: Array<LocalizedEntityInput> | LocalizedEntityInput;
}>;


export type TopicLocalizationsSyncMutation = { __typename?: 'Mutation', topicLocalizationsSync: Array<{ __typename?: 'LocalizedEntity', label: string, entityType: LocalizedEntityType, relationshipEntityId: any, inputs: Array<{ __typename?: 'LocalizedInput', label?: string | null, name: string, type: LocalizedInputType, localizations: Array<{ __typename?: 'Localization', id?: any | null, language: Language, value?: string | null, disabled?: boolean | null, autoEvaluationCriteria?: { __typename?: 'AutoEvaluationCriteriaGraphql', schemaVersion?: string | null, keywordCheck?: { __typename?: 'AutoEvaluationCriteriaKeywordCheck', allowedKeywords?: Array<string> | null, incorrectKeywords?: Array<string> | null } | null } | null }> }> }> };

export type TopicNewSubmitMutationVariables = Exact<{
  name: Scalars['String']['input'];
  photoUrl: Scalars['String']['input'];
}>;


export type TopicNewSubmitMutation = { __typename?: 'Mutation', topicCreate: { __typename?: 'Topic', id: any, name: string, companyId?: any | null, skillCount: number, createdAt: any, updatedAt: any, archivedAt?: any | null, media?: { __typename?: 'Media', id: any, mediaUrl?: string | null } | null, skillTopics: { __typename?: 'SkillTopicConnection', nodes: Array<{ __typename?: 'SkillTopic', id?: any | null, topicId: any, skillId: any, skill: { __typename?: 'Skill', id: any, type: SkillType, name: string, externalId: string, publishedAt?: any | null } }> } } };

export type TopicSkillsSyncMutationVariables = Exact<{
  topicId: Scalars['UUID']['input'];
  skillTopics: Array<SkillTopicInput> | SkillTopicInput;
}>;


export type TopicSkillsSyncMutation = { __typename?: 'Mutation', topicSkillsSync: Array<{ __typename?: 'SkillTopic', id?: any | null, topicId: any, skillId: any, skill: { __typename?: 'Skill', id: any, type: SkillType, name: string, externalId: string, publishedAt?: any | null } }> };

export type TopicUpdateStatusMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  active: Scalars['Boolean']['input'];
}>;


export type TopicUpdateStatusMutation = { __typename?: 'Mutation', topicUpdateStatus: { __typename?: 'Topic', id: any, name: string, companyId?: any | null, skillCount: number, createdAt: any, updatedAt: any, archivedAt?: any | null, media?: { __typename?: 'Media', id: any, mediaUrl?: string | null } | null, skillTopics: { __typename?: 'SkillTopicConnection', nodes: Array<{ __typename?: 'SkillTopic', id?: any | null, topicId: any, skillId: any, skill: { __typename?: 'Skill', id: any, type: SkillType, name: string, externalId: string, publishedAt?: any | null } }> } } };

export type UpdateInterjectionsMutationVariables = Exact<{
  repPromptId: Scalars['UUID']['input'];
  interjections?: InputMaybe<Array<InterjectionInput> | InterjectionInput>;
}>;


export type UpdateInterjectionsMutation = { __typename?: 'Mutation', updateInterjections: Array<{ __typename?: 'Interjection', index?: string | null, start?: string | null, duration?: string | null, author?: string | null, message?: Array<{ __typename?: 'InterjectionMessage', language: Language, translatedText?: string | null }> | null }> };

export type UploadProcessMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type UploadProcessMutation = { __typename?: 'Mutation', uploadProcess: { __typename?: 'Upload', errorDetails?: Array<any> | null, id: string, status: UploadStatus, url: string, source: UploadSource, bucket: string, filePath: string, affectedRowCount?: number | null, errorRowCount?: number | null, error?: any | null, createdAt: any, updatedAt: any } };

export type UploadProvisionMutationVariables = Exact<{
  mediaId?: InputMaybe<Scalars['String']['input']>;
  mimeType: Scalars['String']['input'];
  mediaType: MediaType;
}>;


export type UploadProvisionMutation = { __typename?: 'Mutation', uploadProvision: { __typename?: 'UploadProvision', signedUrl?: string | null, media: { __typename?: 'Media', id: any, mediaUrl?: string | null }, s3: { __typename?: 'AWSS3Params', region: string, bucket: string, key: string }, credentials?: { __typename?: 'AWSCredentials', accessKeyId: string, secretAccessKey: string, sessionToken: string, expiresAt: any } | null } };

export type GetUsersCsvQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUsersCsvQuery = { __typename?: 'Query', getUsersCsv: { __typename?: 'CompanyProfileDownload', url: string } };

export type ApiKeyFragment = { __typename?: 'APIKey', id: any, last4: string, createdAt: any, deletedAt?: any | null, companyProfileId: any, companyProfile?: { __typename?: 'CompanyProfile', id: any, profile: { __typename?: 'Profile', id: string, displayName?: string | null } } | null };

export type CompanyFragment = { __typename?: 'Company', id: any, name?: string | null, displayName?: string | null, externalId?: string | null, enableLearnerInitiatedContextualAssignment?: boolean | null, enableLearnerInitiatedLearningPlanAssignment?: boolean | null, defaultLanguage?: Language | null, countryCode?: CountryCode | null, supportEmail?: string | null, supportContact?: string | null, programName?: string | null, certificateTemplate?: string | null, timezone?: Timezone | null, notificationsEnabled: boolean, whatsappEnabled: boolean, smsEnabled: boolean, updatedAt: any, companyAuthentications?: Array<{ __typename?: 'CompanyAuthentication', id: string, authenticationType: AuthenticationType, app: AuthenticationSource }> | null, logoMedia?: { __typename?: 'Media', id: any, path: string, mediaUrl?: string | null } | null, companyFeatures?: Array<{ __typename?: 'CompanyFeature', id: string, feature: { __typename?: 'Feature', id: string, name: FeatureType } }> | null, companyLanguages?: Array<{ __typename?: 'CompanyLanguage', id: string, language: Language }> | null, siblings?: Array<{ __typename?: 'CompanySiblingDto', id: any, companyId: any, siblingCompanyId: any, deletedAt?: any | null, siblingCompany?: { __typename?: 'SiblingCompanyInfo', id: any, name?: string | null, externalId?: string | null, displayName?: string | null } | null }> | null };

export type CompanyFeatureFragment = { __typename?: 'Company', companyFeatures?: Array<{ __typename?: 'CompanyFeature', id: string, feature: { __typename?: 'Feature', id: string, name: FeatureType } }> | null };

export type CompanyLanguageFragment = { __typename?: 'Company', defaultLanguage?: Language | null, companyLanguages?: Array<{ __typename?: 'CompanyLanguage', id: string, language: Language }> | null };

export type CompanySiblingFragment = { __typename?: 'Company', siblings?: Array<{ __typename?: 'CompanySiblingDto', id: any, companyId: any, siblingCompanyId: any, deletedAt?: any | null, siblingCompany?: { __typename?: 'SiblingCompanyInfo', id: any, name?: string | null, externalId?: string | null, displayName?: string | null } | null }> | null };

export type CustomVocabularyFragment = { __typename?: 'CustomVocabulary', id?: any | null, companyId: any, name: string, description?: string | null, language: DialectTypes, status?: CustomVocabularyStatuses | null, error?: string | null, createdAt: any, updatedAt: any, archivedAt?: any | null };

export type CustomVocabularyKeywordFragment = { __typename?: 'CustomVocabularyKeyword', id?: any | null, companyId: any, vocabularyId: any, phrase: string, soundsLike?: string | null, ipa?: string | null, displayAs?: string | null };

export type FeatureFragment = { __typename?: 'Feature', id: string, name: FeatureType };

export type LpSectionSkillFragment = { __typename?: 'LPSectionSkill', id: any, points: number, position: number, skill: { __typename?: 'Skill', id: any, type: SkillType, name: string, externalId: string, publishedAt?: any | null } };

type LearningCardFragment_LearningCardFile = { __typename?: 'LearningCardFile', id: any, type: LearningCardType, position: number, experimentConfig?: any | null, localizations: { __typename?: 'LearningCardLocalizedFileConnection', nodes: Array<{ __typename?: 'LearningCardLocalizedFile', id: any, language: Language, url?: string | null, media: { __typename?: 'Media', id: any, mediaUrl?: string | null } }> } };

type LearningCardFragment_LearningCardFlashCard = { __typename?: 'LearningCardFlashCard', id: any, type: LearningCardType, position: number, experimentConfig?: any | null, localizations: { __typename?: 'LearningCardLocalizedFlashCardConnection', nodes: Array<{ __typename?: 'LearningCardLocalizedFlashCard', id: any, language: Language, title?: string | null, description?: string | null, fcMedia?: { __typename?: 'Media', id: any, mediaUrl?: string | null } | null }> } };

type LearningCardFragment_LearningCardForm = { __typename?: 'LearningCardForm', id: any, type: LearningCardType, position: number, experimentConfig?: any | null, resetLpIfFail: boolean, form: { __typename?: 'Form', id: any, name: string, type: FormType, title?: string | null, passingThreshold?: number | null, maxTries?: number | null, maxTriesPerPrompt?: MaxTriesPerPrompt | null, randomizePrompts: boolean, numPromptsShow?: number | null, localizations: { __typename?: 'FormLocalizedConnection', nodes: Array<{ __typename?: 'FormLocalized', id: any, language: Language, description: string }> }, prompts: { __typename?: 'PromptConnection', nodes: Array<{ __typename?: 'Prompt', id: any, position: number, isMultiple?: boolean | null, isMandatory?: boolean | null, localizations: { __typename?: 'PromptLocalizedConnection', nodes: Array<{ __typename?: 'PromptLocalized', id: any, language: Language, description: string }> }, choices: { __typename?: 'ChoiceConnection', nodes: Array<{ __typename?: 'Choice', id: any, type: ChoiceType, position: number, isCorrect?: boolean | null, localizations: { __typename?: 'ChoiceLocalizedConnection', nodes: Array<{ __typename?: 'ChoiceLocalized', id: any, language: Language, description?: string | null, media?: { __typename?: 'Media', id: any, mediaUrl?: string | null } | null }> } }> } }> } } };

type LearningCardFragment_LearningCardLinkout = { __typename?: 'LearningCardLinkout', id: any, type: LearningCardType, position: number, experimentConfig?: any | null, localizations: { __typename?: 'LearningCardLocalizedLinkoutConnection', nodes: Array<{ __typename?: 'LearningCardLocalizedLinkout', id: any, language: Language, title?: string | null, url?: string | null, description?: string | null, ctaTitle?: string | null }> } };

type LearningCardFragment_LearningCardVideo = { __typename?: 'LearningCardVideo', id: any, type: LearningCardType, position: number, experimentConfig?: any | null, localizations: { __typename?: 'LearningCardLocalizedVideoConnection', nodes: Array<{ __typename?: 'LearningCardLocalizedVideo', id: any, language: Language, title?: string | null, streamMedia?: { __typename?: 'Media', id: any, mimeType: string, location: MediaLocation, mediaUrl?: string | null } | null, masterMedia?: { __typename?: 'Media', id: any, mediaUrl?: string | null } | null, posterMedia?: { __typename?: 'Media', id: any, mediaUrl?: string | null } | null, textTrackMedia?: { __typename?: 'Media', id: any, mediaUrl?: string | null } | null }> } };

export type LearningCardFragment = LearningCardFragment_LearningCardFile | LearningCardFragment_LearningCardFlashCard | LearningCardFragment_LearningCardForm | LearningCardFragment_LearningCardLinkout | LearningCardFragment_LearningCardVideo;

export type LearningCardLinkoutFragment = { __typename?: 'LearningCardLinkout', id: any, type: LearningCardType, position: number, experimentConfig?: any | null, localizations: { __typename?: 'LearningCardLocalizedLinkoutConnection', nodes: Array<{ __typename?: 'LearningCardLocalizedLinkout', id: any, language: Language, title?: string | null, url?: string | null, description?: string | null, ctaTitle?: string | null }> } };

export type LearningCardVideoFragment = { __typename?: 'LearningCardVideo', id: any, type: LearningCardType, position: number, experimentConfig?: any | null, localizations: { __typename?: 'LearningCardLocalizedVideoConnection', nodes: Array<{ __typename?: 'LearningCardLocalizedVideo', id: any, language: Language, title?: string | null, streamMedia?: { __typename?: 'Media', id: any, mimeType: string, location: MediaLocation, mediaUrl?: string | null } | null, masterMedia?: { __typename?: 'Media', id: any, mediaUrl?: string | null } | null, posterMedia?: { __typename?: 'Media', id: any, mediaUrl?: string | null } | null, textTrackMedia?: { __typename?: 'Media', id: any, mediaUrl?: string | null } | null }> } };

export type LearningCardFlashCardFragment = { __typename?: 'LearningCardFlashCard', id: any, type: LearningCardType, position: number, experimentConfig?: any | null, localizations: { __typename?: 'LearningCardLocalizedFlashCardConnection', nodes: Array<{ __typename?: 'LearningCardLocalizedFlashCard', id: any, language: Language, title?: string | null, description?: string | null, fcMedia?: { __typename?: 'Media', id: any, mediaUrl?: string | null } | null }> } };

export type LearningCardFileFragment = { __typename?: 'LearningCardFile', id: any, type: LearningCardType, position: number, experimentConfig?: any | null, localizations: { __typename?: 'LearningCardLocalizedFileConnection', nodes: Array<{ __typename?: 'LearningCardLocalizedFile', id: any, language: Language, url?: string | null, media: { __typename?: 'Media', id: any, mediaUrl?: string | null } }> } };

export type LearningCardFormFragment = { __typename?: 'LearningCardForm', id: any, type: LearningCardType, position: number, experimentConfig?: any | null, resetLpIfFail: boolean, form: { __typename?: 'Form', id: any, name: string, type: FormType, title?: string | null, passingThreshold?: number | null, maxTries?: number | null, maxTriesPerPrompt?: MaxTriesPerPrompt | null, randomizePrompts: boolean, numPromptsShow?: number | null, localizations: { __typename?: 'FormLocalizedConnection', nodes: Array<{ __typename?: 'FormLocalized', id: any, language: Language, description: string }> }, prompts: { __typename?: 'PromptConnection', nodes: Array<{ __typename?: 'Prompt', id: any, position: number, isMultiple?: boolean | null, isMandatory?: boolean | null, localizations: { __typename?: 'PromptLocalizedConnection', nodes: Array<{ __typename?: 'PromptLocalized', id: any, language: Language, description: string }> }, choices: { __typename?: 'ChoiceConnection', nodes: Array<{ __typename?: 'Choice', id: any, type: ChoiceType, position: number, isCorrect?: boolean | null, localizations: { __typename?: 'ChoiceLocalizedConnection', nodes: Array<{ __typename?: 'ChoiceLocalized', id: any, language: Language, description?: string | null, media?: { __typename?: 'Media', id: any, mediaUrl?: string | null } | null }> } }> } }> } } };

export type LearningPlanFragment = { __typename?: 'LearningPlan', id: any, name: string, displayName: string, externalId: string, description?: string | null, sortRank: number, updatedAt: any, createdAt: any, publishedAt?: any | null, isOrderDisabled: boolean, additionalInfo?: string | null, goal?: string | null, mandatory?: boolean | null, startDateType?: CampaignsDateType | null, startDate?: string | null, endDateType?: CampaignsDateType | null, endDate?: string | null, endDays?: number | null, createdBy?: any | null, updatedBy?: any | null, certificateEnabled?: boolean | null, certificateName?: string | null, isNoDataForBestPractice?: boolean | null, learningPlanDependencies: Array<{ __typename?: 'LearningPlanDependency', id: any, dependentLearningPlan: { __typename?: 'LearningPlan', id: any, name: string, externalId: string } }>, groups: Array<{ __typename?: 'ProfileGroup', id: any, name: string, learnerCount: number, coachCount: number }>, learningPlanFolder?: { __typename?: 'LearningPlanFolder', id: any, name: string } | null };

export type LearningPlanLearnerFragment = { __typename?: 'LearningPlanLearner', id: any, externalId: string, displayName?: string | null, active: boolean };

export type LocalizedFieldFragment = { __typename?: 'LocalizedEntity', label: string, entityType: LocalizedEntityType, relationshipEntityId: any, inputs: Array<{ __typename?: 'LocalizedInput', label?: string | null, name: string, type: LocalizedInputType, localizations: Array<{ __typename?: 'Localization', id?: any | null, language: Language, value?: string | null, disabled?: boolean | null, autoEvaluationCriteria?: { __typename?: 'AutoEvaluationCriteriaGraphql', schemaVersion?: string | null, keywordCheck?: { __typename?: 'AutoEvaluationCriteriaKeywordCheck', allowedKeywords?: Array<string> | null, incorrectKeywords?: Array<string> | null } | null } | null }> }> };

export type MediaFragment = { __typename?: 'Media', id: any, path: string, mimeType: string, mediaType: MediaType, mediaUrl?: string | null, createdAt: any };

export type ProfileFragment = { __typename?: 'CompanyProfile', id: any, profileId: any, language?: Language | null, phoneNumber?: string | null, emailAddress?: string | null, startDate: any, timezone?: Timezone | null, learnerCommsOptOut: boolean, coachCommsOptOut: boolean, excludeFromAnalytics: boolean, externalId: string, archivedAt?: any | null, profileTags?: Array<{ __typename?: 'ProfileTag', id: any, name: string, metadata?: any | null }> | null, profileGrants?: Array<{ __typename?: 'ProfileGrant', id: string, profileRole: { __typename?: 'ProfileRole', id: string, name?: Role | null } }> | null, companyCohortMembers?: Array<{ __typename?: 'ProfileGroupMember', id: any, type: ProfileGroupMemberType, companyCohort: { __typename?: 'ProfileGroup', id: any, name: string, deletedAt?: any | null } }> | null, profile: { __typename?: 'Profile', id: string, displayName?: string | null, preferredName?: string | null, media?: { __typename?: 'Media', id: any, mediaUrl?: string | null } | null, flags: Array<{ __typename?: 'Flag', name: string, value: string }> } };

export type ProfileGroupFragment = { __typename?: 'ProfileGroup', id: any, name: string, description: string, learningPlans: Array<{ __typename?: 'LearningPlan', id: any, name: string, externalId: string }> };

export type ProfileGroupMemberFragment = { __typename?: 'ProfileGroupMember', id: any, type: ProfileGroupMemberType, companyProfile: { __typename?: 'CompanyProfile', id: any, externalId: string, profile: { __typename?: 'Profile', id: string, displayName?: string | null } } };

export type ProfileListFragment = { __typename?: 'CompanyProfile', id: any, externalId: string, createdAt: any, updatedAt: any, phoneNumber?: string | null, archivedAt?: any | null, profileGrants?: Array<{ __typename?: 'ProfileGrant', id: string, profileRole: { __typename?: 'ProfileRole', id: string, name?: Role | null } }> | null, profile: { __typename?: 'Profile', id: string, displayName?: string | null } };

export type ProfileTagFragment = { __typename?: 'ProfileTag', id: any, name: string, companyProfiles?: Array<{ __typename?: 'CompanyProfile', id: any, externalId: string, profile: { __typename?: 'Profile', id: string, displayName?: string | null } }> | null };

export type RepResponseFragment = { __typename?: 'RepResponse', id: any, content?: string | null, responseType: RepResponseKind, createdAt: any, masterMedia?: { __typename?: 'Media', id: any, mediaUrl?: string | null } | null, streamMedia?: { __typename?: 'Media', id: any, mediaUrl?: string | null } | null, posterMedia?: { __typename?: 'Media', mediaUrl?: string | null } | null, assignment: { __typename?: 'RepAssignment', id: any, repAssignmentStatus: RepAssignmentStatus, createdAt: any, prompt: { __typename?: 'RepPrompt', id: any, isCoached: boolean, repType: RepType, assignedAt: any, localizations: Array<{ __typename?: 'RepPromptLocalized', content: string, language: Language }>, form?: { __typename?: 'Form', id: any, localizations: { __typename?: 'FormLocalizedConnection', nodes: Array<{ __typename?: 'FormLocalized', id: any, language: Language, description: string }> }, prompts: { __typename?: 'PromptConnection', nodes: Array<{ __typename?: 'Prompt', id: any, isMultiple?: boolean | null, localizations: { __typename?: 'PromptLocalizedConnection', nodes: Array<{ __typename?: 'PromptLocalized', id: any, language: Language, description: string }> }, choices: { __typename?: 'ChoiceConnection', nodes: Array<{ __typename?: 'Choice', id: any, type: ChoiceType, isCorrect?: boolean | null, localizations: { __typename?: 'ChoiceLocalizedConnection', nodes: Array<{ __typename?: 'ChoiceLocalized', id: any, language: Language, description?: string | null }> } }> } }> } } | null }, skill: { __typename?: 'SkillRep', id: any, displayName: string, externalId: string, repPrompt?: { __typename?: 'RepPrompt', repPromptLocalizeds: Array<{ __typename?: 'RepPromptLocalized', id: any, language: Language, autoEvaluationCriteria?: { __typename?: 'AutoEvaluationCriteriaGraphql', schemaVersion?: string | null, keywordCheck?: { __typename?: 'AutoEvaluationCriteriaKeywordCheck', allowedKeywords?: Array<string> | null, incorrectKeywords?: Array<string> | null } | null } | null }> } | null }, companyProfile: { __typename?: 'CompanyProfile', id: any, externalId: string, emailAddress?: string | null, profile: { __typename?: 'Profile', id: string, displayName?: string | null, media?: { __typename?: 'Media', mediaUrlV2?: string | null } | null } } }, feedback?: Array<{ __typename?: 'RepSubmissionFeedback', id: any, reviewerRole: ReviewerRoleType, responseType: RepResponseKind, feedbackType: RepFeedbackType, content?: string | null, createdAt: any, reviewerCompanyProfile?: { __typename?: 'CompanyProfile', id: any, externalId: string, emailAddress?: string | null, profile: { __typename?: 'Profile', id: string, displayName?: string | null } } | null, rubric?: { __typename?: 'Rubric', formId?: string | null, version?: number | null, prompts?: Array<{ __typename?: 'RubricPrompt', promptId?: string | null, answers?: Array<{ __typename?: 'RubricAnswer', answer?: string | null, choiceId?: string | null }> | null }> | null } | null }> | null, transcriptionMedia?: { __typename?: 'Media', id: any, status: MediaStatus, error?: string | null, mediaUrlV2?: string | null } | null, autoEvaluationOutcome?: { __typename?: 'AutoEvaluationOutcome', isArticulationPass?: boolean | null, isKeywordPass?: boolean | null, schemaVersion?: string | null, languageCode?: string | null, sentiment?: number | null, keywordCheck?: { __typename?: 'AutoEvaluationKeywordCheck', allowedKeywordsMatched?: Array<string> | null, allowedKeywordsNotMatched?: Array<string> | null, incorrectKeywordsMatched?: Array<string> | null, incorrectKeywordsNotMatched?: Array<string> | null, allowedKeywordsMatchedV2?: Array<{ __typename?: 'KeywordsMatch', expectedKeyword?: string | null, actualKeyword?: string | null }> | null, allowedKeywordsFuzzyMatched?: Array<{ __typename?: 'FuzzyMatch', expectedKeyword?: string | null, actualKeyword?: string | null, fuzzyIndex?: number | null }> | null, incorrectKeywordsMatchedV2?: Array<{ __typename?: 'KeywordsMatch', expectedKeyword?: string | null, actualKeyword?: string | null }> | null, incorrectKeywordsFuzzyMatched?: Array<{ __typename?: 'FuzzyMatch', expectedKeyword?: string | null, actualKeyword?: string | null, fuzzyIndex?: number | null }> | null } | null, articulation?: { __typename?: 'Articulation', overallScore?: number | null, mediaLength?: number | null, wordsPerMinute?: number | null, fillerWordsCount?: number | null, keywordScore?: number | null, fillerWords?: Array<string> | null, wpmScore?: number | null, fillerWordScore?: number | null } | null, contentScore?: { __typename?: 'ContentScore', consistency: number, coherence: number, grammar: number, toneNstyle: number } | null, conversationMetrics?: { __typename?: 'ConversationMetrics', conversationType: string, questionRate: number, overallFeedback?: string | null, noOfSubmitterQuestions?: number | null, needsIdentificationScore: { __typename?: 'NeedsIdentificationScore', identificationScore: number, problemClarity: number, needExpressed: boolean, needCaptured: boolean }, nonVerbalSkillScore: { __typename?: 'NonVerbalSkillScore', listening: number, confidence: number, patience: number, pauseDuration: number }, openEndedQuestions: Array<{ __typename?: 'OpenEndedQuestion', question: string, speaker: string, startTime: number }>, stackedQuestions: Array<{ __typename?: 'StackedQuestion', questions: Array<string>, speaker: string, startTime: number }>, speakerLabels?: Array<{ __typename?: 'SpeakerLabel', speakerId?: string | null, speakerLabel?: string | null, speakerRole?: string | null, speakerRoleDisplayed?: string | null, speakerName?: string | null, talkRatio?: number | null, isPresenter?: boolean | null }> | null, thresholds: { __typename?: 'ConversationMetricsThresholds', stackedQuestionsCount: number, talkRatio: number, questionRate: number, pauseDuration: Array<number>, noOfSubmitterQuestions: number } } | null } | null };

export type SkillFragment = { __typename?: 'Skill', id: any, type: SkillType, externalId: string, name: string, displayName: string, description?: string | null, duration?: string | null, createdAt: any, updatedAt: any, publishedAt?: any | null, companyId: any, sourceCompanyId?: any | null, sourceSkillId?: any | null, createdBy?: any | null, updatedBy?: any | null, media?: { __typename?: 'Media', id: any, mediaUrl?: string | null } | null };

export type SkillListFragment = { __typename?: 'Skill', id: any, externalId: string, name: string, duration?: string | null, createdAt: any, publishedAt?: any | null, media?: { __typename?: 'Media', id: any, mediaUrl?: string | null } | null };

export type SkillRepFragment = { __typename?: 'SkillRep', id: any, name: string, externalId: string, displayName: string, publishedAt?: any | null, media?: { __typename?: 'Media', id: any, mediaUrl?: string | null } | null, repPrompt?: { __typename?: 'RepPrompt', id: any, isRepeatable?: boolean | null, isCoached: boolean, isKeywords: boolean, repType: RepType, allowedKeywords?: Array<string> | null, incorrectKeywords?: Array<string> | null, conversationType?: ConversationType | null, rolePlayConfigId?: any | null, isAiEnabled: boolean, isAutoCoachEnabled: boolean, autoCoachConfig?: { __typename?: 'AutoCoachConfig', approvalCutoff: number, rejectionCutoff: number } | null, conversationRoles?: { __typename?: 'ConversationRoles', submitter: string, audience: string } | null, interjections?: Array<{ __typename?: 'Interjection', index?: string | null, duration?: string | null, start?: string | null, message?: Array<{ __typename?: 'InterjectionMessage', translatedText?: string | null, language: Language }> | null }> | null, repPromptLocalizeds: Array<{ __typename?: 'RepPromptLocalized', id: any, language: Language, content: string, autoEvaluationCriteria?: { __typename?: 'AutoEvaluationCriteriaGraphql', keywordCheck?: { __typename?: 'AutoEvaluationCriteriaKeywordCheck', allowedKeywords?: Array<string> | null, incorrectKeywords?: Array<string> | null } | null } | null }>, repPromptResponseTypes: Array<{ __typename?: 'RepPromptResponseType', id: any, responseType: RepResponseKind }>, form?: { __typename?: 'Form', id: any, localizations: { __typename?: 'FormLocalizedConnection', nodes: Array<{ __typename?: 'FormLocalized', id: any, language: Language, description: string }> }, prompts: { __typename?: 'PromptConnection', nodes: Array<{ __typename?: 'Prompt', id: any, isMultiple?: boolean | null, localizations: { __typename?: 'PromptLocalizedConnection', nodes: Array<{ __typename?: 'PromptLocalized', id: any, language: Language, description: string }> }, choices: { __typename?: 'ChoiceConnection', nodes: Array<{ __typename?: 'Choice', id: any, type: ChoiceType, isCorrect?: boolean | null, localizations: { __typename?: 'ChoiceLocalizedConnection', nodes: Array<{ __typename?: 'ChoiceLocalized', id: any, language: Language, description?: string | null }> } }> } }> } } | null } | null };

export type SkillRepListFragment = { __typename?: 'SkillRep', id: any, name: string, externalId: string, createdAt: any, updatedAt: any, publishedAt?: any | null, repPrompt?: { __typename?: 'RepPrompt', id: any, allResponseTypeEnabled: boolean, isCoached: boolean, repType: RepType, repPromptResponseTypes: Array<{ __typename?: 'RepPromptResponseType', id: any, responseType: RepResponseKind }> } | null };

export type SkillTopicFragment = { __typename?: 'SkillTopic', id?: any | null, topicId: any, skillId: any, skill: { __typename?: 'Skill', id: any, type: SkillType, name: string, externalId: string, publishedAt?: any | null } };

export type TopicFragment = { __typename?: 'Topic', id: any, name: string, companyId?: any | null, skillCount: number, createdAt: any, updatedAt: any, archivedAt?: any | null, media?: { __typename?: 'Media', id: any, mediaUrl?: string | null } | null, skillTopics: { __typename?: 'SkillTopicConnection', nodes: Array<{ __typename?: 'SkillTopic', id?: any | null, topicId: any, skillId: any, skill: { __typename?: 'Skill', id: any, type: SkillType, name: string, externalId: string, publishedAt?: any | null } }> } };

export type TopicListFragment = { __typename?: 'Topic', id: any, name: string, companyId?: any | null, skillCount: number, createdAt: any, updatedAt: any, archivedAt?: any | null, media?: { __typename?: 'Media', id: any, mediaUrl?: string | null } | null };

export type UploadFragment = { __typename?: 'Upload', id: string, status: UploadStatus, url: string, source: UploadSource, bucket: string, filePath: string, affectedRowCount?: number | null, errorRowCount?: number | null, error?: any | null, createdAt: any, updatedAt: any };

export const ApiKeyFragmentDoc = gql`
    fragment APIKeyFragment on APIKey {
  id
  last4
  createdAt
  deletedAt
  companyProfileId
  companyProfile {
    id
    profile {
      id
      displayName
    }
  }
}
    `;
export const CompanyFeatureFragmentDoc = gql`
    fragment CompanyFeatureFragment on Company {
  companyFeatures {
    id
    feature {
      id
      name
    }
  }
}
    `;
export const CompanyLanguageFragmentDoc = gql`
    fragment CompanyLanguageFragment on Company {
  defaultLanguage
  companyLanguages {
    id
    language
  }
}
    `;
export const CompanySiblingFragmentDoc = gql`
    fragment CompanySiblingFragment on Company {
  siblings {
    id
    companyId
    siblingCompanyId
    deletedAt
    siblingCompany {
      id
      name
      externalId
      displayName
    }
  }
}
    `;
export const CompanyFragmentDoc = gql`
    fragment CompanyFragment on Company {
  id
  name
  displayName
  externalId
  enableLearnerInitiatedContextualAssignment
  enableLearnerInitiatedLearningPlanAssignment
  ...CompanyFeatureFragment
  ...CompanyLanguageFragment
  ...CompanySiblingFragment
  companyAuthentications {
    id
    authenticationType
    app
  }
  logoMedia {
    id
    path
    mediaUrl
  }
  defaultLanguage
  countryCode
  supportEmail
  supportContact
  programName
  certificateTemplate
  timezone
  notificationsEnabled
  whatsappEnabled
  smsEnabled
  updatedAt
}
    ${CompanyFeatureFragmentDoc}
${CompanyLanguageFragmentDoc}
${CompanySiblingFragmentDoc}`;
export const CustomVocabularyFragmentDoc = gql`
    fragment CustomVocabularyFragment on CustomVocabulary {
  id
  companyId
  name
  description
  language
  status
  error
  createdAt
  updatedAt
  archivedAt
}
    `;
export const CustomVocabularyKeywordFragmentDoc = gql`
    fragment CustomVocabularyKeywordFragment on CustomVocabularyKeyword {
  id
  companyId
  vocabularyId
  phrase
  soundsLike
  ipa
  displayAs
}
    `;
export const FeatureFragmentDoc = gql`
    fragment FeatureFragment on Feature {
  id
  name
}
    `;
export const LpSectionSkillFragmentDoc = gql`
    fragment LPSectionSkillFragment on LPSectionSkill {
  id
  points
  position
  skill {
    id
    type
    name
    externalId
    publishedAt
  }
}
    `;
export const LearningCardLinkoutFragmentDoc = gql`
    fragment LearningCardLinkoutFragment on LearningCardLinkout {
  id
  type
  position
  experimentConfig
  localizations {
    nodes {
      id
      language
      title
      url
      description
      ctaTitle
    }
  }
}
    `;
export const LearningCardVideoFragmentDoc = gql`
    fragment LearningCardVideoFragment on LearningCardVideo {
  id
  type
  position
  experimentConfig
  localizations {
    nodes {
      id
      language
      title
      streamMedia {
        id
        mimeType
        location
        mediaUrl
      }
      masterMedia {
        id
        mediaUrl
      }
      posterMedia {
        id
        mediaUrl
      }
      textTrackMedia {
        id
        mediaUrl
      }
    }
  }
}
    `;
export const LearningCardFlashCardFragmentDoc = gql`
    fragment LearningCardFlashCardFragment on LearningCardFlashCard {
  id
  type
  position
  experimentConfig
  localizations {
    nodes {
      id
      language
      title
      description
      fcMedia: media {
        id
        mediaUrl
      }
    }
  }
}
    `;
export const LearningCardFileFragmentDoc = gql`
    fragment LearningCardFileFragment on LearningCardFile {
  id
  type
  position
  experimentConfig
  localizations {
    nodes {
      id
      language
      url
      media {
        id
        mediaUrl
      }
    }
  }
}
    `;
export const LearningCardFormFragmentDoc = gql`
    fragment LearningCardFormFragment on LearningCardForm {
  id
  type
  position
  experimentConfig
  resetLpIfFail
  form {
    id
    name
    type
    title
    localizations {
      nodes {
        id
        language
        description
      }
    }
    passingThreshold
    maxTries
    maxTriesPerPrompt
    randomizePrompts
    numPromptsShow
    prompts {
      nodes {
        id
        position
        isMultiple
        isMandatory
        localizations {
          nodes {
            id
            language
            description
          }
        }
        choices {
          nodes {
            id
            type
            position
            isCorrect
            localizations {
              nodes {
                id
                language
                description
                media {
                  id
                  mediaUrl
                }
              }
            }
          }
        }
      }
    }
  }
}
    `;
export const LearningCardFragmentDoc = gql`
    fragment LearningCardFragment on LearningCard {
  ...LearningCardLinkoutFragment
  ...LearningCardVideoFragment
  ...LearningCardFlashCardFragment
  ...LearningCardFileFragment
  ...LearningCardFormFragment
}
    ${LearningCardLinkoutFragmentDoc}
${LearningCardVideoFragmentDoc}
${LearningCardFlashCardFragmentDoc}
${LearningCardFileFragmentDoc}
${LearningCardFormFragmentDoc}`;
export const LearningPlanFragmentDoc = gql`
    fragment LearningPlanFragment on LearningPlan {
  id
  name
  displayName
  externalId
  description
  sortRank
  updatedAt
  createdAt
  publishedAt
  isOrderDisabled
  learningPlanDependencies {
    id
    dependentLearningPlan {
      id
      name
      externalId
    }
  }
  groups {
    id
    name
    learnerCount
    coachCount
  }
  additionalInfo
  goal
  mandatory
  startDateType
  startDate
  endDateType
  endDate
  endDays
  createdBy
  updatedBy
  learningPlanFolder {
    id
    name
  }
  certificateEnabled
  certificateName
  isNoDataForBestPractice
}
    `;
export const LearningPlanLearnerFragmentDoc = gql`
    fragment LearningPlanLearnerFragment on LearningPlanLearner {
  id
  externalId
  displayName
  active
}
    `;
export const LocalizedFieldFragmentDoc = gql`
    fragment LocalizedFieldFragment on LocalizedEntity {
  label
  entityType
  relationshipEntityId
  inputs {
    label
    name
    type
    localizations {
      id
      language
      value
      autoEvaluationCriteria {
        schemaVersion
        keywordCheck {
          allowedKeywords
          incorrectKeywords
        }
      }
      disabled
    }
  }
}
    `;
export const MediaFragmentDoc = gql`
    fragment MediaFragment on Media {
  id
  path
  mimeType
  mediaType
  mediaUrl
  createdAt
}
    `;
export const ProfileFragmentDoc = gql`
    fragment ProfileFragment on CompanyProfile {
  id
  profileId
  language
  phoneNumber
  emailAddress
  startDate
  timezone
  learnerCommsOptOut
  coachCommsOptOut
  excludeFromAnalytics
  externalId
  archivedAt
  profileTags {
    id
    name
    metadata
  }
  profileGrants {
    id
    profileRole {
      id
      name
    }
  }
  companyCohortMembers {
    id
    type
    companyCohort {
      id
      name
      deletedAt
    }
  }
  profile {
    id
    displayName
    preferredName
    media {
      id
      mediaUrl
    }
    flags {
      name
      value
    }
  }
}
    `;
export const ProfileGroupFragmentDoc = gql`
    fragment ProfileGroupFragment on ProfileGroup {
  id
  name
  description
  learningPlans {
    id
    name
    externalId
  }
}
    `;
export const ProfileGroupMemberFragmentDoc = gql`
    fragment ProfileGroupMemberFragment on ProfileGroupMember {
  id
  type
  companyProfile {
    id
    externalId
    profile {
      id
      displayName
    }
  }
}
    `;
export const ProfileListFragmentDoc = gql`
    fragment ProfileListFragment on CompanyProfile {
  id
  externalId
  createdAt
  updatedAt
  phoneNumber
  archivedAt
  profileGrants {
    id
    profileRole {
      id
      name
    }
  }
  profile {
    id
    displayName
  }
}
    `;
export const ProfileTagFragmentDoc = gql`
    fragment ProfileTagFragment on ProfileTag {
  id
  name
  companyProfiles {
    id
    externalId
    profile {
      id
      displayName
    }
  }
}
    `;
export const RepResponseFragmentDoc = gql`
    fragment RepResponseFragment on RepResponse {
  id
  content
  masterMedia {
    id
    mediaUrl
  }
  streamMedia {
    id
    mediaUrl
  }
  posterMedia {
    mediaUrl
  }
  responseType
  createdAt
  assignment: repAssignment {
    id
    repAssignmentStatus
    createdAt
    prompt: repPrompt {
      id
      assignedAt: createdAt
      isCoached
      repType
      localizations: repPromptLocalizeds {
        content
        language
      }
      form {
        id
        localizations {
          nodes {
            id
            language
            description
          }
        }
        prompts {
          nodes {
            id
            isMultiple
            localizations {
              nodes {
                id
                language
                description
              }
            }
            choices {
              nodes {
                id
                type
                isCorrect
                localizations {
                  nodes {
                    id
                    language
                    description
                  }
                }
              }
            }
          }
        }
      }
    }
    skill {
      id
      displayName
      externalId
      repPrompt {
        repPromptLocalizeds {
          id
          language
          autoEvaluationCriteria {
            schemaVersion
            keywordCheck {
              allowedKeywords
              incorrectKeywords
            }
          }
        }
      }
    }
    companyProfile {
      id
      externalId
      emailAddress
      profile {
        id
        media {
          mediaUrlV2
        }
        displayName
      }
    }
  }
  feedback: repSubmissionFeedback {
    id
    reviewerRole
    responseType
    feedbackType
    content
    createdAt
    reviewerCompanyProfile: companyProfile {
      id
      externalId
      emailAddress
      profile {
        id
        displayName
      }
    }
    rubric {
      formId
      prompts {
        answers {
          answer
          choiceId
        }
        promptId
      }
      version
    }
  }
  transcriptionMedia {
    id
    status
    error
    mediaUrlV2
  }
  autoEvaluationOutcome {
    isArticulationPass
    isKeywordPass
    schemaVersion
    languageCode
    sentiment
    keywordCheck {
      allowedKeywordsMatched
      allowedKeywordsMatchedV2 {
        expectedKeyword
        actualKeyword
      }
      allowedKeywordsNotMatched
      allowedKeywordsFuzzyMatched {
        expectedKeyword
        actualKeyword
        fuzzyIndex
      }
      incorrectKeywordsMatched
      incorrectKeywordsMatchedV2 {
        expectedKeyword
        actualKeyword
      }
      incorrectKeywordsNotMatched
      incorrectKeywordsFuzzyMatched {
        expectedKeyword
        actualKeyword
        fuzzyIndex
      }
    }
    articulation {
      overallScore
      mediaLength
      wordsPerMinute
      fillerWordsCount
      keywordScore
      fillerWords
      wpmScore
      fillerWordScore
    }
    contentScore {
      consistency
      coherence
      grammar
      toneNstyle
    }
    conversationMetrics {
      conversationType
      needsIdentificationScore {
        identificationScore
        problemClarity
        needExpressed
        needCaptured
      }
      nonVerbalSkillScore {
        listening
        confidence
        patience
        pauseDuration
      }
      openEndedQuestions {
        question
        speaker
        startTime
      }
      stackedQuestions {
        questions
        speaker
        startTime
      }
      questionRate
      overallFeedback
      speakerLabels {
        speakerId
        speakerLabel
        speakerRole
        speakerRoleDisplayed
        speakerName
        talkRatio
        isPresenter
      }
      noOfSubmitterQuestions
      thresholds {
        stackedQuestionsCount
        talkRatio
        questionRate
        pauseDuration
        noOfSubmitterQuestions
      }
    }
  }
}
    `;
export const SkillFragmentDoc = gql`
    fragment SkillFragment on Skill {
  id
  type
  externalId
  name
  displayName
  description
  media {
    id
    mediaUrl
  }
  duration
  createdAt
  updatedAt
  publishedAt
  companyId
  sourceCompanyId
  sourceSkillId
  createdBy
  updatedBy
}
    `;
export const SkillListFragmentDoc = gql`
    fragment SkillListFragment on Skill {
  id
  externalId
  name
  media {
    id
    mediaUrl
  }
  duration
  createdAt
  publishedAt
}
    `;
export const SkillRepFragmentDoc = gql`
    fragment SkillRepFragment on SkillRep {
  id
  media {
    id
    mediaUrl
  }
  name
  externalId
  displayName
  publishedAt
  repPrompt {
    id
    isRepeatable
    isCoached
    isKeywords
    repType
    allowedKeywords
    incorrectKeywords
    conversationType
    rolePlayConfigId
    isAiEnabled
    isAutoCoachEnabled
    autoCoachConfig {
      approvalCutoff
      rejectionCutoff
    }
    conversationRoles {
      submitter
      audience
    }
    interjections {
      index
      message {
        translatedText
        language
      }
      duration
      start
    }
    repPromptLocalizeds {
      id
      language
      content
      autoEvaluationCriteria {
        keywordCheck {
          allowedKeywords
          incorrectKeywords
        }
      }
    }
    repPromptResponseTypes {
      id
      responseType
    }
    form {
      id
      localizations {
        nodes {
          id
          language
          description
        }
      }
      prompts {
        nodes {
          id
          isMultiple
          localizations {
            nodes {
              id
              language
              description
            }
          }
          choices {
            nodes {
              id
              type
              isCorrect
              localizations {
                nodes {
                  id
                  language
                  description
                }
              }
            }
          }
        }
      }
    }
  }
}
    `;
export const SkillRepListFragmentDoc = gql`
    fragment SkillRepListFragment on SkillRep {
  id
  name
  externalId
  createdAt
  updatedAt
  publishedAt
  repPrompt {
    id
    allResponseTypeEnabled
    isCoached
    repType
    repPromptResponseTypes {
      id
      responseType
    }
  }
}
    `;
export const SkillTopicFragmentDoc = gql`
    fragment SkillTopicFragment on SkillTopic {
  id
  topicId
  skillId
  skill {
    id
    type
    name
    externalId
    publishedAt
  }
}
    `;
export const TopicFragmentDoc = gql`
    fragment TopicFragment on Topic {
  id
  name
  companyId
  skillCount
  media {
    id
    mediaUrl
  }
  companyId
  createdAt
  updatedAt
  archivedAt
  skillTopics {
    nodes {
      ...SkillTopicFragment
    }
  }
}
    ${SkillTopicFragmentDoc}`;
export const TopicListFragmentDoc = gql`
    fragment TopicListFragment on Topic {
  id
  name
  companyId
  skillCount
  media {
    id
    mediaUrl
  }
  companyId
  createdAt
  updatedAt
  archivedAt
}
    `;
export const UploadFragmentDoc = gql`
    fragment UploadFragment on Upload {
  id
  status
  url
  source
  bucket
  filePath
  affectedRowCount
  errorRowCount
  error
  createdAt
  updatedAt
}
    `;
export const ApiKeyCreateDocument = gql`
    mutation APIKeyCreate {
  apiKeyCreate {
    id
    accessToken
  }
}
    `;
export type ApiKeyCreateMutationFn = Apollo.MutationFunction<ApiKeyCreateMutation, ApiKeyCreateMutationVariables>;

/**
 * __useApiKeyCreateMutation__
 *
 * To run a mutation, you first call `useApiKeyCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApiKeyCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [apiKeyCreateMutation, { data, loading, error }] = useApiKeyCreateMutation({
 *   variables: {
 *   },
 * });
 */
export function useApiKeyCreateMutation(baseOptions?: Apollo.MutationHookOptions<ApiKeyCreateMutation, ApiKeyCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApiKeyCreateMutation, ApiKeyCreateMutationVariables>(ApiKeyCreateDocument, options);
      }
export type ApiKeyCreateMutationHookResult = ReturnType<typeof useApiKeyCreateMutation>;
export type ApiKeyCreateMutationResult = Apollo.MutationResult<ApiKeyCreateMutation>;
export type ApiKeyCreateMutationOptions = Apollo.BaseMutationOptions<ApiKeyCreateMutation, ApiKeyCreateMutationVariables>;
export const ApiKeyDeleteDocument = gql`
    mutation APIKeyDelete($id: UUID!) {
  apiKeyDelete(id: $id)
}
    `;
export type ApiKeyDeleteMutationFn = Apollo.MutationFunction<ApiKeyDeleteMutation, ApiKeyDeleteMutationVariables>;

/**
 * __useApiKeyDeleteMutation__
 *
 * To run a mutation, you first call `useApiKeyDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApiKeyDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [apiKeyDeleteMutation, { data, loading, error }] = useApiKeyDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useApiKeyDeleteMutation(baseOptions?: Apollo.MutationHookOptions<ApiKeyDeleteMutation, ApiKeyDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApiKeyDeleteMutation, ApiKeyDeleteMutationVariables>(ApiKeyDeleteDocument, options);
      }
export type ApiKeyDeleteMutationHookResult = ReturnType<typeof useApiKeyDeleteMutation>;
export type ApiKeyDeleteMutationResult = Apollo.MutationResult<ApiKeyDeleteMutation>;
export type ApiKeyDeleteMutationOptions = Apollo.BaseMutationOptions<ApiKeyDeleteMutation, ApiKeyDeleteMutationVariables>;
export const ApiKeyListDocument = gql`
    query APIKeyList($paginate: BaseClassicPaginate, $sorts: [APIKeyListOrderBy!]) {
  apiKeyList(paginate: $paginate, sorts: $sorts) {
    nodes {
      ...APIKeyFragment
    }
    pageInfo {
      beforeCursor
      afterCursor
    }
    totalCount
  }
}
    ${ApiKeyFragmentDoc}`;

/**
 * __useApiKeyListQuery__
 *
 * To run a query within a React component, call `useApiKeyListQuery` and pass it any options that fit your needs.
 * When your component renders, `useApiKeyListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useApiKeyListQuery({
 *   variables: {
 *      paginate: // value for 'paginate'
 *      sorts: // value for 'sorts'
 *   },
 * });
 */
export function useApiKeyListQuery(baseOptions?: Apollo.QueryHookOptions<ApiKeyListQuery, ApiKeyListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ApiKeyListQuery, ApiKeyListQueryVariables>(ApiKeyListDocument, options);
      }
export function useApiKeyListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ApiKeyListQuery, ApiKeyListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ApiKeyListQuery, ApiKeyListQueryVariables>(ApiKeyListDocument, options);
        }
export type ApiKeyListQueryHookResult = ReturnType<typeof useApiKeyListQuery>;
export type ApiKeyListLazyQueryHookResult = ReturnType<typeof useApiKeyListLazyQuery>;
export type ApiKeyListQueryResult = Apollo.QueryResult<ApiKeyListQuery, ApiKeyListQueryVariables>;
export const AuthChannelDocument = gql`
    query AuthChannel($profileIdentifier: String!) {
  authChannel(profileIdentifier: $profileIdentifier) {
    channelType
    companyId
    companyProfileId
    ssoChannel {
      idpProxyBaseUrl
      idpProxyPath
    }
    localChannel {
      supportedTypes
    }
  }
}
    `;

/**
 * __useAuthChannelQuery__
 *
 * To run a query within a React component, call `useAuthChannelQuery` and pass it any options that fit your needs.
 * When your component renders, `useAuthChannelQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAuthChannelQuery({
 *   variables: {
 *      profileIdentifier: // value for 'profileIdentifier'
 *   },
 * });
 */
export function useAuthChannelQuery(baseOptions: Apollo.QueryHookOptions<AuthChannelQuery, AuthChannelQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AuthChannelQuery, AuthChannelQueryVariables>(AuthChannelDocument, options);
      }
export function useAuthChannelLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AuthChannelQuery, AuthChannelQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AuthChannelQuery, AuthChannelQueryVariables>(AuthChannelDocument, options);
        }
export type AuthChannelQueryHookResult = ReturnType<typeof useAuthChannelQuery>;
export type AuthChannelLazyQueryHookResult = ReturnType<typeof useAuthChannelLazyQuery>;
export type AuthChannelQueryResult = Apollo.QueryResult<AuthChannelQuery, AuthChannelQueryVariables>;
export const AuthInitDocument = gql`
    mutation AuthInit($profileIdentifier: String!) {
  authInit(profileIdentifier: $profileIdentifier)
}
    `;
export type AuthInitMutationFn = Apollo.MutationFunction<AuthInitMutation, AuthInitMutationVariables>;

/**
 * __useAuthInitMutation__
 *
 * To run a mutation, you first call `useAuthInitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAuthInitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [authInitMutation, { data, loading, error }] = useAuthInitMutation({
 *   variables: {
 *      profileIdentifier: // value for 'profileIdentifier'
 *   },
 * });
 */
export function useAuthInitMutation(baseOptions?: Apollo.MutationHookOptions<AuthInitMutation, AuthInitMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AuthInitMutation, AuthInitMutationVariables>(AuthInitDocument, options);
      }
export type AuthInitMutationHookResult = ReturnType<typeof useAuthInitMutation>;
export type AuthInitMutationResult = Apollo.MutationResult<AuthInitMutation>;
export type AuthInitMutationOptions = Apollo.BaseMutationOptions<AuthInitMutation, AuthInitMutationVariables>;
export const AuthLogoutDocument = gql`
    mutation AuthLogout($logoutInput: LogoutInput!) {
  authLogout(logoutInput: $logoutInput)
}
    `;
export type AuthLogoutMutationFn = Apollo.MutationFunction<AuthLogoutMutation, AuthLogoutMutationVariables>;

/**
 * __useAuthLogoutMutation__
 *
 * To run a mutation, you first call `useAuthLogoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAuthLogoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [authLogoutMutation, { data, loading, error }] = useAuthLogoutMutation({
 *   variables: {
 *      logoutInput: // value for 'logoutInput'
 *   },
 * });
 */
export function useAuthLogoutMutation(baseOptions?: Apollo.MutationHookOptions<AuthLogoutMutation, AuthLogoutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AuthLogoutMutation, AuthLogoutMutationVariables>(AuthLogoutDocument, options);
      }
export type AuthLogoutMutationHookResult = ReturnType<typeof useAuthLogoutMutation>;
export type AuthLogoutMutationResult = Apollo.MutationResult<AuthLogoutMutation>;
export type AuthLogoutMutationOptions = Apollo.BaseMutationOptions<AuthLogoutMutation, AuthLogoutMutationVariables>;
export const AuthRefreshDocument = gql`
    mutation AuthRefresh($refreshToken: String, $source: AuthenticationSource) {
  authRefresh(refreshToken: $refreshToken, source: $source)
}
    `;
export type AuthRefreshMutationFn = Apollo.MutationFunction<AuthRefreshMutation, AuthRefreshMutationVariables>;

/**
 * __useAuthRefreshMutation__
 *
 * To run a mutation, you first call `useAuthRefreshMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAuthRefreshMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [authRefreshMutation, { data, loading, error }] = useAuthRefreshMutation({
 *   variables: {
 *      refreshToken: // value for 'refreshToken'
 *      source: // value for 'source'
 *   },
 * });
 */
export function useAuthRefreshMutation(baseOptions?: Apollo.MutationHookOptions<AuthRefreshMutation, AuthRefreshMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AuthRefreshMutation, AuthRefreshMutationVariables>(AuthRefreshDocument, options);
      }
export type AuthRefreshMutationHookResult = ReturnType<typeof useAuthRefreshMutation>;
export type AuthRefreshMutationResult = Apollo.MutationResult<AuthRefreshMutation>;
export type AuthRefreshMutationOptions = Apollo.BaseMutationOptions<AuthRefreshMutation, AuthRefreshMutationVariables>;
export const AuthVerifyDocument = gql`
    mutation AuthVerify($authInitId: String!, $code: String!) {
  authVerify(authInitId: $authInitId, code: $code) {
    mfaRequired
  }
}
    `;
export type AuthVerifyMutationFn = Apollo.MutationFunction<AuthVerifyMutation, AuthVerifyMutationVariables>;

/**
 * __useAuthVerifyMutation__
 *
 * To run a mutation, you first call `useAuthVerifyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAuthVerifyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [authVerifyMutation, { data, loading, error }] = useAuthVerifyMutation({
 *   variables: {
 *      authInitId: // value for 'authInitId'
 *      code: // value for 'code'
 *   },
 * });
 */
export function useAuthVerifyMutation(baseOptions?: Apollo.MutationHookOptions<AuthVerifyMutation, AuthVerifyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AuthVerifyMutation, AuthVerifyMutationVariables>(AuthVerifyDocument, options);
      }
export type AuthVerifyMutationHookResult = ReturnType<typeof useAuthVerifyMutation>;
export type AuthVerifyMutationResult = Apollo.MutationResult<AuthVerifyMutation>;
export type AuthVerifyMutationOptions = Apollo.BaseMutationOptions<AuthVerifyMutation, AuthVerifyMutationVariables>;
export const CloneLearningPlanDocument = gql`
    mutation CloneLearningPlan($learningPlanId: UUID!, $newLearningPlanExternalId: String!) {
  cloneLearningPlan(
    learningPlanId: $learningPlanId
    newLearningPlanExternalId: $newLearningPlanExternalId
  ) {
    ...LearningPlanFragment
  }
}
    ${LearningPlanFragmentDoc}`;
export type CloneLearningPlanMutationFn = Apollo.MutationFunction<CloneLearningPlanMutation, CloneLearningPlanMutationVariables>;

/**
 * __useCloneLearningPlanMutation__
 *
 * To run a mutation, you first call `useCloneLearningPlanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCloneLearningPlanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cloneLearningPlanMutation, { data, loading, error }] = useCloneLearningPlanMutation({
 *   variables: {
 *      learningPlanId: // value for 'learningPlanId'
 *      newLearningPlanExternalId: // value for 'newLearningPlanExternalId'
 *   },
 * });
 */
export function useCloneLearningPlanMutation(baseOptions?: Apollo.MutationHookOptions<CloneLearningPlanMutation, CloneLearningPlanMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CloneLearningPlanMutation, CloneLearningPlanMutationVariables>(CloneLearningPlanDocument, options);
      }
export type CloneLearningPlanMutationHookResult = ReturnType<typeof useCloneLearningPlanMutation>;
export type CloneLearningPlanMutationResult = Apollo.MutationResult<CloneLearningPlanMutation>;
export type CloneLearningPlanMutationOptions = Apollo.BaseMutationOptions<CloneLearningPlanMutation, CloneLearningPlanMutationVariables>;
export const CloneProfileDocument = gql`
    mutation CloneProfile($profileExternalId: String!, $newProfileExternalId: String!) {
  cloneProfile(
    profileExternalId: $profileExternalId
    newProfileExternalId: $newProfileExternalId
  )
}
    `;
export type CloneProfileMutationFn = Apollo.MutationFunction<CloneProfileMutation, CloneProfileMutationVariables>;

/**
 * __useCloneProfileMutation__
 *
 * To run a mutation, you first call `useCloneProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCloneProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cloneProfileMutation, { data, loading, error }] = useCloneProfileMutation({
 *   variables: {
 *      profileExternalId: // value for 'profileExternalId'
 *      newProfileExternalId: // value for 'newProfileExternalId'
 *   },
 * });
 */
export function useCloneProfileMutation(baseOptions?: Apollo.MutationHookOptions<CloneProfileMutation, CloneProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CloneProfileMutation, CloneProfileMutationVariables>(CloneProfileDocument, options);
      }
export type CloneProfileMutationHookResult = ReturnType<typeof useCloneProfileMutation>;
export type CloneProfileMutationResult = Apollo.MutationResult<CloneProfileMutation>;
export type CloneProfileMutationOptions = Apollo.BaseMutationOptions<CloneProfileMutation, CloneProfileMutationVariables>;
export const CloneRepDocument = gql`
    mutation CloneRep($skillRepId: UUID!, $newSkillRepExternalId: String!) {
  cloneRep(skillRepId: $skillRepId, newSkillRepExternalId: $newSkillRepExternalId) {
    ...SkillRepFragment
  }
}
    ${SkillRepFragmentDoc}`;
export type CloneRepMutationFn = Apollo.MutationFunction<CloneRepMutation, CloneRepMutationVariables>;

/**
 * __useCloneRepMutation__
 *
 * To run a mutation, you first call `useCloneRepMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCloneRepMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cloneRepMutation, { data, loading, error }] = useCloneRepMutation({
 *   variables: {
 *      skillRepId: // value for 'skillRepId'
 *      newSkillRepExternalId: // value for 'newSkillRepExternalId'
 *   },
 * });
 */
export function useCloneRepMutation(baseOptions?: Apollo.MutationHookOptions<CloneRepMutation, CloneRepMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CloneRepMutation, CloneRepMutationVariables>(CloneRepDocument, options);
      }
export type CloneRepMutationHookResult = ReturnType<typeof useCloneRepMutation>;
export type CloneRepMutationResult = Apollo.MutationResult<CloneRepMutation>;
export type CloneRepMutationOptions = Apollo.BaseMutationOptions<CloneRepMutation, CloneRepMutationVariables>;
export const CloneSkillDocument = gql`
    mutation CloneSkill($skillId: UUID!, $newSkillExternalId: String!) {
  cloneSkill(skillId: $skillId, newSkillExternalId: $newSkillExternalId) {
    ...SkillFragment
  }
}
    ${SkillFragmentDoc}`;
export type CloneSkillMutationFn = Apollo.MutationFunction<CloneSkillMutation, CloneSkillMutationVariables>;

/**
 * __useCloneSkillMutation__
 *
 * To run a mutation, you first call `useCloneSkillMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCloneSkillMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cloneSkillMutation, { data, loading, error }] = useCloneSkillMutation({
 *   variables: {
 *      skillId: // value for 'skillId'
 *      newSkillExternalId: // value for 'newSkillExternalId'
 *   },
 * });
 */
export function useCloneSkillMutation(baseOptions?: Apollo.MutationHookOptions<CloneSkillMutation, CloneSkillMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CloneSkillMutation, CloneSkillMutationVariables>(CloneSkillDocument, options);
      }
export type CloneSkillMutationHookResult = ReturnType<typeof useCloneSkillMutation>;
export type CloneSkillMutationResult = Apollo.MutationResult<CloneSkillMutation>;
export type CloneSkillMutationOptions = Apollo.BaseMutationOptions<CloneSkillMutation, CloneSkillMutationVariables>;
export const CollectionsDocument = gql`
    query Collections {
  companies {
    nodes {
      id
      name
      externalId
      countryCode
      timezone
      ...CompanyFeatureFragment
      ...CompanyLanguageFragment
    }
  }
}
    ${CompanyFeatureFragmentDoc}
${CompanyLanguageFragmentDoc}`;

/**
 * __useCollectionsQuery__
 *
 * To run a query within a React component, call `useCollectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCollectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCollectionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useCollectionsQuery(baseOptions?: Apollo.QueryHookOptions<CollectionsQuery, CollectionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CollectionsQuery, CollectionsQueryVariables>(CollectionsDocument, options);
      }
export function useCollectionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CollectionsQuery, CollectionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CollectionsQuery, CollectionsQueryVariables>(CollectionsDocument, options);
        }
export type CollectionsQueryHookResult = ReturnType<typeof useCollectionsQuery>;
export type CollectionsLazyQueryHookResult = ReturnType<typeof useCollectionsLazyQuery>;
export type CollectionsQueryResult = Apollo.QueryResult<CollectionsQuery, CollectionsQueryVariables>;
export const CompanyEditDocument = gql`
    query CompanyEdit {
  company {
    ...CompanyFragment
  }
}
    ${CompanyFragmentDoc}`;

/**
 * __useCompanyEditQuery__
 *
 * To run a query within a React component, call `useCompanyEditQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyEditQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyEditQuery({
 *   variables: {
 *   },
 * });
 */
export function useCompanyEditQuery(baseOptions?: Apollo.QueryHookOptions<CompanyEditQuery, CompanyEditQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompanyEditQuery, CompanyEditQueryVariables>(CompanyEditDocument, options);
      }
export function useCompanyEditLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompanyEditQuery, CompanyEditQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompanyEditQuery, CompanyEditQueryVariables>(CompanyEditDocument, options);
        }
export type CompanyEditQueryHookResult = ReturnType<typeof useCompanyEditQuery>;
export type CompanyEditLazyQueryHookResult = ReturnType<typeof useCompanyEditLazyQuery>;
export type CompanyEditQueryResult = Apollo.QueryResult<CompanyEditQuery, CompanyEditQueryVariables>;
export const CompanyEditSubmitDocument = gql`
    mutation CompanyEditSubmit($companyEditInput: CompanyEditInput!) {
  companyEdit(companyEditInput: $companyEditInput) {
    ...CompanyFragment
  }
}
    ${CompanyFragmentDoc}`;
export type CompanyEditSubmitMutationFn = Apollo.MutationFunction<CompanyEditSubmitMutation, CompanyEditSubmitMutationVariables>;

/**
 * __useCompanyEditSubmitMutation__
 *
 * To run a mutation, you first call `useCompanyEditSubmitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompanyEditSubmitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [companyEditSubmitMutation, { data, loading, error }] = useCompanyEditSubmitMutation({
 *   variables: {
 *      companyEditInput: // value for 'companyEditInput'
 *   },
 * });
 */
export function useCompanyEditSubmitMutation(baseOptions?: Apollo.MutationHookOptions<CompanyEditSubmitMutation, CompanyEditSubmitMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CompanyEditSubmitMutation, CompanyEditSubmitMutationVariables>(CompanyEditSubmitDocument, options);
      }
export type CompanyEditSubmitMutationHookResult = ReturnType<typeof useCompanyEditSubmitMutation>;
export type CompanyEditSubmitMutationResult = Apollo.MutationResult<CompanyEditSubmitMutation>;
export type CompanyEditSubmitMutationOptions = Apollo.BaseMutationOptions<CompanyEditSubmitMutation, CompanyEditSubmitMutationVariables>;
export const CompanyLanguageListDocument = gql`
    query CompanyLanguageList {
  company {
    id
    ...CompanyLanguageFragment
  }
}
    ${CompanyLanguageFragmentDoc}`;

/**
 * __useCompanyLanguageListQuery__
 *
 * To run a query within a React component, call `useCompanyLanguageListQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyLanguageListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyLanguageListQuery({
 *   variables: {
 *   },
 * });
 */
export function useCompanyLanguageListQuery(baseOptions?: Apollo.QueryHookOptions<CompanyLanguageListQuery, CompanyLanguageListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompanyLanguageListQuery, CompanyLanguageListQueryVariables>(CompanyLanguageListDocument, options);
      }
export function useCompanyLanguageListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompanyLanguageListQuery, CompanyLanguageListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompanyLanguageListQuery, CompanyLanguageListQueryVariables>(CompanyLanguageListDocument, options);
        }
export type CompanyLanguageListQueryHookResult = ReturnType<typeof useCompanyLanguageListQuery>;
export type CompanyLanguageListLazyQueryHookResult = ReturnType<typeof useCompanyLanguageListLazyQuery>;
export type CompanyLanguageListQueryResult = Apollo.QueryResult<CompanyLanguageListQuery, CompanyLanguageListQueryVariables>;
export const CompanyNewDocument = gql`
    query CompanyNew {
  featureList {
    ...FeatureFragment
  }
}
    ${FeatureFragmentDoc}`;

/**
 * __useCompanyNewQuery__
 *
 * To run a query within a React component, call `useCompanyNewQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyNewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyNewQuery({
 *   variables: {
 *   },
 * });
 */
export function useCompanyNewQuery(baseOptions?: Apollo.QueryHookOptions<CompanyNewQuery, CompanyNewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompanyNewQuery, CompanyNewQueryVariables>(CompanyNewDocument, options);
      }
export function useCompanyNewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompanyNewQuery, CompanyNewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompanyNewQuery, CompanyNewQueryVariables>(CompanyNewDocument, options);
        }
export type CompanyNewQueryHookResult = ReturnType<typeof useCompanyNewQuery>;
export type CompanyNewLazyQueryHookResult = ReturnType<typeof useCompanyNewLazyQuery>;
export type CompanyNewQueryResult = Apollo.QueryResult<CompanyNewQuery, CompanyNewQueryVariables>;
export const CompanyNewSubmitDocument = gql`
    mutation CompanyNewSubmit($companyCreateInput: CompanyCreateInput!) {
  companyCreate(companyCreateInput: $companyCreateInput) {
    ...CompanyFragment
  }
}
    ${CompanyFragmentDoc}`;
export type CompanyNewSubmitMutationFn = Apollo.MutationFunction<CompanyNewSubmitMutation, CompanyNewSubmitMutationVariables>;

/**
 * __useCompanyNewSubmitMutation__
 *
 * To run a mutation, you first call `useCompanyNewSubmitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompanyNewSubmitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [companyNewSubmitMutation, { data, loading, error }] = useCompanyNewSubmitMutation({
 *   variables: {
 *      companyCreateInput: // value for 'companyCreateInput'
 *   },
 * });
 */
export function useCompanyNewSubmitMutation(baseOptions?: Apollo.MutationHookOptions<CompanyNewSubmitMutation, CompanyNewSubmitMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CompanyNewSubmitMutation, CompanyNewSubmitMutationVariables>(CompanyNewSubmitDocument, options);
      }
export type CompanyNewSubmitMutationHookResult = ReturnType<typeof useCompanyNewSubmitMutation>;
export type CompanyNewSubmitMutationResult = Apollo.MutationResult<CompanyNewSubmitMutation>;
export type CompanyNewSubmitMutationOptions = Apollo.BaseMutationOptions<CompanyNewSubmitMutation, CompanyNewSubmitMutationVariables>;
export const CompanySearchDocument = gql`
    query CompanySearch($paginate: BaseClassicPaginate, $conditions: CompanySearchConditions) {
  companySearch(paginate: $paginate, conditions: $conditions) {
    nodes {
      id
      name
      externalId
    }
  }
}
    `;

/**
 * __useCompanySearchQuery__
 *
 * To run a query within a React component, call `useCompanySearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanySearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanySearchQuery({
 *   variables: {
 *      paginate: // value for 'paginate'
 *      conditions: // value for 'conditions'
 *   },
 * });
 */
export function useCompanySearchQuery(baseOptions?: Apollo.QueryHookOptions<CompanySearchQuery, CompanySearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompanySearchQuery, CompanySearchQueryVariables>(CompanySearchDocument, options);
      }
export function useCompanySearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompanySearchQuery, CompanySearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompanySearchQuery, CompanySearchQueryVariables>(CompanySearchDocument, options);
        }
export type CompanySearchQueryHookResult = ReturnType<typeof useCompanySearchQuery>;
export type CompanySearchLazyQueryHookResult = ReturnType<typeof useCompanySearchLazyQuery>;
export type CompanySearchQueryResult = Apollo.QueryResult<CompanySearchQuery, CompanySearchQueryVariables>;
export const GetCompanySiblingsDocument = gql`
    query GetCompanySiblings($activeOnly: Boolean!) {
  getCompanySiblings(ActiveOnly: $activeOnly) {
    id
    companyId
    siblingCompanyId
    deletedAt
    siblingCompany {
      id
      name
      externalId
      displayName
    }
  }
}
    `;

/**
 * __useGetCompanySiblingsQuery__
 *
 * To run a query within a React component, call `useGetCompanySiblingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanySiblingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanySiblingsQuery({
 *   variables: {
 *      activeOnly: // value for 'activeOnly'
 *   },
 * });
 */
export function useGetCompanySiblingsQuery(baseOptions: Apollo.QueryHookOptions<GetCompanySiblingsQuery, GetCompanySiblingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCompanySiblingsQuery, GetCompanySiblingsQueryVariables>(GetCompanySiblingsDocument, options);
      }
export function useGetCompanySiblingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCompanySiblingsQuery, GetCompanySiblingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCompanySiblingsQuery, GetCompanySiblingsQueryVariables>(GetCompanySiblingsDocument, options);
        }
export type GetCompanySiblingsQueryHookResult = ReturnType<typeof useGetCompanySiblingsQuery>;
export type GetCompanySiblingsLazyQueryHookResult = ReturnType<typeof useGetCompanySiblingsLazyQuery>;
export type GetCompanySiblingsQueryResult = Apollo.QueryResult<GetCompanySiblingsQuery, GetCompanySiblingsQueryVariables>;
export const GetCreatorGroupListDocument = gql`
    query GetCreatorGroupList {
  getCreatorGroupList {
    id
    profile {
      displayName
    }
  }
}
    `;

/**
 * __useGetCreatorGroupListQuery__
 *
 * To run a query within a React component, call `useGetCreatorGroupListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCreatorGroupListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCreatorGroupListQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCreatorGroupListQuery(baseOptions?: Apollo.QueryHookOptions<GetCreatorGroupListQuery, GetCreatorGroupListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCreatorGroupListQuery, GetCreatorGroupListQueryVariables>(GetCreatorGroupListDocument, options);
      }
export function useGetCreatorGroupListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCreatorGroupListQuery, GetCreatorGroupListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCreatorGroupListQuery, GetCreatorGroupListQueryVariables>(GetCreatorGroupListDocument, options);
        }
export type GetCreatorGroupListQueryHookResult = ReturnType<typeof useGetCreatorGroupListQuery>;
export type GetCreatorGroupListLazyQueryHookResult = ReturnType<typeof useGetCreatorGroupListLazyQuery>;
export type GetCreatorGroupListQueryResult = Apollo.QueryResult<GetCreatorGroupListQuery, GetCreatorGroupListQueryVariables>;
export const GetCreatorLpListDocument = gql`
    query GetCreatorLPList {
  getCreatorLPList {
    id
    profile {
      displayName
    }
  }
}
    `;

/**
 * __useGetCreatorLpListQuery__
 *
 * To run a query within a React component, call `useGetCreatorLpListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCreatorLpListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCreatorLpListQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCreatorLpListQuery(baseOptions?: Apollo.QueryHookOptions<GetCreatorLpListQuery, GetCreatorLpListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCreatorLpListQuery, GetCreatorLpListQueryVariables>(GetCreatorLpListDocument, options);
      }
export function useGetCreatorLpListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCreatorLpListQuery, GetCreatorLpListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCreatorLpListQuery, GetCreatorLpListQueryVariables>(GetCreatorLpListDocument, options);
        }
export type GetCreatorLpListQueryHookResult = ReturnType<typeof useGetCreatorLpListQuery>;
export type GetCreatorLpListLazyQueryHookResult = ReturnType<typeof useGetCreatorLpListLazyQuery>;
export type GetCreatorLpListQueryResult = Apollo.QueryResult<GetCreatorLpListQuery, GetCreatorLpListQueryVariables>;
export const GetCreatorListDocument = gql`
    query GetCreatorList {
  getCreatorList {
    id
    profile {
      displayName
    }
  }
}
    `;

/**
 * __useGetCreatorListQuery__
 *
 * To run a query within a React component, call `useGetCreatorListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCreatorListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCreatorListQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCreatorListQuery(baseOptions?: Apollo.QueryHookOptions<GetCreatorListQuery, GetCreatorListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCreatorListQuery, GetCreatorListQueryVariables>(GetCreatorListDocument, options);
      }
export function useGetCreatorListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCreatorListQuery, GetCreatorListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCreatorListQuery, GetCreatorListQueryVariables>(GetCreatorListDocument, options);
        }
export type GetCreatorListQueryHookResult = ReturnType<typeof useGetCreatorListQuery>;
export type GetCreatorListLazyQueryHookResult = ReturnType<typeof useGetCreatorListLazyQuery>;
export type GetCreatorListQueryResult = Apollo.QueryResult<GetCreatorListQuery, GetCreatorListQueryVariables>;
export const GetCreatorRepListDocument = gql`
    query GetCreatorRepList {
  getCreatorRepList {
    id
    profile {
      displayName
    }
  }
}
    `;

/**
 * __useGetCreatorRepListQuery__
 *
 * To run a query within a React component, call `useGetCreatorRepListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCreatorRepListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCreatorRepListQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCreatorRepListQuery(baseOptions?: Apollo.QueryHookOptions<GetCreatorRepListQuery, GetCreatorRepListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCreatorRepListQuery, GetCreatorRepListQueryVariables>(GetCreatorRepListDocument, options);
      }
export function useGetCreatorRepListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCreatorRepListQuery, GetCreatorRepListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCreatorRepListQuery, GetCreatorRepListQueryVariables>(GetCreatorRepListDocument, options);
        }
export type GetCreatorRepListQueryHookResult = ReturnType<typeof useGetCreatorRepListQuery>;
export type GetCreatorRepListLazyQueryHookResult = ReturnType<typeof useGetCreatorRepListLazyQuery>;
export type GetCreatorRepListQueryResult = Apollo.QueryResult<GetCreatorRepListQuery, GetCreatorRepListQueryVariables>;
export const GetCreatorSkillListDocument = gql`
    query GetCreatorSkillList {
  getCreatorSkillList {
    id
    profile {
      displayName
    }
  }
}
    `;

/**
 * __useGetCreatorSkillListQuery__
 *
 * To run a query within a React component, call `useGetCreatorSkillListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCreatorSkillListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCreatorSkillListQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCreatorSkillListQuery(baseOptions?: Apollo.QueryHookOptions<GetCreatorSkillListQuery, GetCreatorSkillListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCreatorSkillListQuery, GetCreatorSkillListQueryVariables>(GetCreatorSkillListDocument, options);
      }
export function useGetCreatorSkillListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCreatorSkillListQuery, GetCreatorSkillListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCreatorSkillListQuery, GetCreatorSkillListQueryVariables>(GetCreatorSkillListDocument, options);
        }
export type GetCreatorSkillListQueryHookResult = ReturnType<typeof useGetCreatorSkillListQuery>;
export type GetCreatorSkillListLazyQueryHookResult = ReturnType<typeof useGetCreatorSkillListLazyQuery>;
export type GetCreatorSkillListQueryResult = Apollo.QueryResult<GetCreatorSkillListQuery, GetCreatorSkillListQueryVariables>;
export const GetCreatorTopicListDocument = gql`
    query GetCreatorTopicList {
  getCreatorTopicList {
    id
    profile {
      displayName
    }
  }
}
    `;

/**
 * __useGetCreatorTopicListQuery__
 *
 * To run a query within a React component, call `useGetCreatorTopicListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCreatorTopicListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCreatorTopicListQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCreatorTopicListQuery(baseOptions?: Apollo.QueryHookOptions<GetCreatorTopicListQuery, GetCreatorTopicListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCreatorTopicListQuery, GetCreatorTopicListQueryVariables>(GetCreatorTopicListDocument, options);
      }
export function useGetCreatorTopicListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCreatorTopicListQuery, GetCreatorTopicListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCreatorTopicListQuery, GetCreatorTopicListQueryVariables>(GetCreatorTopicListDocument, options);
        }
export type GetCreatorTopicListQueryHookResult = ReturnType<typeof useGetCreatorTopicListQuery>;
export type GetCreatorTopicListLazyQueryHookResult = ReturnType<typeof useGetCreatorTopicListLazyQuery>;
export type GetCreatorTopicListQueryResult = Apollo.QueryResult<GetCreatorTopicListQuery, GetCreatorTopicListQueryVariables>;
export const InsertCustomPersonaDocument = gql`
    mutation InsertCustomPersona($input: InsertCustomPersonaInput!) {
  insertCustomPersona(insertCustomPersonaInput: $input) {
    id
    cardTitle
    cardDescription
    status
    personaName
    designation
    details {
      bio
      goal
      traits
    }
    config {
      difficulty
      voiceName
      gender
      voiceService
      avatarUrl
    }
  }
}
    `;
export type InsertCustomPersonaMutationFn = Apollo.MutationFunction<InsertCustomPersonaMutation, InsertCustomPersonaMutationVariables>;

/**
 * __useInsertCustomPersonaMutation__
 *
 * To run a mutation, you first call `useInsertCustomPersonaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertCustomPersonaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertCustomPersonaMutation, { data, loading, error }] = useInsertCustomPersonaMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInsertCustomPersonaMutation(baseOptions?: Apollo.MutationHookOptions<InsertCustomPersonaMutation, InsertCustomPersonaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertCustomPersonaMutation, InsertCustomPersonaMutationVariables>(InsertCustomPersonaDocument, options);
      }
export type InsertCustomPersonaMutationHookResult = ReturnType<typeof useInsertCustomPersonaMutation>;
export type InsertCustomPersonaMutationResult = Apollo.MutationResult<InsertCustomPersonaMutation>;
export type InsertCustomPersonaMutationOptions = Apollo.BaseMutationOptions<InsertCustomPersonaMutation, InsertCustomPersonaMutationVariables>;
export const CustomVocabularyDocument = gql`
    query CustomVocabulary($customVocabularyId: String!) {
  customVocabulary(id: $customVocabularyId) {
    ...CustomVocabularyFragment
    url
  }
}
    ${CustomVocabularyFragmentDoc}`;

/**
 * __useCustomVocabularyQuery__
 *
 * To run a query within a React component, call `useCustomVocabularyQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomVocabularyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomVocabularyQuery({
 *   variables: {
 *      customVocabularyId: // value for 'customVocabularyId'
 *   },
 * });
 */
export function useCustomVocabularyQuery(baseOptions: Apollo.QueryHookOptions<CustomVocabularyQuery, CustomVocabularyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomVocabularyQuery, CustomVocabularyQueryVariables>(CustomVocabularyDocument, options);
      }
export function useCustomVocabularyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomVocabularyQuery, CustomVocabularyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomVocabularyQuery, CustomVocabularyQueryVariables>(CustomVocabularyDocument, options);
        }
export type CustomVocabularyQueryHookResult = ReturnType<typeof useCustomVocabularyQuery>;
export type CustomVocabularyLazyQueryHookResult = ReturnType<typeof useCustomVocabularyLazyQuery>;
export type CustomVocabularyQueryResult = Apollo.QueryResult<CustomVocabularyQuery, CustomVocabularyQueryVariables>;
export const CustomVocabulariesArchiveDocument = gql`
    mutation CustomVocabulariesArchive($ids: [String!]!) {
  customVocabulariesArchive(ids: $ids) {
    ...CustomVocabularyFragment
  }
}
    ${CustomVocabularyFragmentDoc}`;
export type CustomVocabulariesArchiveMutationFn = Apollo.MutationFunction<CustomVocabulariesArchiveMutation, CustomVocabulariesArchiveMutationVariables>;

/**
 * __useCustomVocabulariesArchiveMutation__
 *
 * To run a mutation, you first call `useCustomVocabulariesArchiveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomVocabulariesArchiveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customVocabulariesArchiveMutation, { data, loading, error }] = useCustomVocabulariesArchiveMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useCustomVocabulariesArchiveMutation(baseOptions?: Apollo.MutationHookOptions<CustomVocabulariesArchiveMutation, CustomVocabulariesArchiveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CustomVocabulariesArchiveMutation, CustomVocabulariesArchiveMutationVariables>(CustomVocabulariesArchiveDocument, options);
      }
export type CustomVocabulariesArchiveMutationHookResult = ReturnType<typeof useCustomVocabulariesArchiveMutation>;
export type CustomVocabulariesArchiveMutationResult = Apollo.MutationResult<CustomVocabulariesArchiveMutation>;
export type CustomVocabulariesArchiveMutationOptions = Apollo.BaseMutationOptions<CustomVocabulariesArchiveMutation, CustomVocabulariesArchiveMutationVariables>;
export const CustomVocabularyKeywordListDocument = gql`
    query CustomVocabularyKeywordList($vocabularyId: String!, $paginate: BaseClassicPaginate, $sorts: [CustomVocabularyKeywordListOrderBy!], $conditions: CustomVocabularyKeywordListConditions) {
  customVocabularylKeywordList(
    vocabularyId: $vocabularyId
    paginate: $paginate
    sorts: $sorts
    conditions: $conditions
  ) {
    totalCount
    pageInfo {
      beforeCursor
      afterCursor
    }
    nodes {
      ...CustomVocabularyKeywordFragment
    }
  }
}
    ${CustomVocabularyKeywordFragmentDoc}`;

/**
 * __useCustomVocabularyKeywordListQuery__
 *
 * To run a query within a React component, call `useCustomVocabularyKeywordListQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomVocabularyKeywordListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomVocabularyKeywordListQuery({
 *   variables: {
 *      vocabularyId: // value for 'vocabularyId'
 *      paginate: // value for 'paginate'
 *      sorts: // value for 'sorts'
 *      conditions: // value for 'conditions'
 *   },
 * });
 */
export function useCustomVocabularyKeywordListQuery(baseOptions: Apollo.QueryHookOptions<CustomVocabularyKeywordListQuery, CustomVocabularyKeywordListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomVocabularyKeywordListQuery, CustomVocabularyKeywordListQueryVariables>(CustomVocabularyKeywordListDocument, options);
      }
export function useCustomVocabularyKeywordListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomVocabularyKeywordListQuery, CustomVocabularyKeywordListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomVocabularyKeywordListQuery, CustomVocabularyKeywordListQueryVariables>(CustomVocabularyKeywordListDocument, options);
        }
export type CustomVocabularyKeywordListQueryHookResult = ReturnType<typeof useCustomVocabularyKeywordListQuery>;
export type CustomVocabularyKeywordListLazyQueryHookResult = ReturnType<typeof useCustomVocabularyKeywordListLazyQuery>;
export type CustomVocabularyKeywordListQueryResult = Apollo.QueryResult<CustomVocabularyKeywordListQuery, CustomVocabularyKeywordListQueryVariables>;
export const CustomVocabularyListDocument = gql`
    query CustomVocabularyList($paginate: BaseClassicPaginate, $sorts: [CustomVocabularyListOrderBy!], $conditions: CustomVocabularyListConditions) {
  customVocabularyList(
    paginate: $paginate
    sorts: $sorts
    conditions: $conditions
  ) {
    totalCount
    pageInfo {
      beforeCursor
      afterCursor
    }
    nodes {
      ...CustomVocabularyFragment
    }
  }
}
    ${CustomVocabularyFragmentDoc}`;

/**
 * __useCustomVocabularyListQuery__
 *
 * To run a query within a React component, call `useCustomVocabularyListQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomVocabularyListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomVocabularyListQuery({
 *   variables: {
 *      paginate: // value for 'paginate'
 *      sorts: // value for 'sorts'
 *      conditions: // value for 'conditions'
 *   },
 * });
 */
export function useCustomVocabularyListQuery(baseOptions?: Apollo.QueryHookOptions<CustomVocabularyListQuery, CustomVocabularyListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomVocabularyListQuery, CustomVocabularyListQueryVariables>(CustomVocabularyListDocument, options);
      }
export function useCustomVocabularyListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomVocabularyListQuery, CustomVocabularyListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomVocabularyListQuery, CustomVocabularyListQueryVariables>(CustomVocabularyListDocument, options);
        }
export type CustomVocabularyListQueryHookResult = ReturnType<typeof useCustomVocabularyListQuery>;
export type CustomVocabularyListLazyQueryHookResult = ReturnType<typeof useCustomVocabularyListLazyQuery>;
export type CustomVocabularyListQueryResult = Apollo.QueryResult<CustomVocabularyListQuery, CustomVocabularyListQueryVariables>;
export const CustomVocabularyUpsertDocument = gql`
    mutation CustomVocabularyUpsert($language: DialectTypes!, $status: CustomVocabularyStatuses, $name: String!, $customVocabularyUpsertId: String, $description: String) {
  customVocabularyUpsert(
    language: $language
    status: $status
    name: $name
    id: $customVocabularyUpsertId
    description: $description
  ) {
    ...CustomVocabularyFragment
  }
}
    ${CustomVocabularyFragmentDoc}`;
export type CustomVocabularyUpsertMutationFn = Apollo.MutationFunction<CustomVocabularyUpsertMutation, CustomVocabularyUpsertMutationVariables>;

/**
 * __useCustomVocabularyUpsertMutation__
 *
 * To run a mutation, you first call `useCustomVocabularyUpsertMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomVocabularyUpsertMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customVocabularyUpsertMutation, { data, loading, error }] = useCustomVocabularyUpsertMutation({
 *   variables: {
 *      language: // value for 'language'
 *      status: // value for 'status'
 *      name: // value for 'name'
 *      customVocabularyUpsertId: // value for 'customVocabularyUpsertId'
 *      description: // value for 'description'
 *   },
 * });
 */
export function useCustomVocabularyUpsertMutation(baseOptions?: Apollo.MutationHookOptions<CustomVocabularyUpsertMutation, CustomVocabularyUpsertMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CustomVocabularyUpsertMutation, CustomVocabularyUpsertMutationVariables>(CustomVocabularyUpsertDocument, options);
      }
export type CustomVocabularyUpsertMutationHookResult = ReturnType<typeof useCustomVocabularyUpsertMutation>;
export type CustomVocabularyUpsertMutationResult = Apollo.MutationResult<CustomVocabularyUpsertMutation>;
export type CustomVocabularyUpsertMutationOptions = Apollo.BaseMutationOptions<CustomVocabularyUpsertMutation, CustomVocabularyUpsertMutationVariables>;
export const DeleteSkillProgressDocument = gql`
    mutation DeleteSkillProgress($profileExternalId: String!, $skillExternalId: String!) {
  deleteSkillProgress(
    profileExternalId: $profileExternalId
    skillExternalId: $skillExternalId
  )
}
    `;
export type DeleteSkillProgressMutationFn = Apollo.MutationFunction<DeleteSkillProgressMutation, DeleteSkillProgressMutationVariables>;

/**
 * __useDeleteSkillProgressMutation__
 *
 * To run a mutation, you first call `useDeleteSkillProgressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSkillProgressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSkillProgressMutation, { data, loading, error }] = useDeleteSkillProgressMutation({
 *   variables: {
 *      profileExternalId: // value for 'profileExternalId'
 *      skillExternalId: // value for 'skillExternalId'
 *   },
 * });
 */
export function useDeleteSkillProgressMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSkillProgressMutation, DeleteSkillProgressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSkillProgressMutation, DeleteSkillProgressMutationVariables>(DeleteSkillProgressDocument, options);
      }
export type DeleteSkillProgressMutationHookResult = ReturnType<typeof useDeleteSkillProgressMutation>;
export type DeleteSkillProgressMutationResult = Apollo.MutationResult<DeleteSkillProgressMutation>;
export type DeleteSkillProgressMutationOptions = Apollo.BaseMutationOptions<DeleteSkillProgressMutation, DeleteSkillProgressMutationVariables>;
export const ExportLearningPlanBulkDocument = gql`
    mutation ExportLearningPlanBulk($targetCompanyIds: [UUID!]!, $learningPlanIds: [UUID!]!, $groupsDataIds: [GroupsDataIdsArg!]) {
  exportLearningPlanBulk(
    targetCompanyIds: $targetCompanyIds
    learningPlanIds: $learningPlanIds
    groupsDataIds: $groupsDataIds
  ) {
    ...LearningPlanFragment
  }
}
    ${LearningPlanFragmentDoc}`;
export type ExportLearningPlanBulkMutationFn = Apollo.MutationFunction<ExportLearningPlanBulkMutation, ExportLearningPlanBulkMutationVariables>;

/**
 * __useExportLearningPlanBulkMutation__
 *
 * To run a mutation, you first call `useExportLearningPlanBulkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExportLearningPlanBulkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exportLearningPlanBulkMutation, { data, loading, error }] = useExportLearningPlanBulkMutation({
 *   variables: {
 *      targetCompanyIds: // value for 'targetCompanyIds'
 *      learningPlanIds: // value for 'learningPlanIds'
 *      groupsDataIds: // value for 'groupsDataIds'
 *   },
 * });
 */
export function useExportLearningPlanBulkMutation(baseOptions?: Apollo.MutationHookOptions<ExportLearningPlanBulkMutation, ExportLearningPlanBulkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExportLearningPlanBulkMutation, ExportLearningPlanBulkMutationVariables>(ExportLearningPlanBulkDocument, options);
      }
export type ExportLearningPlanBulkMutationHookResult = ReturnType<typeof useExportLearningPlanBulkMutation>;
export type ExportLearningPlanBulkMutationResult = Apollo.MutationResult<ExportLearningPlanBulkMutation>;
export type ExportLearningPlanBulkMutationOptions = Apollo.BaseMutationOptions<ExportLearningPlanBulkMutation, ExportLearningPlanBulkMutationVariables>;
export const ExportSkillRepsBulkDocument = gql`
    mutation ExportSkillRepsBulk($targetCompanyIds: [UUID!]!, $skillRepIds: [UUID!]!) {
  exportSkillRepsBulk(
    targetCompanyIds: $targetCompanyIds
    skillRepIds: $skillRepIds
  ) {
    ...SkillRepFragment
  }
}
    ${SkillRepFragmentDoc}`;
export type ExportSkillRepsBulkMutationFn = Apollo.MutationFunction<ExportSkillRepsBulkMutation, ExportSkillRepsBulkMutationVariables>;

/**
 * __useExportSkillRepsBulkMutation__
 *
 * To run a mutation, you first call `useExportSkillRepsBulkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExportSkillRepsBulkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exportSkillRepsBulkMutation, { data, loading, error }] = useExportSkillRepsBulkMutation({
 *   variables: {
 *      targetCompanyIds: // value for 'targetCompanyIds'
 *      skillRepIds: // value for 'skillRepIds'
 *   },
 * });
 */
export function useExportSkillRepsBulkMutation(baseOptions?: Apollo.MutationHookOptions<ExportSkillRepsBulkMutation, ExportSkillRepsBulkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExportSkillRepsBulkMutation, ExportSkillRepsBulkMutationVariables>(ExportSkillRepsBulkDocument, options);
      }
export type ExportSkillRepsBulkMutationHookResult = ReturnType<typeof useExportSkillRepsBulkMutation>;
export type ExportSkillRepsBulkMutationResult = Apollo.MutationResult<ExportSkillRepsBulkMutation>;
export type ExportSkillRepsBulkMutationOptions = Apollo.BaseMutationOptions<ExportSkillRepsBulkMutation, ExportSkillRepsBulkMutationVariables>;
export const ExportSkillsBulkDocument = gql`
    mutation ExportSkillsBulk($targetCompanyIds: [UUID!]!, $skillIds: [UUID!]!) {
  exportSkillsBulk(targetCompanyIds: $targetCompanyIds, skillIds: $skillIds) {
    ...SkillFragment
  }
}
    ${SkillFragmentDoc}`;
export type ExportSkillsBulkMutationFn = Apollo.MutationFunction<ExportSkillsBulkMutation, ExportSkillsBulkMutationVariables>;

/**
 * __useExportSkillsBulkMutation__
 *
 * To run a mutation, you first call `useExportSkillsBulkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExportSkillsBulkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exportSkillsBulkMutation, { data, loading, error }] = useExportSkillsBulkMutation({
 *   variables: {
 *      targetCompanyIds: // value for 'targetCompanyIds'
 *      skillIds: // value for 'skillIds'
 *   },
 * });
 */
export function useExportSkillsBulkMutation(baseOptions?: Apollo.MutationHookOptions<ExportSkillsBulkMutation, ExportSkillsBulkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExportSkillsBulkMutation, ExportSkillsBulkMutationVariables>(ExportSkillsBulkDocument, options);
      }
export type ExportSkillsBulkMutationHookResult = ReturnType<typeof useExportSkillsBulkMutation>;
export type ExportSkillsBulkMutationResult = Apollo.MutationResult<ExportSkillsBulkMutation>;
export type ExportSkillsBulkMutationOptions = Apollo.BaseMutationOptions<ExportSkillsBulkMutation, ExportSkillsBulkMutationVariables>;
export const FeatureListDocument = gql`
    query FeatureList {
  featureList {
    ...FeatureFragment
  }
}
    ${FeatureFragmentDoc}`;

/**
 * __useFeatureListQuery__
 *
 * To run a query within a React component, call `useFeatureListQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeatureListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeatureListQuery({
 *   variables: {
 *   },
 * });
 */
export function useFeatureListQuery(baseOptions?: Apollo.QueryHookOptions<FeatureListQuery, FeatureListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FeatureListQuery, FeatureListQueryVariables>(FeatureListDocument, options);
      }
export function useFeatureListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FeatureListQuery, FeatureListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FeatureListQuery, FeatureListQueryVariables>(FeatureListDocument, options);
        }
export type FeatureListQueryHookResult = ReturnType<typeof useFeatureListQuery>;
export type FeatureListLazyQueryHookResult = ReturnType<typeof useFeatureListLazyQuery>;
export type FeatureListQueryResult = Apollo.QueryResult<FeatureListQuery, FeatureListQueryVariables>;
export const FileUploaderGetSignedUrlDocument = gql`
    mutation FileUploaderGetSignedUrl($fileType: String!, $uploadSource: UploadSource!, $options: UploadOptionsInput) {
  fileUploadGetSignedUrl(
    fileType: $fileType
    uploadSource: $uploadSource
    options: $options
  ) {
    ...UploadFragment
  }
}
    ${UploadFragmentDoc}`;
export type FileUploaderGetSignedUrlMutationFn = Apollo.MutationFunction<FileUploaderGetSignedUrlMutation, FileUploaderGetSignedUrlMutationVariables>;

/**
 * __useFileUploaderGetSignedUrlMutation__
 *
 * To run a mutation, you first call `useFileUploaderGetSignedUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFileUploaderGetSignedUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [fileUploaderGetSignedUrlMutation, { data, loading, error }] = useFileUploaderGetSignedUrlMutation({
 *   variables: {
 *      fileType: // value for 'fileType'
 *      uploadSource: // value for 'uploadSource'
 *      options: // value for 'options'
 *   },
 * });
 */
export function useFileUploaderGetSignedUrlMutation(baseOptions?: Apollo.MutationHookOptions<FileUploaderGetSignedUrlMutation, FileUploaderGetSignedUrlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FileUploaderGetSignedUrlMutation, FileUploaderGetSignedUrlMutationVariables>(FileUploaderGetSignedUrlDocument, options);
      }
export type FileUploaderGetSignedUrlMutationHookResult = ReturnType<typeof useFileUploaderGetSignedUrlMutation>;
export type FileUploaderGetSignedUrlMutationResult = Apollo.MutationResult<FileUploaderGetSignedUrlMutation>;
export type FileUploaderGetSignedUrlMutationOptions = Apollo.BaseMutationOptions<FileUploaderGetSignedUrlMutation, FileUploaderGetSignedUrlMutationVariables>;
export const GetTranscriptionMediaObjectByIdDocument = gql`
    query GetTranscriptionMediaObjectById($mediaId: String!) {
  getTranscriptionMediaObjectById(mediaId: $mediaId) {
    awsOutcome {
      jobName
      accountId
      status
      results {
        transcripts {
          transcript
          language
        }
        timeline {
          sentence
          speaker
          start_time
          end_time
        }
      }
    }
  }
}
    `;

/**
 * __useGetTranscriptionMediaObjectByIdQuery__
 *
 * To run a query within a React component, call `useGetTranscriptionMediaObjectByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTranscriptionMediaObjectByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTranscriptionMediaObjectByIdQuery({
 *   variables: {
 *      mediaId: // value for 'mediaId'
 *   },
 * });
 */
export function useGetTranscriptionMediaObjectByIdQuery(baseOptions: Apollo.QueryHookOptions<GetTranscriptionMediaObjectByIdQuery, GetTranscriptionMediaObjectByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTranscriptionMediaObjectByIdQuery, GetTranscriptionMediaObjectByIdQueryVariables>(GetTranscriptionMediaObjectByIdDocument, options);
      }
export function useGetTranscriptionMediaObjectByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTranscriptionMediaObjectByIdQuery, GetTranscriptionMediaObjectByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTranscriptionMediaObjectByIdQuery, GetTranscriptionMediaObjectByIdQueryVariables>(GetTranscriptionMediaObjectByIdDocument, options);
        }
export type GetTranscriptionMediaObjectByIdQueryHookResult = ReturnType<typeof useGetTranscriptionMediaObjectByIdQuery>;
export type GetTranscriptionMediaObjectByIdLazyQueryHookResult = ReturnType<typeof useGetTranscriptionMediaObjectByIdLazyQuery>;
export type GetTranscriptionMediaObjectByIdQueryResult = Apollo.QueryResult<GetTranscriptionMediaObjectByIdQuery, GetTranscriptionMediaObjectByIdQueryVariables>;
export const GetWordCloudMediaObjectByIdDocument = gql`
    query GetWordCloudMediaObjectById($repPromptId: String!) {
  getWordCloudMediaObjectById(repPromptId: $repPromptId) {
    words {
      word
      count
      percentage
    }
    schemaVersion
  }
}
    `;

/**
 * __useGetWordCloudMediaObjectByIdQuery__
 *
 * To run a query within a React component, call `useGetWordCloudMediaObjectByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWordCloudMediaObjectByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWordCloudMediaObjectByIdQuery({
 *   variables: {
 *      repPromptId: // value for 'repPromptId'
 *   },
 * });
 */
export function useGetWordCloudMediaObjectByIdQuery(baseOptions: Apollo.QueryHookOptions<GetWordCloudMediaObjectByIdQuery, GetWordCloudMediaObjectByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWordCloudMediaObjectByIdQuery, GetWordCloudMediaObjectByIdQueryVariables>(GetWordCloudMediaObjectByIdDocument, options);
      }
export function useGetWordCloudMediaObjectByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWordCloudMediaObjectByIdQuery, GetWordCloudMediaObjectByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWordCloudMediaObjectByIdQuery, GetWordCloudMediaObjectByIdQueryVariables>(GetWordCloudMediaObjectByIdDocument, options);
        }
export type GetWordCloudMediaObjectByIdQueryHookResult = ReturnType<typeof useGetWordCloudMediaObjectByIdQuery>;
export type GetWordCloudMediaObjectByIdLazyQueryHookResult = ReturnType<typeof useGetWordCloudMediaObjectByIdLazyQuery>;
export type GetWordCloudMediaObjectByIdQueryResult = Apollo.QueryResult<GetWordCloudMediaObjectByIdQuery, GetWordCloudMediaObjectByIdQueryVariables>;
export const GoogleAuthVerifyDocument = gql`
    mutation GoogleAuthVerify($idToken: String!, $source: AuthenticationSource) {
  googleAuthVerify(token: $idToken, source: $source)
}
    `;
export type GoogleAuthVerifyMutationFn = Apollo.MutationFunction<GoogleAuthVerifyMutation, GoogleAuthVerifyMutationVariables>;

/**
 * __useGoogleAuthVerifyMutation__
 *
 * To run a mutation, you first call `useGoogleAuthVerifyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGoogleAuthVerifyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [googleAuthVerifyMutation, { data, loading, error }] = useGoogleAuthVerifyMutation({
 *   variables: {
 *      idToken: // value for 'idToken'
 *      source: // value for 'source'
 *   },
 * });
 */
export function useGoogleAuthVerifyMutation(baseOptions?: Apollo.MutationHookOptions<GoogleAuthVerifyMutation, GoogleAuthVerifyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GoogleAuthVerifyMutation, GoogleAuthVerifyMutationVariables>(GoogleAuthVerifyDocument, options);
      }
export type GoogleAuthVerifyMutationHookResult = ReturnType<typeof useGoogleAuthVerifyMutation>;
export type GoogleAuthVerifyMutationResult = Apollo.MutationResult<GoogleAuthVerifyMutation>;
export type GoogleAuthVerifyMutationOptions = Apollo.BaseMutationOptions<GoogleAuthVerifyMutation, GoogleAuthVerifyMutationVariables>;
export const IsNewAuthDocument = gql`
    query IsNewAuth($email: String) {
  isNewAuth(email: $email)
}
    `;

/**
 * __useIsNewAuthQuery__
 *
 * To run a query within a React component, call `useIsNewAuthQuery` and pass it any options that fit your needs.
 * When your component renders, `useIsNewAuthQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIsNewAuthQuery({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useIsNewAuthQuery(baseOptions?: Apollo.QueryHookOptions<IsNewAuthQuery, IsNewAuthQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IsNewAuthQuery, IsNewAuthQueryVariables>(IsNewAuthDocument, options);
      }
export function useIsNewAuthLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IsNewAuthQuery, IsNewAuthQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IsNewAuthQuery, IsNewAuthQueryVariables>(IsNewAuthDocument, options);
        }
export type IsNewAuthQueryHookResult = ReturnType<typeof useIsNewAuthQuery>;
export type IsNewAuthLazyQueryHookResult = ReturnType<typeof useIsNewAuthLazyQuery>;
export type IsNewAuthQueryResult = Apollo.QueryResult<IsNewAuthQuery, IsNewAuthQueryVariables>;
export const LearningCardsDeleteSubmitDocument = gql`
    mutation LearningCardsDeleteSubmit($skillId: String!, $ids: [String!]!) {
  learningCardsDelete(skillId: $skillId, ids: $ids)
}
    `;
export type LearningCardsDeleteSubmitMutationFn = Apollo.MutationFunction<LearningCardsDeleteSubmitMutation, LearningCardsDeleteSubmitMutationVariables>;

/**
 * __useLearningCardsDeleteSubmitMutation__
 *
 * To run a mutation, you first call `useLearningCardsDeleteSubmitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLearningCardsDeleteSubmitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [learningCardsDeleteSubmitMutation, { data, loading, error }] = useLearningCardsDeleteSubmitMutation({
 *   variables: {
 *      skillId: // value for 'skillId'
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useLearningCardsDeleteSubmitMutation(baseOptions?: Apollo.MutationHookOptions<LearningCardsDeleteSubmitMutation, LearningCardsDeleteSubmitMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LearningCardsDeleteSubmitMutation, LearningCardsDeleteSubmitMutationVariables>(LearningCardsDeleteSubmitDocument, options);
      }
export type LearningCardsDeleteSubmitMutationHookResult = ReturnType<typeof useLearningCardsDeleteSubmitMutation>;
export type LearningCardsDeleteSubmitMutationResult = Apollo.MutationResult<LearningCardsDeleteSubmitMutation>;
export type LearningCardsDeleteSubmitMutationOptions = Apollo.BaseMutationOptions<LearningCardsDeleteSubmitMutation, LearningCardsDeleteSubmitMutationVariables>;
export const LearningCardsUpsertSubmitDocument = gql`
    mutation LearningCardsUpsertSubmit($skillId: String, $linkouts: [LearningCardLinkoutInput!], $videos: [LearningCardVideoInput!], $flashCards: [LearningCardFlashCardInput!], $files: [LearningCardFileInput!], $form: LearningCardFormInput) {
  learningCardsUpsert(
    skillId: $skillId
    linkouts: $linkouts
    videos: $videos
    flashCards: $flashCards
    files: $files
    form: $form
  ) {
    nodes {
      ...LearningCardFragment
    }
  }
}
    ${LearningCardFragmentDoc}`;
export type LearningCardsUpsertSubmitMutationFn = Apollo.MutationFunction<LearningCardsUpsertSubmitMutation, LearningCardsUpsertSubmitMutationVariables>;

/**
 * __useLearningCardsUpsertSubmitMutation__
 *
 * To run a mutation, you first call `useLearningCardsUpsertSubmitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLearningCardsUpsertSubmitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [learningCardsUpsertSubmitMutation, { data, loading, error }] = useLearningCardsUpsertSubmitMutation({
 *   variables: {
 *      skillId: // value for 'skillId'
 *      linkouts: // value for 'linkouts'
 *      videos: // value for 'videos'
 *      flashCards: // value for 'flashCards'
 *      files: // value for 'files'
 *      form: // value for 'form'
 *   },
 * });
 */
export function useLearningCardsUpsertSubmitMutation(baseOptions?: Apollo.MutationHookOptions<LearningCardsUpsertSubmitMutation, LearningCardsUpsertSubmitMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LearningCardsUpsertSubmitMutation, LearningCardsUpsertSubmitMutationVariables>(LearningCardsUpsertSubmitDocument, options);
      }
export type LearningCardsUpsertSubmitMutationHookResult = ReturnType<typeof useLearningCardsUpsertSubmitMutation>;
export type LearningCardsUpsertSubmitMutationResult = Apollo.MutationResult<LearningCardsUpsertSubmitMutation>;
export type LearningCardsUpsertSubmitMutationOptions = Apollo.BaseMutationOptions<LearningCardsUpsertSubmitMutation, LearningCardsUpsertSubmitMutationVariables>;
export const LearningPlanAddGroupsDocument = gql`
    mutation LearningPlanAddGroups($learningPlanId: UUID!, $groups: [GroupInput!]!) {
  learningPlanAddGroups(learningPlanId: $learningPlanId, groups: $groups) {
    ...LearningPlanFragment
  }
}
    ${LearningPlanFragmentDoc}`;
export type LearningPlanAddGroupsMutationFn = Apollo.MutationFunction<LearningPlanAddGroupsMutation, LearningPlanAddGroupsMutationVariables>;

/**
 * __useLearningPlanAddGroupsMutation__
 *
 * To run a mutation, you first call `useLearningPlanAddGroupsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLearningPlanAddGroupsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [learningPlanAddGroupsMutation, { data, loading, error }] = useLearningPlanAddGroupsMutation({
 *   variables: {
 *      learningPlanId: // value for 'learningPlanId'
 *      groups: // value for 'groups'
 *   },
 * });
 */
export function useLearningPlanAddGroupsMutation(baseOptions?: Apollo.MutationHookOptions<LearningPlanAddGroupsMutation, LearningPlanAddGroupsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LearningPlanAddGroupsMutation, LearningPlanAddGroupsMutationVariables>(LearningPlanAddGroupsDocument, options);
      }
export type LearningPlanAddGroupsMutationHookResult = ReturnType<typeof useLearningPlanAddGroupsMutation>;
export type LearningPlanAddGroupsMutationResult = Apollo.MutationResult<LearningPlanAddGroupsMutation>;
export type LearningPlanAddGroupsMutationOptions = Apollo.BaseMutationOptions<LearningPlanAddGroupsMutation, LearningPlanAddGroupsMutationVariables>;
export const LearningPlanArchiveDocument = gql`
    mutation LearningPlanArchive($learningPlanId: UUID!) {
  learningPlanArchive(learningPlanId: $learningPlanId) {
    ...LearningPlanFragment
  }
}
    ${LearningPlanFragmentDoc}`;
export type LearningPlanArchiveMutationFn = Apollo.MutationFunction<LearningPlanArchiveMutation, LearningPlanArchiveMutationVariables>;

/**
 * __useLearningPlanArchiveMutation__
 *
 * To run a mutation, you first call `useLearningPlanArchiveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLearningPlanArchiveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [learningPlanArchiveMutation, { data, loading, error }] = useLearningPlanArchiveMutation({
 *   variables: {
 *      learningPlanId: // value for 'learningPlanId'
 *   },
 * });
 */
export function useLearningPlanArchiveMutation(baseOptions?: Apollo.MutationHookOptions<LearningPlanArchiveMutation, LearningPlanArchiveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LearningPlanArchiveMutation, LearningPlanArchiveMutationVariables>(LearningPlanArchiveDocument, options);
      }
export type LearningPlanArchiveMutationHookResult = ReturnType<typeof useLearningPlanArchiveMutation>;
export type LearningPlanArchiveMutationResult = Apollo.MutationResult<LearningPlanArchiveMutation>;
export type LearningPlanArchiveMutationOptions = Apollo.BaseMutationOptions<LearningPlanArchiveMutation, LearningPlanArchiveMutationVariables>;
export const LearningPlanAssignToFolderDocument = gql`
    mutation LearningPlanAssignToFolder($learningPlansIds: [UUID!]!, $folderId: UUID) {
  learningPlanAssignToFolder(
    learningPlansIds: $learningPlansIds
    folderId: $folderId
  ) {
    id
    externalId
    name
    sortRank
    skillsCount
    createdAt
    updatedAt
    publishedAt
    archivedAt
    learningPlanFolder {
      id
      name
    }
  }
}
    `;
export type LearningPlanAssignToFolderMutationFn = Apollo.MutationFunction<LearningPlanAssignToFolderMutation, LearningPlanAssignToFolderMutationVariables>;

/**
 * __useLearningPlanAssignToFolderMutation__
 *
 * To run a mutation, you first call `useLearningPlanAssignToFolderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLearningPlanAssignToFolderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [learningPlanAssignToFolderMutation, { data, loading, error }] = useLearningPlanAssignToFolderMutation({
 *   variables: {
 *      learningPlansIds: // value for 'learningPlansIds'
 *      folderId: // value for 'folderId'
 *   },
 * });
 */
export function useLearningPlanAssignToFolderMutation(baseOptions?: Apollo.MutationHookOptions<LearningPlanAssignToFolderMutation, LearningPlanAssignToFolderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LearningPlanAssignToFolderMutation, LearningPlanAssignToFolderMutationVariables>(LearningPlanAssignToFolderDocument, options);
      }
export type LearningPlanAssignToFolderMutationHookResult = ReturnType<typeof useLearningPlanAssignToFolderMutation>;
export type LearningPlanAssignToFolderMutationResult = Apollo.MutationResult<LearningPlanAssignToFolderMutation>;
export type LearningPlanAssignToFolderMutationOptions = Apollo.BaseMutationOptions<LearningPlanAssignToFolderMutation, LearningPlanAssignToFolderMutationVariables>;
export const LearningPlanDeleteGroupsDocument = gql`
    mutation LearningPlanDeleteGroups($learningPlanId: UUID!, $groups: [GroupInput!]!) {
  learningPlanDeleteGroups(learningPlanId: $learningPlanId, groups: $groups) {
    ...LearningPlanFragment
  }
}
    ${LearningPlanFragmentDoc}`;
export type LearningPlanDeleteGroupsMutationFn = Apollo.MutationFunction<LearningPlanDeleteGroupsMutation, LearningPlanDeleteGroupsMutationVariables>;

/**
 * __useLearningPlanDeleteGroupsMutation__
 *
 * To run a mutation, you first call `useLearningPlanDeleteGroupsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLearningPlanDeleteGroupsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [learningPlanDeleteGroupsMutation, { data, loading, error }] = useLearningPlanDeleteGroupsMutation({
 *   variables: {
 *      learningPlanId: // value for 'learningPlanId'
 *      groups: // value for 'groups'
 *   },
 * });
 */
export function useLearningPlanDeleteGroupsMutation(baseOptions?: Apollo.MutationHookOptions<LearningPlanDeleteGroupsMutation, LearningPlanDeleteGroupsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LearningPlanDeleteGroupsMutation, LearningPlanDeleteGroupsMutationVariables>(LearningPlanDeleteGroupsDocument, options);
      }
export type LearningPlanDeleteGroupsMutationHookResult = ReturnType<typeof useLearningPlanDeleteGroupsMutation>;
export type LearningPlanDeleteGroupsMutationResult = Apollo.MutationResult<LearningPlanDeleteGroupsMutation>;
export type LearningPlanDeleteGroupsMutationOptions = Apollo.BaseMutationOptions<LearningPlanDeleteGroupsMutation, LearningPlanDeleteGroupsMutationVariables>;
export const LearningPlanEditDocument = gql`
    query LearningPlanEdit($id: UUID!) {
  learningPlan(id: $id) {
    ...LearningPlanFragment
  }
}
    ${LearningPlanFragmentDoc}`;

/**
 * __useLearningPlanEditQuery__
 *
 * To run a query within a React component, call `useLearningPlanEditQuery` and pass it any options that fit your needs.
 * When your component renders, `useLearningPlanEditQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLearningPlanEditQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useLearningPlanEditQuery(baseOptions: Apollo.QueryHookOptions<LearningPlanEditQuery, LearningPlanEditQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LearningPlanEditQuery, LearningPlanEditQueryVariables>(LearningPlanEditDocument, options);
      }
export function useLearningPlanEditLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LearningPlanEditQuery, LearningPlanEditQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LearningPlanEditQuery, LearningPlanEditQueryVariables>(LearningPlanEditDocument, options);
        }
export type LearningPlanEditQueryHookResult = ReturnType<typeof useLearningPlanEditQuery>;
export type LearningPlanEditLazyQueryHookResult = ReturnType<typeof useLearningPlanEditLazyQuery>;
export type LearningPlanEditQueryResult = Apollo.QueryResult<LearningPlanEditQuery, LearningPlanEditQueryVariables>;
export const LearningPlanEditSubmitDocument = gql`
    mutation LearningPlanEditSubmit($id: UUID!, $externalId: String!, $name: String!, $displayName: String!, $sortRank: Int!, $description: String, $dependencies: [LearningPlanDependencyInput!]!, $additionalInfo: String, $goal: String, $mandatory: Boolean, $startDate: String, $endDateType: CampaignsDateType, $endDate: String, $endDays: Int, $updatedBy: UUID, $learningPlanFolder: LearningPlanFolderInput, $certificateEnabled: Boolean, $certificateName: String) {
  learningPlanEdit(
    id: $id
    externalId: $externalId
    name: $name
    displayName: $displayName
    sortRank: $sortRank
    description: $description
    dependencies: $dependencies
    additionalInfo: $additionalInfo
    goal: $goal
    mandatory: $mandatory
    startDate: $startDate
    endDateType: $endDateType
    endDate: $endDate
    endDays: $endDays
    updatedBy: $updatedBy
    learningPlanFolder: $learningPlanFolder
    certificateEnabled: $certificateEnabled
    certificateName: $certificateName
  ) {
    ...LearningPlanFragment
  }
}
    ${LearningPlanFragmentDoc}`;
export type LearningPlanEditSubmitMutationFn = Apollo.MutationFunction<LearningPlanEditSubmitMutation, LearningPlanEditSubmitMutationVariables>;

/**
 * __useLearningPlanEditSubmitMutation__
 *
 * To run a mutation, you first call `useLearningPlanEditSubmitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLearningPlanEditSubmitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [learningPlanEditSubmitMutation, { data, loading, error }] = useLearningPlanEditSubmitMutation({
 *   variables: {
 *      id: // value for 'id'
 *      externalId: // value for 'externalId'
 *      name: // value for 'name'
 *      displayName: // value for 'displayName'
 *      sortRank: // value for 'sortRank'
 *      description: // value for 'description'
 *      dependencies: // value for 'dependencies'
 *      additionalInfo: // value for 'additionalInfo'
 *      goal: // value for 'goal'
 *      mandatory: // value for 'mandatory'
 *      startDate: // value for 'startDate'
 *      endDateType: // value for 'endDateType'
 *      endDate: // value for 'endDate'
 *      endDays: // value for 'endDays'
 *      updatedBy: // value for 'updatedBy'
 *      learningPlanFolder: // value for 'learningPlanFolder'
 *      certificateEnabled: // value for 'certificateEnabled'
 *      certificateName: // value for 'certificateName'
 *   },
 * });
 */
export function useLearningPlanEditSubmitMutation(baseOptions?: Apollo.MutationHookOptions<LearningPlanEditSubmitMutation, LearningPlanEditSubmitMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LearningPlanEditSubmitMutation, LearningPlanEditSubmitMutationVariables>(LearningPlanEditSubmitDocument, options);
      }
export type LearningPlanEditSubmitMutationHookResult = ReturnType<typeof useLearningPlanEditSubmitMutation>;
export type LearningPlanEditSubmitMutationResult = Apollo.MutationResult<LearningPlanEditSubmitMutation>;
export type LearningPlanEditSubmitMutationOptions = Apollo.BaseMutationOptions<LearningPlanEditSubmitMutation, LearningPlanEditSubmitMutationVariables>;
export const LearningPlanFolderCreateDocument = gql`
    mutation LearningPlanFolderCreate($name: String!, $learningPlansIds: [UUID!]!) {
  learningPlanFolderCreate(name: $name, learningPlansIds: $learningPlansIds) {
    id
    name
  }
}
    `;
export type LearningPlanFolderCreateMutationFn = Apollo.MutationFunction<LearningPlanFolderCreateMutation, LearningPlanFolderCreateMutationVariables>;

/**
 * __useLearningPlanFolderCreateMutation__
 *
 * To run a mutation, you first call `useLearningPlanFolderCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLearningPlanFolderCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [learningPlanFolderCreateMutation, { data, loading, error }] = useLearningPlanFolderCreateMutation({
 *   variables: {
 *      name: // value for 'name'
 *      learningPlansIds: // value for 'learningPlansIds'
 *   },
 * });
 */
export function useLearningPlanFolderCreateMutation(baseOptions?: Apollo.MutationHookOptions<LearningPlanFolderCreateMutation, LearningPlanFolderCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LearningPlanFolderCreateMutation, LearningPlanFolderCreateMutationVariables>(LearningPlanFolderCreateDocument, options);
      }
export type LearningPlanFolderCreateMutationHookResult = ReturnType<typeof useLearningPlanFolderCreateMutation>;
export type LearningPlanFolderCreateMutationResult = Apollo.MutationResult<LearningPlanFolderCreateMutation>;
export type LearningPlanFolderCreateMutationOptions = Apollo.BaseMutationOptions<LearningPlanFolderCreateMutation, LearningPlanFolderCreateMutationVariables>;
export const LearningPlanFoldersListDocument = gql`
    query LearningPlanFoldersList($paginate: BaseClassicPaginate, $sorts: [LearningPlanFolderListOrderBy!], $conditions: LearningPlanFolderListConditions) {
  learningPlanFoldersList(
    paginate: $paginate
    sorts: $sorts
    conditions: $conditions
  ) {
    nodes {
      id
      name
      createdAt
      updatedAt
    }
    totalCount
    pageInfo {
      beforeCursor
      afterCursor
    }
  }
}
    `;

/**
 * __useLearningPlanFoldersListQuery__
 *
 * To run a query within a React component, call `useLearningPlanFoldersListQuery` and pass it any options that fit your needs.
 * When your component renders, `useLearningPlanFoldersListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLearningPlanFoldersListQuery({
 *   variables: {
 *      paginate: // value for 'paginate'
 *      sorts: // value for 'sorts'
 *      conditions: // value for 'conditions'
 *   },
 * });
 */
export function useLearningPlanFoldersListQuery(baseOptions?: Apollo.QueryHookOptions<LearningPlanFoldersListQuery, LearningPlanFoldersListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LearningPlanFoldersListQuery, LearningPlanFoldersListQueryVariables>(LearningPlanFoldersListDocument, options);
      }
export function useLearningPlanFoldersListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LearningPlanFoldersListQuery, LearningPlanFoldersListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LearningPlanFoldersListQuery, LearningPlanFoldersListQueryVariables>(LearningPlanFoldersListDocument, options);
        }
export type LearningPlanFoldersListQueryHookResult = ReturnType<typeof useLearningPlanFoldersListQuery>;
export type LearningPlanFoldersListLazyQueryHookResult = ReturnType<typeof useLearningPlanFoldersListLazyQuery>;
export type LearningPlanFoldersListQueryResult = Apollo.QueryResult<LearningPlanFoldersListQuery, LearningPlanFoldersListQueryVariables>;
export const LearningPlanFolderSearchDocument = gql`
    query LearningPlanFolderSearch($paginate: BaseClassicPaginate, $conditions: LearningPlanFolderSearchCondition) {
  learningPlanFolderSearch(paginate: $paginate, conditions: $conditions) {
    nodes {
      id
      name
    }
  }
}
    `;

/**
 * __useLearningPlanFolderSearchQuery__
 *
 * To run a query within a React component, call `useLearningPlanFolderSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useLearningPlanFolderSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLearningPlanFolderSearchQuery({
 *   variables: {
 *      paginate: // value for 'paginate'
 *      conditions: // value for 'conditions'
 *   },
 * });
 */
export function useLearningPlanFolderSearchQuery(baseOptions?: Apollo.QueryHookOptions<LearningPlanFolderSearchQuery, LearningPlanFolderSearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LearningPlanFolderSearchQuery, LearningPlanFolderSearchQueryVariables>(LearningPlanFolderSearchDocument, options);
      }
export function useLearningPlanFolderSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LearningPlanFolderSearchQuery, LearningPlanFolderSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LearningPlanFolderSearchQuery, LearningPlanFolderSearchQueryVariables>(LearningPlanFolderSearchDocument, options);
        }
export type LearningPlanFolderSearchQueryHookResult = ReturnType<typeof useLearningPlanFolderSearchQuery>;
export type LearningPlanFolderSearchLazyQueryHookResult = ReturnType<typeof useLearningPlanFolderSearchLazyQuery>;
export type LearningPlanFolderSearchQueryResult = Apollo.QueryResult<LearningPlanFolderSearchQuery, LearningPlanFolderSearchQueryVariables>;
export const LearningPlanFromPromptDocument = gql`
    mutation LearningPlanFromPrompt($includeRep: Boolean!, $includeExistRep: Boolean!, $includeQuiz: Boolean!, $complexity: String!, $objective: String!, $prompt: String!, $company: String!) {
  createCampaignFromPrompt(
    includeRep: $includeRep
    includeExistRep: $includeExistRep
    includeQuiz: $includeQuiz
    complexity: $complexity
    objective: $objective
    prompt: $prompt
    company: $company
  ) {
    ...LearningPlanFragment
  }
}
    ${LearningPlanFragmentDoc}`;
export type LearningPlanFromPromptMutationFn = Apollo.MutationFunction<LearningPlanFromPromptMutation, LearningPlanFromPromptMutationVariables>;

/**
 * __useLearningPlanFromPromptMutation__
 *
 * To run a mutation, you first call `useLearningPlanFromPromptMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLearningPlanFromPromptMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [learningPlanFromPromptMutation, { data, loading, error }] = useLearningPlanFromPromptMutation({
 *   variables: {
 *      includeRep: // value for 'includeRep'
 *      includeExistRep: // value for 'includeExistRep'
 *      includeQuiz: // value for 'includeQuiz'
 *      complexity: // value for 'complexity'
 *      objective: // value for 'objective'
 *      prompt: // value for 'prompt'
 *      company: // value for 'company'
 *   },
 * });
 */
export function useLearningPlanFromPromptMutation(baseOptions?: Apollo.MutationHookOptions<LearningPlanFromPromptMutation, LearningPlanFromPromptMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LearningPlanFromPromptMutation, LearningPlanFromPromptMutationVariables>(LearningPlanFromPromptDocument, options);
      }
export type LearningPlanFromPromptMutationHookResult = ReturnType<typeof useLearningPlanFromPromptMutation>;
export type LearningPlanFromPromptMutationResult = Apollo.MutationResult<LearningPlanFromPromptMutation>;
export type LearningPlanFromPromptMutationOptions = Apollo.BaseMutationOptions<LearningPlanFromPromptMutation, LearningPlanFromPromptMutationVariables>;
export const LearningPlanFromPromptCleanupDocument = gql`
    mutation LearningPlanFromPromptCleanup($id: String!) {
  aiCampaignDataCleanup(campaignId: $id) {
    ...LearningPlanFragment
  }
}
    ${LearningPlanFragmentDoc}`;
export type LearningPlanFromPromptCleanupMutationFn = Apollo.MutationFunction<LearningPlanFromPromptCleanupMutation, LearningPlanFromPromptCleanupMutationVariables>;

/**
 * __useLearningPlanFromPromptCleanupMutation__
 *
 * To run a mutation, you first call `useLearningPlanFromPromptCleanupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLearningPlanFromPromptCleanupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [learningPlanFromPromptCleanupMutation, { data, loading, error }] = useLearningPlanFromPromptCleanupMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useLearningPlanFromPromptCleanupMutation(baseOptions?: Apollo.MutationHookOptions<LearningPlanFromPromptCleanupMutation, LearningPlanFromPromptCleanupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LearningPlanFromPromptCleanupMutation, LearningPlanFromPromptCleanupMutationVariables>(LearningPlanFromPromptCleanupDocument, options);
      }
export type LearningPlanFromPromptCleanupMutationHookResult = ReturnType<typeof useLearningPlanFromPromptCleanupMutation>;
export type LearningPlanFromPromptCleanupMutationResult = Apollo.MutationResult<LearningPlanFromPromptCleanupMutation>;
export type LearningPlanFromPromptCleanupMutationOptions = Apollo.BaseMutationOptions<LearningPlanFromPromptCleanupMutation, LearningPlanFromPromptCleanupMutationVariables>;
export const LearningPlanLearnersDocument = gql`
    query LearningPlanLearners($learningPlanId: UUID!, $search: String, $paginate: BaseClassicPaginate, $conditions: LearningPlanLearnersConditions) {
  learningPlanLearners(
    learningPlanId: $learningPlanId
    search: $search
    paginate: $paginate
    conditions: $conditions
  ) {
    totalCount
    nodes {
      ...LearningPlanLearnerFragment
    }
    pageInfo {
      beforeCursor
      afterCursor
    }
  }
}
    ${LearningPlanLearnerFragmentDoc}`;

/**
 * __useLearningPlanLearnersQuery__
 *
 * To run a query within a React component, call `useLearningPlanLearnersQuery` and pass it any options that fit your needs.
 * When your component renders, `useLearningPlanLearnersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLearningPlanLearnersQuery({
 *   variables: {
 *      learningPlanId: // value for 'learningPlanId'
 *      search: // value for 'search'
 *      paginate: // value for 'paginate'
 *      conditions: // value for 'conditions'
 *   },
 * });
 */
export function useLearningPlanLearnersQuery(baseOptions: Apollo.QueryHookOptions<LearningPlanLearnersQuery, LearningPlanLearnersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LearningPlanLearnersQuery, LearningPlanLearnersQueryVariables>(LearningPlanLearnersDocument, options);
      }
export function useLearningPlanLearnersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LearningPlanLearnersQuery, LearningPlanLearnersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LearningPlanLearnersQuery, LearningPlanLearnersQueryVariables>(LearningPlanLearnersDocument, options);
        }
export type LearningPlanLearnersQueryHookResult = ReturnType<typeof useLearningPlanLearnersQuery>;
export type LearningPlanLearnersLazyQueryHookResult = ReturnType<typeof useLearningPlanLearnersLazyQuery>;
export type LearningPlanLearnersQueryResult = Apollo.QueryResult<LearningPlanLearnersQuery, LearningPlanLearnersQueryVariables>;
export const LearningPlanLearnersSyncDocument = gql`
    mutation LearningPlanLearnersSync($learningPlanId: UUID!, $learners: [LearnerInput!]!, $paginate: BaseClassicPaginate, $conditions: LearningPlanLearnersConditions) {
  learningPlanLearnersSync(
    learningPlanId: $learningPlanId
    learners: $learners
    paginate: $paginate
    conditions: $conditions
  ) {
    totalCount
    nodes {
      ...LearningPlanLearnerFragment
    }
    pageInfo {
      beforeCursor
      afterCursor
    }
  }
}
    ${LearningPlanLearnerFragmentDoc}`;
export type LearningPlanLearnersSyncMutationFn = Apollo.MutationFunction<LearningPlanLearnersSyncMutation, LearningPlanLearnersSyncMutationVariables>;

/**
 * __useLearningPlanLearnersSyncMutation__
 *
 * To run a mutation, you first call `useLearningPlanLearnersSyncMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLearningPlanLearnersSyncMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [learningPlanLearnersSyncMutation, { data, loading, error }] = useLearningPlanLearnersSyncMutation({
 *   variables: {
 *      learningPlanId: // value for 'learningPlanId'
 *      learners: // value for 'learners'
 *      paginate: // value for 'paginate'
 *      conditions: // value for 'conditions'
 *   },
 * });
 */
export function useLearningPlanLearnersSyncMutation(baseOptions?: Apollo.MutationHookOptions<LearningPlanLearnersSyncMutation, LearningPlanLearnersSyncMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LearningPlanLearnersSyncMutation, LearningPlanLearnersSyncMutationVariables>(LearningPlanLearnersSyncDocument, options);
      }
export type LearningPlanLearnersSyncMutationHookResult = ReturnType<typeof useLearningPlanLearnersSyncMutation>;
export type LearningPlanLearnersSyncMutationResult = Apollo.MutationResult<LearningPlanLearnersSyncMutation>;
export type LearningPlanLearnersSyncMutationOptions = Apollo.BaseMutationOptions<LearningPlanLearnersSyncMutation, LearningPlanLearnersSyncMutationVariables>;
export const LearningPlanListDocument = gql`
    query LearningPlanList($paginate: BaseClassicPaginate, $sorts: [LearningPlanListOrderBy!], $conditions: LearningPlanListConditions) {
  learningPlans(paginate: $paginate, sorts: $sorts, conditions: $conditions) {
    totalCount
    pageInfo {
      beforeCursor
      afterCursor
    }
    nodes {
      id
      externalId
      name
      sortRank
      skillsCount
      createdAt
      updatedAt
      publishedAt
      archivedAt
      learningPlanFolder {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useLearningPlanListQuery__
 *
 * To run a query within a React component, call `useLearningPlanListQuery` and pass it any options that fit your needs.
 * When your component renders, `useLearningPlanListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLearningPlanListQuery({
 *   variables: {
 *      paginate: // value for 'paginate'
 *      sorts: // value for 'sorts'
 *      conditions: // value for 'conditions'
 *   },
 * });
 */
export function useLearningPlanListQuery(baseOptions?: Apollo.QueryHookOptions<LearningPlanListQuery, LearningPlanListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LearningPlanListQuery, LearningPlanListQueryVariables>(LearningPlanListDocument, options);
      }
export function useLearningPlanListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LearningPlanListQuery, LearningPlanListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LearningPlanListQuery, LearningPlanListQueryVariables>(LearningPlanListDocument, options);
        }
export type LearningPlanListQueryHookResult = ReturnType<typeof useLearningPlanListQuery>;
export type LearningPlanListLazyQueryHookResult = ReturnType<typeof useLearningPlanListLazyQuery>;
export type LearningPlanListQueryResult = Apollo.QueryResult<LearningPlanListQuery, LearningPlanListQueryVariables>;
export const LearningPlanLocalizationsDocument = gql`
    query LearningPlanLocalizations($id: UUID!) {
  learningPlanLocalizations(id: $id) {
    ...LocalizedFieldFragment
  }
}
    ${LocalizedFieldFragmentDoc}`;

/**
 * __useLearningPlanLocalizationsQuery__
 *
 * To run a query within a React component, call `useLearningPlanLocalizationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLearningPlanLocalizationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLearningPlanLocalizationsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useLearningPlanLocalizationsQuery(baseOptions: Apollo.QueryHookOptions<LearningPlanLocalizationsQuery, LearningPlanLocalizationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LearningPlanLocalizationsQuery, LearningPlanLocalizationsQueryVariables>(LearningPlanLocalizationsDocument, options);
      }
export function useLearningPlanLocalizationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LearningPlanLocalizationsQuery, LearningPlanLocalizationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LearningPlanLocalizationsQuery, LearningPlanLocalizationsQueryVariables>(LearningPlanLocalizationsDocument, options);
        }
export type LearningPlanLocalizationsQueryHookResult = ReturnType<typeof useLearningPlanLocalizationsQuery>;
export type LearningPlanLocalizationsLazyQueryHookResult = ReturnType<typeof useLearningPlanLocalizationsLazyQuery>;
export type LearningPlanLocalizationsQueryResult = Apollo.QueryResult<LearningPlanLocalizationsQuery, LearningPlanLocalizationsQueryVariables>;
export const LearningPlanLocalizationsSyncDocument = gql`
    mutation LearningPlanLocalizationsSync($id: UUID!, $entities: [LocalizedEntityInput!]!) {
  learningPlanLocalizationsSync(id: $id, entities: $entities) {
    ...LocalizedFieldFragment
  }
}
    ${LocalizedFieldFragmentDoc}`;
export type LearningPlanLocalizationsSyncMutationFn = Apollo.MutationFunction<LearningPlanLocalizationsSyncMutation, LearningPlanLocalizationsSyncMutationVariables>;

/**
 * __useLearningPlanLocalizationsSyncMutation__
 *
 * To run a mutation, you first call `useLearningPlanLocalizationsSyncMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLearningPlanLocalizationsSyncMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [learningPlanLocalizationsSyncMutation, { data, loading, error }] = useLearningPlanLocalizationsSyncMutation({
 *   variables: {
 *      id: // value for 'id'
 *      entities: // value for 'entities'
 *   },
 * });
 */
export function useLearningPlanLocalizationsSyncMutation(baseOptions?: Apollo.MutationHookOptions<LearningPlanLocalizationsSyncMutation, LearningPlanLocalizationsSyncMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LearningPlanLocalizationsSyncMutation, LearningPlanLocalizationsSyncMutationVariables>(LearningPlanLocalizationsSyncDocument, options);
      }
export type LearningPlanLocalizationsSyncMutationHookResult = ReturnType<typeof useLearningPlanLocalizationsSyncMutation>;
export type LearningPlanLocalizationsSyncMutationResult = Apollo.MutationResult<LearningPlanLocalizationsSyncMutation>;
export type LearningPlanLocalizationsSyncMutationOptions = Apollo.BaseMutationOptions<LearningPlanLocalizationsSyncMutation, LearningPlanLocalizationsSyncMutationVariables>;
export const LearningPlanNewSubmitDocument = gql`
    mutation LearningPlanNewSubmit($externalId: String!, $name: String!, $displayName: String!, $sortRank: Int!, $description: String, $dependencies: [LearningPlanDependencyInput!]!, $additionalInfo: String, $goal: String, $mandatory: Boolean, $startDate: String, $endDateType: CampaignsDateType, $endDate: String, $endDays: Int, $createdBy: UUID, $certificateEnabled: Boolean, $certificateName: String, $learningPlanFolder: LearningPlanFolderInput) {
  learningPlanCreate(
    externalId: $externalId
    name: $name
    displayName: $displayName
    sortRank: $sortRank
    description: $description
    dependencies: $dependencies
    additionalInfo: $additionalInfo
    goal: $goal
    mandatory: $mandatory
    startDate: $startDate
    endDateType: $endDateType
    endDate: $endDate
    endDays: $endDays
    createdBy: $createdBy
    learningPlanFolder: $learningPlanFolder
    certificateEnabled: $certificateEnabled
    certificateName: $certificateName
  ) {
    ...LearningPlanFragment
  }
}
    ${LearningPlanFragmentDoc}`;
export type LearningPlanNewSubmitMutationFn = Apollo.MutationFunction<LearningPlanNewSubmitMutation, LearningPlanNewSubmitMutationVariables>;

/**
 * __useLearningPlanNewSubmitMutation__
 *
 * To run a mutation, you first call `useLearningPlanNewSubmitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLearningPlanNewSubmitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [learningPlanNewSubmitMutation, { data, loading, error }] = useLearningPlanNewSubmitMutation({
 *   variables: {
 *      externalId: // value for 'externalId'
 *      name: // value for 'name'
 *      displayName: // value for 'displayName'
 *      sortRank: // value for 'sortRank'
 *      description: // value for 'description'
 *      dependencies: // value for 'dependencies'
 *      additionalInfo: // value for 'additionalInfo'
 *      goal: // value for 'goal'
 *      mandatory: // value for 'mandatory'
 *      startDate: // value for 'startDate'
 *      endDateType: // value for 'endDateType'
 *      endDate: // value for 'endDate'
 *      endDays: // value for 'endDays'
 *      createdBy: // value for 'createdBy'
 *      certificateEnabled: // value for 'certificateEnabled'
 *      certificateName: // value for 'certificateName'
 *      learningPlanFolder: // value for 'learningPlanFolder'
 *   },
 * });
 */
export function useLearningPlanNewSubmitMutation(baseOptions?: Apollo.MutationHookOptions<LearningPlanNewSubmitMutation, LearningPlanNewSubmitMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LearningPlanNewSubmitMutation, LearningPlanNewSubmitMutationVariables>(LearningPlanNewSubmitDocument, options);
      }
export type LearningPlanNewSubmitMutationHookResult = ReturnType<typeof useLearningPlanNewSubmitMutation>;
export type LearningPlanNewSubmitMutationResult = Apollo.MutationResult<LearningPlanNewSubmitMutation>;
export type LearningPlanNewSubmitMutationOptions = Apollo.BaseMutationOptions<LearningPlanNewSubmitMutation, LearningPlanNewSubmitMutationVariables>;
export const LearningPlanPublishDocument = gql`
    mutation LearningPlanPublish($id: UUID!) {
  learningPlanPublish(id: $id) {
    ...LearningPlanFragment
  }
}
    ${LearningPlanFragmentDoc}`;
export type LearningPlanPublishMutationFn = Apollo.MutationFunction<LearningPlanPublishMutation, LearningPlanPublishMutationVariables>;

/**
 * __useLearningPlanPublishMutation__
 *
 * To run a mutation, you first call `useLearningPlanPublishMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLearningPlanPublishMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [learningPlanPublishMutation, { data, loading, error }] = useLearningPlanPublishMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useLearningPlanPublishMutation(baseOptions?: Apollo.MutationHookOptions<LearningPlanPublishMutation, LearningPlanPublishMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LearningPlanPublishMutation, LearningPlanPublishMutationVariables>(LearningPlanPublishDocument, options);
      }
export type LearningPlanPublishMutationHookResult = ReturnType<typeof useLearningPlanPublishMutation>;
export type LearningPlanPublishMutationResult = Apollo.MutationResult<LearningPlanPublishMutation>;
export type LearningPlanPublishMutationOptions = Apollo.BaseMutationOptions<LearningPlanPublishMutation, LearningPlanPublishMutationVariables>;
export const LearningPlanSearchDocument = gql`
    query LearningPlanSearch($paginate: BaseClassicPaginate, $conditions: LearningPlanSearchConditions) {
  learningPlanSearch(paginate: $paginate, conditions: $conditions) {
    totalCount
    pageInfo {
      beforeCursor
      afterCursor
    }
    nodes {
      id
      name
      externalId
    }
  }
}
    `;

/**
 * __useLearningPlanSearchQuery__
 *
 * To run a query within a React component, call `useLearningPlanSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useLearningPlanSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLearningPlanSearchQuery({
 *   variables: {
 *      paginate: // value for 'paginate'
 *      conditions: // value for 'conditions'
 *   },
 * });
 */
export function useLearningPlanSearchQuery(baseOptions?: Apollo.QueryHookOptions<LearningPlanSearchQuery, LearningPlanSearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LearningPlanSearchQuery, LearningPlanSearchQueryVariables>(LearningPlanSearchDocument, options);
      }
export function useLearningPlanSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LearningPlanSearchQuery, LearningPlanSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LearningPlanSearchQuery, LearningPlanSearchQueryVariables>(LearningPlanSearchDocument, options);
        }
export type LearningPlanSearchQueryHookResult = ReturnType<typeof useLearningPlanSearchQuery>;
export type LearningPlanSearchLazyQueryHookResult = ReturnType<typeof useLearningPlanSearchLazyQuery>;
export type LearningPlanSearchQueryResult = Apollo.QueryResult<LearningPlanSearchQuery, LearningPlanSearchQueryVariables>;
export const LearningPlanSkillsDocument = gql`
    query LearningPlanSkills($learningPlanId: UUID!) {
  learningPlanSkills(learningPlanId: $learningPlanId) {
    ...LPSectionSkillFragment
  }
}
    ${LpSectionSkillFragmentDoc}`;

/**
 * __useLearningPlanSkillsQuery__
 *
 * To run a query within a React component, call `useLearningPlanSkillsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLearningPlanSkillsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLearningPlanSkillsQuery({
 *   variables: {
 *      learningPlanId: // value for 'learningPlanId'
 *   },
 * });
 */
export function useLearningPlanSkillsQuery(baseOptions: Apollo.QueryHookOptions<LearningPlanSkillsQuery, LearningPlanSkillsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LearningPlanSkillsQuery, LearningPlanSkillsQueryVariables>(LearningPlanSkillsDocument, options);
      }
export function useLearningPlanSkillsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LearningPlanSkillsQuery, LearningPlanSkillsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LearningPlanSkillsQuery, LearningPlanSkillsQueryVariables>(LearningPlanSkillsDocument, options);
        }
export type LearningPlanSkillsQueryHookResult = ReturnType<typeof useLearningPlanSkillsQuery>;
export type LearningPlanSkillsLazyQueryHookResult = ReturnType<typeof useLearningPlanSkillsLazyQuery>;
export type LearningPlanSkillsQueryResult = Apollo.QueryResult<LearningPlanSkillsQuery, LearningPlanSkillsQueryVariables>;
export const LearningPlanSkillsSyncDocument = gql`
    mutation LearningPlanSkillsSync($learningPlanId: UUID!, $lpSectionSkills: [LPSectionSkillInput!]!, $unlocked: Boolean!) {
  learningPlanSkillsSync(
    learningPlanId: $learningPlanId
    lpSectionSkills: $lpSectionSkills
    unlocked: $unlocked
  ) {
    lpSectionSkills {
      ...LPSectionSkillFragment
    }
    isOrderDisabled
  }
}
    ${LpSectionSkillFragmentDoc}`;
export type LearningPlanSkillsSyncMutationFn = Apollo.MutationFunction<LearningPlanSkillsSyncMutation, LearningPlanSkillsSyncMutationVariables>;

/**
 * __useLearningPlanSkillsSyncMutation__
 *
 * To run a mutation, you first call `useLearningPlanSkillsSyncMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLearningPlanSkillsSyncMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [learningPlanSkillsSyncMutation, { data, loading, error }] = useLearningPlanSkillsSyncMutation({
 *   variables: {
 *      learningPlanId: // value for 'learningPlanId'
 *      lpSectionSkills: // value for 'lpSectionSkills'
 *      unlocked: // value for 'unlocked'
 *   },
 * });
 */
export function useLearningPlanSkillsSyncMutation(baseOptions?: Apollo.MutationHookOptions<LearningPlanSkillsSyncMutation, LearningPlanSkillsSyncMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LearningPlanSkillsSyncMutation, LearningPlanSkillsSyncMutationVariables>(LearningPlanSkillsSyncDocument, options);
      }
export type LearningPlanSkillsSyncMutationHookResult = ReturnType<typeof useLearningPlanSkillsSyncMutation>;
export type LearningPlanSkillsSyncMutationResult = Apollo.MutationResult<LearningPlanSkillsSyncMutation>;
export type LearningPlanSkillsSyncMutationOptions = Apollo.BaseMutationOptions<LearningPlanSkillsSyncMutation, LearningPlanSkillsSyncMutationVariables>;
export const LearningPlansAssociatedWithSkillDocument = gql`
    query LearningPlansAssociatedWithSkill($skillId: UUID!) {
  learningPlansAssociatedWithSkill(skillId: $skillId) {
    id
    name
  }
}
    `;

/**
 * __useLearningPlansAssociatedWithSkillQuery__
 *
 * To run a query within a React component, call `useLearningPlansAssociatedWithSkillQuery` and pass it any options that fit your needs.
 * When your component renders, `useLearningPlansAssociatedWithSkillQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLearningPlansAssociatedWithSkillQuery({
 *   variables: {
 *      skillId: // value for 'skillId'
 *   },
 * });
 */
export function useLearningPlansAssociatedWithSkillQuery(baseOptions: Apollo.QueryHookOptions<LearningPlansAssociatedWithSkillQuery, LearningPlansAssociatedWithSkillQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LearningPlansAssociatedWithSkillQuery, LearningPlansAssociatedWithSkillQueryVariables>(LearningPlansAssociatedWithSkillDocument, options);
      }
export function useLearningPlansAssociatedWithSkillLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LearningPlansAssociatedWithSkillQuery, LearningPlansAssociatedWithSkillQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LearningPlansAssociatedWithSkillQuery, LearningPlansAssociatedWithSkillQueryVariables>(LearningPlansAssociatedWithSkillDocument, options);
        }
export type LearningPlansAssociatedWithSkillQueryHookResult = ReturnType<typeof useLearningPlansAssociatedWithSkillQuery>;
export type LearningPlansAssociatedWithSkillLazyQueryHookResult = ReturnType<typeof useLearningPlansAssociatedWithSkillLazyQuery>;
export type LearningPlansAssociatedWithSkillQueryResult = Apollo.QueryResult<LearningPlansAssociatedWithSkillQuery, LearningPlansAssociatedWithSkillQueryVariables>;
export const MeDocument = gql`
    query Me($appName: String, $appVersion: String, $browserName: String, $browserVersion: String, $osName: String, $osVersion: String, $platform: String, $platformType: String, $platformVendor: String, $platformModel: String) {
  me {
    id
    displayName
    photoUrl
    isSuperAdmin
    createdAt
    updatedAt
    companyProfiles {
      id
      externalId
      emailAddress
      phoneNumber
      language
      score
      company {
        id
        name
        externalId
      }
      roles
      permissions
    }
    flags(
      appName: $appName
      appVersion: $appVersion
      browserName: $browserName
      browserVersion: $browserVersion
      osName: $osName
      osVersion: $osVersion
      platform: $platform
      platformType: $platformType
      platformVendor: $platformVendor
      platformModel: $platformModel
    ) {
      name
      value
    }
  }
}
    `;

/**
 * __useMeQuery__
 *
 * To run a query within a React component, call `useMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMeQuery({
 *   variables: {
 *      appName: // value for 'appName'
 *      appVersion: // value for 'appVersion'
 *      browserName: // value for 'browserName'
 *      browserVersion: // value for 'browserVersion'
 *      osName: // value for 'osName'
 *      osVersion: // value for 'osVersion'
 *      platform: // value for 'platform'
 *      platformType: // value for 'platformType'
 *      platformVendor: // value for 'platformVendor'
 *      platformModel: // value for 'platformModel'
 *   },
 * });
 */
export function useMeQuery(baseOptions?: Apollo.QueryHookOptions<MeQuery, MeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MeQuery, MeQueryVariables>(MeDocument, options);
      }
export function useMeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MeQuery, MeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MeQuery, MeQueryVariables>(MeDocument, options);
        }
export type MeQueryHookResult = ReturnType<typeof useMeQuery>;
export type MeLazyQueryHookResult = ReturnType<typeof useMeLazyQuery>;
export type MeQueryResult = Apollo.QueryResult<MeQuery, MeQueryVariables>;
export const MediaNewSubmitDocument = gql`
    mutation MediaNewSubmit($path: String!, $mimeType: String!, $mediaType: MediaType!) {
  mediaCreate(path: $path, mimeType: $mimeType, mediaType: $mediaType) {
    ...MediaFragment
  }
}
    ${MediaFragmentDoc}`;
export type MediaNewSubmitMutationFn = Apollo.MutationFunction<MediaNewSubmitMutation, MediaNewSubmitMutationVariables>;

/**
 * __useMediaNewSubmitMutation__
 *
 * To run a mutation, you first call `useMediaNewSubmitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMediaNewSubmitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mediaNewSubmitMutation, { data, loading, error }] = useMediaNewSubmitMutation({
 *   variables: {
 *      path: // value for 'path'
 *      mimeType: // value for 'mimeType'
 *      mediaType: // value for 'mediaType'
 *   },
 * });
 */
export function useMediaNewSubmitMutation(baseOptions?: Apollo.MutationHookOptions<MediaNewSubmitMutation, MediaNewSubmitMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MediaNewSubmitMutation, MediaNewSubmitMutationVariables>(MediaNewSubmitDocument, options);
      }
export type MediaNewSubmitMutationHookResult = ReturnType<typeof useMediaNewSubmitMutation>;
export type MediaNewSubmitMutationResult = Apollo.MutationResult<MediaNewSubmitMutation>;
export type MediaNewSubmitMutationOptions = Apollo.BaseMutationOptions<MediaNewSubmitMutation, MediaNewSubmitMutationVariables>;
export const ProfileEditDocument = gql`
    query ProfileEdit($id: String!) {
  profile(id: $id) {
    ...ProfileFragment
  }
}
    ${ProfileFragmentDoc}`;

/**
 * __useProfileEditQuery__
 *
 * To run a query within a React component, call `useProfileEditQuery` and pass it any options that fit your needs.
 * When your component renders, `useProfileEditQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProfileEditQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useProfileEditQuery(baseOptions: Apollo.QueryHookOptions<ProfileEditQuery, ProfileEditQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProfileEditQuery, ProfileEditQueryVariables>(ProfileEditDocument, options);
      }
export function useProfileEditLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProfileEditQuery, ProfileEditQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProfileEditQuery, ProfileEditQueryVariables>(ProfileEditDocument, options);
        }
export type ProfileEditQueryHookResult = ReturnType<typeof useProfileEditQuery>;
export type ProfileEditLazyQueryHookResult = ReturnType<typeof useProfileEditLazyQuery>;
export type ProfileEditQueryResult = Apollo.QueryResult<ProfileEditQuery, ProfileEditQueryVariables>;
export const ProfileEditSubmitDocument = gql`
    mutation ProfileEditSubmit($id: UUID!, $displayName: String, $photoUrl: String, $externalId: String!, $language: String, $phoneNumber: String, $emailAddress: String, $active: Boolean, $roles: [Role!]!, $preferredName: String, $timezone: Timezone, $startDate: String!, $learnerCommsOptOut: Boolean!, $coachCommsOptOut: Boolean, $excludeFromAnalytics: Boolean!, $regions: [RegionInput!], $departments: [DepartmentInput!], $mergeAcceptance: Boolean) {
  profileEdit(
    id: $id
    displayName: $displayName
    photoUrl: $photoUrl
    externalId: $externalId
    language: $language
    phoneNumber: $phoneNumber
    emailAddress: $emailAddress
    active: $active
    roles: $roles
    preferredName: $preferredName
    timezone: $timezone
    startDate: $startDate
    learnerCommsOptOut: $learnerCommsOptOut
    coachCommsOptOut: $coachCommsOptOut
    excludeFromAnalytics: $excludeFromAnalytics
    regions: $regions
    departments: $departments
    mergeAcceptance: $mergeAcceptance
  ) {
    ...ProfileFragment
  }
}
    ${ProfileFragmentDoc}`;
export type ProfileEditSubmitMutationFn = Apollo.MutationFunction<ProfileEditSubmitMutation, ProfileEditSubmitMutationVariables>;

/**
 * __useProfileEditSubmitMutation__
 *
 * To run a mutation, you first call `useProfileEditSubmitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProfileEditSubmitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [profileEditSubmitMutation, { data, loading, error }] = useProfileEditSubmitMutation({
 *   variables: {
 *      id: // value for 'id'
 *      displayName: // value for 'displayName'
 *      photoUrl: // value for 'photoUrl'
 *      externalId: // value for 'externalId'
 *      language: // value for 'language'
 *      phoneNumber: // value for 'phoneNumber'
 *      emailAddress: // value for 'emailAddress'
 *      active: // value for 'active'
 *      roles: // value for 'roles'
 *      preferredName: // value for 'preferredName'
 *      timezone: // value for 'timezone'
 *      startDate: // value for 'startDate'
 *      learnerCommsOptOut: // value for 'learnerCommsOptOut'
 *      coachCommsOptOut: // value for 'coachCommsOptOut'
 *      excludeFromAnalytics: // value for 'excludeFromAnalytics'
 *      regions: // value for 'regions'
 *      departments: // value for 'departments'
 *      mergeAcceptance: // value for 'mergeAcceptance'
 *   },
 * });
 */
export function useProfileEditSubmitMutation(baseOptions?: Apollo.MutationHookOptions<ProfileEditSubmitMutation, ProfileEditSubmitMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProfileEditSubmitMutation, ProfileEditSubmitMutationVariables>(ProfileEditSubmitDocument, options);
      }
export type ProfileEditSubmitMutationHookResult = ReturnType<typeof useProfileEditSubmitMutation>;
export type ProfileEditSubmitMutationResult = Apollo.MutationResult<ProfileEditSubmitMutation>;
export type ProfileEditSubmitMutationOptions = Apollo.BaseMutationOptions<ProfileEditSubmitMutation, ProfileEditSubmitMutationVariables>;
export const ProfileGroupArchiveDocument = gql`
    mutation ProfileGroupArchive($id: UUID!) {
  profileGroupArchive(id: $id) {
    ...ProfileGroupFragment
  }
}
    ${ProfileGroupFragmentDoc}`;
export type ProfileGroupArchiveMutationFn = Apollo.MutationFunction<ProfileGroupArchiveMutation, ProfileGroupArchiveMutationVariables>;

/**
 * __useProfileGroupArchiveMutation__
 *
 * To run a mutation, you first call `useProfileGroupArchiveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProfileGroupArchiveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [profileGroupArchiveMutation, { data, loading, error }] = useProfileGroupArchiveMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useProfileGroupArchiveMutation(baseOptions?: Apollo.MutationHookOptions<ProfileGroupArchiveMutation, ProfileGroupArchiveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProfileGroupArchiveMutation, ProfileGroupArchiveMutationVariables>(ProfileGroupArchiveDocument, options);
      }
export type ProfileGroupArchiveMutationHookResult = ReturnType<typeof useProfileGroupArchiveMutation>;
export type ProfileGroupArchiveMutationResult = Apollo.MutationResult<ProfileGroupArchiveMutation>;
export type ProfileGroupArchiveMutationOptions = Apollo.BaseMutationOptions<ProfileGroupArchiveMutation, ProfileGroupArchiveMutationVariables>;
export const ProfileGroupCohortMembersDocument = gql`
    query ProfileGroupCohortMembers($id: String!, $paginate: BaseClassicPaginate) {
  profileGroup(id: $id) {
    companyCohortMembers(paginate: $paginate) {
      nodes {
        ...ProfileGroupMemberFragment
      }
      pageInfo {
        afterCursor
        beforeCursor
      }
      totalCount
    }
  }
}
    ${ProfileGroupMemberFragmentDoc}`;

/**
 * __useProfileGroupCohortMembersQuery__
 *
 * To run a query within a React component, call `useProfileGroupCohortMembersQuery` and pass it any options that fit your needs.
 * When your component renders, `useProfileGroupCohortMembersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProfileGroupCohortMembersQuery({
 *   variables: {
 *      id: // value for 'id'
 *      paginate: // value for 'paginate'
 *   },
 * });
 */
export function useProfileGroupCohortMembersQuery(baseOptions: Apollo.QueryHookOptions<ProfileGroupCohortMembersQuery, ProfileGroupCohortMembersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProfileGroupCohortMembersQuery, ProfileGroupCohortMembersQueryVariables>(ProfileGroupCohortMembersDocument, options);
      }
export function useProfileGroupCohortMembersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProfileGroupCohortMembersQuery, ProfileGroupCohortMembersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProfileGroupCohortMembersQuery, ProfileGroupCohortMembersQueryVariables>(ProfileGroupCohortMembersDocument, options);
        }
export type ProfileGroupCohortMembersQueryHookResult = ReturnType<typeof useProfileGroupCohortMembersQuery>;
export type ProfileGroupCohortMembersLazyQueryHookResult = ReturnType<typeof useProfileGroupCohortMembersLazyQuery>;
export type ProfileGroupCohortMembersQueryResult = Apollo.QueryResult<ProfileGroupCohortMembersQuery, ProfileGroupCohortMembersQueryVariables>;
export const ProfileGroupEditDocument = gql`
    query ProfileGroupEdit($id: String!) {
  profileGroup(id: $id) {
    ...ProfileGroupFragment
  }
}
    ${ProfileGroupFragmentDoc}`;

/**
 * __useProfileGroupEditQuery__
 *
 * To run a query within a React component, call `useProfileGroupEditQuery` and pass it any options that fit your needs.
 * When your component renders, `useProfileGroupEditQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProfileGroupEditQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useProfileGroupEditQuery(baseOptions: Apollo.QueryHookOptions<ProfileGroupEditQuery, ProfileGroupEditQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProfileGroupEditQuery, ProfileGroupEditQueryVariables>(ProfileGroupEditDocument, options);
      }
export function useProfileGroupEditLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProfileGroupEditQuery, ProfileGroupEditQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProfileGroupEditQuery, ProfileGroupEditQueryVariables>(ProfileGroupEditDocument, options);
        }
export type ProfileGroupEditQueryHookResult = ReturnType<typeof useProfileGroupEditQuery>;
export type ProfileGroupEditLazyQueryHookResult = ReturnType<typeof useProfileGroupEditLazyQuery>;
export type ProfileGroupEditQueryResult = Apollo.QueryResult<ProfileGroupEditQuery, ProfileGroupEditQueryVariables>;
export const ProfileGroupEditSubmitDocument = gql`
    mutation ProfileGroupEditSubmit($id: UUID!, $name: String!, $description: String!, $learningPlans: [UUID!]) {
  profileGroupEdit(
    id: $id
    name: $name
    description: $description
    learningPlans: $learningPlans
  ) {
    ...ProfileGroupFragment
  }
}
    ${ProfileGroupFragmentDoc}`;
export type ProfileGroupEditSubmitMutationFn = Apollo.MutationFunction<ProfileGroupEditSubmitMutation, ProfileGroupEditSubmitMutationVariables>;

/**
 * __useProfileGroupEditSubmitMutation__
 *
 * To run a mutation, you first call `useProfileGroupEditSubmitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProfileGroupEditSubmitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [profileGroupEditSubmitMutation, { data, loading, error }] = useProfileGroupEditSubmitMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      learningPlans: // value for 'learningPlans'
 *   },
 * });
 */
export function useProfileGroupEditSubmitMutation(baseOptions?: Apollo.MutationHookOptions<ProfileGroupEditSubmitMutation, ProfileGroupEditSubmitMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProfileGroupEditSubmitMutation, ProfileGroupEditSubmitMutationVariables>(ProfileGroupEditSubmitDocument, options);
      }
export type ProfileGroupEditSubmitMutationHookResult = ReturnType<typeof useProfileGroupEditSubmitMutation>;
export type ProfileGroupEditSubmitMutationResult = Apollo.MutationResult<ProfileGroupEditSubmitMutation>;
export type ProfileGroupEditSubmitMutationOptions = Apollo.BaseMutationOptions<ProfileGroupEditSubmitMutation, ProfileGroupEditSubmitMutationVariables>;
export const ProfileGroupListDocument = gql`
    query ProfileGroupList($paginate: BaseClassicPaginate, $sorts: [ProfileGroupListOrderBy!], $conditions: ProfileGroupListConditions) {
  profileGroupList(paginate: $paginate, sorts: $sorts, conditions: $conditions) {
    totalCount
    pageInfo {
      beforeCursor
      afterCursor
    }
    nodes {
      id
      name
      description
      coachCount
      learnerCount
      creatorProfile {
        id
        displayName
      }
      createdAt
      updatedAt
      deletedAt
    }
  }
}
    `;

/**
 * __useProfileGroupListQuery__
 *
 * To run a query within a React component, call `useProfileGroupListQuery` and pass it any options that fit your needs.
 * When your component renders, `useProfileGroupListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProfileGroupListQuery({
 *   variables: {
 *      paginate: // value for 'paginate'
 *      sorts: // value for 'sorts'
 *      conditions: // value for 'conditions'
 *   },
 * });
 */
export function useProfileGroupListQuery(baseOptions?: Apollo.QueryHookOptions<ProfileGroupListQuery, ProfileGroupListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProfileGroupListQuery, ProfileGroupListQueryVariables>(ProfileGroupListDocument, options);
      }
export function useProfileGroupListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProfileGroupListQuery, ProfileGroupListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProfileGroupListQuery, ProfileGroupListQueryVariables>(ProfileGroupListDocument, options);
        }
export type ProfileGroupListQueryHookResult = ReturnType<typeof useProfileGroupListQuery>;
export type ProfileGroupListLazyQueryHookResult = ReturnType<typeof useProfileGroupListLazyQuery>;
export type ProfileGroupListQueryResult = Apollo.QueryResult<ProfileGroupListQuery, ProfileGroupListQueryVariables>;
export const ProfileGroupListofProfileDocument = gql`
    query ProfileGroupListofProfile($companyProfileId: String!) {
  profileGroupListofProfile(companyProfileId: $companyProfileId) {
    id
    companyCohort {
      name
      id
    }
    type
  }
}
    `;

/**
 * __useProfileGroupListofProfileQuery__
 *
 * To run a query within a React component, call `useProfileGroupListofProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useProfileGroupListofProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProfileGroupListofProfileQuery({
 *   variables: {
 *      companyProfileId: // value for 'companyProfileId'
 *   },
 * });
 */
export function useProfileGroupListofProfileQuery(baseOptions: Apollo.QueryHookOptions<ProfileGroupListofProfileQuery, ProfileGroupListofProfileQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProfileGroupListofProfileQuery, ProfileGroupListofProfileQueryVariables>(ProfileGroupListofProfileDocument, options);
      }
export function useProfileGroupListofProfileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProfileGroupListofProfileQuery, ProfileGroupListofProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProfileGroupListofProfileQuery, ProfileGroupListofProfileQueryVariables>(ProfileGroupListofProfileDocument, options);
        }
export type ProfileGroupListofProfileQueryHookResult = ReturnType<typeof useProfileGroupListofProfileQuery>;
export type ProfileGroupListofProfileLazyQueryHookResult = ReturnType<typeof useProfileGroupListofProfileLazyQuery>;
export type ProfileGroupListofProfileQueryResult = Apollo.QueryResult<ProfileGroupListofProfileQuery, ProfileGroupListofProfileQueryVariables>;
export const ProfileGroupMemberDeleteDocument = gql`
    mutation ProfileGroupMemberDelete($id: UUID!) {
  profileGroupMemberDelete(id: $id) {
    ...ProfileGroupMemberFragment
  }
}
    ${ProfileGroupMemberFragmentDoc}`;
export type ProfileGroupMemberDeleteMutationFn = Apollo.MutationFunction<ProfileGroupMemberDeleteMutation, ProfileGroupMemberDeleteMutationVariables>;

/**
 * __useProfileGroupMemberDeleteMutation__
 *
 * To run a mutation, you first call `useProfileGroupMemberDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProfileGroupMemberDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [profileGroupMemberDeleteMutation, { data, loading, error }] = useProfileGroupMemberDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useProfileGroupMemberDeleteMutation(baseOptions?: Apollo.MutationHookOptions<ProfileGroupMemberDeleteMutation, ProfileGroupMemberDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProfileGroupMemberDeleteMutation, ProfileGroupMemberDeleteMutationVariables>(ProfileGroupMemberDeleteDocument, options);
      }
export type ProfileGroupMemberDeleteMutationHookResult = ReturnType<typeof useProfileGroupMemberDeleteMutation>;
export type ProfileGroupMemberDeleteMutationResult = Apollo.MutationResult<ProfileGroupMemberDeleteMutation>;
export type ProfileGroupMemberDeleteMutationOptions = Apollo.BaseMutationOptions<ProfileGroupMemberDeleteMutation, ProfileGroupMemberDeleteMutationVariables>;
export const ProfileGroupMemberEditSubmitDocument = gql`
    mutation ProfileGroupMemberEditSubmit($id: UUID!, $type: ProfileGroupMemberType!, $companyProfileId: UUID!, $profileGroupId: UUID) {
  profileGroupMemberEdit(
    id: $id
    type: $type
    companyProfileId: $companyProfileId
    profileGroupId: $profileGroupId
  ) {
    ...ProfileGroupMemberFragment
  }
}
    ${ProfileGroupMemberFragmentDoc}`;
export type ProfileGroupMemberEditSubmitMutationFn = Apollo.MutationFunction<ProfileGroupMemberEditSubmitMutation, ProfileGroupMemberEditSubmitMutationVariables>;

/**
 * __useProfileGroupMemberEditSubmitMutation__
 *
 * To run a mutation, you first call `useProfileGroupMemberEditSubmitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProfileGroupMemberEditSubmitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [profileGroupMemberEditSubmitMutation, { data, loading, error }] = useProfileGroupMemberEditSubmitMutation({
 *   variables: {
 *      id: // value for 'id'
 *      type: // value for 'type'
 *      companyProfileId: // value for 'companyProfileId'
 *      profileGroupId: // value for 'profileGroupId'
 *   },
 * });
 */
export function useProfileGroupMemberEditSubmitMutation(baseOptions?: Apollo.MutationHookOptions<ProfileGroupMemberEditSubmitMutation, ProfileGroupMemberEditSubmitMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProfileGroupMemberEditSubmitMutation, ProfileGroupMemberEditSubmitMutationVariables>(ProfileGroupMemberEditSubmitDocument, options);
      }
export type ProfileGroupMemberEditSubmitMutationHookResult = ReturnType<typeof useProfileGroupMemberEditSubmitMutation>;
export type ProfileGroupMemberEditSubmitMutationResult = Apollo.MutationResult<ProfileGroupMemberEditSubmitMutation>;
export type ProfileGroupMemberEditSubmitMutationOptions = Apollo.BaseMutationOptions<ProfileGroupMemberEditSubmitMutation, ProfileGroupMemberEditSubmitMutationVariables>;
export const ProfileGroupMemberNewSubmitDocument = gql`
    mutation ProfileGroupMemberNewSubmit($type: ProfileGroupMemberType!, $companyProfileId: UUID!, $profileGroupId: UUID!) {
  profileGroupMemberCreate(
    type: $type
    companyProfileId: $companyProfileId
    profileGroupId: $profileGroupId
  ) {
    ...ProfileGroupMemberFragment
  }
}
    ${ProfileGroupMemberFragmentDoc}`;
export type ProfileGroupMemberNewSubmitMutationFn = Apollo.MutationFunction<ProfileGroupMemberNewSubmitMutation, ProfileGroupMemberNewSubmitMutationVariables>;

/**
 * __useProfileGroupMemberNewSubmitMutation__
 *
 * To run a mutation, you first call `useProfileGroupMemberNewSubmitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProfileGroupMemberNewSubmitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [profileGroupMemberNewSubmitMutation, { data, loading, error }] = useProfileGroupMemberNewSubmitMutation({
 *   variables: {
 *      type: // value for 'type'
 *      companyProfileId: // value for 'companyProfileId'
 *      profileGroupId: // value for 'profileGroupId'
 *   },
 * });
 */
export function useProfileGroupMemberNewSubmitMutation(baseOptions?: Apollo.MutationHookOptions<ProfileGroupMemberNewSubmitMutation, ProfileGroupMemberNewSubmitMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProfileGroupMemberNewSubmitMutation, ProfileGroupMemberNewSubmitMutationVariables>(ProfileGroupMemberNewSubmitDocument, options);
      }
export type ProfileGroupMemberNewSubmitMutationHookResult = ReturnType<typeof useProfileGroupMemberNewSubmitMutation>;
export type ProfileGroupMemberNewSubmitMutationResult = Apollo.MutationResult<ProfileGroupMemberNewSubmitMutation>;
export type ProfileGroupMemberNewSubmitMutationOptions = Apollo.BaseMutationOptions<ProfileGroupMemberNewSubmitMutation, ProfileGroupMemberNewSubmitMutationVariables>;
export const ProfileGroupNewSubmitDocument = gql`
    mutation ProfileGroupNewSubmit($name: String!, $description: String!, $learningPlans: [UUID!]) {
  profileGroupCreate(
    name: $name
    description: $description
    learningPlans: $learningPlans
  ) {
    ...ProfileGroupFragment
  }
}
    ${ProfileGroupFragmentDoc}`;
export type ProfileGroupNewSubmitMutationFn = Apollo.MutationFunction<ProfileGroupNewSubmitMutation, ProfileGroupNewSubmitMutationVariables>;

/**
 * __useProfileGroupNewSubmitMutation__
 *
 * To run a mutation, you first call `useProfileGroupNewSubmitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProfileGroupNewSubmitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [profileGroupNewSubmitMutation, { data, loading, error }] = useProfileGroupNewSubmitMutation({
 *   variables: {
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      learningPlans: // value for 'learningPlans'
 *   },
 * });
 */
export function useProfileGroupNewSubmitMutation(baseOptions?: Apollo.MutationHookOptions<ProfileGroupNewSubmitMutation, ProfileGroupNewSubmitMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProfileGroupNewSubmitMutation, ProfileGroupNewSubmitMutationVariables>(ProfileGroupNewSubmitDocument, options);
      }
export type ProfileGroupNewSubmitMutationHookResult = ReturnType<typeof useProfileGroupNewSubmitMutation>;
export type ProfileGroupNewSubmitMutationResult = Apollo.MutationResult<ProfileGroupNewSubmitMutation>;
export type ProfileGroupNewSubmitMutationOptions = Apollo.BaseMutationOptions<ProfileGroupNewSubmitMutation, ProfileGroupNewSubmitMutationVariables>;
export const ProfileGroupSearchDocument = gql`
    query ProfileGroupSearch($paginate: BaseClassicPaginate, $conditions: ProfileGroupSearchConditions, $companyId: UUID) {
  profileGroupSearch(
    paginate: $paginate
    conditions: $conditions
    companyId: $companyId
  ) {
    totalCount
    pageInfo {
      beforeCursor
      afterCursor
    }
    nodes {
      id
      name
      description
      learnerCount
      coachCount
      companyCohortMembers {
        nodes {
          id
          type
          companyProfile {
            id
            externalId
            profile {
              id
              displayName
            }
          }
        }
      }
      creatorProfile {
        id
        displayName
      }
    }
  }
}
    `;

/**
 * __useProfileGroupSearchQuery__
 *
 * To run a query within a React component, call `useProfileGroupSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useProfileGroupSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProfileGroupSearchQuery({
 *   variables: {
 *      paginate: // value for 'paginate'
 *      conditions: // value for 'conditions'
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useProfileGroupSearchQuery(baseOptions?: Apollo.QueryHookOptions<ProfileGroupSearchQuery, ProfileGroupSearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProfileGroupSearchQuery, ProfileGroupSearchQueryVariables>(ProfileGroupSearchDocument, options);
      }
export function useProfileGroupSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProfileGroupSearchQuery, ProfileGroupSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProfileGroupSearchQuery, ProfileGroupSearchQueryVariables>(ProfileGroupSearchDocument, options);
        }
export type ProfileGroupSearchQueryHookResult = ReturnType<typeof useProfileGroupSearchQuery>;
export type ProfileGroupSearchLazyQueryHookResult = ReturnType<typeof useProfileGroupSearchLazyQuery>;
export type ProfileGroupSearchQueryResult = Apollo.QueryResult<ProfileGroupSearchQuery, ProfileGroupSearchQueryVariables>;
export const ProfileListDocument = gql`
    query ProfileList($paginate: BaseClassicPaginate, $sorts: [CompanyProfileListOrderBy!], $conditions: CompanyProfileListConditions) {
  profileList(paginate: $paginate, sorts: $sorts, conditions: $conditions) {
    totalCount
    pageInfo {
      beforeCursor
      afterCursor
    }
    nodes {
      ...ProfileListFragment
    }
  }
}
    ${ProfileListFragmentDoc}`;

/**
 * __useProfileListQuery__
 *
 * To run a query within a React component, call `useProfileListQuery` and pass it any options that fit your needs.
 * When your component renders, `useProfileListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProfileListQuery({
 *   variables: {
 *      paginate: // value for 'paginate'
 *      sorts: // value for 'sorts'
 *      conditions: // value for 'conditions'
 *   },
 * });
 */
export function useProfileListQuery(baseOptions?: Apollo.QueryHookOptions<ProfileListQuery, ProfileListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProfileListQuery, ProfileListQueryVariables>(ProfileListDocument, options);
      }
export function useProfileListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProfileListQuery, ProfileListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProfileListQuery, ProfileListQueryVariables>(ProfileListDocument, options);
        }
export type ProfileListQueryHookResult = ReturnType<typeof useProfileListQuery>;
export type ProfileListLazyQueryHookResult = ReturnType<typeof useProfileListLazyQuery>;
export type ProfileListQueryResult = Apollo.QueryResult<ProfileListQuery, ProfileListQueryVariables>;
export const ProfileNewSubmitDocument = gql`
    mutation ProfileNewSubmit($displayName: String, $photoUrl: String, $externalId: String!, $language: String, $phoneNumber: String, $emailAddress: String, $active: Boolean, $roles: [Role!]!, $preferredName: String, $timezone: Timezone, $startDate: String!, $learnerCommsOptOut: Boolean!, $coachCommsOptOut: Boolean, $excludeFromAnalytics: Boolean!, $regions: [RegionInput!], $departments: [DepartmentInput!], $mergeAcceptance: Boolean) {
  profileCreate(
    displayName: $displayName
    photoUrl: $photoUrl
    externalId: $externalId
    language: $language
    phoneNumber: $phoneNumber
    emailAddress: $emailAddress
    active: $active
    roles: $roles
    preferredName: $preferredName
    timezone: $timezone
    startDate: $startDate
    learnerCommsOptOut: $learnerCommsOptOut
    coachCommsOptOut: $coachCommsOptOut
    excludeFromAnalytics: $excludeFromAnalytics
    regions: $regions
    departments: $departments
    mergeAcceptance: $mergeAcceptance
  ) {
    ...ProfileFragment
  }
}
    ${ProfileFragmentDoc}`;
export type ProfileNewSubmitMutationFn = Apollo.MutationFunction<ProfileNewSubmitMutation, ProfileNewSubmitMutationVariables>;

/**
 * __useProfileNewSubmitMutation__
 *
 * To run a mutation, you first call `useProfileNewSubmitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProfileNewSubmitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [profileNewSubmitMutation, { data, loading, error }] = useProfileNewSubmitMutation({
 *   variables: {
 *      displayName: // value for 'displayName'
 *      photoUrl: // value for 'photoUrl'
 *      externalId: // value for 'externalId'
 *      language: // value for 'language'
 *      phoneNumber: // value for 'phoneNumber'
 *      emailAddress: // value for 'emailAddress'
 *      active: // value for 'active'
 *      roles: // value for 'roles'
 *      preferredName: // value for 'preferredName'
 *      timezone: // value for 'timezone'
 *      startDate: // value for 'startDate'
 *      learnerCommsOptOut: // value for 'learnerCommsOptOut'
 *      coachCommsOptOut: // value for 'coachCommsOptOut'
 *      excludeFromAnalytics: // value for 'excludeFromAnalytics'
 *      regions: // value for 'regions'
 *      departments: // value for 'departments'
 *      mergeAcceptance: // value for 'mergeAcceptance'
 *   },
 * });
 */
export function useProfileNewSubmitMutation(baseOptions?: Apollo.MutationHookOptions<ProfileNewSubmitMutation, ProfileNewSubmitMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProfileNewSubmitMutation, ProfileNewSubmitMutationVariables>(ProfileNewSubmitDocument, options);
      }
export type ProfileNewSubmitMutationHookResult = ReturnType<typeof useProfileNewSubmitMutation>;
export type ProfileNewSubmitMutationResult = Apollo.MutationResult<ProfileNewSubmitMutation>;
export type ProfileNewSubmitMutationOptions = Apollo.BaseMutationOptions<ProfileNewSubmitMutation, ProfileNewSubmitMutationVariables>;
export const ProfileSearchDocument = gql`
    query ProfileSearch($paginate: BaseClassicPaginate, $conditions: CompanyProfileSearchConditions) {
  profileSearch(paginate: $paginate, conditions: $conditions) {
    totalCount
    pageInfo {
      beforeCursor
      afterCursor
    }
    nodes {
      id
      externalId
      profile {
        id
        displayName
        emailAddress
      }
    }
  }
}
    `;

/**
 * __useProfileSearchQuery__
 *
 * To run a query within a React component, call `useProfileSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useProfileSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProfileSearchQuery({
 *   variables: {
 *      paginate: // value for 'paginate'
 *      conditions: // value for 'conditions'
 *   },
 * });
 */
export function useProfileSearchQuery(baseOptions?: Apollo.QueryHookOptions<ProfileSearchQuery, ProfileSearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProfileSearchQuery, ProfileSearchQueryVariables>(ProfileSearchDocument, options);
      }
export function useProfileSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProfileSearchQuery, ProfileSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProfileSearchQuery, ProfileSearchQueryVariables>(ProfileSearchDocument, options);
        }
export type ProfileSearchQueryHookResult = ReturnType<typeof useProfileSearchQuery>;
export type ProfileSearchLazyQueryHookResult = ReturnType<typeof useProfileSearchLazyQuery>;
export type ProfileSearchQueryResult = Apollo.QueryResult<ProfileSearchQuery, ProfileSearchQueryVariables>;
export const ProfileTagEditDocument = gql`
    query ProfileTagEdit($id: String!) {
  profileTag(id: $id) {
    ...ProfileTagFragment
  }
}
    ${ProfileTagFragmentDoc}`;

/**
 * __useProfileTagEditQuery__
 *
 * To run a query within a React component, call `useProfileTagEditQuery` and pass it any options that fit your needs.
 * When your component renders, `useProfileTagEditQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProfileTagEditQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useProfileTagEditQuery(baseOptions: Apollo.QueryHookOptions<ProfileTagEditQuery, ProfileTagEditQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProfileTagEditQuery, ProfileTagEditQueryVariables>(ProfileTagEditDocument, options);
      }
export function useProfileTagEditLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProfileTagEditQuery, ProfileTagEditQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProfileTagEditQuery, ProfileTagEditQueryVariables>(ProfileTagEditDocument, options);
        }
export type ProfileTagEditQueryHookResult = ReturnType<typeof useProfileTagEditQuery>;
export type ProfileTagEditLazyQueryHookResult = ReturnType<typeof useProfileTagEditLazyQuery>;
export type ProfileTagEditQueryResult = Apollo.QueryResult<ProfileTagEditQuery, ProfileTagEditQueryVariables>;
export const ProfileTagEditSubmitDocument = gql`
    mutation ProfileTagEditSubmit($id: UUID!, $name: String!, $companyProfileIds: [String!] = []) {
  profileTagEdit(id: $id, name: $name, companyProfileIds: $companyProfileIds) {
    ...ProfileTagFragment
  }
}
    ${ProfileTagFragmentDoc}`;
export type ProfileTagEditSubmitMutationFn = Apollo.MutationFunction<ProfileTagEditSubmitMutation, ProfileTagEditSubmitMutationVariables>;

/**
 * __useProfileTagEditSubmitMutation__
 *
 * To run a mutation, you first call `useProfileTagEditSubmitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProfileTagEditSubmitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [profileTagEditSubmitMutation, { data, loading, error }] = useProfileTagEditSubmitMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      companyProfileIds: // value for 'companyProfileIds'
 *   },
 * });
 */
export function useProfileTagEditSubmitMutation(baseOptions?: Apollo.MutationHookOptions<ProfileTagEditSubmitMutation, ProfileTagEditSubmitMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProfileTagEditSubmitMutation, ProfileTagEditSubmitMutationVariables>(ProfileTagEditSubmitDocument, options);
      }
export type ProfileTagEditSubmitMutationHookResult = ReturnType<typeof useProfileTagEditSubmitMutation>;
export type ProfileTagEditSubmitMutationResult = Apollo.MutationResult<ProfileTagEditSubmitMutation>;
export type ProfileTagEditSubmitMutationOptions = Apollo.BaseMutationOptions<ProfileTagEditSubmitMutation, ProfileTagEditSubmitMutationVariables>;
export const ProfileTagListDocument = gql`
    query ProfileTagList($paginate: BaseClassicPaginate, $sorts: [ProfileTagListOrderBy!], $conditions: ProfileTagListConditions) {
  profileTagList(paginate: $paginate, sorts: $sorts, conditions: $conditions) {
    totalCount
    pageInfo {
      beforeCursor
      afterCursor
    }
    nodes {
      id
      name
      metadata
      profileCount
      createdAt
      updatedAt
    }
  }
}
    `;

/**
 * __useProfileTagListQuery__
 *
 * To run a query within a React component, call `useProfileTagListQuery` and pass it any options that fit your needs.
 * When your component renders, `useProfileTagListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProfileTagListQuery({
 *   variables: {
 *      paginate: // value for 'paginate'
 *      sorts: // value for 'sorts'
 *      conditions: // value for 'conditions'
 *   },
 * });
 */
export function useProfileTagListQuery(baseOptions?: Apollo.QueryHookOptions<ProfileTagListQuery, ProfileTagListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProfileTagListQuery, ProfileTagListQueryVariables>(ProfileTagListDocument, options);
      }
export function useProfileTagListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProfileTagListQuery, ProfileTagListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProfileTagListQuery, ProfileTagListQueryVariables>(ProfileTagListDocument, options);
        }
export type ProfileTagListQueryHookResult = ReturnType<typeof useProfileTagListQuery>;
export type ProfileTagListLazyQueryHookResult = ReturnType<typeof useProfileTagListLazyQuery>;
export type ProfileTagListQueryResult = Apollo.QueryResult<ProfileTagListQuery, ProfileTagListQueryVariables>;
export const ProfileTagNewSubmitDocument = gql`
    mutation ProfileTagNewSubmit($name: String!, $companyProfileIds: [String!] = []) {
  profileTagCreate(name: $name, companyProfileIds: $companyProfileIds) {
    ...ProfileTagFragment
  }
}
    ${ProfileTagFragmentDoc}`;
export type ProfileTagNewSubmitMutationFn = Apollo.MutationFunction<ProfileTagNewSubmitMutation, ProfileTagNewSubmitMutationVariables>;

/**
 * __useProfileTagNewSubmitMutation__
 *
 * To run a mutation, you first call `useProfileTagNewSubmitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProfileTagNewSubmitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [profileTagNewSubmitMutation, { data, loading, error }] = useProfileTagNewSubmitMutation({
 *   variables: {
 *      name: // value for 'name'
 *      companyProfileIds: // value for 'companyProfileIds'
 *   },
 * });
 */
export function useProfileTagNewSubmitMutation(baseOptions?: Apollo.MutationHookOptions<ProfileTagNewSubmitMutation, ProfileTagNewSubmitMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProfileTagNewSubmitMutation, ProfileTagNewSubmitMutationVariables>(ProfileTagNewSubmitDocument, options);
      }
export type ProfileTagNewSubmitMutationHookResult = ReturnType<typeof useProfileTagNewSubmitMutation>;
export type ProfileTagNewSubmitMutationResult = Apollo.MutationResult<ProfileTagNewSubmitMutation>;
export type ProfileTagNewSubmitMutationOptions = Apollo.BaseMutationOptions<ProfileTagNewSubmitMutation, ProfileTagNewSubmitMutationVariables>;
export const ProfileTagSearchDocument = gql`
    query ProfileTagSearch($paginate: BaseClassicPaginate, $conditions: ProfileTagSearchConditions) {
  profileTagSearch(paginate: $paginate, conditions: $conditions) {
    totalCount
    pageInfo {
      beforeCursor
      afterCursor
    }
    nodes {
      id
      name
    }
  }
}
    `;

/**
 * __useProfileTagSearchQuery__
 *
 * To run a query within a React component, call `useProfileTagSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useProfileTagSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProfileTagSearchQuery({
 *   variables: {
 *      paginate: // value for 'paginate'
 *      conditions: // value for 'conditions'
 *   },
 * });
 */
export function useProfileTagSearchQuery(baseOptions?: Apollo.QueryHookOptions<ProfileTagSearchQuery, ProfileTagSearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProfileTagSearchQuery, ProfileTagSearchQueryVariables>(ProfileTagSearchDocument, options);
      }
export function useProfileTagSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProfileTagSearchQuery, ProfileTagSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProfileTagSearchQuery, ProfileTagSearchQueryVariables>(ProfileTagSearchDocument, options);
        }
export type ProfileTagSearchQueryHookResult = ReturnType<typeof useProfileTagSearchQuery>;
export type ProfileTagSearchLazyQueryHookResult = ReturnType<typeof useProfileTagSearchLazyQuery>;
export type ProfileTagSearchQueryResult = Apollo.QueryResult<ProfileTagSearchQuery, ProfileTagSearchQueryVariables>;
export const ProfileUpdateStatusDocument = gql`
    mutation ProfileUpdateStatus($id: UUID!, $active: Boolean!) {
  profileUpdateStatus(id: $id, active: $active) {
    ...ProfileFragment
  }
}
    ${ProfileFragmentDoc}`;
export type ProfileUpdateStatusMutationFn = Apollo.MutationFunction<ProfileUpdateStatusMutation, ProfileUpdateStatusMutationVariables>;

/**
 * __useProfileUpdateStatusMutation__
 *
 * To run a mutation, you first call `useProfileUpdateStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProfileUpdateStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [profileUpdateStatusMutation, { data, loading, error }] = useProfileUpdateStatusMutation({
 *   variables: {
 *      id: // value for 'id'
 *      active: // value for 'active'
 *   },
 * });
 */
export function useProfileUpdateStatusMutation(baseOptions?: Apollo.MutationHookOptions<ProfileUpdateStatusMutation, ProfileUpdateStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProfileUpdateStatusMutation, ProfileUpdateStatusMutationVariables>(ProfileUpdateStatusDocument, options);
      }
export type ProfileUpdateStatusMutationHookResult = ReturnType<typeof useProfileUpdateStatusMutation>;
export type ProfileUpdateStatusMutationResult = Apollo.MutationResult<ProfileUpdateStatusMutation>;
export type ProfileUpdateStatusMutationOptions = Apollo.BaseMutationOptions<ProfileUpdateStatusMutation, ProfileUpdateStatusMutationVariables>;
export const ProfileUpdateTagsDocument = gql`
    mutation ProfileUpdateTags($id: UUID!, $tags: [ProfileTagInput!]!) {
  profileUpdateTags(id: $id, tags: $tags) {
    ...ProfileFragment
  }
}
    ${ProfileFragmentDoc}`;
export type ProfileUpdateTagsMutationFn = Apollo.MutationFunction<ProfileUpdateTagsMutation, ProfileUpdateTagsMutationVariables>;

/**
 * __useProfileUpdateTagsMutation__
 *
 * To run a mutation, you first call `useProfileUpdateTagsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProfileUpdateTagsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [profileUpdateTagsMutation, { data, loading, error }] = useProfileUpdateTagsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      tags: // value for 'tags'
 *   },
 * });
 */
export function useProfileUpdateTagsMutation(baseOptions?: Apollo.MutationHookOptions<ProfileUpdateTagsMutation, ProfileUpdateTagsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProfileUpdateTagsMutation, ProfileUpdateTagsMutationVariables>(ProfileUpdateTagsDocument, options);
      }
export type ProfileUpdateTagsMutationHookResult = ReturnType<typeof useProfileUpdateTagsMutation>;
export type ProfileUpdateTagsMutationResult = Apollo.MutationResult<ProfileUpdateTagsMutation>;
export type ProfileUpdateTagsMutationOptions = Apollo.BaseMutationOptions<ProfileUpdateTagsMutation, ProfileUpdateTagsMutationVariables>;
export const RepPromptSearchDocument = gql`
    query RepPromptSearch($paginate: BaseClassicPaginate, $conditions: RepPromptLocalizedSearchConditions) {
  repPromptSearch(paginate: $paginate, conditions: $conditions) {
    totalCount
    pageInfo {
      beforeCursor
      afterCursor
    }
    nodes {
      repPromptId
      content
      skillId
    }
  }
}
    `;

/**
 * __useRepPromptSearchQuery__
 *
 * To run a query within a React component, call `useRepPromptSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useRepPromptSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRepPromptSearchQuery({
 *   variables: {
 *      paginate: // value for 'paginate'
 *      conditions: // value for 'conditions'
 *   },
 * });
 */
export function useRepPromptSearchQuery(baseOptions?: Apollo.QueryHookOptions<RepPromptSearchQuery, RepPromptSearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RepPromptSearchQuery, RepPromptSearchQueryVariables>(RepPromptSearchDocument, options);
      }
export function useRepPromptSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RepPromptSearchQuery, RepPromptSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RepPromptSearchQuery, RepPromptSearchQueryVariables>(RepPromptSearchDocument, options);
        }
export type RepPromptSearchQueryHookResult = ReturnType<typeof useRepPromptSearchQuery>;
export type RepPromptSearchLazyQueryHookResult = ReturnType<typeof useRepPromptSearchLazyQuery>;
export type RepPromptSearchQueryResult = Apollo.QueryResult<RepPromptSearchQuery, RepPromptSearchQueryVariables>;
export const RepResponseDocument = gql`
    query RepResponse($id: String!) {
  repResponse(id: $id) {
    ...RepResponseFragment
  }
}
    ${RepResponseFragmentDoc}`;

/**
 * __useRepResponseQuery__
 *
 * To run a query within a React component, call `useRepResponseQuery` and pass it any options that fit your needs.
 * When your component renders, `useRepResponseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRepResponseQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRepResponseQuery(baseOptions: Apollo.QueryHookOptions<RepResponseQuery, RepResponseQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RepResponseQuery, RepResponseQueryVariables>(RepResponseDocument, options);
      }
export function useRepResponseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RepResponseQuery, RepResponseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RepResponseQuery, RepResponseQueryVariables>(RepResponseDocument, options);
        }
export type RepResponseQueryHookResult = ReturnType<typeof useRepResponseQuery>;
export type RepResponseLazyQueryHookResult = ReturnType<typeof useRepResponseLazyQuery>;
export type RepResponseQueryResult = Apollo.QueryResult<RepResponseQuery, RepResponseQueryVariables>;
export const RepResponseListDocument = gql`
    query RepResponseList($filters: RepResponseFilter!, $limit: Int, $cursor: String, $orderBy: RepResponseListOrderBy, $orderDirection: OrderByDirection) {
  repResponseList(
    filters: $filters
    paginator: {limit: $limit, cursor: $cursor}
    orderBy: $orderBy
    orderDirection: $orderDirection
  ) {
    count
    beforeCursor
    afterCursor
    nodes {
      ...RepResponseFragment
    }
  }
}
    ${RepResponseFragmentDoc}`;

/**
 * __useRepResponseListQuery__
 *
 * To run a query within a React component, call `useRepResponseListQuery` and pass it any options that fit your needs.
 * When your component renders, `useRepResponseListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRepResponseListQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      limit: // value for 'limit'
 *      cursor: // value for 'cursor'
 *      orderBy: // value for 'orderBy'
 *      orderDirection: // value for 'orderDirection'
 *   },
 * });
 */
export function useRepResponseListQuery(baseOptions: Apollo.QueryHookOptions<RepResponseListQuery, RepResponseListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RepResponseListQuery, RepResponseListQueryVariables>(RepResponseListDocument, options);
      }
export function useRepResponseListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RepResponseListQuery, RepResponseListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RepResponseListQuery, RepResponseListQueryVariables>(RepResponseListDocument, options);
        }
export type RepResponseListQueryHookResult = ReturnType<typeof useRepResponseListQuery>;
export type RepResponseListLazyQueryHookResult = ReturnType<typeof useRepResponseListLazyQuery>;
export type RepResponseListQueryResult = Apollo.QueryResult<RepResponseListQuery, RepResponseListQueryVariables>;
export const RolePlayConfigListDocument = gql`
    query RolePlayConfigList {
  getRolePlayConfigs {
    id
    cardTitle
    cardDescription
    status
    personaName
    designation
    details {
      bio
      goal
      traits
    }
    config {
      difficulty
      voiceName
      gender
      voiceService
      avatarUrl
    }
  }
}
    `;

/**
 * __useRolePlayConfigListQuery__
 *
 * To run a query within a React component, call `useRolePlayConfigListQuery` and pass it any options that fit your needs.
 * When your component renders, `useRolePlayConfigListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRolePlayConfigListQuery({
 *   variables: {
 *   },
 * });
 */
export function useRolePlayConfigListQuery(baseOptions?: Apollo.QueryHookOptions<RolePlayConfigListQuery, RolePlayConfigListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RolePlayConfigListQuery, RolePlayConfigListQueryVariables>(RolePlayConfigListDocument, options);
      }
export function useRolePlayConfigListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RolePlayConfigListQuery, RolePlayConfigListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RolePlayConfigListQuery, RolePlayConfigListQueryVariables>(RolePlayConfigListDocument, options);
        }
export type RolePlayConfigListQueryHookResult = ReturnType<typeof useRolePlayConfigListQuery>;
export type RolePlayConfigListLazyQueryHookResult = ReturnType<typeof useRolePlayConfigListLazyQuery>;
export type RolePlayConfigListQueryResult = Apollo.QueryResult<RolePlayConfigListQuery, RolePlayConfigListQueryVariables>;
export const SkillArchiveDocument = gql`
    mutation SkillArchive($skillId: UUID!) {
  skillArchive(skillId: $skillId) {
    ...SkillFragment
  }
}
    ${SkillFragmentDoc}`;
export type SkillArchiveMutationFn = Apollo.MutationFunction<SkillArchiveMutation, SkillArchiveMutationVariables>;

/**
 * __useSkillArchiveMutation__
 *
 * To run a mutation, you first call `useSkillArchiveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSkillArchiveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [skillArchiveMutation, { data, loading, error }] = useSkillArchiveMutation({
 *   variables: {
 *      skillId: // value for 'skillId'
 *   },
 * });
 */
export function useSkillArchiveMutation(baseOptions?: Apollo.MutationHookOptions<SkillArchiveMutation, SkillArchiveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SkillArchiveMutation, SkillArchiveMutationVariables>(SkillArchiveDocument, options);
      }
export type SkillArchiveMutationHookResult = ReturnType<typeof useSkillArchiveMutation>;
export type SkillArchiveMutationResult = Apollo.MutationResult<SkillArchiveMutation>;
export type SkillArchiveMutationOptions = Apollo.BaseMutationOptions<SkillArchiveMutation, SkillArchiveMutationVariables>;
export const SkillEditDocument = gql`
    query SkillEdit($id: UUID!) {
  skill(id: $id) {
    ...SkillFragment
    learningCards {
      nodes {
        ...LearningCardFragment
      }
    }
  }
}
    ${SkillFragmentDoc}
${LearningCardFragmentDoc}`;

/**
 * __useSkillEditQuery__
 *
 * To run a query within a React component, call `useSkillEditQuery` and pass it any options that fit your needs.
 * When your component renders, `useSkillEditQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSkillEditQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSkillEditQuery(baseOptions: Apollo.QueryHookOptions<SkillEditQuery, SkillEditQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SkillEditQuery, SkillEditQueryVariables>(SkillEditDocument, options);
      }
export function useSkillEditLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SkillEditQuery, SkillEditQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SkillEditQuery, SkillEditQueryVariables>(SkillEditDocument, options);
        }
export type SkillEditQueryHookResult = ReturnType<typeof useSkillEditQuery>;
export type SkillEditLazyQueryHookResult = ReturnType<typeof useSkillEditLazyQuery>;
export type SkillEditQueryResult = Apollo.QueryResult<SkillEditQuery, SkillEditQueryVariables>;
export const SkillListDocument = gql`
    query SkillList($paginate: BaseClassicPaginate, $sorts: [SkillListOrderBy!], $conditions: SkillListConditions) {
  skillList(paginate: $paginate, sorts: $sorts, conditions: $conditions) {
    totalCount
    pageInfo {
      beforeCursor
      afterCursor
    }
    nodes {
      ...SkillListFragment
    }
  }
}
    ${SkillListFragmentDoc}`;

/**
 * __useSkillListQuery__
 *
 * To run a query within a React component, call `useSkillListQuery` and pass it any options that fit your needs.
 * When your component renders, `useSkillListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSkillListQuery({
 *   variables: {
 *      paginate: // value for 'paginate'
 *      sorts: // value for 'sorts'
 *      conditions: // value for 'conditions'
 *   },
 * });
 */
export function useSkillListQuery(baseOptions?: Apollo.QueryHookOptions<SkillListQuery, SkillListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SkillListQuery, SkillListQueryVariables>(SkillListDocument, options);
      }
export function useSkillListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SkillListQuery, SkillListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SkillListQuery, SkillListQueryVariables>(SkillListDocument, options);
        }
export type SkillListQueryHookResult = ReturnType<typeof useSkillListQuery>;
export type SkillListLazyQueryHookResult = ReturnType<typeof useSkillListLazyQuery>;
export type SkillListQueryResult = Apollo.QueryResult<SkillListQuery, SkillListQueryVariables>;
export const SkillLocalizationsDocument = gql`
    query SkillLocalizations($id: UUID!) {
  skillLocalizations(id: $id) {
    ...LocalizedFieldFragment
  }
}
    ${LocalizedFieldFragmentDoc}`;

/**
 * __useSkillLocalizationsQuery__
 *
 * To run a query within a React component, call `useSkillLocalizationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSkillLocalizationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSkillLocalizationsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSkillLocalizationsQuery(baseOptions: Apollo.QueryHookOptions<SkillLocalizationsQuery, SkillLocalizationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SkillLocalizationsQuery, SkillLocalizationsQueryVariables>(SkillLocalizationsDocument, options);
      }
export function useSkillLocalizationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SkillLocalizationsQuery, SkillLocalizationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SkillLocalizationsQuery, SkillLocalizationsQueryVariables>(SkillLocalizationsDocument, options);
        }
export type SkillLocalizationsQueryHookResult = ReturnType<typeof useSkillLocalizationsQuery>;
export type SkillLocalizationsLazyQueryHookResult = ReturnType<typeof useSkillLocalizationsLazyQuery>;
export type SkillLocalizationsQueryResult = Apollo.QueryResult<SkillLocalizationsQuery, SkillLocalizationsQueryVariables>;
export const SkillLocalizationsSyncDocument = gql`
    mutation SkillLocalizationsSync($id: UUID!, $entities: [LocalizedEntityInput!]!) {
  skillLocalizationsSync(id: $id, entities: $entities) {
    ...LocalizedFieldFragment
  }
}
    ${LocalizedFieldFragmentDoc}`;
export type SkillLocalizationsSyncMutationFn = Apollo.MutationFunction<SkillLocalizationsSyncMutation, SkillLocalizationsSyncMutationVariables>;

/**
 * __useSkillLocalizationsSyncMutation__
 *
 * To run a mutation, you first call `useSkillLocalizationsSyncMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSkillLocalizationsSyncMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [skillLocalizationsSyncMutation, { data, loading, error }] = useSkillLocalizationsSyncMutation({
 *   variables: {
 *      id: // value for 'id'
 *      entities: // value for 'entities'
 *   },
 * });
 */
export function useSkillLocalizationsSyncMutation(baseOptions?: Apollo.MutationHookOptions<SkillLocalizationsSyncMutation, SkillLocalizationsSyncMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SkillLocalizationsSyncMutation, SkillLocalizationsSyncMutationVariables>(SkillLocalizationsSyncDocument, options);
      }
export type SkillLocalizationsSyncMutationHookResult = ReturnType<typeof useSkillLocalizationsSyncMutation>;
export type SkillLocalizationsSyncMutationResult = Apollo.MutationResult<SkillLocalizationsSyncMutation>;
export type SkillLocalizationsSyncMutationOptions = Apollo.BaseMutationOptions<SkillLocalizationsSyncMutation, SkillLocalizationsSyncMutationVariables>;
export const SkillPublishDocument = gql`
    mutation SkillPublish($id: UUID!) {
  skillPublish(id: $id) {
    ...SkillFragment
  }
}
    ${SkillFragmentDoc}`;
export type SkillPublishMutationFn = Apollo.MutationFunction<SkillPublishMutation, SkillPublishMutationVariables>;

/**
 * __useSkillPublishMutation__
 *
 * To run a mutation, you first call `useSkillPublishMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSkillPublishMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [skillPublishMutation, { data, loading, error }] = useSkillPublishMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSkillPublishMutation(baseOptions?: Apollo.MutationHookOptions<SkillPublishMutation, SkillPublishMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SkillPublishMutation, SkillPublishMutationVariables>(SkillPublishDocument, options);
      }
export type SkillPublishMutationHookResult = ReturnType<typeof useSkillPublishMutation>;
export type SkillPublishMutationResult = Apollo.MutationResult<SkillPublishMutation>;
export type SkillPublishMutationOptions = Apollo.BaseMutationOptions<SkillPublishMutation, SkillPublishMutationVariables>;
export const SkillRepEditDocument = gql`
    query SkillRepEdit($id: UUID!) {
  skillRep(id: $id) {
    ...SkillRepFragment
  }
}
    ${SkillRepFragmentDoc}`;

/**
 * __useSkillRepEditQuery__
 *
 * To run a query within a React component, call `useSkillRepEditQuery` and pass it any options that fit your needs.
 * When your component renders, `useSkillRepEditQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSkillRepEditQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSkillRepEditQuery(baseOptions: Apollo.QueryHookOptions<SkillRepEditQuery, SkillRepEditQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SkillRepEditQuery, SkillRepEditQueryVariables>(SkillRepEditDocument, options);
      }
export function useSkillRepEditLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SkillRepEditQuery, SkillRepEditQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SkillRepEditQuery, SkillRepEditQueryVariables>(SkillRepEditDocument, options);
        }
export type SkillRepEditQueryHookResult = ReturnType<typeof useSkillRepEditQuery>;
export type SkillRepEditLazyQueryHookResult = ReturnType<typeof useSkillRepEditLazyQuery>;
export type SkillRepEditQueryResult = Apollo.QueryResult<SkillRepEditQuery, SkillRepEditQueryVariables>;
export const SkillRepListDocument = gql`
    query SkillRepList($paginate: BaseClassicPaginate, $sorts: [SkillRepListOrderBy!], $conditions: SkillRepListConditions) {
  skillRepList(paginate: $paginate, sorts: $sorts, conditions: $conditions) {
    totalCount
    pageInfo {
      beforeCursor
      afterCursor
    }
    nodes {
      ...SkillRepListFragment
    }
  }
}
    ${SkillRepListFragmentDoc}`;

/**
 * __useSkillRepListQuery__
 *
 * To run a query within a React component, call `useSkillRepListQuery` and pass it any options that fit your needs.
 * When your component renders, `useSkillRepListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSkillRepListQuery({
 *   variables: {
 *      paginate: // value for 'paginate'
 *      sorts: // value for 'sorts'
 *      conditions: // value for 'conditions'
 *   },
 * });
 */
export function useSkillRepListQuery(baseOptions?: Apollo.QueryHookOptions<SkillRepListQuery, SkillRepListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SkillRepListQuery, SkillRepListQueryVariables>(SkillRepListDocument, options);
      }
export function useSkillRepListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SkillRepListQuery, SkillRepListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SkillRepListQuery, SkillRepListQueryVariables>(SkillRepListDocument, options);
        }
export type SkillRepListQueryHookResult = ReturnType<typeof useSkillRepListQuery>;
export type SkillRepListLazyQueryHookResult = ReturnType<typeof useSkillRepListLazyQuery>;
export type SkillRepListQueryResult = Apollo.QueryResult<SkillRepListQuery, SkillRepListQueryVariables>;
export const SkillRepLocalizationsDocument = gql`
    query SkillRepLocalizations($id: UUID!) {
  skillRepLocalizations(id: $id) {
    ...LocalizedFieldFragment
  }
}
    ${LocalizedFieldFragmentDoc}`;

/**
 * __useSkillRepLocalizationsQuery__
 *
 * To run a query within a React component, call `useSkillRepLocalizationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSkillRepLocalizationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSkillRepLocalizationsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSkillRepLocalizationsQuery(baseOptions: Apollo.QueryHookOptions<SkillRepLocalizationsQuery, SkillRepLocalizationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SkillRepLocalizationsQuery, SkillRepLocalizationsQueryVariables>(SkillRepLocalizationsDocument, options);
      }
export function useSkillRepLocalizationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SkillRepLocalizationsQuery, SkillRepLocalizationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SkillRepLocalizationsQuery, SkillRepLocalizationsQueryVariables>(SkillRepLocalizationsDocument, options);
        }
export type SkillRepLocalizationsQueryHookResult = ReturnType<typeof useSkillRepLocalizationsQuery>;
export type SkillRepLocalizationsLazyQueryHookResult = ReturnType<typeof useSkillRepLocalizationsLazyQuery>;
export type SkillRepLocalizationsQueryResult = Apollo.QueryResult<SkillRepLocalizationsQuery, SkillRepLocalizationsQueryVariables>;
export const SkillRepLocalizationsSyncDocument = gql`
    mutation SkillRepLocalizationsSync($id: UUID!, $entities: [LocalizedEntityInput!]!) {
  skillRepLocalizationsSync(id: $id, entities: $entities) {
    ...LocalizedFieldFragment
  }
}
    ${LocalizedFieldFragmentDoc}`;
export type SkillRepLocalizationsSyncMutationFn = Apollo.MutationFunction<SkillRepLocalizationsSyncMutation, SkillRepLocalizationsSyncMutationVariables>;

/**
 * __useSkillRepLocalizationsSyncMutation__
 *
 * To run a mutation, you first call `useSkillRepLocalizationsSyncMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSkillRepLocalizationsSyncMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [skillRepLocalizationsSyncMutation, { data, loading, error }] = useSkillRepLocalizationsSyncMutation({
 *   variables: {
 *      id: // value for 'id'
 *      entities: // value for 'entities'
 *   },
 * });
 */
export function useSkillRepLocalizationsSyncMutation(baseOptions?: Apollo.MutationHookOptions<SkillRepLocalizationsSyncMutation, SkillRepLocalizationsSyncMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SkillRepLocalizationsSyncMutation, SkillRepLocalizationsSyncMutationVariables>(SkillRepLocalizationsSyncDocument, options);
      }
export type SkillRepLocalizationsSyncMutationHookResult = ReturnType<typeof useSkillRepLocalizationsSyncMutation>;
export type SkillRepLocalizationsSyncMutationResult = Apollo.MutationResult<SkillRepLocalizationsSyncMutation>;
export type SkillRepLocalizationsSyncMutationOptions = Apollo.BaseMutationOptions<SkillRepLocalizationsSyncMutation, SkillRepLocalizationsSyncMutationVariables>;
export const SkillRepPublishDocument = gql`
    mutation SkillRepPublish($id: UUID!) {
  skillRepPublish(id: $id) {
    ...SkillRepFragment
  }
}
    ${SkillRepFragmentDoc}`;
export type SkillRepPublishMutationFn = Apollo.MutationFunction<SkillRepPublishMutation, SkillRepPublishMutationVariables>;

/**
 * __useSkillRepPublishMutation__
 *
 * To run a mutation, you first call `useSkillRepPublishMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSkillRepPublishMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [skillRepPublishMutation, { data, loading, error }] = useSkillRepPublishMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSkillRepPublishMutation(baseOptions?: Apollo.MutationHookOptions<SkillRepPublishMutation, SkillRepPublishMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SkillRepPublishMutation, SkillRepPublishMutationVariables>(SkillRepPublishDocument, options);
      }
export type SkillRepPublishMutationHookResult = ReturnType<typeof useSkillRepPublishMutation>;
export type SkillRepPublishMutationResult = Apollo.MutationResult<SkillRepPublishMutation>;
export type SkillRepPublishMutationOptions = Apollo.BaseMutationOptions<SkillRepPublishMutation, SkillRepPublishMutationVariables>;
export const SkillRepUpsertDocument = gql`
    mutation SkillRepUpsert($upsertSkillRepInput: UpsertSkillRepInput!) {
  upsertSkillRep(upsertSkillRepInput: $upsertSkillRepInput) {
    ...SkillRepFragment
  }
}
    ${SkillRepFragmentDoc}`;
export type SkillRepUpsertMutationFn = Apollo.MutationFunction<SkillRepUpsertMutation, SkillRepUpsertMutationVariables>;

/**
 * __useSkillRepUpsertMutation__
 *
 * To run a mutation, you first call `useSkillRepUpsertMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSkillRepUpsertMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [skillRepUpsertMutation, { data, loading, error }] = useSkillRepUpsertMutation({
 *   variables: {
 *      upsertSkillRepInput: // value for 'upsertSkillRepInput'
 *   },
 * });
 */
export function useSkillRepUpsertMutation(baseOptions?: Apollo.MutationHookOptions<SkillRepUpsertMutation, SkillRepUpsertMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SkillRepUpsertMutation, SkillRepUpsertMutationVariables>(SkillRepUpsertDocument, options);
      }
export type SkillRepUpsertMutationHookResult = ReturnType<typeof useSkillRepUpsertMutation>;
export type SkillRepUpsertMutationResult = Apollo.MutationResult<SkillRepUpsertMutation>;
export type SkillRepUpsertMutationOptions = Apollo.BaseMutationOptions<SkillRepUpsertMutation, SkillRepUpsertMutationVariables>;
export const SkillSearchDocument = gql`
    query SkillSearch($paginate: BaseClassicPaginate, $conditions: SkillSearchConditions) {
  skillSearch(paginate: $paginate, conditions: $conditions) {
    totalCount
    pageInfo {
      beforeCursor
      afterCursor
    }
    nodes {
      id
      type
      externalId
      name
      publishedAt
    }
  }
}
    `;

/**
 * __useSkillSearchQuery__
 *
 * To run a query within a React component, call `useSkillSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useSkillSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSkillSearchQuery({
 *   variables: {
 *      paginate: // value for 'paginate'
 *      conditions: // value for 'conditions'
 *   },
 * });
 */
export function useSkillSearchQuery(baseOptions?: Apollo.QueryHookOptions<SkillSearchQuery, SkillSearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SkillSearchQuery, SkillSearchQueryVariables>(SkillSearchDocument, options);
      }
export function useSkillSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SkillSearchQuery, SkillSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SkillSearchQuery, SkillSearchQueryVariables>(SkillSearchDocument, options);
        }
export type SkillSearchQueryHookResult = ReturnType<typeof useSkillSearchQuery>;
export type SkillSearchLazyQueryHookResult = ReturnType<typeof useSkillSearchLazyQuery>;
export type SkillSearchQueryResult = Apollo.QueryResult<SkillSearchQuery, SkillSearchQueryVariables>;
export const SkillUpsertSubmitDocument = gql`
    mutation SkillUpsertSubmit($id: String, $externalId: String!, $name: String!, $displayName: String!, $description: String, $photoUrl: String!, $duration: String) {
  skillUpsert(
    id: $id
    externalId: $externalId
    name: $name
    displayName: $displayName
    description: $description
    photoUrl: $photoUrl
    duration: $duration
  ) {
    ...SkillFragment
  }
}
    ${SkillFragmentDoc}`;
export type SkillUpsertSubmitMutationFn = Apollo.MutationFunction<SkillUpsertSubmitMutation, SkillUpsertSubmitMutationVariables>;

/**
 * __useSkillUpsertSubmitMutation__
 *
 * To run a mutation, you first call `useSkillUpsertSubmitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSkillUpsertSubmitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [skillUpsertSubmitMutation, { data, loading, error }] = useSkillUpsertSubmitMutation({
 *   variables: {
 *      id: // value for 'id'
 *      externalId: // value for 'externalId'
 *      name: // value for 'name'
 *      displayName: // value for 'displayName'
 *      description: // value for 'description'
 *      photoUrl: // value for 'photoUrl'
 *      duration: // value for 'duration'
 *   },
 * });
 */
export function useSkillUpsertSubmitMutation(baseOptions?: Apollo.MutationHookOptions<SkillUpsertSubmitMutation, SkillUpsertSubmitMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SkillUpsertSubmitMutation, SkillUpsertSubmitMutationVariables>(SkillUpsertSubmitDocument, options);
      }
export type SkillUpsertSubmitMutationHookResult = ReturnType<typeof useSkillUpsertSubmitMutation>;
export type SkillUpsertSubmitMutationResult = Apollo.MutationResult<SkillUpsertSubmitMutation>;
export type SkillUpsertSubmitMutationOptions = Apollo.BaseMutationOptions<SkillUpsertSubmitMutation, SkillUpsertSubmitMutationVariables>;
export const SynkCustomVocabularyDocument = gql`
    mutation SynkCustomVocabulary($vocabularyId: String!) {
  synkCustomVocabulary(vocabularyId: $vocabularyId) {
    success
  }
}
    `;
export type SynkCustomVocabularyMutationFn = Apollo.MutationFunction<SynkCustomVocabularyMutation, SynkCustomVocabularyMutationVariables>;

/**
 * __useSynkCustomVocabularyMutation__
 *
 * To run a mutation, you first call `useSynkCustomVocabularyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSynkCustomVocabularyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [synkCustomVocabularyMutation, { data, loading, error }] = useSynkCustomVocabularyMutation({
 *   variables: {
 *      vocabularyId: // value for 'vocabularyId'
 *   },
 * });
 */
export function useSynkCustomVocabularyMutation(baseOptions?: Apollo.MutationHookOptions<SynkCustomVocabularyMutation, SynkCustomVocabularyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SynkCustomVocabularyMutation, SynkCustomVocabularyMutationVariables>(SynkCustomVocabularyDocument, options);
      }
export type SynkCustomVocabularyMutationHookResult = ReturnType<typeof useSynkCustomVocabularyMutation>;
export type SynkCustomVocabularyMutationResult = Apollo.MutationResult<SynkCustomVocabularyMutation>;
export type SynkCustomVocabularyMutationOptions = Apollo.BaseMutationOptions<SynkCustomVocabularyMutation, SynkCustomVocabularyMutationVariables>;
export const TopicEditDocument = gql`
    query TopicEdit($id: String!) {
  topic(id: $id) {
    ...TopicFragment
  }
}
    ${TopicFragmentDoc}`;

/**
 * __useTopicEditQuery__
 *
 * To run a query within a React component, call `useTopicEditQuery` and pass it any options that fit your needs.
 * When your component renders, `useTopicEditQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTopicEditQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTopicEditQuery(baseOptions: Apollo.QueryHookOptions<TopicEditQuery, TopicEditQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TopicEditQuery, TopicEditQueryVariables>(TopicEditDocument, options);
      }
export function useTopicEditLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TopicEditQuery, TopicEditQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TopicEditQuery, TopicEditQueryVariables>(TopicEditDocument, options);
        }
export type TopicEditQueryHookResult = ReturnType<typeof useTopicEditQuery>;
export type TopicEditLazyQueryHookResult = ReturnType<typeof useTopicEditLazyQuery>;
export type TopicEditQueryResult = Apollo.QueryResult<TopicEditQuery, TopicEditQueryVariables>;
export const TopicEditSubmitDocument = gql`
    mutation TopicEditSubmit($id: UUID!, $name: String!, $photoUrl: String!) {
  topicEdit(id: $id, name: $name, photoUrl: $photoUrl) {
    ...TopicFragment
  }
}
    ${TopicFragmentDoc}`;
export type TopicEditSubmitMutationFn = Apollo.MutationFunction<TopicEditSubmitMutation, TopicEditSubmitMutationVariables>;

/**
 * __useTopicEditSubmitMutation__
 *
 * To run a mutation, you first call `useTopicEditSubmitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTopicEditSubmitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [topicEditSubmitMutation, { data, loading, error }] = useTopicEditSubmitMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      photoUrl: // value for 'photoUrl'
 *   },
 * });
 */
export function useTopicEditSubmitMutation(baseOptions?: Apollo.MutationHookOptions<TopicEditSubmitMutation, TopicEditSubmitMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TopicEditSubmitMutation, TopicEditSubmitMutationVariables>(TopicEditSubmitDocument, options);
      }
export type TopicEditSubmitMutationHookResult = ReturnType<typeof useTopicEditSubmitMutation>;
export type TopicEditSubmitMutationResult = Apollo.MutationResult<TopicEditSubmitMutation>;
export type TopicEditSubmitMutationOptions = Apollo.BaseMutationOptions<TopicEditSubmitMutation, TopicEditSubmitMutationVariables>;
export const TopicListDocument = gql`
    query TopicList($paginate: BaseClassicPaginate, $sorts: [TopicListOrderBy!], $conditions: TopicListConditions) {
  topicList(paginate: $paginate, sorts: $sorts, conditions: $conditions) {
    totalCount
    pageInfo {
      beforeCursor
      afterCursor
    }
    nodes {
      ...TopicListFragment
    }
  }
}
    ${TopicListFragmentDoc}`;

/**
 * __useTopicListQuery__
 *
 * To run a query within a React component, call `useTopicListQuery` and pass it any options that fit your needs.
 * When your component renders, `useTopicListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTopicListQuery({
 *   variables: {
 *      paginate: // value for 'paginate'
 *      sorts: // value for 'sorts'
 *      conditions: // value for 'conditions'
 *   },
 * });
 */
export function useTopicListQuery(baseOptions?: Apollo.QueryHookOptions<TopicListQuery, TopicListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TopicListQuery, TopicListQueryVariables>(TopicListDocument, options);
      }
export function useTopicListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TopicListQuery, TopicListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TopicListQuery, TopicListQueryVariables>(TopicListDocument, options);
        }
export type TopicListQueryHookResult = ReturnType<typeof useTopicListQuery>;
export type TopicListLazyQueryHookResult = ReturnType<typeof useTopicListLazyQuery>;
export type TopicListQueryResult = Apollo.QueryResult<TopicListQuery, TopicListQueryVariables>;
export const TopicLocalizationsDocument = gql`
    query TopicLocalizations($id: UUID!) {
  topicLocalizations(id: $id) {
    ...LocalizedFieldFragment
  }
}
    ${LocalizedFieldFragmentDoc}`;

/**
 * __useTopicLocalizationsQuery__
 *
 * To run a query within a React component, call `useTopicLocalizationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTopicLocalizationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTopicLocalizationsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTopicLocalizationsQuery(baseOptions: Apollo.QueryHookOptions<TopicLocalizationsQuery, TopicLocalizationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TopicLocalizationsQuery, TopicLocalizationsQueryVariables>(TopicLocalizationsDocument, options);
      }
export function useTopicLocalizationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TopicLocalizationsQuery, TopicLocalizationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TopicLocalizationsQuery, TopicLocalizationsQueryVariables>(TopicLocalizationsDocument, options);
        }
export type TopicLocalizationsQueryHookResult = ReturnType<typeof useTopicLocalizationsQuery>;
export type TopicLocalizationsLazyQueryHookResult = ReturnType<typeof useTopicLocalizationsLazyQuery>;
export type TopicLocalizationsQueryResult = Apollo.QueryResult<TopicLocalizationsQuery, TopicLocalizationsQueryVariables>;
export const TopicLocalizationsSyncDocument = gql`
    mutation TopicLocalizationsSync($id: UUID!, $entities: [LocalizedEntityInput!]!) {
  topicLocalizationsSync(id: $id, entities: $entities) {
    ...LocalizedFieldFragment
  }
}
    ${LocalizedFieldFragmentDoc}`;
export type TopicLocalizationsSyncMutationFn = Apollo.MutationFunction<TopicLocalizationsSyncMutation, TopicLocalizationsSyncMutationVariables>;

/**
 * __useTopicLocalizationsSyncMutation__
 *
 * To run a mutation, you first call `useTopicLocalizationsSyncMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTopicLocalizationsSyncMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [topicLocalizationsSyncMutation, { data, loading, error }] = useTopicLocalizationsSyncMutation({
 *   variables: {
 *      id: // value for 'id'
 *      entities: // value for 'entities'
 *   },
 * });
 */
export function useTopicLocalizationsSyncMutation(baseOptions?: Apollo.MutationHookOptions<TopicLocalizationsSyncMutation, TopicLocalizationsSyncMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TopicLocalizationsSyncMutation, TopicLocalizationsSyncMutationVariables>(TopicLocalizationsSyncDocument, options);
      }
export type TopicLocalizationsSyncMutationHookResult = ReturnType<typeof useTopicLocalizationsSyncMutation>;
export type TopicLocalizationsSyncMutationResult = Apollo.MutationResult<TopicLocalizationsSyncMutation>;
export type TopicLocalizationsSyncMutationOptions = Apollo.BaseMutationOptions<TopicLocalizationsSyncMutation, TopicLocalizationsSyncMutationVariables>;
export const TopicNewSubmitDocument = gql`
    mutation TopicNewSubmit($name: String!, $photoUrl: String!) {
  topicCreate(name: $name, photoUrl: $photoUrl) {
    ...TopicFragment
  }
}
    ${TopicFragmentDoc}`;
export type TopicNewSubmitMutationFn = Apollo.MutationFunction<TopicNewSubmitMutation, TopicNewSubmitMutationVariables>;

/**
 * __useTopicNewSubmitMutation__
 *
 * To run a mutation, you first call `useTopicNewSubmitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTopicNewSubmitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [topicNewSubmitMutation, { data, loading, error }] = useTopicNewSubmitMutation({
 *   variables: {
 *      name: // value for 'name'
 *      photoUrl: // value for 'photoUrl'
 *   },
 * });
 */
export function useTopicNewSubmitMutation(baseOptions?: Apollo.MutationHookOptions<TopicNewSubmitMutation, TopicNewSubmitMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TopicNewSubmitMutation, TopicNewSubmitMutationVariables>(TopicNewSubmitDocument, options);
      }
export type TopicNewSubmitMutationHookResult = ReturnType<typeof useTopicNewSubmitMutation>;
export type TopicNewSubmitMutationResult = Apollo.MutationResult<TopicNewSubmitMutation>;
export type TopicNewSubmitMutationOptions = Apollo.BaseMutationOptions<TopicNewSubmitMutation, TopicNewSubmitMutationVariables>;
export const TopicSkillsSyncDocument = gql`
    mutation TopicSkillsSync($topicId: UUID!, $skillTopics: [SkillTopicInput!]!) {
  topicSkillsSync(topicId: $topicId, skillTopics: $skillTopics) {
    ...SkillTopicFragment
  }
}
    ${SkillTopicFragmentDoc}`;
export type TopicSkillsSyncMutationFn = Apollo.MutationFunction<TopicSkillsSyncMutation, TopicSkillsSyncMutationVariables>;

/**
 * __useTopicSkillsSyncMutation__
 *
 * To run a mutation, you first call `useTopicSkillsSyncMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTopicSkillsSyncMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [topicSkillsSyncMutation, { data, loading, error }] = useTopicSkillsSyncMutation({
 *   variables: {
 *      topicId: // value for 'topicId'
 *      skillTopics: // value for 'skillTopics'
 *   },
 * });
 */
export function useTopicSkillsSyncMutation(baseOptions?: Apollo.MutationHookOptions<TopicSkillsSyncMutation, TopicSkillsSyncMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TopicSkillsSyncMutation, TopicSkillsSyncMutationVariables>(TopicSkillsSyncDocument, options);
      }
export type TopicSkillsSyncMutationHookResult = ReturnType<typeof useTopicSkillsSyncMutation>;
export type TopicSkillsSyncMutationResult = Apollo.MutationResult<TopicSkillsSyncMutation>;
export type TopicSkillsSyncMutationOptions = Apollo.BaseMutationOptions<TopicSkillsSyncMutation, TopicSkillsSyncMutationVariables>;
export const TopicUpdateStatusDocument = gql`
    mutation TopicUpdateStatus($id: UUID!, $active: Boolean!) {
  topicUpdateStatus(id: $id, active: $active) {
    ...TopicFragment
  }
}
    ${TopicFragmentDoc}`;
export type TopicUpdateStatusMutationFn = Apollo.MutationFunction<TopicUpdateStatusMutation, TopicUpdateStatusMutationVariables>;

/**
 * __useTopicUpdateStatusMutation__
 *
 * To run a mutation, you first call `useTopicUpdateStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTopicUpdateStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [topicUpdateStatusMutation, { data, loading, error }] = useTopicUpdateStatusMutation({
 *   variables: {
 *      id: // value for 'id'
 *      active: // value for 'active'
 *   },
 * });
 */
export function useTopicUpdateStatusMutation(baseOptions?: Apollo.MutationHookOptions<TopicUpdateStatusMutation, TopicUpdateStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TopicUpdateStatusMutation, TopicUpdateStatusMutationVariables>(TopicUpdateStatusDocument, options);
      }
export type TopicUpdateStatusMutationHookResult = ReturnType<typeof useTopicUpdateStatusMutation>;
export type TopicUpdateStatusMutationResult = Apollo.MutationResult<TopicUpdateStatusMutation>;
export type TopicUpdateStatusMutationOptions = Apollo.BaseMutationOptions<TopicUpdateStatusMutation, TopicUpdateStatusMutationVariables>;
export const UpdateInterjectionsDocument = gql`
    mutation UpdateInterjections($repPromptId: UUID!, $interjections: [InterjectionInput!]) {
  updateInterjections(repPromptId: $repPromptId, interjections: $interjections) {
    index
    start
    duration
    message {
      language
      translatedText
    }
    author
  }
}
    `;
export type UpdateInterjectionsMutationFn = Apollo.MutationFunction<UpdateInterjectionsMutation, UpdateInterjectionsMutationVariables>;

/**
 * __useUpdateInterjectionsMutation__
 *
 * To run a mutation, you first call `useUpdateInterjectionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateInterjectionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateInterjectionsMutation, { data, loading, error }] = useUpdateInterjectionsMutation({
 *   variables: {
 *      repPromptId: // value for 'repPromptId'
 *      interjections: // value for 'interjections'
 *   },
 * });
 */
export function useUpdateInterjectionsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateInterjectionsMutation, UpdateInterjectionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateInterjectionsMutation, UpdateInterjectionsMutationVariables>(UpdateInterjectionsDocument, options);
      }
export type UpdateInterjectionsMutationHookResult = ReturnType<typeof useUpdateInterjectionsMutation>;
export type UpdateInterjectionsMutationResult = Apollo.MutationResult<UpdateInterjectionsMutation>;
export type UpdateInterjectionsMutationOptions = Apollo.BaseMutationOptions<UpdateInterjectionsMutation, UpdateInterjectionsMutationVariables>;
export const UploadProcessDocument = gql`
    mutation UploadProcess($id: String!) {
  uploadProcess(id: $id) {
    ...UploadFragment
    errorDetails
  }
}
    ${UploadFragmentDoc}`;
export type UploadProcessMutationFn = Apollo.MutationFunction<UploadProcessMutation, UploadProcessMutationVariables>;

/**
 * __useUploadProcessMutation__
 *
 * To run a mutation, you first call `useUploadProcessMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadProcessMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadProcessMutation, { data, loading, error }] = useUploadProcessMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUploadProcessMutation(baseOptions?: Apollo.MutationHookOptions<UploadProcessMutation, UploadProcessMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadProcessMutation, UploadProcessMutationVariables>(UploadProcessDocument, options);
      }
export type UploadProcessMutationHookResult = ReturnType<typeof useUploadProcessMutation>;
export type UploadProcessMutationResult = Apollo.MutationResult<UploadProcessMutation>;
export type UploadProcessMutationOptions = Apollo.BaseMutationOptions<UploadProcessMutation, UploadProcessMutationVariables>;
export const UploadProvisionDocument = gql`
    mutation UploadProvision($mediaId: String, $mimeType: String!, $mediaType: MediaType!) {
  uploadProvision(mediaId: $mediaId, mimeType: $mimeType, mediaType: $mediaType) {
    media {
      id
      mediaUrl
    }
    s3 {
      region
      bucket
      key
    }
    credentials {
      accessKeyId
      secretAccessKey
      sessionToken
      expiresAt
    }
    signedUrl
  }
}
    `;
export type UploadProvisionMutationFn = Apollo.MutationFunction<UploadProvisionMutation, UploadProvisionMutationVariables>;

/**
 * __useUploadProvisionMutation__
 *
 * To run a mutation, you first call `useUploadProvisionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadProvisionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadProvisionMutation, { data, loading, error }] = useUploadProvisionMutation({
 *   variables: {
 *      mediaId: // value for 'mediaId'
 *      mimeType: // value for 'mimeType'
 *      mediaType: // value for 'mediaType'
 *   },
 * });
 */
export function useUploadProvisionMutation(baseOptions?: Apollo.MutationHookOptions<UploadProvisionMutation, UploadProvisionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadProvisionMutation, UploadProvisionMutationVariables>(UploadProvisionDocument, options);
      }
export type UploadProvisionMutationHookResult = ReturnType<typeof useUploadProvisionMutation>;
export type UploadProvisionMutationResult = Apollo.MutationResult<UploadProvisionMutation>;
export type UploadProvisionMutationOptions = Apollo.BaseMutationOptions<UploadProvisionMutation, UploadProvisionMutationVariables>;
export const GetUsersCsvDocument = gql`
    query GetUsersCsv {
  getUsersCsv {
    url
  }
}
    `;

/**
 * __useGetUsersCsvQuery__
 *
 * To run a query within a React component, call `useGetUsersCsvQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUsersCsvQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUsersCsvQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUsersCsvQuery(baseOptions?: Apollo.QueryHookOptions<GetUsersCsvQuery, GetUsersCsvQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUsersCsvQuery, GetUsersCsvQueryVariables>(GetUsersCsvDocument, options);
      }
export function useGetUsersCsvLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUsersCsvQuery, GetUsersCsvQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUsersCsvQuery, GetUsersCsvQueryVariables>(GetUsersCsvDocument, options);
        }
export type GetUsersCsvQueryHookResult = ReturnType<typeof useGetUsersCsvQuery>;
export type GetUsersCsvLazyQueryHookResult = ReturnType<typeof useGetUsersCsvLazyQuery>;
export type GetUsersCsvQueryResult = Apollo.QueryResult<GetUsersCsvQuery, GetUsersCsvQueryVariables>;